
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dmrHV", function(module, exports) {

$parcel$export(module.exports, "initLogs", () => $9ba2d293ca4ede77$export$fb7e693220d78ec9);
$parcel$export(module.exports, "initRum", () => $9ba2d293ca4ede77$export$cc17ffb21418a272);
$parcel$export(module.exports, "setUser", () => $9ba2d293ca4ede77$export$8b6bb3dd62a01be2);

var $319l6 = parcelRequire("319l6");

var $cNbKI = parcelRequire("cNbKI");
const $9ba2d293ca4ede77$var$EMODE = {
    DEV: 'dev',
    TEST: 'test',
    PROD: 'prod'
};
const $9ba2d293ca4ede77$export$fb7e693220d78ec9 = ()=>{
    const params = {
        site: 'ap1.datadoghq.com',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100
    };
    switch("prod"){
        case $9ba2d293ca4ede77$var$EMODE.PROD:
            (0, $319l6.datadogLogs).init({
                ...params,
                clientToken: 'pubf9f58eaafad3eec60c6338fa08cd4a15',
                service: 'prod-web',
                env: $9ba2d293ca4ede77$var$EMODE.PROD
            });
            break;
        case $9ba2d293ca4ede77$var$EMODE.TEST:
            (0, $319l6.datadogLogs).init({
                ...params,
                clientToken: 'pub86b0263af14807817d3c2e9d7b12c129',
                service: 'test-web',
                env: $9ba2d293ca4ede77$var$EMODE.TEST
            });
            break;
    }
};
const $9ba2d293ca4ede77$export$cc17ffb21418a272 = ()=>{
    const params = {
        site: 'ap1.datadoghq.com',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask-user-input'
    };
    switch("prod"){
        case $9ba2d293ca4ede77$var$EMODE.PROD:
            (0, $cNbKI.datadogRum).init({
                ...params,
                applicationId: '346d781a-1c65-45e0-9196-c4325b0f304c',
                clientToken: 'pubf9f58eaafad3eec60c6338fa08cd4a15',
                service: 'prod-web',
                env: $9ba2d293ca4ede77$var$EMODE.PROD
            });
            break;
        case $9ba2d293ca4ede77$var$EMODE.TEST:
            (0, $cNbKI.datadogRum).init({
                ...params,
                applicationId: '4400e359-e852-4bb5-b2ed-f462b1baf180',
                clientToken: 'pub86b0263af14807817d3c2e9d7b12c129',
                service: 'test-web',
                env: $9ba2d293ca4ede77$var$EMODE.TEST
            });
            break;
    }
};
const $9ba2d293ca4ede77$export$8b6bb3dd62a01be2 = (userInfo = {})=>{
    if ([
        $9ba2d293ca4ede77$var$EMODE.PROD,
        $9ba2d293ca4ede77$var$EMODE.TEST
    ].includes("prod")) (0, $cNbKI.datadogRum).setUser(userInfo);
};

});
parcelRegister("319l6", function(module, exports) {

$parcel$export(module.exports, "datadogLogs", () => $2328b5add783e02a$export$64696fc4da45d740);
/**
 *
 * Datadog Browser Logs SDK for collecting and forwarding browser logs to Datadog.
 * Provides comprehensive logging capabilities with automatic error tracking and custom log collection.
 *
 * @packageDocumentation
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */ 
var $ewVF5 = parcelRequire("ewVF5");
var $1sTNW = parcelRequire("1sTNW");

var $6ucbP = parcelRequire("6ucbP");

var $hVbxe = parcelRequire("hVbxe");

var $lkd4w = parcelRequire("lkd4w");
const $2328b5add783e02a$export$64696fc4da45d740 = (0, $6ucbP.makeLogsPublicApi)();
(0, $ewVF5.defineGlobal)((0, $1sTNW.getGlobalObject)(), 'DD_LOGS', $2328b5add783e02a$export$64696fc4da45d740);

});
parcelRegister("ewVF5", function(module, exports) {

$parcel$export(module.exports, "makePublicApi", () => $a940c8408eeade74$export$119e7fe763fbc1d1);
$parcel$export(module.exports, "defineGlobal", () => $a940c8408eeade74$export$884b45263866f2b7);

var $1yDAt = parcelRequire("1yDAt");

var $2wH3Z = parcelRequire("2wH3Z");

var $5IDGB = parcelRequire("5IDGB");
function $a940c8408eeade74$export$119e7fe763fbc1d1(stub) {
    const publicApi = {
        version: "6.33.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady (callback) {
            callback();
        },
        ...stub
    };
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get () {
            return 0, $2wH3Z.setDebugMode;
        },
        enumerable: false
    });
    return publicApi;
}
function $a940c8408eeade74$export$884b45263866f2b7(global, name, api) {
    const existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) (0, $5IDGB.display).warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach((fn)=>(0, $1yDAt.catchUserErrors)(fn, 'onReady callback threw an error:')());
}

});
parcelRegister("1yDAt", function(module, exports) {

$parcel$export(module.exports, "catchUserErrors", () => $1227ac9fbf79b35b$export$a7d71543eda007d0);

var $5IDGB = parcelRequire("5IDGB");
function $1227ac9fbf79b35b$export$a7d71543eda007d0(fn, errorMsg) {
    return (...args)=>{
        try {
            return fn(...args);
        } catch (err) {
            (0, $5IDGB.display).error(errorMsg, err);
        }
    };
}

});
parcelRegister("5IDGB", function(module, exports) {

$parcel$export(module.exports, "ConsoleApiName", () => $429fd8a62f4aa1b2$export$d37676e8a94e6b40);
$parcel$export(module.exports, "globalConsole", () => $429fd8a62f4aa1b2$export$d07b2d1b8b601164);
$parcel$export(module.exports, "originalConsoleMethods", () => $429fd8a62f4aa1b2$export$77c4ce905194557b);
$parcel$export(module.exports, "display", () => $429fd8a62f4aa1b2$export$79693fdaa4661ff2);
$parcel$export(module.exports, "DOCS_ORIGIN", () => $429fd8a62f4aa1b2$export$61b69f86bb46c85e);
$parcel$export(module.exports, "DOCS_TROUBLESHOOTING", () => $429fd8a62f4aa1b2$export$f3bbdb3cea20e78e);
$parcel$export(module.exports, "MORE_DETAILS", () => $429fd8a62f4aa1b2$export$69ce01f6d41ea86c);
/* eslint-disable local-rules/disallow-side-effects */ /**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */ const $429fd8a62f4aa1b2$export$d37676e8a94e6b40 = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error'
};
const $429fd8a62f4aa1b2$export$d07b2d1b8b601164 = console;
const $429fd8a62f4aa1b2$export$77c4ce905194557b = {};
Object.keys($429fd8a62f4aa1b2$export$d37676e8a94e6b40).forEach((name)=>{
    $429fd8a62f4aa1b2$export$77c4ce905194557b[name] = $429fd8a62f4aa1b2$export$d07b2d1b8b601164[name];
});
const $429fd8a62f4aa1b2$var$PREFIX = 'Datadog Browser SDK:';
const $429fd8a62f4aa1b2$export$79693fdaa4661ff2 = {
    debug: $429fd8a62f4aa1b2$export$77c4ce905194557b.debug.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    log: $429fd8a62f4aa1b2$export$77c4ce905194557b.log.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    info: $429fd8a62f4aa1b2$export$77c4ce905194557b.info.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    warn: $429fd8a62f4aa1b2$export$77c4ce905194557b.warn.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    error: $429fd8a62f4aa1b2$export$77c4ce905194557b.error.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX)
};
const $429fd8a62f4aa1b2$export$61b69f86bb46c85e = 'https://docs.datadoghq.com';
const $429fd8a62f4aa1b2$export$f3bbdb3cea20e78e = `${$429fd8a62f4aa1b2$export$61b69f86bb46c85e}/real_user_monitoring/browser/troubleshooting`;
const $429fd8a62f4aa1b2$export$69ce01f6d41ea86c = 'More details:';

});


parcelRegister("2wH3Z", function(module, exports) {

$parcel$export(module.exports, "startMonitorErrorCollection", () => $1d6ff96621fb36bb$export$2fa3dec4f40a39a2);
$parcel$export(module.exports, "setDebugMode", () => $1d6ff96621fb36bb$export$2be227cb6aa211be);
$parcel$export(module.exports, "monitored", () => $1d6ff96621fb36bb$export$efef192ceb8f8a31);
$parcel$export(module.exports, "monitor", () => $1d6ff96621fb36bb$export$ec5b303098bc4b7f);
$parcel$export(module.exports, "callMonitored", () => $1d6ff96621fb36bb$export$b69eb0f8afebfb6d);
$parcel$export(module.exports, "monitorError", () => $1d6ff96621fb36bb$export$7ec91d0dd633c6c2);
$parcel$export(module.exports, "displayIfDebugEnabled", () => $1d6ff96621fb36bb$export$54b26de4de044ec5);

var $5IDGB = parcelRequire("5IDGB");
let $1d6ff96621fb36bb$var$onMonitorErrorCollected;
let $1d6ff96621fb36bb$var$debugMode = false;
function $1d6ff96621fb36bb$export$2fa3dec4f40a39a2(newOnMonitorErrorCollected) {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function $1d6ff96621fb36bb$export$2be227cb6aa211be(newDebugMode) {
    $1d6ff96621fb36bb$var$debugMode = newDebugMode;
}
function $1d6ff96621fb36bb$export$6c5b5d0667b12cfc() {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = undefined;
    $1d6ff96621fb36bb$var$debugMode = false;
}
function $1d6ff96621fb36bb$export$efef192ceb8f8a31(_, __, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
        const decorated = $1d6ff96621fb36bb$var$onMonitorErrorCollected ? $1d6ff96621fb36bb$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function $1d6ff96621fb36bb$export$ec5b303098bc4b7f(fn) {
    return function(...args) {
        return $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, this, args);
    }; // consider output type has input type
}
function $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, context, args) {
    try {
        return fn.apply(context, args);
    } catch (e) {
        $1d6ff96621fb36bb$export$7ec91d0dd633c6c2(e);
    }
}
function $1d6ff96621fb36bb$export$7ec91d0dd633c6c2(e) {
    $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
    if ($1d6ff96621fb36bb$var$onMonitorErrorCollected) try {
        $1d6ff96621fb36bb$var$onMonitorErrorCollected(e);
    } catch (e) {
        $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
    }
}
function $1d6ff96621fb36bb$export$54b26de4de044ec5(...args) {
    if ($1d6ff96621fb36bb$var$debugMode) (0, $5IDGB.display).error('[MONITOR]', ...args);
}

});


parcelRegister("1sTNW", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $1113b1944b4b5a94$export$256479dc0cea61c4);
$parcel$export(module.exports, "globalObject", () => $1113b1944b4b5a94$export$ded1884231baf037);
$parcel$export(module.exports, "isWorkerEnvironment", () => $1113b1944b4b5a94$export$24f8daea74528daa);
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */ function $1113b1944b4b5a94$export$256479dc0cea61c4() {
    if (typeof globalThis === 'object') return globalThis;
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get () {
            return this;
        },
        configurable: true
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    let globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') globalObject = self;
        else if (typeof window === 'object') globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}
const $1113b1944b4b5a94$export$ded1884231baf037 = $1113b1944b4b5a94$export$256479dc0cea61c4();
const $1113b1944b4b5a94$export$24f8daea74528daa = 'WorkerGlobalScope' in $1113b1944b4b5a94$export$ded1884231baf037;

});

parcelRegister("6ucbP", function(module, exports) {

$parcel$export(module.exports, "makeLogsPublicApi", () => $4b8f0012af858341$export$39525f74d82d4cd7);

var $fhNdh = parcelRequire("fhNdh");
var $2wH3Z = parcelRequire("2wH3Z");
var $7v3G2 = parcelRequire("7v3G2");
var $95XVG = parcelRequire("95XVG");
var $j9iCm = parcelRequire("j9iCm");
var $cJkro = parcelRequire("cJkro");
var $gurxr = parcelRequire("gurxr");
var $ewVF5 = parcelRequire("ewVF5");
var $4Umqd = parcelRequire("4Umqd");
var $1RdIU = parcelRequire("1RdIU");
var $ia9TG = parcelRequire("ia9TG");

var $hVbxe = parcelRequire("hVbxe");

var $iOUkG = parcelRequire("iOUkG");

var $22u1E = parcelRequire("22u1E");

var $d5UeM = parcelRequire("d5UeM");
function $4b8f0012af858341$export$39525f74d82d4cd7() {
    const trackingConsentState = (0, $95XVG.createTrackingConsentState)();
    const bufferedDataObservable = (0, $ia9TG.startBufferingData)().observable;
    let strategy = (0, $d5UeM.createPreStartStrategy)((0, $iOUkG.buildCommonContext), trackingConsentState, (initConfiguration, configuration, hooks)=>{
        const startLogsResult = (0, $4Umqd.mockable)((0, $22u1E.startLogs))(configuration, (0, $iOUkG.buildCommonContext), trackingConsentState, bufferedDataObservable, hooks);
        strategy = $4b8f0012af858341$var$createPostStartStrategy(initConfiguration, startLogsResult);
        return startLogsResult;
    });
    const getStrategy = ()=>strategy;
    const customLoggers = {};
    const mainLogger = new (0, $hVbxe.Logger)((...params)=>strategy.handleLog(...params));
    return (0, $ewVF5.makePublicApi)({
        logger: mainLogger,
        init: (initConfiguration)=>{
            const errorStack = new Error().stack;
            (0, $2wH3Z.callMonitored)(()=>strategy.init(initConfiguration, errorStack));
        },
        setTrackingConsent: (0, $2wH3Z.monitor)((trackingConsent)=>{
            trackingConsentState.update(trackingConsent);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-tracking-consent',
                tracking_consent: trackingConsent
            });
        }),
        getGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).getContext),
        setGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).setContext),
        setGlobalContextProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).setContextProperty),
        removeGlobalContextProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty),
        clearGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).clearContext),
        createLogger: (0, $2wH3Z.monitor)((name, conf = {})=>{
            customLoggers[name] = new (0, $hVbxe.Logger)((...params)=>strategy.handleLog(...params), (0, $1RdIU.sanitize)(name), conf.handler, conf.level, (0, $1RdIU.sanitize)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0, $2wH3Z.monitor)((name)=>customLoggers[name]),
        getInitConfiguration: (0, $2wH3Z.monitor)(()=>(0, $j9iCm.deepClone)(strategy.initConfiguration)),
        getInternalContext: (0, $2wH3Z.monitor)((startTime)=>strategy.getInternalContext(startTime)),
        setUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).setContext),
        getUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).getContext),
        setUserProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).setContextProperty),
        removeUserProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty),
        clearUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).clearContext),
        setAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).setContext),
        getAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).getContext),
        setAccountProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).setContextProperty),
        removeAccountProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty),
        clearAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).clearContext)
    });
}
function $4b8f0012af858341$var$createPostStartStrategy(initConfiguration, startLogsResult) {
    return {
        init: (initConfiguration)=>{
            (0, $gurxr.displayAlreadyInitializedError)('DD_LOGS', initConfiguration);
        },
        initConfiguration: initConfiguration,
        ...startLogsResult
    };
}

});
parcelRegister("fhNdh", function(module, exports) {

$parcel$export(module.exports, "startTelemetry", () => $b20e9e3ee3028089$export$a1198c4bba5d5e18);
$parcel$export(module.exports, "addTelemetryError", () => $b20e9e3ee3028089$export$2e825f93958b0e6a);
$parcel$export(module.exports, "addTelemetryDebug", () => $b20e9e3ee3028089$export$d922954195a17683);
$parcel$export(module.exports, "addTelemetryConfiguration", () => $b20e9e3ee3028089$export$d546dcbd09bc447f);
$parcel$export(module.exports, "addTelemetryMetrics", () => $b20e9e3ee3028089$export$4a0be9503ff69005);
$parcel$export(module.exports, "addTelemetryUsage", () => $b20e9e3ee3028089$export$1241dad04919e70b);

var $5IDGB = parcelRequire("5IDGB");

var $4Be0w = parcelRequire("4Be0w");

var $6q317 = parcelRequire("6q317");

var $k2pmh = parcelRequire("k2pmh");

var $hBiX7 = parcelRequire("hBiX7");

var $iLlhv = parcelRequire("iLlhv");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $2wH3Z = parcelRequire("2wH3Z");

var $cfGi1 = parcelRequire("cfGi1");

var $bQmeT = parcelRequire("bQmeT");

var $1W8NF = parcelRequire("1W8NF");

var $j9iCm = parcelRequire("j9iCm");

var $3aiPa = parcelRequire("3aiPa");

var $82OHb = parcelRequire("82OHb");

var $kFaIT = parcelRequire("kFaIT");
var $c8B2g = parcelRequire("c8B2g");
var $cETgK = parcelRequire("cETgK");
var $3qksw = parcelRequire("3qksw");

var $lTIYX = parcelRequire("lTIYX");

var $70xdd = parcelRequire("70xdd");

var $i3LOd = parcelRequire("i3LOd");

var $1sTNW = parcelRequire("1sTNW");

var $aed8w = parcelRequire("aed8w");

var $1RGSv = parcelRequire("1RGSv");
const $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>'
];
const $b20e9e3ee3028089$var$METRIC_SAMPLE_RATE = 1;
const $b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $iLlhv.INTAKE_SITE_US1_FED),
    (0, $iLlhv.INTAKE_SITE_US2_FED)
];
const $b20e9e3ee3028089$var$MAX_TELEMETRY_EVENTS_PER_PAGE = 15;
let $b20e9e3ee3028089$var$telemetryObservable;
function $b20e9e3ee3028089$export$6b87b6bd493d4cbf() {
    if (!$b20e9e3ee3028089$var$telemetryObservable) $b20e9e3ee3028089$var$telemetryObservable = new (0, $4wc1a.BufferedObservable)(100);
    return $b20e9e3ee3028089$var$telemetryObservable;
}
function $b20e9e3ee3028089$export$a1198c4bba5d5e18(telemetryService, configuration, hooks) {
    const observable = new (0, $4wc1a.Observable)();
    const { enabled: enabled, metricsEnabled: metricsEnabled } = $b20e9e3ee3028089$export$bf13ce82ed454ffe(telemetryService, configuration, hooks, observable);
    const { stop: stop } = $b20e9e3ee3028089$export$e21b6c2f85dfc755(configuration, observable);
    return {
        stop: stop,
        enabled: enabled,
        metricsEnabled: metricsEnabled
    };
}
function $b20e9e3ee3028089$export$bf13ce82ed454ffe(telemetryService, configuration, hooks, observable, metricSampleRate = $b20e9e3ee3028089$var$METRIC_SAMPLE_RATE, maxTelemetryEventsPerPage = $b20e9e3ee3028089$var$MAX_TELEMETRY_EVENTS_PER_PAGE) {
    const alreadySentEventsByKind = {};
    const telemetryEnabled = !$b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && (0, $bQmeT.performDraw)(configuration.telemetrySampleRate);
    const telemetryEnabledPerType = {
        [(0, $1RGSv.TelemetryType).LOG]: telemetryEnabled,
        [(0, $1RGSv.TelemetryType).CONFIGURATION]: telemetryEnabled && (0, $bQmeT.performDraw)(configuration.telemetryConfigurationSampleRate),
        [(0, $1RGSv.TelemetryType).USAGE]: telemetryEnabled && (0, $bQmeT.performDraw)(configuration.telemetryUsageSampleRate),
        // not an actual "type" but using a single draw for all metrics
        metric: telemetryEnabled && (0, $bQmeT.performDraw)(metricSampleRate)
    };
    const runtimeEnvInfo = $b20e9e3ee3028089$var$getRuntimeEnvInfo();
    const telemetryObservable = $b20e9e3ee3028089$export$6b87b6bd493d4cbf();
    telemetryObservable.subscribe(({ rawEvent: rawEvent, metricName: metricName })=>{
        if (metricName && !telemetryEnabledPerType['metric'] || !telemetryEnabledPerType[rawEvent.type]) return;
        const kind = metricName || rawEvent.status || rawEvent.type;
        let alreadySentEvents = alreadySentEventsByKind[kind];
        if (!alreadySentEvents) alreadySentEvents = alreadySentEventsByKind[kind] = new Set();
        if (alreadySentEvents.size >= maxTelemetryEventsPerPage) return;
        const stringifiedEvent = (0, $1W8NF.jsonStringify)(rawEvent);
        if (alreadySentEvents.has(stringifiedEvent)) return;
        const defaultTelemetryEventAttributes = hooks.triggerHook(1 /* HookNames.AssembleTelemetry */ , {
            startTime: (0, $ly0px.clocksNow)().relative
        });
        if (defaultTelemetryEventAttributes === (0, $i3LOd.DISCARDED)) return;
        const event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
        observable.notify(event);
        (0, $cfGi1.sendToExtension)('telemetry', event);
        alreadySentEvents.add(stringifiedEvent);
    });
    telemetryObservable.unbuffer();
    (0, $2wH3Z.startMonitorErrorCollection)($b20e9e3ee3028089$export$2e825f93958b0e6a);
    return {
        enabled: telemetryEnabled,
        metricsEnabled: telemetryEnabledPerType['metric']
    };
    function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
        const clockNow = (0, $ly0px.clocksNow)();
        const event = {
            type: 'telemetry',
            date: clockNow.timeStamp,
            service: telemetryService,
            version: "6.33.0",
            source: 'browser',
            _dd: {
                format_version: 2
            },
            telemetry: (0, $j9iCm.combine)(rawEvent, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $82OHb.getConnectivity)(),
                sdk_setup: "npm"
            }),
            ddtags: (0, $hBiX7.buildTags)(configuration).join(','),
            experimental_features: Array.from((0, $k2pmh.getExperimentalFeatures)())
        };
        return (0, $j9iCm.combine)(event, defaultTelemetryEventAttributes);
    }
}
function $b20e9e3ee3028089$export$e21b6c2f85dfc755(configuration, telemetryObservable) {
    const cleanupTasks = [];
    if ((0, $kFaIT.canUseEventBridge)()) {
        const bridge = (0, $kFaIT.getEventBridge)();
        const telemetrySubscription = telemetryObservable.subscribe((event)=>bridge.send('internal_telemetry', event));
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    } else {
        const endpoints = [
            configuration.rumEndpointBuilder
        ];
        if (configuration.replica && $b20e9e3ee3028089$var$isTelemetryReplicationAllowed(configuration)) endpoints.push(configuration.replica.rumEndpointBuilder);
        const telemetryBatch = (0, $c8B2g.createBatch)({
            encoder: (0, $lTIYX.createIdentityEncoder)(),
            request: (0, $3qksw.createHttpRequest)(endpoints, // Ignore transport errors for telemetry
            (0, $aed8w.noop)),
            flushController: (0, $cETgK.createFlushController)({
                pageMayExitObservable: (0, $70xdd.createPageMayExitObservable)(configuration),
                // We don't use an actual session expire observable here, to make telemetry collection
                // independent of the session. This allows to start and send telemetry events earlier.
                sessionExpireObservable: new (0, $4wc1a.Observable)()
            })
        });
        cleanupTasks.push(telemetryBatch.stop);
        const telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);
        cleanupTasks.push(telemetrySubscription.unsubscribe);
    }
    return {
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}
function $b20e9e3ee3028089$var$getRuntimeEnvInfo() {
    var _a;
    return {
        is_local_file: ((_a = (0, $1sTNW.globalObject).location) === null || _a === void 0 ? void 0 : _a.protocol) === 'file:',
        is_worker: (0, $1sTNW.isWorkerEnvironment)
    };
}
function $b20e9e3ee3028089$export$bcc442d9456bda5() {
    $b20e9e3ee3028089$var$telemetryObservable = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */ function $b20e9e3ee3028089$var$isTelemetryReplicationAllowed(configuration) {
    return configuration.site === (0, $iLlhv.INTAKE_SITE_STAGING);
}
function $b20e9e3ee3028089$export$d922954195a17683(message, context) {
    (0, $2wH3Z.displayIfDebugEnabled)((0, $5IDGB.ConsoleApiName).debug, message, context);
    $b20e9e3ee3028089$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $1RGSv.TelemetryType).LOG,
            message: message,
            status: "debug" /* StatusType.debug */ ,
            ...context
        }
    });
}
function $b20e9e3ee3028089$export$2e825f93958b0e6a(e, context) {
    $b20e9e3ee3028089$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $1RGSv.TelemetryType).LOG,
            status: "error" /* StatusType.error */ ,
            ...$b20e9e3ee3028089$export$7b5b869ee98c16ab(e),
            ...context
        }
    });
}
function $b20e9e3ee3028089$export$d546dcbd09bc447f(configuration) {
    $b20e9e3ee3028089$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $1RGSv.TelemetryType).CONFIGURATION,
            configuration: configuration
        }
    });
}
function $b20e9e3ee3028089$export$4a0be9503ff69005(metricName, context) {
    $b20e9e3ee3028089$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $1RGSv.TelemetryType).LOG,
            message: metricName,
            status: "debug" /* StatusType.debug */ ,
            ...context
        },
        metricName: metricName
    });
}
function $b20e9e3ee3028089$export$1241dad04919e70b(usage) {
    $b20e9e3ee3028089$export$6b87b6bd493d4cbf().notify({
        rawEvent: {
            type: (0, $1RGSv.TelemetryType).USAGE,
            usage: usage
        }
    });
}
function $b20e9e3ee3028089$export$7b5b869ee98c16ab(e) {
    if ((0, $4Be0w.isError)(e)) {
        const stackTrace = (0, $3aiPa.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $6q317.toStackTraceString)($b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $4Be0w.NO_ERROR_STACK_PRESENT_MESSAGE)
        },
        message: `${"Uncaught" /* NonErrorPrefix.UNCAUGHT */ } ${(0, $1W8NF.jsonStringify)(e)}`
    };
}
function $b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter((frame)=>!frame.url || $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS.some((allowedFrameUrl)=>frame.url.startsWith(allowedFrameUrl)));
    return stackTrace;
}

});
parcelRegister("4Be0w", function(module, exports) {

$parcel$export(module.exports, "NO_ERROR_STACK_PRESENT_MESSAGE", () => $35957bb00d7299b7$export$25ad0fcc62fe3571);
$parcel$export(module.exports, "isError", () => $35957bb00d7299b7$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "computeRawError", () => $35957bb00d7299b7$export$b8dc46b79c72ee26);
$parcel$export(module.exports, "getFileFromStackTraceString", () => $35957bb00d7299b7$export$edc1986890374033);

var $1RdIU = parcelRequire("1RdIU");

var $1W8NF = parcelRequire("1W8NF");

var $3aiPa = parcelRequire("3aiPa");

var $6q317 = parcelRequire("6q317");

var $5DEie = parcelRequire("5DEie");
const $35957bb00d7299b7$export$25ad0fcc62fe3571 = 'No stack, consider using an instance of Error';
function $35957bb00d7299b7$var$computeErrorBase({ originalError: originalError, stackTrace: stackTrace, source: source, useFallbackStack: useFallbackStack = true, nonErrorPrefix: nonErrorPrefix }) {
    const isErrorInstance = $35957bb00d7299b7$export$e6127cc7fe7395c3(originalError);
    if (!stackTrace && isErrorInstance) stackTrace = (0, $3aiPa.computeStackTrace)(originalError);
    return {
        source: source,
        type: stackTrace ? stackTrace.name : undefined,
        message: $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
        stack: stackTrace ? (0, $6q317.toStackTraceString)(stackTrace) : useFallbackStack ? $35957bb00d7299b7$export$25ad0fcc62fe3571 : undefined
    };
}
function $35957bb00d7299b7$export$b8dc46b79c72ee26({ stackTrace: stackTrace, originalError: originalError, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, nonErrorPrefix: nonErrorPrefix, useFallbackStack: useFallbackStack = true, source: source, handling: handling }) {
    const errorBase = $35957bb00d7299b7$var$computeErrorBase({
        originalError: originalError,
        stackTrace: stackTrace,
        source: source,
        useFallbackStack: useFallbackStack,
        nonErrorPrefix: nonErrorPrefix
    });
    return {
        startClocks: startClocks,
        handling: handling,
        handlingStack: handlingStack,
        componentStack: componentStack,
        originalError: originalError,
        ...errorBase,
        causes: $35957bb00d7299b7$export$e6127cc7fe7395c3(originalError) ? $35957bb00d7299b7$export$bf9a979d43c83a9(originalError, source) : undefined,
        fingerprint: $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError),
        context: $35957bb00d7299b7$export$2f5123898fe3d684(originalError)
    };
}
function $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? nonErrorPrefix ? `${nonErrorPrefix} ${(0, $1W8NF.jsonStringify)((0, $1RdIU.sanitize)(originalError))}` : (0, $1W8NF.jsonStringify)((0, $1RdIU.sanitize)(originalError)) : 'Empty message';
}
function $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError) {
    return $35957bb00d7299b7$export$e6127cc7fe7395c3(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function $35957bb00d7299b7$export$2f5123898fe3d684(originalError) {
    if ((0, $5DEie.isIndexableObject)(originalError)) return originalError.dd_context;
}
function $35957bb00d7299b7$export$edc1986890374033(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function $35957bb00d7299b7$export$e6127cc7fe7395c3(error) {
    return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
function $35957bb00d7299b7$export$bf9a979d43c83a9(error, parentSource) {
    const causes = [];
    let currentCause = error.cause;
    while(currentCause !== undefined && currentCause !== null && causes.length < 10){
        const causeBase = $35957bb00d7299b7$var$computeErrorBase({
            originalError: currentCause,
            source: parentSource,
            useFallbackStack: false
        });
        causes.push(causeBase);
        currentCause = $35957bb00d7299b7$export$e6127cc7fe7395c3(currentCause) ? currentCause.cause : undefined;
    }
    return causes.length ? causes : undefined;
}

});
parcelRegister("1RdIU", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $15a562dd6816cf15$export$83d2e9e3e4ee39ed);

var $5IDGB = parcelRequire("5IDGB");

var $7S2uk = parcelRequire("7S2uk");

var $1W8NF = parcelRequire("1W8NF");
const $15a562dd6816cf15$export$9e92fe25085833dd = 220 * (0, $7S2uk.ONE_KIBI_BYTE);
// Symbol for the root element of the JSONPath used for visited objects
const $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
const $15a562dd6816cf15$var$KEY_DECORATION_LENGTH = 3;
function $15a562dd6816cf15$export$83d2e9e3e4ee39ed(source, maxCharacterCount = $15a562dd6816cf15$export$9e92fe25085833dd) {
    // Unbind any toJSON function we may have on [] or {} prototypes
    const restoreObjectPrototypeToJson = (0, $1W8NF.detachToJsonMethod)(Object.prototype);
    const restoreArrayPrototypeToJson = (0, $1W8NF.detachToJsonMethod)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    const containerQueue = [];
    const visitedObjectsWithPath = new WeakMap();
    const sanitizedData = $15a562dd6816cf15$var$sanitizeProcessor(source, $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    const serializedSanitizedData = JSON.stringify(sanitizedData);
    let accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
        const containerToProcess = containerQueue.shift();
        let separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) for(let key = 0; key < containerToProcess.source.length; key++){
            const targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
            if (targetData !== undefined) accumulatedCharacterCount += JSON.stringify(targetData).length;
            else // When an element of an Array (targetData) is undefined, it is serialized as null:
            // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
            accumulatedCharacterCount += 4;
            accumulatedCharacterCount += separatorLength;
            separatorLength = 1;
            if (accumulatedCharacterCount > maxCharacterCount) {
                $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                break;
            }
            containerToProcess.target[key] = targetData;
        }
        else {
            for(const key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                const targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                // When a property of an object has an undefined value, it will be dropped during serialization:
                // JSON.stringify({a:undefined}) => '{}'
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $15a562dd6816cf15$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */ function $15a562dd6816cf15$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    const sourceToSanitize = $15a562dd6816cf15$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') return $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    const sanitizedSource = $15a562dd6816cf15$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') return sanitizedSource;
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    const sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return `[Reference seen at ${visitedObjectsWithPath.get(sourceAsObject)}]`;
    // Add processed source to queue
    const currentPath = key !== undefined ? `${parentPath}.${key}` : parentPath;
    const target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */ function $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') return `[BigInt] ${value.toString()}`;
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') return `[Function] ${value.name || 'unknown'}`;
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') return `[Symbol] ${value.description || value.toString()}`;
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 */ function $15a562dd6816cf15$var$sanitizeObjects(value) {
    try {
        if (value instanceof Event) return $15a562dd6816cf15$var$sanitizeEvent(value);
        if (value instanceof RegExp) return `[RegExp] ${value.toString()}`;
        // Handle all remaining object types in a generic way
        const result = Object.prototype.toString.call(value);
        const match = result.match(/\[object (.*)\]/);
        if (match && match[1]) return `[${match[1]}]`;
    } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
function $15a562dd6816cf15$var$sanitizeEvent(event) {
    return {
        type: event.type,
        isTrusted: event.isTrusted,
        currentTarget: event.currentTarget ? $15a562dd6816cf15$var$sanitizeObjects(event.currentTarget) : null,
        target: event.target ? $15a562dd6816cf15$var$sanitizeObjects(event.target) : null
    };
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */ function $15a562dd6816cf15$var$tryToApplyToJSON(value) {
    const object = value;
    if (object && typeof object.toJSON === 'function') try {
        return object.toJSON();
    } catch (_a) {
    // If toJSON fails, we continue by trying to serialize the value manually
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */ function $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $5IDGB.display).warn(`The data provided has been ${changeType} as it is over the limit of ${maxCharacterCount} characters:`, source);
}

});
parcelRegister("7S2uk", function(module, exports) {

$parcel$export(module.exports, "ONE_KIBI_BYTE", () => $5baf81a8b4674c85$export$756c3d65870c899e);
$parcel$export(module.exports, "ONE_MEBI_BYTE", () => $5baf81a8b4674c85$export$377b1474fc07c10f);
$parcel$export(module.exports, "computeBytesCount", () => $5baf81a8b4674c85$export$36cba7c53d8f13a2);
$parcel$export(module.exports, "concatBuffers", () => $5baf81a8b4674c85$export$28e250f55413be00);
const $5baf81a8b4674c85$export$756c3d65870c899e = 1024;
const $5baf81a8b4674c85$export$377b1474fc07c10f = 1024 * $5baf81a8b4674c85$export$756c3d65870c899e;
// eslint-disable-next-line no-control-regex
const $5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $5baf81a8b4674c85$export$36cba7c53d8f13a2(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!$5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
    return new Blob([
        candidate
    ]).size;
}
function $5baf81a8b4674c85$export$28e250f55413be00(buffers) {
    // Optimization: if there is a single buffer, no need to copy it
    if (buffers.length === 1) return buffers[0];
    const length = buffers.reduce((total, buffer)=>total + buffer.length, 0);
    const result = new Uint8Array(length);
    let offset = 0;
    for (const buffer of buffers){
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}

});

parcelRegister("1W8NF", function(module, exports) {

$parcel$export(module.exports, "jsonStringify", () => $169208b8dc904506$export$1f8609334739c2b6);
$parcel$export(module.exports, "detachToJsonMethod", () => $169208b8dc904506$export$f6ec9d87b663748);

var $aed8w = parcelRequire("aed8w");
function $169208b8dc904506$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== 'object' || value === null) return JSON.stringify(value);
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    const restoreObjectPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.prototype);
    const restoreArrayPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Array.prototype);
    const restoreValuePrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    const restoreValueToJson = $169208b8dc904506$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch (_a) {
        return '<error: unable to serialize object>';
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $169208b8dc904506$export$f6ec9d87b663748(value) {
    const object = value;
    const objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return ()=>{
            object.toJSON = objectToJson;
        };
    }
    return 0, $aed8w.noop;
}

});
parcelRegister("aed8w", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $772566d0dfa3645c$export$de363e709c412c8a);
$parcel$export(module.exports, "noop", () => $772566d0dfa3645c$export$8793edee2d425525);

var $d97UU = parcelRequire("d97UU");
function $772566d0dfa3645c$export$de363e709c412c8a(fn, wait, options) {
    const needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    const needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    let inWaitPeriod = false;
    let pendingExecutionWithParameters;
    let pendingTimeoutId;
    return {
        throttled: (...parameters)=>{
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn(...parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $d97UU.setTimeout)(()=>{
                if (needTrailingExecution && pendingExecutionWithParameters) fn(...pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: ()=>{
            (0, $d97UU.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        }
    };
}
function $772566d0dfa3645c$export$8793edee2d425525() {}

});
parcelRegister("d97UU", function(module, exports) {

$parcel$export(module.exports, "setTimeout", () => $02784b622c768a70$export$831dc9f2ab0a617b);
$parcel$export(module.exports, "clearTimeout", () => $02784b622c768a70$export$4e6a25ba7ce9d78e);
$parcel$export(module.exports, "setInterval", () => $02784b622c768a70$export$cda6c73645970615);
$parcel$export(module.exports, "clearInterval", () => $02784b622c768a70$export$5c0dc72231454d02);

var $5sf7S = parcelRequire("5sf7S");

var $2wH3Z = parcelRequire("2wH3Z");

var $1sTNW = parcelRequire("1sTNW");
function $02784b622c768a70$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $5sf7S.getZoneJsOriginalValue)((0, $1sTNW.getGlobalObject)(), 'setTimeout')((0, $2wH3Z.monitor)(callback), delay);
}
function $02784b622c768a70$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $5sf7S.getZoneJsOriginalValue)((0, $1sTNW.getGlobalObject)(), 'clearTimeout')(timeoutId);
}
function $02784b622c768a70$export$cda6c73645970615(callback, delay) {
    return (0, $5sf7S.getZoneJsOriginalValue)((0, $1sTNW.getGlobalObject)(), 'setInterval')((0, $2wH3Z.monitor)(callback), delay);
}
function $02784b622c768a70$export$5c0dc72231454d02(timeoutId) {
    (0, $5sf7S.getZoneJsOriginalValue)((0, $1sTNW.getGlobalObject)(), 'clearInterval')(timeoutId);
}

});
parcelRegister("5sf7S", function(module, exports) {

$parcel$export(module.exports, "getZoneJsOriginalValue", () => $3f8b4cfb9b188c27$export$610f486206760177);

var $1sTNW = parcelRequire("1sTNW");
function $3f8b4cfb9b188c27$export$610f486206760177(target, name) {
    const browserWindow = (0, $1sTNW.getGlobalObject)();
    let original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}

});





parcelRegister("3aiPa", function(module, exports) {

$parcel$export(module.exports, "computeStackTrace", () => $24e0e8626c2d0274$export$81296eded4f2ac09);
$parcel$export(module.exports, "computeStackTraceFromOnErrorMessage", () => $24e0e8626c2d0274$export$e8e53f0e2ff18afa);
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */ 
var $5DEie = parcelRequire("5DEie");
const $24e0e8626c2d0274$var$UNKNOWN_FUNCTION = '?';
function $24e0e8626c2d0274$export$81296eded4f2ac09(ex) {
    var _a, _b;
    const stack = [];
    let stackProperty = $24e0e8626c2d0274$var$tryToGetString(ex, 'stack');
    const exString = String(ex);
    if (stackProperty && stackProperty.startsWith(exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split('\n').forEach((line)=>{
        const stackFrame = $24e0e8626c2d0274$var$parseChromeLine(line) || $24e0e8626c2d0274$var$parseChromeAnonymousLine(line) || $24e0e8626c2d0274$var$parseWinLine(line) || $24e0e8626c2d0274$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $24e0e8626c2d0274$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    if (stack.length > 0 && $24e0e8626c2d0274$var$isWronglyReportingCustomErrors() && ex instanceof Error) {
        // if we are wrongly reporting custom errors
        const constructors = [];
        // go through each inherited constructor
        let currentPrototype = ex;
        while((currentPrototype = Object.getPrototypeOf(currentPrototype)) && $24e0e8626c2d0274$var$isNonNativeClassPrototype(currentPrototype)){
            const constructorName = ((_a = currentPrototype.constructor) === null || _a === void 0 ? void 0 : _a.name) || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION;
            constructors.push(constructorName);
        }
        // traverse the stacktrace in reverse order because the stacktrace starts with the last inherited constructor
        // we check constructor names to ensure we remove the correct frame (and there isn't a weird unsupported environment behavior)
        for(let i = constructors.length - 1; i >= 0 && ((_b = stack[0]) === null || _b === void 0 ? void 0 : _b.func) === constructors[i]; i--)// if the first stack frame is the custom error constructor
        // null stack frames may represent frames that failed to be parsed because the error class did not have a constructor
        stack.shift(); // remove it
    }
    return {
        message: $24e0e8626c2d0274$var$tryToGetString(ex, 'message'),
        name: $24e0e8626c2d0274$var$tryToGetString(ex, 'name'),
        stack: stack
    };
}
const $24e0e8626c2d0274$var$fileUrl = '((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
const $24e0e8626c2d0274$var$filePosition = '(?::(\\d+))';
const $24e0e8626c2d0274$var$CHROME_LINE_RE = new RegExp(`^\\s*at (.*?) ?\\(${$24e0e8626c2d0274$var$fileUrl}${$24e0e8626c2d0274$var$filePosition}?${$24e0e8626c2d0274$var$filePosition}?\\)?\\s*$`, 'i');
const $24e0e8626c2d0274$var$CHROME_EVAL_RE = new RegExp(`\\((\\S*)${$24e0e8626c2d0274$var$filePosition}${$24e0e8626c2d0274$var$filePosition}\\)`);
function $24e0e8626c2d0274$var$parseChromeLine(line) {
    const parts = $24e0e8626c2d0274$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    const isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    const submatch = $24e0e8626c2d0274$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined
    };
}
const $24e0e8626c2d0274$var$htmlAnonymousPart = '(?:(.*)?(?: @))';
const $24e0e8626c2d0274$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp(`^\\s*at\\s*${$24e0e8626c2d0274$var$htmlAnonymousPart}?\\s*${$24e0e8626c2d0274$var$fileUrl}${$24e0e8626c2d0274$var$filePosition}?${$24e0e8626c2d0274$var$filePosition}??\\s*$`, 'i');
function $24e0e8626c2d0274$var$parseChromeAnonymousLine(line) {
    const parts = $24e0e8626c2d0274$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: parts[2]
    };
}
const $24e0e8626c2d0274$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $24e0e8626c2d0274$var$parseWinLine(line) {
    const parts = $24e0e8626c2d0274$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
const $24e0e8626c2d0274$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i;
const $24e0e8626c2d0274$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $24e0e8626c2d0274$var$parseGeckoLine(line) {
    const parts = $24e0e8626c2d0274$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    const submatch = $24e0e8626c2d0274$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3]
    };
}
function $24e0e8626c2d0274$var$tryToGetString(candidate, property) {
    return (0, $5DEie.isIndexableObject)(candidate) && typeof candidate[property] === 'string' ? candidate[property] : undefined;
}
function $24e0e8626c2d0274$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    if (url === undefined) return;
    const { name: name, message: message } = $24e0e8626c2d0274$var$tryToParseMessage(messageObj);
    return {
        name: name,
        message: message,
        stack: [
            {
                url: url,
                column: column,
                line: line
            }
        ]
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
const $24e0e8626c2d0274$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $24e0e8626c2d0274$var$tryToParseMessage(messageObj) {
    let name;
    let message;
    if (({}).toString.call(messageObj) === '[object String]') [, name, message] = $24e0e8626c2d0274$var$ERROR_TYPES_RE.exec(messageObj);
    return {
        name: name,
        message: message
    };
}
// Custom error stacktrace fix
// Some browsers (safari/firefox) add the error constructor as a frame in the stacktrace
// In order to normalize the stacktrace, we need to remove it
function $24e0e8626c2d0274$var$isNonNativeClassPrototype(prototype) {
    return String(prototype.constructor).startsWith('class ');
}
let $24e0e8626c2d0274$var$isWronglyReportingCustomErrorsCache;
function $24e0e8626c2d0274$var$isWronglyReportingCustomErrors() {
    if ($24e0e8626c2d0274$var$isWronglyReportingCustomErrorsCache !== undefined) return $24e0e8626c2d0274$var$isWronglyReportingCustomErrorsCache;
    /* eslint-disable no-restricted-syntax */ class DatadogTestCustomError extends Error {
        constructor(){
            super();
            this.name = 'Error'; // set name to Error so that no browser would default to the constructor name
        }
    }
    const [customError, nativeError] = [
        DatadogTestCustomError,
        Error
    ].map((errConstructor)=>new errConstructor()); // so that both errors should exactly have the same stacktrace
    $24e0e8626c2d0274$var$isWronglyReportingCustomErrorsCache = // If customError is not a class, it means that this was built with ES5 as target, converting the class to a normal object.
    // Thus, error constructors will be reported on all browsers, which is the expected behavior.
    $24e0e8626c2d0274$var$isNonNativeClassPrototype(Object.getPrototypeOf(customError)) && // If the browser is correctly reporting the stacktrace, the normal error stacktrace should be the same as the custom error stacktrace
    nativeError.stack !== customError.stack;
    return $24e0e8626c2d0274$var$isWronglyReportingCustomErrorsCache;
}

});
parcelRegister("5DEie", function(module, exports) {

$parcel$export(module.exports, "getType", () => $41afd9a0399e7c82$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "isIndexableObject", () => $41afd9a0399e7c82$export$e6bfaed68d90ccbd);
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */ function $41afd9a0399e7c82$export$e2b5c5db9e2009fd(value) {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    return typeof value;
}
function $41afd9a0399e7c82$export$e6bfaed68d90ccbd(value) {
    return $41afd9a0399e7c82$export$e2b5c5db9e2009fd(value) === 'object';
}

});


parcelRegister("6q317", function(module, exports) {

$parcel$export(module.exports, "createHandlingStack", () => $4ac782ea9e4e9601$export$46c2cbbc853cd95b);
$parcel$export(module.exports, "toStackTraceString", () => $4ac782ea9e4e9601$export$36ad41d7075a6f2b);
$parcel$export(module.exports, "formatErrorMessage", () => $4ac782ea9e4e9601$export$5201d50a34753d71);

var $2wH3Z = parcelRequire("2wH3Z");

var $3aiPa = parcelRequire("3aiPa");
function $4ac782ea9e4e9601$export$46c2cbbc853cd95b(type) {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */ const internalFramesToSkip = 2;
    const error = new Error(type);
    error.name = 'HandlingStack';
    let formattedStack;
    (0, $2wH3Z.callMonitored)(()=>{
        const stackTrace = (0, $3aiPa.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $4ac782ea9e4e9601$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $4ac782ea9e4e9601$export$36ad41d7075a6f2b(stack) {
    let result = $4ac782ea9e4e9601$export$5201d50a34753d71(stack);
    stack.stack.forEach((frame)=>{
        const func = frame.func === '?' ? '<anonymous>' : frame.func;
        const args = frame.args && frame.args.length > 0 ? `(${frame.args.join(', ')})` : '';
        const line = frame.line ? `:${frame.line}` : '';
        const column = frame.line && frame.column ? `:${frame.column}` : '';
        result += `\n  at ${func}${args} @ ${frame.url}${line}${column}`;
    });
    return result;
}
function $4ac782ea9e4e9601$export$5201d50a34753d71(stack) {
    return `${stack.name || 'Error'}: ${stack.message}`;
}

});


parcelRegister("k2pmh", function(module, exports) {

$parcel$export(module.exports, "ExperimentalFeature", () => $e967aa36fccc7e29$export$8c1a7666d5772525);
$parcel$export(module.exports, "initFeatureFlags", () => $e967aa36fccc7e29$export$f9d0db67c92b2ab2);
$parcel$export(module.exports, "isExperimentalFeatureEnabled", () => $e967aa36fccc7e29$export$ada3eaf101ef7eb6);
$parcel$export(module.exports, "getExperimentalFeatures", () => $e967aa36fccc7e29$export$45a70c97bd86e1c8);
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */ // We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

var $8PiRA = parcelRequire("8PiRA");
var $e967aa36fccc7e29$export$8c1a7666d5772525;
(function(ExperimentalFeature) {
    ExperimentalFeature["TRACK_INTAKE_REQUESTS"] = "track_intake_requests";
    ExperimentalFeature["USE_TREE_WALKER_FOR_ACTION_NAME"] = "use_tree_walker_for_action_name";
    ExperimentalFeature["FEATURE_OPERATION_VITAL"] = "feature_operation_vital";
    ExperimentalFeature["START_STOP_ACTION"] = "start_stop_action";
    ExperimentalFeature["START_STOP_RESOURCE"] = "start_stop_resource";
    ExperimentalFeature["USE_CHANGE_RECORDS"] = "use_change_records";
    ExperimentalFeature["USE_INCREMENTAL_CHANGE_RECORDS"] = "use_incremental_change_records";
    ExperimentalFeature["TOO_MANY_REQUESTS_INVESTIGATION"] = "too_many_requests_investigation";
    ExperimentalFeature["TRACK_RESOURCE_HEADERS"] = "track_resource_headers";
})($e967aa36fccc7e29$export$8c1a7666d5772525 || ($e967aa36fccc7e29$export$8c1a7666d5772525 = {}));
const $e967aa36fccc7e29$var$enabledExperimentalFeatures = new Set();
function $e967aa36fccc7e29$export$f9d0db67c92b2ab2(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) $e967aa36fccc7e29$export$6d36e587aa761763(enableExperimentalFeatures.filter((flag)=>(0, $8PiRA.objectHasValue)($e967aa36fccc7e29$export$8c1a7666d5772525, flag)));
}
function $e967aa36fccc7e29$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach((flag)=>{
        $e967aa36fccc7e29$var$enabledExperimentalFeatures.add(flag);
    });
}
function $e967aa36fccc7e29$export$ada3eaf101ef7eb6(featureName) {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures.has(featureName);
}
function $e967aa36fccc7e29$export$4248398637d8b60d() {
    $e967aa36fccc7e29$var$enabledExperimentalFeatures.clear();
}
function $e967aa36fccc7e29$export$45a70c97bd86e1c8() {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures;
}

});
parcelRegister("8PiRA", function(module, exports) {

$parcel$export(module.exports, "tryJsonParse", () => $66d1b7fd2da44c06$export$cb915d61ff5253f2);
$parcel$export(module.exports, "shallowClone", () => $66d1b7fd2da44c06$export$370e8311c3cdebd9);
$parcel$export(module.exports, "objectHasValue", () => $66d1b7fd2da44c06$export$783ef1184b4cd483);
$parcel$export(module.exports, "isEmptyObject", () => $66d1b7fd2da44c06$export$83b788b1a3698c03);
$parcel$export(module.exports, "mapValues", () => $66d1b7fd2da44c06$export$825e789796ab7275);
function $66d1b7fd2da44c06$export$cb915d61ff5253f2(text) {
    try {
        return JSON.parse(text);
    } catch (_a) {
    // ignore
    }
}
function $66d1b7fd2da44c06$export$370e8311c3cdebd9(object) {
    return {
        ...object
    };
}
function $66d1b7fd2da44c06$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some((key)=>object[key] === value);
}
function $66d1b7fd2da44c06$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $66d1b7fd2da44c06$export$825e789796ab7275(object, fn) {
    const newObject = {};
    for (const key of Object.keys(object))newObject[key] = fn(object[key]);
    return newObject;
}

});


parcelRegister("hBiX7", function(module, exports) {

$parcel$export(module.exports, "buildTags", () => $cd0497f4816fcccb$export$ebabee42db672bb6);
$parcel$export(module.exports, "buildTag", () => $cd0497f4816fcccb$export$4478cda40be33ba2);
$parcel$export(module.exports, "sanitizeTag", () => $cd0497f4816fcccb$export$f478f5145f8a9a3d);

var $5IDGB = parcelRequire("5IDGB");
const $cd0497f4816fcccb$export$4f41fac0b8471c73 = 200;
function $cd0497f4816fcccb$export$ebabee42db672bb6(configuration) {
    const { env: env, service: service, version: version, datacenter: datacenter, sdkVersion: sdkVersion, variant: variant } = configuration;
    const tags = [
        $cd0497f4816fcccb$export$4478cda40be33ba2('sdk_version', sdkVersion !== null && sdkVersion !== void 0 ? sdkVersion : "6.33.0")
    ];
    if (env) tags.push($cd0497f4816fcccb$export$4478cda40be33ba2('env', env));
    if (service) tags.push($cd0497f4816fcccb$export$4478cda40be33ba2('service', service));
    if (version) tags.push($cd0497f4816fcccb$export$4478cda40be33ba2('version', version));
    if (datacenter) tags.push($cd0497f4816fcccb$export$4478cda40be33ba2('datacenter', datacenter));
    if (variant) tags.push($cd0497f4816fcccb$export$4478cda40be33ba2('variant', variant));
    return tags;
}
function $cd0497f4816fcccb$export$4478cda40be33ba2(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    const tag = rawValue ? `${key}:${rawValue}` : key;
    if (tag.length > $cd0497f4816fcccb$export$4f41fac0b8471c73 || $cd0497f4816fcccb$var$hasForbiddenCharacters(tag)) (0, $5IDGB.display).warn(`Tag ${tag} doesn't meet tag requirements and will be sanitized. ${(0, $5IDGB.MORE_DETAILS)} ${(0, $5IDGB.DOCS_ORIGIN)}/getting_started/tagging/#defining-tags`);
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    return $cd0497f4816fcccb$export$f478f5145f8a9a3d(tag);
}
function $cd0497f4816fcccb$export$f478f5145f8a9a3d(tag) {
    return tag.replace(/,/g, '_');
}
function $cd0497f4816fcccb$var$hasForbiddenCharacters(rawValue) {
    // Unicode property escapes is not supported in all browsers, so we use a try/catch.
    // Todo: Remove the try/catch when dropping support for Chrome 63 and Firefox 67
    // see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#browser_compatibility
    if (!$cd0497f4816fcccb$export$a8efa6d27d175125()) return false;
    // We use the Unicode property escapes to match any character that is a letter including other languages like Chinese, Japanese, etc.
    // p{Ll} matches a lowercase letter.
    // p{Lo} matches a letter that is neither uppercase nor lowercase (ex: Japanese characters).
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#unicode_property_escapes_vs._character_classes
    return new RegExp('[^\\p{Ll}\\p{Lo}0-9_:./-]', 'u').test(rawValue);
}
function $cd0497f4816fcccb$export$a8efa6d27d175125() {
    try {
        new RegExp('[\\p{Ll}]', 'u');
        return true;
    } catch (_a) {
        return false;
    }
}

});

parcelRegister("iLlhv", function(module, exports) {

$parcel$export(module.exports, "INTAKE_SITE_STAGING", () => $da8d1fd389131cf5$export$a204b9d5a62f1e2c);
$parcel$export(module.exports, "INTAKE_SITE_FED_STAGING", () => $da8d1fd389131cf5$export$62cc10d94d5ff7fd);
$parcel$export(module.exports, "INTAKE_SITE_US1", () => $da8d1fd389131cf5$export$6b79fd7dd2f5fb9a);
$parcel$export(module.exports, "INTAKE_SITE_EU1", () => $da8d1fd389131cf5$export$7452d85ec570d2ea);
$parcel$export(module.exports, "INTAKE_SITE_US1_FED", () => $da8d1fd389131cf5$export$241ba7106e833c7b);
$parcel$export(module.exports, "INTAKE_SITE_US2_FED", () => $da8d1fd389131cf5$export$aea49056f677f575);
$parcel$export(module.exports, "PCI_INTAKE_HOST_US1", () => $da8d1fd389131cf5$export$e02f42b31d885a8c);
$parcel$export(module.exports, "INTAKE_URL_PARAMETERS", () => $da8d1fd389131cf5$export$e36b5f83de28fc8a);
const $da8d1fd389131cf5$export$a204b9d5a62f1e2c = 'datad0g.com';
const $da8d1fd389131cf5$export$62cc10d94d5ff7fd = 'dd0g-gov.com';
const $da8d1fd389131cf5$export$6b79fd7dd2f5fb9a = 'datadoghq.com';
const $da8d1fd389131cf5$export$7452d85ec570d2ea = 'datadoghq.eu';
const $da8d1fd389131cf5$export$241ba7106e833c7b = 'ddog-gov.com';
const $da8d1fd389131cf5$export$aea49056f677f575 = 'us2.ddog-gov.com';
const $da8d1fd389131cf5$export$e02f42b31d885a8c = 'pci.browser-intake-datadoghq.com';
const $da8d1fd389131cf5$export$e36b5f83de28fc8a = [
    'ddsource',
    'dd-api-key',
    'dd-request-id'
];

});

parcelRegister("4wc1a", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $34a3791423ee474f$export$77cea355fa80b5f4);
$parcel$export(module.exports, "mergeObservables", () => $34a3791423ee474f$export$ca54b410f15f44fe);
$parcel$export(module.exports, "BufferedObservable", () => $34a3791423ee474f$export$c18dc866571e997c);

var $75h88 = parcelRequire("75h88");
class $34a3791423ee474f$export$77cea355fa80b5f4 {
    constructor(onFirstSubscribe){
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    subscribe(observer) {
        this.addObserver(observer);
        return {
            unsubscribe: ()=>this.removeObserver(observer)
        };
    }
    notify(data) {
        this.observers.forEach((observer)=>observer(data));
    }
    addObserver(observer) {
        this.observers.push(observer);
        if (this.observers.length === 1 && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((other)=>observer !== other);
        if (!this.observers.length && this.onLastUnsubscribe) this.onLastUnsubscribe();
    }
}
function $34a3791423ee474f$export$ca54b410f15f44fe(...observables) {
    return new $34a3791423ee474f$export$77cea355fa80b5f4((globalObservable)=>{
        const subscriptions = observables.map((observable)=>observable.subscribe((data)=>globalObservable.notify(data)));
        return ()=>subscriptions.forEach((subscription)=>subscription.unsubscribe());
    });
}
class $34a3791423ee474f$export$c18dc866571e997c extends $34a3791423ee474f$export$77cea355fa80b5f4 {
    constructor(maxBufferSize){
        super();
        this.maxBufferSize = maxBufferSize;
        this.buffer = [];
    }
    notify(data) {
        this.buffer.push(data);
        if (this.buffer.length > this.maxBufferSize) this.buffer.shift();
        super.notify(data);
    }
    subscribe(observer) {
        let closed = false;
        const subscription = {
            unsubscribe: ()=>{
                closed = true;
                this.removeObserver(observer);
            }
        };
        (0, $75h88.queueMicrotask)(()=>{
            for (const data of this.buffer){
                if (closed) return;
                observer(data);
            }
            if (!closed) this.addObserver(observer);
        });
        return subscription;
    }
    /**
     * Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
     * needed anymore. This can be seen as a performance optimization, and things will work probably
     * even if this method isn't called, but still useful to clarify our intent and lowering our
     * memory impact.
     */ unbuffer() {
        (0, $75h88.queueMicrotask)(()=>{
            this.maxBufferSize = this.buffer.length = 0;
        });
    }
}

});
parcelRegister("75h88", function(module, exports) {

$parcel$export(module.exports, "queueMicrotask", () => $528649b71a92b5fc$export$940a1c21a3fba9d1);

var $2wH3Z = parcelRequire("2wH3Z");

var $1sTNW = parcelRequire("1sTNW");
function $528649b71a92b5fc$export$940a1c21a3fba9d1(callback) {
    // Intentionally avoid .bind(globalObject): in some environments (e.g. Selenium GeckoDriver's
    // executeScript), globalThis is not a proper global object, so calling the bound function throws
    // 'queueMicrotask called on an object that does not implement interface Window'. Calling it as an
    // unbound method is fine, as the proper global object will be used implicitly.
    // See https://github.com/mozilla/geckodriver/issues/1798
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const nativeImplementation = (0, $1sTNW.globalObject).queueMicrotask;
    if (typeof nativeImplementation === 'function') nativeImplementation((0, $2wH3Z.monitor)(callback));
    else // eslint-disable-next-line @typescript-eslint/no-floating-promises -- the callback is monitored, so it'll never throw
    Promise.resolve().then((0, $2wH3Z.monitor)(callback));
}

});


parcelRegister("ly0px", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $fafd178883cb17fc$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $fafd178883cb17fc$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $fafd178883cb17fc$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_YEAR", () => $fafd178883cb17fc$export$99cafda57477293d);
$parcel$export(module.exports, "relativeToClocks", () => $fafd178883cb17fc$export$6d554362ef4543f2);
$parcel$export(module.exports, "timeStampToClocks", () => $fafd178883cb17fc$export$1208e92a226eb540);
$parcel$export(module.exports, "getRelativeTime", () => $fafd178883cb17fc$export$493c11ff22f45a24);
$parcel$export(module.exports, "dateNow", () => $fafd178883cb17fc$export$ceae11818251d43c);
$parcel$export(module.exports, "addDuration", () => $fafd178883cb17fc$export$c0c581816dedfc70);
$parcel$export(module.exports, "currentDrift", () => $fafd178883cb17fc$export$5dcf4148298ed557);
$parcel$export(module.exports, "toServerDuration", () => $fafd178883cb17fc$export$cc7917ebd320fa93);
$parcel$export(module.exports, "timeStampNow", () => $fafd178883cb17fc$export$71f52cdbbf629086);
$parcel$export(module.exports, "relativeNow", () => $fafd178883cb17fc$export$53cb631b087d9e92);
$parcel$export(module.exports, "clocksNow", () => $fafd178883cb17fc$export$67898643147706d3);
$parcel$export(module.exports, "clocksOrigin", () => $fafd178883cb17fc$export$d8b428538156d05f);
$parcel$export(module.exports, "elapsed", () => $fafd178883cb17fc$export$e04aa69d28450d55);
$parcel$export(module.exports, "looksLikeRelativeTime", () => $fafd178883cb17fc$export$dc53cd187b19c9f8);

var $bQmeT = parcelRequire("bQmeT");
const $fafd178883cb17fc$export$32c0454ceff7f92d = 1000;
const $fafd178883cb17fc$export$35acaebf644db34e = 60 * $fafd178883cb17fc$export$32c0454ceff7f92d;
const $fafd178883cb17fc$export$82541edf19e5e3b0 = 60 * $fafd178883cb17fc$export$35acaebf644db34e;
const $fafd178883cb17fc$export$a97a1358cbb650ab = 24 * $fafd178883cb17fc$export$82541edf19e5e3b0;
const $fafd178883cb17fc$export$99cafda57477293d = 365 * $fafd178883cb17fc$export$a97a1358cbb650ab;
function $fafd178883cb17fc$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $fafd178883cb17fc$var$getCorrectedTimeStamp(relative)
    };
}
function $fafd178883cb17fc$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $fafd178883cb17fc$export$493c11ff22f45a24(timeStamp),
        timeStamp: timeStamp
    };
}
function $fafd178883cb17fc$var$getCorrectedTimeStamp(relativeTime) {
    const correctedOrigin = $fafd178883cb17fc$export$ceae11818251d43c() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > $fafd178883cb17fc$var$getNavigationStart()) return Math.round($fafd178883cb17fc$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime);
}
function $fafd178883cb17fc$export$5dcf4148298ed557() {
    return Math.round($fafd178883cb17fc$export$ceae11818251d43c() - $fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), performance.now()));
}
function $fafd178883cb17fc$export$cc7917ebd320fa93(duration) {
    if (!(0, $bQmeT.isNumber)(duration)) return duration;
    return (0, $bQmeT.round)(duration * 1e6, 0);
}
function $fafd178883cb17fc$export$ceae11818251d43c() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function $fafd178883cb17fc$export$71f52cdbbf629086() {
    return $fafd178883cb17fc$export$ceae11818251d43c();
}
function $fafd178883cb17fc$export$53cb631b087d9e92() {
    return performance.now();
}
function $fafd178883cb17fc$export$67898643147706d3() {
    return {
        relative: $fafd178883cb17fc$export$53cb631b087d9e92(),
        timeStamp: $fafd178883cb17fc$export$71f52cdbbf629086()
    };
}
function $fafd178883cb17fc$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $fafd178883cb17fc$var$getNavigationStart()
    };
}
function $fafd178883cb17fc$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $fafd178883cb17fc$export$c0c581816dedfc70(a, b) {
    return a + b;
}
function $fafd178883cb17fc$export$493c11ff22f45a24(timestamp) {
    return timestamp - $fafd178883cb17fc$var$getNavigationStart();
}
function $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime) {
    return Math.round($fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), relativeTime));
}
function $fafd178883cb17fc$export$dc53cd187b19c9f8(time) {
    return time < $fafd178883cb17fc$export$99cafda57477293d;
}
/**
 * Navigation start slightly change on some rare cases
 */ let $fafd178883cb17fc$var$navigationStart;
/**
 * Notes: this does not use `performance.timeOrigin` because:
 * - It doesn't seem to reflect the actual time on which the navigation has started: it may be much farther in the past,
 * at least in Firefox 71. (see: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926)
 * - It is not supported in Safari <15
 */ function $fafd178883cb17fc$var$getNavigationStart() {
    var _a, _b;
    if ($fafd178883cb17fc$var$navigationStart === undefined) // ServiceWorkers do not support navigationStart (it's deprecated), so we fallback to timeOrigin
    $fafd178883cb17fc$var$navigationStart = (_b = (_a = performance.timing) === null || _a === void 0 ? void 0 : _a.navigationStart) !== null && _b !== void 0 ? _b : performance.timeOrigin;
    return $fafd178883cb17fc$var$navigationStart;
}

});
parcelRegister("bQmeT", function(module, exports) {

$parcel$export(module.exports, "performDraw", () => $89f5cd41be2839b1$export$72c7afebfef3b500);
$parcel$export(module.exports, "round", () => $89f5cd41be2839b1$export$2077e0241d6afd3c);
$parcel$export(module.exports, "isPercentage", () => $89f5cd41be2839b1$export$d86432a85610ea90);
$parcel$export(module.exports, "isNumber", () => $89f5cd41be2839b1$export$7e4aa119212bc614);
/**
 * Return true if the draw is successful
 *
 * @param threshold - Threshold between 0 and 100
 */ function $89f5cd41be2839b1$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $89f5cd41be2839b1$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $89f5cd41be2839b1$export$d86432a85610ea90(value) {
    return $89f5cd41be2839b1$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $89f5cd41be2839b1$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}

});


parcelRegister("cfGi1", function(module, exports) {

$parcel$export(module.exports, "sendToExtension", () => $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b);

var $1sTNW = parcelRequire("1sTNW");
function $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b(type, payload) {
    const callback = (0, $1sTNW.globalObject).__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}

});

parcelRegister("j9iCm", function(module, exports) {

$parcel$export(module.exports, "deepClone", () => $df0d4cb06c424d45$export$b7d58db314e0ac27);
$parcel$export(module.exports, "combine", () => $df0d4cb06c424d45$export$1be1fc439b849fdf);

var $5DEie = parcelRequire("5DEie");
function $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker = $df0d4cb06c424d45$var$createCircularReferenceChecker()) {
    // ignore the source if it is undefined
    if (source === undefined) return destination;
    if (typeof source !== 'object' || source === null) // primitive values - just return source
    return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) {
        const flags = source.flags || // old browsers compatibility
        [
            source.global ? 'g' : '',
            source.ignoreCase ? 'i' : '',
            source.multiline ? 'm' : '',
            source.sticky ? 'y' : '',
            source.unicode ? 'u' : ''
        ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) // remove circular references
    return undefined;
    else if (Array.isArray(source)) {
        const merged = Array.isArray(destination) ? destination : [];
        for(let i = 0; i < source.length; ++i)merged[i] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged[i], source[i], circularReferenceChecker);
        return merged;
    }
    const merged = (0, $5DEie.getType)(destination) === 'object' ? destination : {};
    for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key)) merged[key] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged[key], source[key], circularReferenceChecker);
    return merged;
}
function $df0d4cb06c424d45$export$b7d58db314e0ac27(value) {
    return $df0d4cb06c424d45$export$f00f2bc10b5384e6(undefined, value);
}
function $df0d4cb06c424d45$export$1be1fc439b849fdf(...sources) {
    let destination;
    for (const source of sources){
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $df0d4cb06c424d45$var$createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        const set = new WeakSet();
        return {
            hasAlreadyBeenSeen (value) {
                const has = set.has(value);
                if (!has) set.add(value);
                return has;
            }
        };
    }
    const array = [];
    return {
        hasAlreadyBeenSeen (value) {
            const has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}

});

parcelRegister("82OHb", function(module, exports) {

$parcel$export(module.exports, "getConnectivity", () => $5db5d5af84f5318f$export$5c86d3b16901f3ce);

var $1sTNW = parcelRequire("1sTNW");
function $5db5d5af84f5318f$export$5c86d3b16901f3ce() {
    var _a;
    const navigator = (0, $1sTNW.globalObject).navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [
            navigator.connection.type
        ] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
    };
}

});

parcelRegister("kFaIT", function(module, exports) {

$parcel$export(module.exports, "getEventBridge", () => $f0aff45a57046ce0$export$86c8e1e7efd0dfc1);
$parcel$export(module.exports, "bridgeSupports", () => $f0aff45a57046ce0$export$c3d8d1f8445a3630);
$parcel$export(module.exports, "canUseEventBridge", () => $f0aff45a57046ce0$export$a8ab916fee43a31b);

var $1sTNW = parcelRequire("1sTNW");
function $f0aff45a57046ce0$export$86c8e1e7efd0dfc1() {
    const eventBridgeGlobal = $f0aff45a57046ce0$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities () {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
        },
        getPrivacyLevel () {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send (eventType, event, viewId) {
            const view = viewId ? {
                id: viewId
            } : undefined;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $f0aff45a57046ce0$export$c3d8d1f8445a3630(capability) {
    const bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getCapabilities().includes(capability);
}
function $f0aff45a57046ce0$export$a8ab916fee43a31b(currentHost) {
    var _a;
    if (currentHost === void 0) currentHost = (_a = (0, $1sTNW.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname;
    const bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getAllowedWebViewHosts().some((allowedHost)=>currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`));
}
function $f0aff45a57046ce0$var$getEventBridgeGlobal() {
    return (0, $1sTNW.getGlobalObject)().DatadogEventBridge;
}

});

parcelRegister("c8B2g", function(module, exports) {

$parcel$export(module.exports, "createBatch", () => $8d62f5e28b135c89$export$71e68e90ba624b44);

var $5IDGB = parcelRequire("5IDGB");

var $fkj4Q = parcelRequire("fkj4Q");

var $70xdd = parcelRequire("70xdd");

var $1W8NF = parcelRequire("1W8NF");

var $7S2uk = parcelRequire("7S2uk");
const $8d62f5e28b135c89$export$187bee24de14bef = 256 * (0, $7S2uk.ONE_KIBI_BYTE);
function $8d62f5e28b135c89$export$71e68e90ba624b44({ encoder: encoder, request: request, flushController: flushController }) {
    let upsertBuffer = {};
    const flushSubscription = flushController.flushObservable.subscribe((event)=>flush(event));
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        } else encoder.write(encoder.isEmpty ? serializedMessage : `\n${serializedMessage}`, (realMessageBytesCount)=>{
            flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
        });
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        const removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        const messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        const serializedMessage = (0, $1W8NF.jsonStringify)(message);
        const estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= $8d62f5e28b135c89$export$187bee24de14bef) {
            (0, $5IDGB.display).warn(`Discarded a message whose size was bigger than the maximum allowed size ${$8d62f5e28b135c89$export$187bee24de14bef / (0, $7S2uk.ONE_KIBI_BYTE)}KiB. ${(0, $5IDGB.MORE_DETAILS)} ${(0, $5IDGB.DOCS_TROUBLESHOOTING)}/#technical-limitations`);
            return;
        }
        if (hasMessageFor(key)) remove(key);
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        const upsertMessages = (0, $fkj4Q.objectValues)(upsertBuffer).join('\n');
        upsertBuffer = {};
        const pageMightExit = (0, $70xdd.isPageExitReason)(event.reason);
        const send = pageMightExit ? request.sendOnExit : request.send;
        if (pageMightExit && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
        // if the encoder is async we need to send two requests in some cases (one for encoded data
        // and the other for non-encoded data). But if it's not async, we don't have to worry about
        // it and always send a single request.
        encoder.isAsync) {
            const encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult));
            // Send messages that are not yet encoded at this point
            const pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join('\n');
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $7S2uk.computeBytesCount)(pendingMessages)
            });
        } else {
            if (upsertMessages) encoder.write(encoder.isEmpty ? upsertMessages : `\n${upsertMessages}`);
            encoder.finish((encoderResult)=>{
                send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController: flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe
    };
}
function $8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult) {
    let data;
    if (typeof encoderResult.output === 'string') data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        // This will set the 'Content-Type: text/plain' header. Reasoning:
        // * The intake rejects the request if there is no content type.
        // * The browser will issue CORS preflight requests if we set it to 'application/json', which
        // could induce higher intake load (and maybe has other impacts).
        // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
        // new lines.
        type: 'text/plain'
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding
    };
}

});
parcelRegister("fkj4Q", function(module, exports) {

$parcel$export(module.exports, "findLast", () => $b287859a2cd2eacd$export$296de88ccac4bedb);
$parcel$export(module.exports, "objectValues", () => $b287859a2cd2eacd$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "objectEntries", () => $b287859a2cd2eacd$export$6a29ade99f81ec8a);
function $b287859a2cd2eacd$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i -= 1){
        const item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $b287859a2cd2eacd$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $b287859a2cd2eacd$export$6a29ade99f81ec8a(object) {
    return Object.entries(object);
}

});

parcelRegister("70xdd", function(module, exports) {

$parcel$export(module.exports, "PageExitReason", () => $51a24bb5553b555d$export$69c8658089134213);
$parcel$export(module.exports, "createPageMayExitObservable", () => $51a24bb5553b555d$export$c59fbb34be0ea4a);
$parcel$export(module.exports, "isPageExitReason", () => $51a24bb5553b555d$export$cbb6b5cdbd0f2b60);

var $4wc1a = parcelRequire("4wc1a");

var $fkj4Q = parcelRequire("fkj4Q");

var $1sTNW = parcelRequire("1sTNW");

var $hXhfS = parcelRequire("hXhfS");
const $51a24bb5553b555d$export$69c8658089134213 = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen'
};
function $51a24bb5553b555d$export$c59fbb34be0ea4a(configuration) {
    return new (0, $4wc1a.Observable)((observable)=>{
        if (0, $1sTNW.isWorkerEnvironment) // Page exit is not observable in worker environments (no window/document events)
        return;
        const { stop: stopListeners } = (0, $hXhfS.addEventListeners)(configuration, window, [
            "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
            "freeze" /* DOM_EVENT.FREEZE */ 
        ], (event)=>{
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */  && document.visibilityState === 'hidden') /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */ observable.notify({
                reason: $51a24bb5553b555d$export$69c8658089134213.HIDDEN
            });
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */ observable.notify({
                reason: $51a24bb5553b555d$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        });
        const stopBeforeUnloadListener = (0, $hXhfS.addEventListener)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */ , ()=>{
            observable.notify({
                reason: $51a24bb5553b555d$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return ()=>{
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $51a24bb5553b555d$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $fkj4Q.objectValues)($51a24bb5553b555d$export$69c8658089134213).includes(reason);
}

});
parcelRegister("hXhfS", function(module, exports) {

$parcel$export(module.exports, "addEventListener", () => $d12554daef4f5e60$export$3f65cefe8380dbea);
$parcel$export(module.exports, "addEventListeners", () => $d12554daef4f5e60$export$40a4ed63e5cb7043);

var $2wH3Z = parcelRequire("2wH3Z");

var $5sf7S = parcelRequire("5sf7S");
function $d12554daef4f5e60$export$3f65cefe8380dbea(configuration, eventTarget, eventName, listener, options) {
    return $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, [
        eventName
    ], listener, options);
}
function $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, eventNames, listener, { once: once, capture: capture, passive: passive } = {}) {
    const listenerWithMonitor = (0, $2wH3Z.monitor)((event)=>{
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) return;
        if (once) stop();
        listener(event);
    });
    const options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    // Use the window.EventTarget.prototype when possible to avoid wrong overrides (e.g: https://github.com/salesforce/lwc/issues/1824)
    const listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
    const add = (0, $5sf7S.getZoneJsOriginalValue)(listenerTarget, 'addEventListener');
    eventNames.forEach((eventName)=>add.call(eventTarget, eventName, listenerWithMonitor, options));
    function stop() {
        const remove = (0, $5sf7S.getZoneJsOriginalValue)(listenerTarget, 'removeEventListener');
        eventNames.forEach((eventName)=>remove.call(eventTarget, eventName, listenerWithMonitor, options));
    }
    return {
        stop: stop
    };
}

});



parcelRegister("cETgK", function(module, exports) {

$parcel$export(module.exports, "createFlushController", () => $937417c8633ccd25$export$afc20ff9bd852d2b);

var $1sTNW = parcelRequire("1sTNW");

var $4wc1a = parcelRequire("4wc1a");

var $d97UU = parcelRequire("d97UU");

var $ly0px = parcelRequire("ly0px");

var $3qksw = parcelRequire("3qksw");
const $937417c8633ccd25$export$dedca8af5f86b2c = 30 * (0, $ly0px.ONE_SECOND);
const $937417c8633ccd25$export$7ee84a9580ca1c30 = (0, $1sTNW.isWorkerEnvironment) ? 1 : 50;
function $937417c8633ccd25$export$afc20ff9bd852d2b({ pageMayExitObservable: pageMayExitObservable, sessionExpireObservable: sessionExpireObservable }) {
    let forcedFlushReason;
    const preparePageExitFlushObservable = new (0, $4wc1a.Observable)();
    const pageMayExitSubscription = pageMayExitObservable.subscribe((event)=>{
        forcedFlushReason = event.reason;
        try {
            preparePageExitFlushObservable.notify(event.reason);
        } finally{
            forcedFlushReason = undefined;
        }
        flush(event.reason);
    });
    const sessionExpireSubscription = sessionExpireObservable.subscribe(()=>flush('session_expire'));
    const flushObservable = new (0, $4wc1a.Observable)(()=>()=>{
            pageMayExitSubscription.unsubscribe();
            sessionExpireSubscription.unsubscribe();
        });
    let currentBytesCount = 0;
    let currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        const messagesCount = currentMessagesCount;
        const bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    let durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) durationLimitTimeoutId = (0, $d97UU.setTimeout)(()=>{
            flush('duration_limit');
        }, $937417c8633ccd25$export$dedca8af5f86b2c);
    }
    function cancelDurationLimitTimeout() {
        (0, $d97UU.clearTimeout)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        preparePageExitFlushObservable: preparePageExitFlushObservable,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount - an estimation of the message bytes count once it is
         * actually added.
         */ notifyBeforeAddMessage (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= (0, $3qksw.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush(forcedFlushReason !== null && forcedFlushReason !== void 0 ? forcedFlushReason : 'bytes_limit');
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff - the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */ notifyAfterAddMessage (messageBytesCountDiff = 0) {
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= $937417c8633ccd25$export$7ee84a9580ca1c30) flush(forcedFlushReason !== null && forcedFlushReason !== void 0 ? forcedFlushReason : 'messages_limit');
            else if (currentBytesCount >= (0, $3qksw.RECOMMENDED_REQUEST_BYTES_LIMIT)) flush(forcedFlushReason !== null && forcedFlushReason !== void 0 ? forcedFlushReason : 'bytes_limit');
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount - the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */ notifyAfterRemoveMessage (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) cancelDurationLimitTimeout();
        }
    };
}

});
parcelRegister("3qksw", function(module, exports) {

$parcel$export(module.exports, "RECOMMENDED_REQUEST_BYTES_LIMIT", () => $27e3ab8a1341cab4$export$4c94f4312ed62ea6);
$parcel$export(module.exports, "createHttpRequest", () => $27e3ab8a1341cab4$export$58d47321b4325073);

var $7NaKU = parcelRequire("7NaKU");

var $2wH3Z = parcelRequire("2wH3Z");

var $4wc1a = parcelRequire("4wc1a");

var $7S2uk = parcelRequire("7S2uk");

var $4WwWt = parcelRequire("4WwWt");
const $27e3ab8a1341cab4$export$4c94f4312ed62ea6 = 16 * (0, $7S2uk.ONE_KIBI_BYTE);
function $27e3ab8a1341cab4$export$58d47321b4325073(endpointBuilders, reportError, bytesLimit = $27e3ab8a1341cab4$export$4c94f4312ed62ea6) {
    const observable = new (0, $4wc1a.Observable)();
    const retryState = (0, $4WwWt.newRetryState)();
    return {
        observable: observable,
        send: (payload)=>{
            for (const endpointBuilder of endpointBuilders)(0, $4WwWt.sendWithRetryStrategy)(payload, retryState, (payload, onResponse)=>{
                $27e3ab8a1341cab4$export$ba55352ffa668a55(endpointBuilder, payload, onResponse);
            }, endpointBuilder.trackType, reportError, observable);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */ sendOnExit: (payload)=>{
            for (const endpointBuilder of endpointBuilders)$27e3ab8a1341cab4$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        }
    };
}
function $27e3ab8a1341cab4$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
    const canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) try {
        const beaconUrl = endpointBuilder.build('beacon', payload);
        const isQueued = navigator.sendBeacon(beaconUrl, payload.data);
        if (isQueued) return;
    } catch (e) {
        $27e3ab8a1341cab4$var$reportBeaconError(e);
    }
    $27e3ab8a1341cab4$export$ba55352ffa668a55(endpointBuilder, payload);
}
let $27e3ab8a1341cab4$var$hasReportedBeaconError = false;
function $27e3ab8a1341cab4$var$reportBeaconError(e) {
    if (!$27e3ab8a1341cab4$var$hasReportedBeaconError) {
        $27e3ab8a1341cab4$var$hasReportedBeaconError = true;
        (0, $2wH3Z.monitorError)(e);
    }
}
function $27e3ab8a1341cab4$export$ba55352ffa668a55(endpointBuilder, payload, onResponse) {
    const fetchUrl = endpointBuilder.build('fetch', payload);
    (0, $7NaKU.fetch)(fetchUrl, {
        method: 'POST',
        body: payload.data,
        mode: 'cors'
    }).then((0, $2wH3Z.monitor)((response)=>onResponse === null || onResponse === void 0 ? void 0 : onResponse({
            status: response.status,
            type: response.type
        }))).catch((0, $2wH3Z.monitor)(()=>onResponse === null || onResponse === void 0 ? void 0 : onResponse({
            status: 0
        })));
}

});
parcelRegister("7NaKU", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $5ac573de9ab9f9a6$export$e7aa7bc5c1b3cfb3);

var $5sf7S = parcelRequire("5sf7S");

var $1sTNW = parcelRequire("1sTNW");
function $5ac573de9ab9f9a6$export$e7aa7bc5c1b3cfb3(input, init) {
    return (0, $5sf7S.getZoneJsOriginalValue)((0, $1sTNW.getGlobalObject)(), 'fetch')(input, init);
}

});

parcelRegister("4WwWt", function(module, exports) {

$parcel$export(module.exports, "sendWithRetryStrategy", () => $399621d7cfb3f6e5$export$96c9f5ab1844e401);
$parcel$export(module.exports, "newRetryState", () => $399621d7cfb3f6e5$export$1663dd4904e17e74);

var $d97UU = parcelRequire("d97UU");

var $ly0px = parcelRequire("ly0px");

var $7S2uk = parcelRequire("7S2uk");

var $8yLbx = parcelRequire("8yLbx");

var $1zKlK = parcelRequire("1zKlK");
const $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 = 80 * (0, $7S2uk.ONE_KIBI_BYTE);
const $399621d7cfb3f6e5$export$86ca45574dbc49bd = 32;
const $399621d7cfb3f6e5$export$5557f582a01f898f = 20 * (0, $7S2uk.ONE_MEBI_BYTE);
const $399621d7cfb3f6e5$export$ba196f7860333423 = (0, $ly0px.ONE_MINUTE);
const $399621d7cfb3f6e5$export$c3914d5086178577 = (0, $ly0px.ONE_SECOND);
function $399621d7cfb3f6e5$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus === 0 /* TransportStatus.UP */  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, requestObservable, {
        onSuccess: ()=>$399621d7cfb3f6e5$var$retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */ , state, sendStrategy, trackType, reportError, requestObservable),
        onFailure: ()=>{
            if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
                type: 'queue-full',
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
        }
    });
    else if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
        type: 'queue-full',
        bandwidth: state.bandwidthMonitor.stats(),
        payload: payload
    });
}
function $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */ ) return;
    (0, $d97UU.setTimeout)(()=>{
        const payload = state.queuedPayloads.first();
        $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, requestObservable, {
            onSuccess: ()=>{
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $399621d7cfb3f6e5$export$c3914d5086178577;
                $399621d7cfb3f6e5$var$retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */ , state, sendStrategy, trackType, reportError, requestObservable);
            },
            onFailure: ()=>{
                state.currentBackoffTime = Math.min($399621d7cfb3f6e5$export$ba196f7860333423, state.currentBackoffTime * 2);
                $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
            }
        });
    }, state.currentBackoffTime);
}
function $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, requestObservable, { onSuccess: onSuccess, onFailure: onFailure }) {
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, (response)=>{
        state.bandwidthMonitor.remove(payload);
        if (!$399621d7cfb3f6e5$var$shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */ ;
            requestObservable.notify({
                type: 'success',
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onSuccess();
        } else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */  : 2 /* TransportStatus.DOWN */ ;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            requestObservable.notify({
                type: 'failure',
                bandwidth: state.bandwidthMonitor.stats(),
                payload: payload
            });
            onFailure();
        }
    });
}
function $399621d7cfb3f6e5$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError, requestObservable) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */  && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: `Reached max ${trackType} events size queued for upload: ${$399621d7cfb3f6e5$export$5557f582a01f898f / (0, $7S2uk.ONE_MEBI_BYTE)}MiB`,
            source: (0, $1zKlK.ErrorSource).AGENT,
            startClocks: (0, $ly0px.clocksNow)()
        });
        state.queueFullReported = true;
    }
    const previousQueue = state.queuedPayloads;
    state.queuedPayloads = $399621d7cfb3f6e5$var$newPayloadQueue();
    while(previousQueue.size() > 0)$399621d7cfb3f6e5$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError, requestObservable);
}
function $399621d7cfb3f6e5$var$shouldRetryRequest(response) {
    return response.type !== 'opaque' && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $8yLbx.isServerError)(response.status));
}
function $399621d7cfb3f6e5$export$1663dd4904e17e74() {
    return {
        transportStatus: 0 /* TransportStatus.UP */ ,
        currentBackoffTime: $399621d7cfb3f6e5$export$c3914d5086178577,
        bandwidthMonitor: $399621d7cfb3f6e5$var$newBandwidthMonitor(),
        queuedPayloads: $399621d7cfb3f6e5$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $399621d7cfb3f6e5$var$newPayloadQueue() {
    const queue = [];
    return {
        bytesCount: 0,
        enqueue (payload) {
            if (this.isFull()) return false;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
            return true;
        },
        first () {
            return queue[0];
        },
        dequeue () {
            const payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size () {
            return queue.length;
        },
        isFull () {
            return this.bytesCount >= $399621d7cfb3f6e5$export$5557f582a01f898f;
        }
    };
}
function $399621d7cfb3f6e5$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle (payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < $399621d7cfb3f6e5$export$86ca45574dbc49bd;
        },
        add (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
        stats () {
            return {
                ongoingByteCount: this.ongoingByteCount,
                ongoingRequestCount: this.ongoingRequestCount
            };
        }
    };
}

});
parcelRegister("8yLbx", function(module, exports) {

$parcel$export(module.exports, "isServerError", () => $63b619b5581ec78b$export$a7cbe72d7c4012af);
$parcel$export(module.exports, "tryToClone", () => $63b619b5581ec78b$export$8a0df03d5faeada4);
function $63b619b5581ec78b$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $63b619b5581ec78b$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch (_a) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}

});

parcelRegister("1zKlK", function(module, exports) {

$parcel$export(module.exports, "ErrorSource", () => $125d036ad0d2a2af$export$4f7d2dba9330699b);
const $125d036ad0d2a2af$export$4f7d2dba9330699b = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report'
};

});




parcelRegister("lTIYX", function(module, exports) {

$parcel$export(module.exports, "createIdentityEncoder", () => $ff11a0928c846f93$export$b5341466c7007825);

var $7S2uk = parcelRequire("7S2uk");
function $ff11a0928c846f93$export$b5341466c7007825() {
    let output = '';
    let outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write (data, callback) {
            const additionalEncodedBytesCount = (0, $7S2uk.computeBytesCount)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish (callback) {
            callback(this.finishSync());
        },
        finishSync () {
            const result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ''
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount (data) {
            return data.length;
        }
    };
}

});

parcelRegister("i3LOd", function(module, exports) {

$parcel$export(module.exports, "DISCARDED", () => $d25d97ad68f49cdc$export$c8e0478a0e0003f8);
$parcel$export(module.exports, "SKIPPED", () => $d25d97ad68f49cdc$export$bbe2f08ef1e830d8);
$parcel$export(module.exports, "abstractHooks", () => $d25d97ad68f49cdc$export$89e467f85ac4cc90);

var $j9iCm = parcelRequire("j9iCm");
const $d25d97ad68f49cdc$export$c8e0478a0e0003f8 = 'DISCARDED';
const $d25d97ad68f49cdc$export$bbe2f08ef1e830d8 = 'SKIPPED';
function $d25d97ad68f49cdc$export$89e467f85ac4cc90() {
    const callbacks = {};
    return {
        register (hookName, callback) {
            if (!callbacks[hookName]) callbacks[hookName] = [];
            callbacks[hookName].push(callback);
            return {
                unregister: ()=>{
                    callbacks[hookName] = callbacks[hookName].filter((cb)=>cb !== callback);
                }
            };
        },
        triggerHook (hookName, param) {
            const hookCallbacks = callbacks[hookName] || [];
            const results = [];
            for (const callback of hookCallbacks){
                const result = callback(param);
                if (result === $d25d97ad68f49cdc$export$c8e0478a0e0003f8) return $d25d97ad68f49cdc$export$c8e0478a0e0003f8;
                if (result === $d25d97ad68f49cdc$export$bbe2f08ef1e830d8) continue;
                results.push(result);
            }
            return (0, $j9iCm.combine)(...results);
        }
    };
}

});

parcelRegister("1RGSv", function(module, exports) {

$parcel$export(module.exports, "TelemetryType", () => $15bc0061a7f329ff$export$8c1a12d9d019b209);
const $15bc0061a7f329ff$export$8c1a12d9d019b209 = {
    LOG: 'log',
    CONFIGURATION: 'configuration',
    USAGE: 'usage'
};

});


parcelRegister("7v3G2", function(module, exports) {

$parcel$export(module.exports, "CustomerContextKey", () => $575e47d2545170b2$export$a18622daaa394f17);
$parcel$export(module.exports, "ContextManagerMethod", () => $575e47d2545170b2$export$cb7fa5be07ff81f4);
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
const $575e47d2545170b2$export$a18622daaa394f17 = {
    userContext: 'userContext',
    globalContext: 'globalContext',
    accountContext: 'accountContext'
};
const $575e47d2545170b2$export$cb7fa5be07ff81f4 = {
    getContext: 'getContext',
    setContext: 'setContext',
    setContextProperty: 'setContextProperty',
    removeContextProperty: 'removeContextProperty',
    clearContext: 'clearContext'
};

});

parcelRegister("95XVG", function(module, exports) {

$parcel$export(module.exports, "TrackingConsent", () => $69f3116f372ada5b$export$52745dd8ee2d32b2);
$parcel$export(module.exports, "createTrackingConsentState", () => $69f3116f372ada5b$export$6a999af43d888e18);

var $4wc1a = parcelRequire("4wc1a");
const $69f3116f372ada5b$export$52745dd8ee2d32b2 = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted'
};
function $69f3116f372ada5b$export$6a999af43d888e18(currentConsent) {
    const observable = new (0, $4wc1a.Observable)();
    return {
        tryToInit (trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        update (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted () {
            return currentConsent === $69f3116f372ada5b$export$52745dd8ee2d32b2.GRANTED;
        },
        observable: observable
    };
}

});

parcelRegister("cJkro", function(module, exports) {

$parcel$export(module.exports, "defineContextMethod", () => $94498b1d72c01492$export$288575403fa2adbb);
$parcel$export(module.exports, "bufferContextCalls", () => $94498b1d72c01492$export$3adfc94c48fc5c98);

var $fhNdh = parcelRequire("fhNdh");

var $2wH3Z = parcelRequire("2wH3Z");
function $94498b1d72c01492$export$288575403fa2adbb(getStrategy, contextName, methodName, usage) {
    return (0, $2wH3Z.monitor)((...args)=>{
        if (usage) (0, $fhNdh.addTelemetryUsage)({
            feature: usage
        });
        return getStrategy()[contextName][methodName](...args);
    });
}
function $94498b1d72c01492$export$3adfc94c48fc5c98(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(()=>{
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startResult)=>startResult[name].setContext(context));
    });
}

});

parcelRegister("gurxr", function(module, exports) {

$parcel$export(module.exports, "displayAlreadyInitializedError", () => $c014cf41d8e6d87d$export$b25c854130ebaef9);

var $5IDGB = parcelRequire("5IDGB");
function $c014cf41d8e6d87d$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $5IDGB.display).error(`${sdkName} is already initialized.`);
}

});

parcelRegister("4Umqd", function(module, exports) {

$parcel$export(module.exports, "mockable", () => $392dc8ea87ea1b4b$export$ee85b4ef9d075583);
const $392dc8ea87ea1b4b$export$2c5261ee1aa257 = new Map();
function $392dc8ea87ea1b4b$export$ee85b4ef9d075583(value) {
    // In production, return the value as-is
    return value;
}

});

parcelRegister("ia9TG", function(module, exports) {

$parcel$export(module.exports, "startBufferingData", () => $d390d682ac092658$export$8be22dc4343dffdd);

var $4wc1a = parcelRequire("4wc1a");

var $4Umqd = parcelRequire("4Umqd");

var $WWr2U = parcelRequire("WWr2U");
const $d390d682ac092658$var$BUFFER_LIMIT = 500;
function $d390d682ac092658$export$8be22dc4343dffdd() {
    const observable = new (0, $4wc1a.BufferedObservable)($d390d682ac092658$var$BUFFER_LIMIT);
    const runtimeErrorSubscription = (0, $4Umqd.mockable)((0, $WWr2U.trackRuntimeError))().subscribe((error)=>{
        observable.notify({
            type: 0 /* BufferedDataType.RUNTIME_ERROR */ ,
            error: error
        });
    });
    return {
        observable: observable,
        stop: ()=>{
            runtimeErrorSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("WWr2U", function(module, exports) {

$parcel$export(module.exports, "trackRuntimeError", () => $0b12bee99c6c13be$export$5f76c2084a9e04d);

var $35a54 = parcelRequire("35a54");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $3aiPa = parcelRequire("3aiPa");

var $1sTNW = parcelRequire("1sTNW");

var $4Be0w = parcelRequire("4Be0w");

var $1zKlK = parcelRequire("1zKlK");
function $0b12bee99c6c13be$export$5f76c2084a9e04d() {
    return new (0, $4wc1a.Observable)((observer)=>{
        const handleRuntimeError = (originalError, stackTrace)=>{
            const rawError = (0, $4Be0w.computeRawError)({
                stackTrace: stackTrace,
                originalError: originalError,
                startClocks: (0, $ly0px.clocksNow)(),
                nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */ ,
                source: (0, $1zKlK.ErrorSource).SOURCE,
                handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
            });
            observer.notify(rawError);
        };
        const { stop: stopInstrumentingOnError } = $0b12bee99c6c13be$export$f636584f9e54fd1(handleRuntimeError);
        const { stop: stopInstrumentingOnUnhandledRejection } = $0b12bee99c6c13be$export$fac10d06c5b5cb33(handleRuntimeError);
        return ()=>{
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        };
    });
}
function $0b12bee99c6c13be$export$f636584f9e54fd1(callback) {
    return (0, $35a54.instrumentMethod)((0, $1sTNW.getGlobalObject)(), 'onerror', ({ parameters: [messageObj, url, line, column, errorObj] })=>{
        let stackTrace;
        if (!(0, $4Be0w.isError)(errorObj)) stackTrace = (0, $3aiPa.computeStackTraceFromOnErrorMessage)(messageObj, url, line, column);
        callback(errorObj !== null && errorObj !== void 0 ? errorObj : messageObj, stackTrace);
    });
}
function $0b12bee99c6c13be$export$fac10d06c5b5cb33(callback) {
    return (0, $35a54.instrumentMethod)((0, $1sTNW.getGlobalObject)(), 'onunhandledrejection', ({ parameters: [e] })=>{
        callback(e.reason || 'Empty reason');
    });
}

});
parcelRegister("35a54", function(module, exports) {

$parcel$export(module.exports, "instrumentMethod", () => $23e9a88fc9385609$export$f00f71a511cb3cac);
$parcel$export(module.exports, "instrumentSetter", () => $23e9a88fc9385609$export$2a2b9a3e88aa9011);

var $d97UU = parcelRequire("d97UU");

var $2wH3Z = parcelRequire("2wH3Z");

var $aed8w = parcelRequire("aed8w");

var $6q317 = parcelRequire("6q317");
function $23e9a88fc9385609$export$f00f71a511cb3cac(targetPrototype, method, onPreCall, { computeHandlingStack: computeHandlingStack } = {}) {
    let original = targetPrototype[method];
    if (typeof original !== 'function') {
        if (method in targetPrototype && typeof method === 'string' && method.startsWith('on')) original = (0, $aed8w.noop);
        else return {
            stop: (0, $aed8w.noop)
        };
    }
    let stopped = false;
    const instrumentation = function() {
        if (stopped) // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return original.apply(this, arguments);
        const parameters = Array.from(arguments);
        let postCallCallback;
        (0, $2wH3Z.callMonitored)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: (callback)=>{
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? (0, $6q317.createHandlingStack)('instrumented method') : undefined
            }
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        const result = original.apply(this, parameters);
        if (postCallCallback) (0, $2wH3Z.callMonitored)(postCallCallback, null, [
            result
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: ()=>{
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) targetPrototype[method] = original;
        }
    };
}
function $23e9a88fc9385609$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    const originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) return {
        stop: (0, $aed8w.noop)
    };
    const stoppedInstrumentation = (0, $aed8w.noop);
    let instrumentation = (target, value)=>{
        // put hooked setter into event loop to avoid of set latency
        (0, $d97UU.setTimeout)(()=>{
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    const instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: ()=>{
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}

});



parcelRegister("hVbxe", function(module, exports) {

$parcel$export(module.exports, "HandlerType", () => $d0c0b52a4da92eb4$export$533bc3391342c4f6);
$parcel$export(module.exports, "STATUSES", () => $d0c0b52a4da92eb4$export$b41c0f52c41112e3);
$parcel$export(module.exports, "Logger", () => $d0c0b52a4da92eb4$export$efa9a398d6368992);

var $hBiX7 = parcelRequire("hBiX7");
var $ly0px = parcelRequire("ly0px");
var $j9iCm = parcelRequire("j9iCm");
var $4Be0w = parcelRequire("4Be0w");
var $el7hs = parcelRequire("el7hs");
var $6q317 = parcelRequire("6q317");
var $1zKlK = parcelRequire("1zKlK");
var $2wH3Z = parcelRequire("2wH3Z");
var $1RdIU = parcelRequire("1RdIU");

var $lkd4w = parcelRequire("lkd4w");

var $lSUlb = parcelRequire("lSUlb");
var $d0c0b52a4da92eb4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d0c0b52a4da92eb4$export$533bc3391342c4f6 = {
    console: 'console',
    http: 'http',
    silent: 'silent'
};
const $d0c0b52a4da92eb4$export$b41c0f52c41112e3 = Object.keys((0, $lkd4w.StatusType));
class $d0c0b52a4da92eb4$export$efa9a398d6368992 {
    constructor(handleLogStrategy, name, handlerType = $d0c0b52a4da92eb4$export$533bc3391342c4f6.http, level = (0, $lkd4w.StatusType).debug, loggerContext = {}){
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0, $el7hs.createContextManager)('logger');
        this.tags = [];
        this.contextManager.setContext(loggerContext);
        if (name) this.contextManager.setContextProperty('logger', {
            name: name
        });
    }
    logImplementation(message, messageContext, status = (0, $lkd4w.StatusType).info, error, handlingStack) {
        const sanitizedMessageContext = (0, $1RdIU.sanitize)(messageContext);
        let context;
        if (error !== undefined && error !== null) {
            const rawError = (0, $4Be0w.computeRawError)({
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $1zKlK.ErrorSource).LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */ ,
                startClocks: (0, $ly0px.clocksNow)()
            });
            context = (0, $j9iCm.combine)({
                error: (0, $lSUlb.createErrorFieldFromRawError)(rawError, {
                    includeMessage: true
                })
            }, rawError.context, sanitizedMessageContext);
        } else context = sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0, $1RdIU.sanitize)(message),
            context: context,
            status: status
        }, this, handlingStack);
    }
    log(message, messageContext, status = (0, $lkd4w.StatusType).info, error) {
        let handlingStack;
        if ((0, $lkd4w.isAuthorized)(status, $d0c0b52a4da92eb4$export$533bc3391342c4f6.http, this)) handlingStack = (0, $6q317.createHandlingStack)('log');
        this.logImplementation(message, messageContext, status, error, handlingStack);
    }
    setContext(context) {
        this.contextManager.setContext(context);
    }
    getContext() {
        return this.contextManager.getContext();
    }
    setContextProperty(key, value) {
        this.contextManager.setContextProperty(key, value);
    }
    removeContextProperty(key) {
        this.contextManager.removeContextProperty(key);
    }
    clearContext() {
        this.contextManager.clearContext();
    }
    addTag(key, value) {
        this.tags.push((0, $hBiX7.buildTag)(key, value));
    }
    removeTagsWithKey(key) {
        const sanitizedKey = (0, $hBiX7.sanitizeTag)(key);
        this.tags = this.tags.filter((tag)=>tag !== sanitizedKey && !tag.startsWith(`${sanitizedKey}:`));
    }
    getTags() {
        return this.tags.slice();
    }
    setHandler(handler) {
        this.handlerType = handler;
    }
    getHandler() {
        return this.handlerType;
    }
    setLevel(level) {
        this.level = level;
    }
    getLevel() {
        return this.level;
    }
}
$d0c0b52a4da92eb4$var$__decorate([
    (0, $2wH3Z.monitored)
], $d0c0b52a4da92eb4$export$efa9a398d6368992.prototype, "logImplementation", null);
/* eslint-disable local-rules/disallow-side-effects */ $d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.ok = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).ok);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.debug = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).debug);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.info = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).info);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.notice = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).notice);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.warn = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).warn);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.error = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).error);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.critical = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).critical);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.alert = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).alert);
$d0c0b52a4da92eb4$export$efa9a398d6368992.prototype.emerg = $d0c0b52a4da92eb4$var$createLoggerMethod((0, $lkd4w.StatusType).emerg);
function $d0c0b52a4da92eb4$var$createLoggerMethod(status) {
    return function(message, messageContext, error) {
        let handlingStack;
        if ((0, $lkd4w.isAuthorized)(status, $d0c0b52a4da92eb4$export$533bc3391342c4f6.http, this)) handlingStack = (0, $6q317.createHandlingStack)('log');
        this.logImplementation(message, messageContext, status, error, handlingStack);
    };
}

});
parcelRegister("el7hs", function(module, exports) {

$parcel$export(module.exports, "createContextManager", () => $a708ac9bed8d6582$export$fe3149b78a43e1ad);

var $j9iCm = parcelRequire("j9iCm");

var $1RdIU = parcelRequire("1RdIU");

var $4wc1a = parcelRequire("4wc1a");

var $5IDGB = parcelRequire("5IDGB");

var $an1dz = parcelRequire("an1dz");
function $a708ac9bed8d6582$var$ensureProperties(context, propertiesConfig, name) {
    const newContext = {
        ...context
    };
    for (const [key, { required: required, type: type }] of Object.entries(propertiesConfig)){
        /**
         * Ensure specified properties are strings as defined here:
         * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
         */ if (type === 'string' && !$a708ac9bed8d6582$var$isDefined(newContext[key])) /* eslint-disable @typescript-eslint/no-base-to-string */ newContext[key] = String(newContext[key]);
        if (required && $a708ac9bed8d6582$var$isDefined(newContext[key])) (0, $5IDGB.display).warn(`The property ${key} of ${name} is required; context will not be sent to the intake.`);
    }
    return newContext;
}
function $a708ac9bed8d6582$var$isDefined(value) {
    return value === undefined || value === null || value === '';
}
function $a708ac9bed8d6582$export$fe3149b78a43e1ad(name = '', { propertiesConfig: propertiesConfig = {} } = {}) {
    let context = {};
    const changeObservable = new (0, $4wc1a.Observable)();
    const contextManager = {
        getContext: ()=>(0, $j9iCm.deepClone)(context),
        setContext: (newContext)=>{
            if ((0, $an1dz.checkContext)(newContext)) context = (0, $1RdIU.sanitize)($a708ac9bed8d6582$var$ensureProperties(newContext, propertiesConfig, name));
            else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: (key, property)=>{
            context = (0, $1RdIU.sanitize)($a708ac9bed8d6582$var$ensureProperties({
                ...context,
                [key]: property
            }, propertiesConfig, name));
            changeObservable.notify();
        },
        removeContextProperty: (key)=>{
            delete context[key];
            $a708ac9bed8d6582$var$ensureProperties(context, propertiesConfig, name);
            changeObservable.notify();
        },
        clearContext: ()=>{
            context = {};
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}

});
parcelRegister("an1dz", function(module, exports) {

$parcel$export(module.exports, "checkContext", () => $78ccff369618a610$export$775b4f8fc598bf34);

var $5IDGB = parcelRequire("5IDGB");

var $5DEie = parcelRequire("5DEie");
function $78ccff369618a610$export$775b4f8fc598bf34(maybeContext) {
    const isValid = (0, $5DEie.getType)(maybeContext) === 'object';
    if (!isValid) (0, $5IDGB.display).error('Unsupported context:', maybeContext);
    return isValid;
}

});


parcelRegister("lkd4w", function(module, exports) {

$parcel$export(module.exports, "isAuthorized", () => $f8659b0fa790815d$export$4f612ab7b7b1d133);
$parcel$export(module.exports, "StatusType", () => $f8659b0fa790815d$export$e35c1996c6f482ad);
function $f8659b0fa790815d$export$4f612ab7b7b1d133(status, handlerType, logger) {
    const loggerHandler = logger.getHandler();
    const sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [
        loggerHandler
    ];
    return $f8659b0fa790815d$export$33137eb87fdcc0f7[status] >= $f8659b0fa790815d$export$33137eb87fdcc0f7[logger.getLevel()] && sanitizedHandlerType.includes(handlerType);
}
const $f8659b0fa790815d$export$e35c1996c6f482ad = {
    ok: 'ok',
    debug: 'debug',
    info: 'info',
    notice: 'notice',
    warn: 'warn',
    error: 'error',
    critical: 'critical',
    alert: 'alert',
    emerg: 'emerg'
};
const $f8659b0fa790815d$export$33137eb87fdcc0f7 = {
    [$f8659b0fa790815d$export$e35c1996c6f482ad.ok]: 0,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.debug]: 1,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.info]: 2,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.notice]: 4,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.warn]: 5,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.error]: 6,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.critical]: 7,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.alert]: 8,
    [$f8659b0fa790815d$export$e35c1996c6f482ad.emerg]: 9
};

});

parcelRegister("lSUlb", function(module, exports) {

$parcel$export(module.exports, "createErrorFieldFromRawError", () => $feea5837c24572b1$export$9acf36e88a596ad);
function $feea5837c24572b1$export$9acf36e88a596ad(rawError, { includeMessage: /**
 * Set this to `true` to include the error message in the error field. In most cases, the error
 * message is already included in the log message, so we don't need to include it again.
 */ includeMessage = false } = {}) {
    return {
        stack: rawError.stack,
        kind: rawError.type,
        message: includeMessage ? rawError.message : undefined,
        causes: rawError.causes,
        fingerprint: rawError.fingerprint,
        handling: rawError.handling
    };
}

});


parcelRegister("iOUkG", function(module, exports) {

$parcel$export(module.exports, "buildCommonContext", () => $db3897fdb576bc57$export$ef57df7b19d2c9ab);

var $1sTNW = parcelRequire("1sTNW");
function $db3897fdb576bc57$export$ef57df7b19d2c9ab() {
    if (0, $1sTNW.isWorkerEnvironment) return {};
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href
        }
    };
}

});

parcelRegister("22u1E", function(module, exports) {

$parcel$export(module.exports, "startLogs", () => $17c30f29b8ea5739$export$660a5342b09224dc);

var $kFaIT = parcelRequire("kFaIT");
var $70xdd = parcelRequire("70xdd");
var $cfGi1 = parcelRequire("cfGi1");
var $aqcpf = parcelRequire("aqcpf");
var $gZP56 = parcelRequire("gZP56");
var $62z74 = parcelRequire("62z74");
var $djpEA = parcelRequire("djpEA");
var $eA1KP = parcelRequire("eA1KP");

var $hO7qg = parcelRequire("hO7qg");

var $EGbAq = parcelRequire("EGbAq");

var $fzjZY = parcelRequire("fzjZY");

var $5NDJ0 = parcelRequire("5NDJ0");

var $hJXJf = parcelRequire("hJXJf");

var $bnyWV = parcelRequire("bnyWV");

var $7QcfF = parcelRequire("7QcfF");

var $f7pcn = parcelRequire("f7pcn");

var $gtZEA = parcelRequire("gtZEA");

var $b4X3T = parcelRequire("b4X3T");

var $bOMs4 = parcelRequire("bOMs4");

var $cgp7x = parcelRequire("cgp7x");

var $j6Koz = parcelRequire("j6Koz");

var $4mPVX = parcelRequire("4mPVX");

var $fCoJ8 = parcelRequire("fCoJ8");
const $17c30f29b8ea5739$var$LOGS_STORAGE_KEY = 'logs';
function $17c30f29b8ea5739$export$660a5342b09224dc(configuration, getCommonContext, // `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, bufferedDataObservable, hooks) {
    const lifeCycle = new (0, $7QcfF.LifeCycle)();
    const cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , (log)=>(0, $cfGi1.sendToExtension)('logs', log));
    const reportError = (0, $cgp7x.startReportError)(lifeCycle);
    const pageMayExitObservable = (0, $70xdd.createPageMayExitObservable)(configuration);
    const session = configuration.sessionStoreStrategyType && !(0, $kFaIT.canUseEventBridge)() && !(0, $eA1KP.willSyntheticsInjectRum)() ? (0, $hO7qg.startLogsSessionManager)(configuration, trackingConsentState) : (0, $hO7qg.startLogsSessionManagerStub)(configuration);
    (0, $fCoJ8.startTrackingConsentContext)(hooks, trackingConsentState);
    // Start user and account context first to allow overrides from global context
    (0, $4mPVX.startSessionContext)(hooks, configuration, session);
    const accountContext = (0, $aqcpf.startAccountContext)(hooks, configuration, $17c30f29b8ea5739$var$LOGS_STORAGE_KEY);
    const userContext = (0, $djpEA.startUserContext)(hooks, configuration, session, $17c30f29b8ea5739$var$LOGS_STORAGE_KEY);
    const globalContext = (0, $gZP56.startGlobalContext)(hooks, configuration, $17c30f29b8ea5739$var$LOGS_STORAGE_KEY, false);
    (0, $j6Koz.startRUMInternalContext)(hooks);
    (0, $62z74.startTabContext)(hooks);
    (0, $hJXJf.startNetworkErrorCollection)(configuration, lifeCycle);
    (0, $bnyWV.startRuntimeErrorCollection)(configuration, lifeCycle, bufferedDataObservable);
    bufferedDataObservable.unbuffer();
    (0, $fzjZY.startConsoleCollection)(configuration, lifeCycle);
    (0, $5NDJ0.startReportCollection)(configuration, lifeCycle);
    const { handleLog: handleLog } = (0, $f7pcn.startLoggerCollection)(lifeCycle);
    (0, $EGbAq.startLogsAssembly)(configuration, lifeCycle, hooks, getCommonContext, reportError);
    if (!(0, $kFaIT.canUseEventBridge)()) {
        const { stop: stopLogsBatch } = (0, $gtZEA.startLogsBatch)(configuration, lifeCycle, reportError, pageMayExitObservable, session);
        cleanupTasks.push(()=>stopLogsBatch());
    } else (0, $b4X3T.startLogsBridge)(lifeCycle);
    const internalContext = (0, $bOMs4.startInternalContext)(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        accountContext: accountContext,
        globalContext: globalContext,
        userContext: userContext,
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        }
    };
}

});
parcelRegister("aqcpf", function(module, exports) {

$parcel$export(module.exports, "startAccountContext", () => $7965f4b7aada6b0c$export$cf2a880268c4528);
$parcel$export(module.exports, "buildAccountContextManager", () => $7965f4b7aada6b0c$export$ce92dcf53cc1a6a);

var $adV8b = parcelRequire("adV8b");

var $i3LOd = parcelRequire("i3LOd");

var $8PiRA = parcelRequire("8PiRA");

var $el7hs = parcelRequire("el7hs");
function $7965f4b7aada6b0c$export$cf2a880268c4528(hooks, configuration, productKey) {
    const accountContextManager = $7965f4b7aada6b0c$export$ce92dcf53cc1a6a();
    if (configuration.storeContextsAcrossPages) (0, $adV8b.storeContextManager)(configuration, accountContextManager, productKey, 4 /* CustomerDataType.Account */ );
    hooks.register(0 /* HookNames.Assemble */ , ()=>{
        const account = accountContextManager.getContext();
        if ((0, $8PiRA.isEmptyObject)(account) || !account.id) return 0, $i3LOd.SKIPPED;
        return {
            account: account
        };
    });
    return accountContextManager;
}
function $7965f4b7aada6b0c$export$ce92dcf53cc1a6a() {
    return (0, $el7hs.createContextManager)('account', {
        propertiesConfig: {
            id: {
                type: 'string',
                required: true
            },
            name: {
                type: 'string'
            }
        }
    });
}

});
parcelRegister("adV8b", function(module, exports) {

$parcel$export(module.exports, "storeContextManager", () => $77176f4fd68bc5cf$export$a658cbc041b124d0);

var $hXhfS = parcelRequire("hXhfS");

var $j9iCm = parcelRequire("j9iCm");

var $8PiRA = parcelRequire("8PiRA");
const $77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX = '_dd_c';
const $77176f4fd68bc5cf$var$storageListeners = [];
function $77176f4fd68bc5cf$export$a658cbc041b124d0(configuration, contextManager, productKey, customerDataType) {
    const storageKey = $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $77176f4fd68bc5cf$var$storageListeners.push((0, $hXhfS.addEventListener)(configuration, window, "storage" /* DOM_EVENT.STORAGE */ , ({ key: key })=>{
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    const contextFromStorage = (0, $j9iCm.combine)(getFromStorage(), contextManager.getContext());
    if (!(0, $8PiRA.isEmptyObject)(contextFromStorage)) contextManager.setContext(contextFromStorage);
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        const rawContext = localStorage.getItem(storageKey);
        return rawContext ? JSON.parse(rawContext) : {};
    }
}
function $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return `${$77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX}_${productKey}_${customerDataType}`;
}
function $77176f4fd68bc5cf$export$c82fd872f963a6c() {
    $77176f4fd68bc5cf$var$storageListeners.map((listener)=>listener.stop());
}

});


parcelRegister("gZP56", function(module, exports) {

$parcel$export(module.exports, "startGlobalContext", () => $c5f9f785f799fe4a$export$79168511affd2fc8);
$parcel$export(module.exports, "buildGlobalContextManager", () => $c5f9f785f799fe4a$export$74c774929829d55);

var $adV8b = parcelRequire("adV8b");

var $el7hs = parcelRequire("el7hs");
function $c5f9f785f799fe4a$export$79168511affd2fc8(hooks, configuration, productKey, useContextNamespace) {
    const globalContextManager = $c5f9f785f799fe4a$export$74c774929829d55();
    if (configuration.storeContextsAcrossPages) (0, $adV8b.storeContextManager)(configuration, globalContextManager, productKey, 2 /* CustomerDataType.GlobalContext */ );
    hooks.register(0 /* HookNames.Assemble */ , ()=>{
        const context = globalContextManager.getContext();
        return useContextNamespace ? {
            context: context
        } : context;
    });
    return globalContextManager;
}
function $c5f9f785f799fe4a$export$74c774929829d55() {
    return (0, $el7hs.createContextManager)('global context');
}

});

parcelRegister("62z74", function(module, exports) {

$parcel$export(module.exports, "startTabContext", () => $465e2ab95874d53e$export$b43e6f92624488b6);

var $99fDv = parcelRequire("99fDv");
const $465e2ab95874d53e$export$ecc65ceb1b2e53fb = '_dd_tab_id';
let $465e2ab95874d53e$var$cachedTabId;
function $465e2ab95874d53e$export$a0f4bfbe864a828e() {
    $465e2ab95874d53e$var$cachedTabId = undefined;
}
function $465e2ab95874d53e$export$b43e6f92624488b6(hooks) {
    const tabId = $465e2ab95874d53e$var$retrieveOrCreateTabId();
    hooks.register(0 /* HookNames.Assemble */ , ()=>({
            tab: {
                id: tabId
            }
        }));
}
function $465e2ab95874d53e$var$retrieveOrCreateTabId() {
    var _a;
    if (!$465e2ab95874d53e$var$cachedTabId) $465e2ab95874d53e$var$cachedTabId = (_a = $465e2ab95874d53e$var$getOrCreateIdInSessionStorage()) !== null && _a !== void 0 ? _a : (0, $99fDv.generateUUID)();
    return $465e2ab95874d53e$var$cachedTabId;
}
function $465e2ab95874d53e$var$getOrCreateIdInSessionStorage() {
    try {
        const existingId = sessionStorage.getItem($465e2ab95874d53e$export$ecc65ceb1b2e53fb);
        if (existingId) return existingId;
        const newId = (0, $99fDv.generateUUID)();
        sessionStorage.setItem($465e2ab95874d53e$export$ecc65ceb1b2e53fb, newId);
        return newId;
    } catch (_a) {
        // sessionStorage unavailable (e.g. Web Worker, sandboxed iframe, quota exceeded)
        return undefined;
    }
}

});
parcelRegister("99fDv", function(module, exports) {

$parcel$export(module.exports, "generateUUID", () => $01b8047924249a5c$export$e73c8bd0f20705a);
$parcel$export(module.exports, "findCommaSeparatedValue", () => $01b8047924249a5c$export$fe87bb5193f3e70);
$parcel$export(module.exports, "findAllCommaSeparatedValues", () => $01b8047924249a5c$export$bdcfc1f2b1056fb7);
$parcel$export(module.exports, "findCommaSeparatedValues", () => $01b8047924249a5c$export$58032b923d63748e);
$parcel$export(module.exports, "safeTruncate", () => $01b8047924249a5c$export$b26462d2f74496cd);
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */ function $01b8047924249a5c$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, $01b8047924249a5c$export$e73c8bd0f20705a);
}
// Assuming input string is following the HTTP Cookie format defined in
// https://www.ietf.org/rfc/rfc2616.txt and https://www.ietf.org/rfc/rfc6265.txt, we don't need to
// be too strict with this regex.
const $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE = /(\S+?)\s*=\s*(.+?)(?:;|$)/g;
function $01b8047924249a5c$export$fe87bb5193f3e70(rawString, name) {
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
function $01b8047924249a5c$export$bdcfc1f2b1056fb7(rawString) {
    const result = new Map();
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            const key = match[1];
            const value = match[2];
            if (result.has(key)) result.get(key).push(value);
            else result.set(key, [
                value
            ]);
        } else break;
    }
    return result;
}
function $01b8047924249a5c$export$58032b923d63748e(rawString) {
    const result = new Map();
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    while(true){
        const match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $01b8047924249a5c$export$b26462d2f74496cd(candidate, length, suffix = '') {
    const lastChar = candidate.charCodeAt(length - 1);
    const isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    const correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return `${candidate.slice(0, correctedLength)}${suffix}`;
}

});


parcelRegister("djpEA", function(module, exports) {

$parcel$export(module.exports, "startUserContext", () => $9b10f2f72e49c175$export$bc474ea3ef4605f1);
$parcel$export(module.exports, "buildUserContextManager", () => $9b10f2f72e49c175$export$aef22fb136f9980c);

var $adV8b = parcelRequire("adV8b");

var $i3LOd = parcelRequire("i3LOd");

var $el7hs = parcelRequire("el7hs");

var $8PiRA = parcelRequire("8PiRA");
function $9b10f2f72e49c175$export$bc474ea3ef4605f1(hooks, configuration, sessionManager, productKey) {
    const userContextManager = $9b10f2f72e49c175$export$aef22fb136f9980c();
    if (configuration.storeContextsAcrossPages) (0, $adV8b.storeContextManager)(configuration, userContextManager, productKey, 1 /* CustomerDataType.User */ );
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType, startTime: startTime })=>{
        const user = userContextManager.getContext();
        const session = sessionManager.findTrackedSession(startTime);
        if (session && session.anonymousId && !user.anonymous_id && !!configuration.trackAnonymousUser) user.anonymous_id = session.anonymousId;
        if ((0, $8PiRA.isEmptyObject)(user)) return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            usr: user
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        var _a;
        return {
            anonymous_id: (_a = sessionManager.findTrackedSession(startTime)) === null || _a === void 0 ? void 0 : _a.anonymousId
        };
    });
    return userContextManager;
}
function $9b10f2f72e49c175$export$aef22fb136f9980c() {
    return (0, $el7hs.createContextManager)('user', {
        propertiesConfig: {
            id: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            email: {
                type: 'string'
            }
        }
    });
}

});

parcelRegister("eA1KP", function(module, exports) {

$parcel$export(module.exports, "willSyntheticsInjectRum", () => $a9d5c9dbe5afd19a$export$749ed8af36cd25e0);
$parcel$export(module.exports, "getSyntheticsContext", () => $a9d5c9dbe5afd19a$export$f36825a638794cc1);
$parcel$export(module.exports, "isSyntheticsTest", () => $a9d5c9dbe5afd19a$export$334d13f0551749);

var $4i26u = parcelRequire("4i26u");

var $1sTNW = parcelRequire("1sTNW");

var $8PiRA = parcelRequire("8PiRA");
const $a9d5c9dbe5afd19a$var$cookieNamePrefix = 'datadog-synthetics-';
const $a9d5c9dbe5afd19a$export$ef391ea72457ea48 = `${$a9d5c9dbe5afd19a$var$cookieNamePrefix}public-id`;
const $a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9 = `${$a9d5c9dbe5afd19a$var$cookieNamePrefix}result-id`;
const $a9d5c9dbe5afd19a$export$c8a0c5680e097130 = `${$a9d5c9dbe5afd19a$var$cookieNamePrefix}injects-rum`;
const $a9d5c9dbe5afd19a$export$bcc1d30e2cefd5e9 = `${$a9d5c9dbe5afd19a$var$cookieNamePrefix}rum-context`;
function $a9d5c9dbe5afd19a$export$749ed8af36cd25e0() {
    if (0, $1sTNW.isWorkerEnvironment) // We don't expect to run synthetics tests in a worker environment
    return false;
    return Boolean((0, $1sTNW.globalObject)._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$c8a0c5680e097130));
}
function $a9d5c9dbe5afd19a$export$f36825a638794cc1() {
    const raw = $a9d5c9dbe5afd19a$var$getRawSyntheticsContext();
    return $a9d5c9dbe5afd19a$var$isValidSyntheticsContext(raw) ? raw : undefined;
}
function $a9d5c9dbe5afd19a$export$334d13f0551749() {
    return Boolean($a9d5c9dbe5afd19a$export$f36825a638794cc1());
}
function $a9d5c9dbe5afd19a$var$getRawSyntheticsContext() {
    const rawGlobal = (0, $1sTNW.globalObject)._DATADOG_SYNTHETICS_RUM_CONTEXT;
    if (rawGlobal) return rawGlobal;
    const rawCookie = (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$bcc1d30e2cefd5e9);
    if (rawCookie) return (0, $8PiRA.tryJsonParse)(decodeURIComponent(rawCookie));
    return {
        test_id: window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$ef391ea72457ea48),
        result_id: window._DATADOG_SYNTHETICS_RESULT_ID || (0, $4i26u.getInitCookie)($a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9)
    };
}
function $a9d5c9dbe5afd19a$var$isValidSyntheticsContext(value) {
    return typeof value === 'object' && value !== null && typeof value.test_id === 'string' && typeof value.result_id === 'string';
}

});
parcelRegister("4i26u", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $31fa799c5ed9e680$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $31fa799c5ed9e680$export$4be65e66cfa2648a);
$parcel$export(module.exports, "getCookies", () => $31fa799c5ed9e680$export$f3eb5caaef7b2b34);
$parcel$export(module.exports, "getInitCookie", () => $31fa799c5ed9e680$export$379e6c34a14280ba);
$parcel$export(module.exports, "areCookiesAuthorized", () => $31fa799c5ed9e680$export$29b13dee24cadcda);
$parcel$export(module.exports, "getCurrentSite", () => $31fa799c5ed9e680$export$8d7fb5ac3c42095);

var $5IDGB = parcelRequire("5IDGB");

var $ly0px = parcelRequire("ly0px");

var $99fDv = parcelRequire("99fDv");

var $bVLiF = parcelRequire("bVLiF");
function $31fa799c5ed9e680$export$110700823644f4a6(name, value, expireDelay = 0, options) {
    const date = new Date();
    date.setTime(date.getTime() + expireDelay);
    const expires = `expires=${date.toUTCString()}`;
    const sameSite = options && options.crossSite ? 'none' : 'strict';
    const domain = options && options.domain ? `;domain=${options.domain}` : '';
    const secure = options && options.secure ? ';secure' : '';
    const partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = `${name}=${value};${expires};path=/;samesite=${sameSite}${domain}${secure}${partitioned}`;
}
function $31fa799c5ed9e680$export$4be65e66cfa2648a(name) {
    return (0, $99fDv.findCommaSeparatedValue)(document.cookie, name);
}
function $31fa799c5ed9e680$export$f3eb5caaef7b2b34(name) {
    return (0, $99fDv.findAllCommaSeparatedValues)(document.cookie).get(name) || [];
}
let $31fa799c5ed9e680$var$initCookieParsed;
function $31fa799c5ed9e680$export$379e6c34a14280ba(name) {
    if (!$31fa799c5ed9e680$var$initCookieParsed) $31fa799c5ed9e680$var$initCookieParsed = (0, $99fDv.findCommaSeparatedValues)(document.cookie);
    return $31fa799c5ed9e680$var$initCookieParsed.get(name);
}
function $31fa799c5ed9e680$export$c97a852288b43516() {
    $31fa799c5ed9e680$var$initCookieParsed = undefined;
}
function $31fa799c5ed9e680$export$b43e45590305ffaa(name, options) {
    $31fa799c5ed9e680$export$110700823644f4a6(name, '', 0, options);
}
function $31fa799c5ed9e680$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        const testCookieName = `dd_cookie_test_${(0, $99fDv.generateUUID)()}`;
        const testCookieValue = 'test';
        $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $ly0px.ONE_MINUTE), options);
        const isCookieCorrectlySet = $31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
        $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, options);
        return isCookieCorrectlySet;
    } catch (error) {
        (0, $5IDGB.display).error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ let $31fa799c5ed9e680$var$getCurrentSiteCache;
function $31fa799c5ed9e680$export$8d7fb5ac3c42095(hostname = location.hostname, referrer = document.referrer) {
    if ($31fa799c5ed9e680$var$getCurrentSiteCache === undefined) {
        const defaultHostName = $31fa799c5ed9e680$var$getCookieDefaultHostName(hostname, referrer);
        if (defaultHostName) {
            // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
            // the test cookie lifetime
            const testCookieName = `dd_site_test_${(0, $99fDv.generateUUID)()}`;
            const testCookieValue = 'test';
            const domainLevels = defaultHostName.split('.');
            let candidateDomain = domainLevels.pop();
            while(domainLevels.length && !$31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName)){
                candidateDomain = `${domainLevels.pop()}.${candidateDomain}`;
                $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $ly0px.ONE_SECOND), {
                    domain: candidateDomain
                });
            }
            $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, {
                domain: candidateDomain
            });
            $31fa799c5ed9e680$var$getCurrentSiteCache = candidateDomain;
        }
    }
    return $31fa799c5ed9e680$var$getCurrentSiteCache;
}
function $31fa799c5ed9e680$var$getCookieDefaultHostName(hostname, referrer) {
    try {
        return hostname || (0, $bVLiF.buildUrl)(referrer).hostname;
    } catch (_a) {
    // Ignore
    }
}
function $31fa799c5ed9e680$export$641a97bd45a185e2() {
    $31fa799c5ed9e680$var$getCurrentSiteCache = undefined;
}

});
parcelRegister("bVLiF", function(module, exports) {

$parcel$export(module.exports, "normalizeUrl", () => $8af9b5626c1bb968$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "buildUrl", () => $8af9b5626c1bb968$export$b5cd97dee32de81d);
$parcel$export(module.exports, "isValidUrl", () => $8af9b5626c1bb968$export$bef94a5618bf18bf);
$parcel$export(module.exports, "getPathName", () => $8af9b5626c1bb968$export$ba1b94ff70383687);

var $1sTNW = parcelRequire("1sTNW");
function $8af9b5626c1bb968$export$6535eb414fa2c8b6(url) {
    return $8af9b5626c1bb968$export$b5cd97dee32de81d(url, location.href).href;
}
function $8af9b5626c1bb968$export$bef94a5618bf18bf(url) {
    try {
        return !!$8af9b5626c1bb968$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $8af9b5626c1bb968$export$ba1b94ff70383687(url) {
    const pathname = $8af9b5626c1bb968$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === '/' ? pathname : `/${pathname}`;
}
function $8af9b5626c1bb968$export$b5cd97dee32de81d(url, base) {
    const { URL: URL } = $8af9b5626c1bb968$export$d5113ba3ff2db2da();
    try {
        return base !== undefined ? new URL(url, base) : new URL(url);
    } catch (error) {
        throw new Error(`Failed to construct URL: ${String(error)}`);
    }
}
/**
 * Get native URL constructor from a clean iframe
 * This avoids polyfill issues by getting the native implementation from a fresh iframe context
 * Falls back to the original URL constructor if iframe approach fails
 */ let $8af9b5626c1bb968$var$getPristineGlobalObjectCache;
function $8af9b5626c1bb968$export$d5113ba3ff2db2da() {
    var _a;
    if (!$8af9b5626c1bb968$var$getPristineGlobalObjectCache) {
        let iframe;
        let pristineWindow;
        try {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            pristineWindow = (_a = iframe.contentWindow) !== null && _a !== void 0 ? _a : (0, $1sTNW.globalObject);
        } catch (_b) {
            pristineWindow = (0, $1sTNW.globalObject);
        }
        $8af9b5626c1bb968$var$getPristineGlobalObjectCache = {
            URL: pristineWindow.URL
        };
        iframe === null || iframe === void 0 || iframe.remove();
    }
    return $8af9b5626c1bb968$var$getPristineGlobalObjectCache;
}

});



parcelRegister("hO7qg", function(module, exports) {

$parcel$export(module.exports, "startLogsSessionManager", () => $cf6cdd27f8c9885e$export$3f8657259c35672b);
$parcel$export(module.exports, "startLogsSessionManagerStub", () => $cf6cdd27f8c9885e$export$272a61c5dde71b62);

var $4wc1a = parcelRequire("4wc1a");
var $bQmeT = parcelRequire("bQmeT");
var $1q2aX = parcelRequire("1q2aX");
const $cf6cdd27f8c9885e$export$c47fdbea9837fd34 = 'logs';
function $cf6cdd27f8c9885e$export$3f8657259c35672b(configuration, trackingConsentState) {
    const sessionManager = (0, $1q2aX.startSessionManager)(configuration, $cf6cdd27f8c9885e$export$c47fdbea9837fd34, (rawTrackingType)=>$cf6cdd27f8c9885e$var$computeTrackingType(configuration, rawTrackingType), trackingConsentState);
    return {
        findTrackedSession: (startTime, options = {
            returnInactive: false
        })=>{
            const session = sessionManager.findSession(startTime, options);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */  ? {
                id: session.id,
                anonymousId: session.anonymousId
            } : undefined;
        },
        expireObservable: sessionManager.expireObservable
    };
}
function $cf6cdd27f8c9885e$export$272a61c5dde71b62(configuration) {
    const isTracked = $cf6cdd27f8c9885e$var$computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */ ;
    const session = isTracked ? {} : undefined;
    return {
        findTrackedSession: ()=>session,
        expireObservable: new (0, $4wc1a.Observable)()
    };
}
function $cf6cdd27f8c9885e$var$computeTrackingType(configuration, rawTrackingType) {
    if ($cf6cdd27f8c9885e$var$hasValidLoggerSession(rawTrackingType)) return rawTrackingType;
    if (!(0, $bQmeT.performDraw)(configuration.sessionSampleRate)) return "0" /* LoggerTrackingType.NOT_TRACKED */ ;
    return "1" /* LoggerTrackingType.TRACKED */ ;
}
function $cf6cdd27f8c9885e$var$hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */  || trackingType === "1" /* LoggerTrackingType.TRACKED */ ;
}

});
parcelRegister("1q2aX", function(module, exports) {

$parcel$export(module.exports, "startSessionManager", () => $1089e830cf773e23$export$3b6b9a4f35a367c5);

var $4wc1a = parcelRequire("4wc1a");

var $80mka = parcelRequire("80mka");

var $ly0px = parcelRequire("ly0px");

var $hXhfS = parcelRequire("hXhfS");

var $d97UU = parcelRequire("d97UU");

var $fhNdh = parcelRequire("fhNdh");

var $eA1KP = parcelRequire("eA1KP");

var $4i26u = parcelRequire("4i26u");

var $5xfjl = parcelRequire("5xfjl");

var $9HnmS = parcelRequire("9HnmS");

var $iyblG = parcelRequire("iyblG");

var $fQ9VW = parcelRequire("fQ9VW");

var $24NU9 = parcelRequire("24NU9");
const $1089e830cf773e23$export$3d1fb0c94cce8478 = (0, $ly0px.ONE_MINUTE);
const $1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
let $1089e830cf773e23$var$stopCallbacks = [];
function $1089e830cf773e23$export$3b6b9a4f35a367c5(configuration, productKey, computeTrackingType, trackingConsentState) {
    const renewObservable = new (0, $4wc1a.Observable)();
    const expireObservable = new (0, $4wc1a.Observable)();
    // TODO - Improve configuration type and remove assertion
    const sessionStore = (0, $9HnmS.startSessionStore)(configuration.sessionStoreStrategyType, configuration, productKey, computeTrackingType);
    $1089e830cf773e23$var$stopCallbacks.push(()=>sessionStore.stop());
    const sessionContextHistory = (0, $80mka.createValueHistory)({
        expireDelay: $1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY
    });
    $1089e830cf773e23$var$stopCallbacks.push(()=>sessionContextHistory.stop());
    sessionStore.renewObservable.subscribe(()=>{
        sessionContextHistory.add(buildSessionContext(), (0, $ly0px.relativeNow)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(()=>{
        expireObservable.notify();
        sessionContextHistory.closeActive((0, $ly0px.relativeNow)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, $ly0px.clocksOrigin)().relative);
    trackingConsentState.observable.subscribe(()=>{
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
        else sessionStore.expire(false);
    });
    $1089e830cf773e23$var$trackActivity(configuration, ()=>{
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
    });
    $1089e830cf773e23$var$trackVisibility(configuration, ()=>sessionStore.expandSession());
    $1089e830cf773e23$var$trackResume(configuration, ()=>sessionStore.restartSession());
    function buildSessionContext() {
        const session = sessionStore.getSession();
        if (!session) {
            $1089e830cf773e23$var$reportUnexpectedSessionState(configuration).catch(()=>void 0); // Ignore errors
            return {
                id: 'invalid',
                trackingType: (0, $5xfjl.SESSION_NOT_TRACKED),
                isReplayForced: false,
                anonymousId: undefined
            };
        }
        return {
            id: session.id,
            trackingType: session[productKey],
            isReplayForced: !!session.forcedReplay,
            anonymousId: session.anonymousId
        };
    }
    return {
        findSession: (startTime, options)=>sessionContextHistory.find(startTime, options),
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState
    };
}
function $1089e830cf773e23$export$c08596f6814fce4f() {
    $1089e830cf773e23$var$stopCallbacks.forEach((e)=>e());
    $1089e830cf773e23$var$stopCallbacks = [];
}
function $1089e830cf773e23$var$trackActivity(configuration, expandOrRenewSession) {
    const { stop: stop } = (0, $hXhfS.addEventListeners)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "scroll" /* DOM_EVENT.SCROLL */ 
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    });
    $1089e830cf773e23$var$stopCallbacks.push(stop);
}
function $1089e830cf773e23$var$trackVisibility(configuration, expandSession) {
    const expandSessionWhenVisible = ()=>{
        if (document.visibilityState === 'visible') expandSession();
    };
    const { stop: stop } = (0, $hXhfS.addEventListener)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ , expandSessionWhenVisible);
    $1089e830cf773e23$var$stopCallbacks.push(stop);
    const visibilityCheckInterval = (0, $d97UU.setInterval)(expandSessionWhenVisible, $1089e830cf773e23$export$3d1fb0c94cce8478);
    $1089e830cf773e23$var$stopCallbacks.push(()=>{
        (0, $d97UU.clearInterval)(visibilityCheckInterval);
    });
}
function $1089e830cf773e23$var$trackResume(configuration, cb) {
    const { stop: stop } = (0, $hXhfS.addEventListener)(configuration, window, "resume" /* DOM_EVENT.RESUME */ , cb, {
        capture: true
    });
    $1089e830cf773e23$var$stopCallbacks.push(stop);
}
async function $1089e830cf773e23$var$reportUnexpectedSessionState(configuration) {
    const sessionStoreStrategyType = configuration.sessionStoreStrategyType;
    if (!sessionStoreStrategyType) return;
    let rawSession;
    let cookieContext;
    if (sessionStoreStrategyType.type === (0, $5xfjl.SessionPersistence).COOKIE) {
        rawSession = (0, $iyblG.retrieveSessionCookie)(sessionStoreStrategyType.cookieOptions, configuration);
        cookieContext = {
            cookie: await $1089e830cf773e23$var$getSessionCookies(),
            currentDomain: `${window.location.protocol}//${window.location.hostname}`
        };
    } else rawSession = (0, $24NU9.retrieveSessionFromLocalStorage)();
    // monitor-until: forever, could be handy to troubleshoot issues until session manager rework
    (0, $fhNdh.addTelemetryDebug)('Unexpected session state', {
        sessionStoreStrategyType: sessionStoreStrategyType.type,
        session: rawSession,
        isSyntheticsTest: (0, $eA1KP.isSyntheticsTest)(),
        createdTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.created,
        expireTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.expire,
        ...cookieContext
    });
}
async function $1089e830cf773e23$var$getSessionCookies() {
    let sessionCookies;
    if ('cookieStore' in window) sessionCookies = await window.cookieStore.getAll((0, $fQ9VW.SESSION_STORE_KEY));
    else sessionCookies = document.cookie.split(/\s*;\s*/).filter((cookie)=>cookie.startsWith((0, $fQ9VW.SESSION_STORE_KEY)));
    return {
        count: sessionCookies.length,
        domain: (0, $4i26u.getCurrentSite)() || 'undefined',
        ...sessionCookies
    };
}

});
parcelRegister("80mka", function(module, exports) {

$parcel$export(module.exports, "createValueHistory", () => $5d3fa3f7dfe2dca0$export$74da638c6075b86);

var $d97UU = parcelRequire("d97UU");

var $lHOXU = parcelRequire("lHOXU");

var $ly0px = parcelRequire("ly0px");
const $5d3fa3f7dfe2dca0$var$END_OF_TIMES = Infinity;
const $5d3fa3f7dfe2dca0$export$7cf440d5901bea64 = (0, $ly0px.ONE_MINUTE);
let $5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval;
const $5d3fa3f7dfe2dca0$var$cleanupTasks = new Set();
function $5d3fa3f7dfe2dca0$var$cleanupHistories() {
    $5d3fa3f7dfe2dca0$var$cleanupTasks.forEach((task)=>task());
}
function $5d3fa3f7dfe2dca0$export$74da638c6075b86({ expireDelay: expireDelay, maxEntries: maxEntries }) {
    let entries = [];
    if (!$5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval) $5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval = (0, $d97UU.setInterval)(()=>$5d3fa3f7dfe2dca0$var$cleanupHistories(), $5d3fa3f7dfe2dca0$export$7cf440d5901bea64);
    const clearExpiredValues = ()=>{
        const oldTimeThreshold = (0, $ly0px.relativeNow)() - expireDelay;
        while(entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold)entries.pop();
    };
    $5d3fa3f7dfe2dca0$var$cleanupTasks.add(clearExpiredValues);
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */ function add(value, startTime) {
        const entry = {
            value: value,
            startTime: startTime,
            endTime: $5d3fa3f7dfe2dca0$var$END_OF_TIMES,
            remove: ()=>{
                (0, $lHOXU.removeItem)(entries, entry);
            },
            close: (endTime)=>{
                entry.endTime = endTime;
            }
        };
        if (maxEntries && entries.length >= maxEntries) entries.pop();
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */ function find(startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES, options = {
        returnInactive: false
    }) {
        for (const entry of entries)if (entry.startTime <= startTime) {
            if (options.returnInactive || startTime <= entry.endTime) return entry.value;
            break;
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */ function closeActive(endTime) {
        const latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === $5d3fa3f7dfe2dca0$var$END_OF_TIMES) latestEntry.close(endTime);
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */ function findAll(startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES, duration = 0) {
        const endTime = (0, $ly0px.addDuration)(startTime, duration);
        return entries.filter((entry)=>entry.startTime <= endTime && startTime <= entry.endTime).map((entry)=>entry.value);
    }
    /**
     * Return all the entries whose start time is equal to the given startTime.
     */ function getEntries(startTime) {
        return entries.filter((entry)=>entry.startTime === startTime);
    }
    /**
     * Remove all entries from this collection.
     */ function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */ function stop() {
        $5d3fa3f7dfe2dca0$var$cleanupTasks.delete(clearExpiredValues);
        if ($5d3fa3f7dfe2dca0$var$cleanupTasks.size === 0 && $5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval) {
            (0, $d97UU.clearInterval)($5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval);
            $5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval = undefined;
        }
    }
    return {
        add: add,
        find: find,
        closeActive: closeActive,
        findAll: findAll,
        getEntries: getEntries,
        reset: reset,
        stop: stop
    };
}
function $5d3fa3f7dfe2dca0$export$9e2c59d8dded439a() {
    $5d3fa3f7dfe2dca0$var$cleanupTasks.clear();
    (0, $d97UU.clearInterval)($5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval);
    $5d3fa3f7dfe2dca0$var$cleanupHistoriesInterval = undefined;
}

});
parcelRegister("lHOXU", function(module, exports) {

$parcel$export(module.exports, "removeDuplicates", () => $fcd525cace9de4ff$export$2e2262a44ac61957);
$parcel$export(module.exports, "removeItem", () => $fcd525cace9de4ff$export$fe2d9b4e03920b4c);
$parcel$export(module.exports, "isNonEmptyArray", () => $fcd525cace9de4ff$export$d307f5934e447d0e);
function $fcd525cace9de4ff$export$2e2262a44ac61957(array) {
    const set = new Set();
    array.forEach((item)=>set.add(item));
    return Array.from(set);
}
function $fcd525cace9de4ff$export$fe2d9b4e03920b4c(array, item) {
    const index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $fcd525cace9de4ff$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("5xfjl", function(module, exports) {

$parcel$export(module.exports, "SESSION_TIME_OUT_DELAY", () => $407be9496e601c3b$export$324def7afe89d7e8);
$parcel$export(module.exports, "SESSION_EXPIRATION_DELAY", () => $407be9496e601c3b$export$481fdd126dba0912);
$parcel$export(module.exports, "SESSION_COOKIE_EXPIRATION_DELAY", () => $407be9496e601c3b$export$39360b0e14efae23);
$parcel$export(module.exports, "SESSION_NOT_TRACKED", () => $407be9496e601c3b$export$b63d4ae1bc652a1b);
$parcel$export(module.exports, "SessionPersistence", () => $407be9496e601c3b$export$6b08240aba869f7e);

var $ly0px = parcelRequire("ly0px");
const $407be9496e601c3b$export$324def7afe89d7e8 = 4 * (0, $ly0px.ONE_HOUR);
const $407be9496e601c3b$export$481fdd126dba0912 = 15 * (0, $ly0px.ONE_MINUTE);
const $407be9496e601c3b$export$39360b0e14efae23 = (0, $ly0px.ONE_YEAR);
const $407be9496e601c3b$export$b63d4ae1bc652a1b = '0';
const $407be9496e601c3b$export$6b08240aba869f7e = {
    COOKIE: 'cookie',
    MEMORY: 'memory',
    LOCAL_STORAGE: 'local-storage'
};

});

parcelRegister("9HnmS", function(module, exports) {

$parcel$export(module.exports, "selectSessionStoreStrategyType", () => $70fa419824414645$export$2ae22598cc9269e0);
$parcel$export(module.exports, "startSessionStore", () => $70fa419824414645$export$99eabf0f32a21670);

var $d97UU = parcelRequire("d97UU");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $aed8w = parcelRequire("aed8w");

var $99fDv = parcelRequire("99fDv");

var $5IDGB = parcelRequire("5IDGB");

var $iyblG = parcelRequire("iyblG");

var $5iH1t = parcelRequire("5iH1t");

var $24NU9 = parcelRequire("24NU9");

var $f8aZL = parcelRequire("f8aZL");

var $5xfjl = parcelRequire("5xfjl");

var $bhz6Z = parcelRequire("bhz6Z");
const $70fa419824414645$export$97790393ff416f6c = (0, $ly0px.ONE_SECOND);
function $70fa419824414645$export$2ae22598cc9269e0(initConfiguration) {
    const { sessionPersistence: sessionPersistence } = initConfiguration;
    const persistenceList = $70fa419824414645$var$normalizePersistenceList(sessionPersistence, initConfiguration);
    for (const persistence of persistenceList){
        const strategyType = $70fa419824414645$var$selectStrategyForPersistence(persistence, initConfiguration);
        if (strategyType !== undefined) return strategyType;
    }
    return undefined;
}
function $70fa419824414645$var$normalizePersistenceList(sessionPersistence, initConfiguration) {
    if (Array.isArray(sessionPersistence)) return sessionPersistence;
    if (sessionPersistence !== undefined) return [
        sessionPersistence
    ];
    // Legacy default behavior: cookie first, with optional localStorage fallback
    return initConfiguration.allowFallbackToLocalStorage ? [
        (0, $5xfjl.SessionPersistence).COOKIE,
        (0, $5xfjl.SessionPersistence).LOCAL_STORAGE
    ] : [
        (0, $5xfjl.SessionPersistence).COOKIE
    ];
}
function $70fa419824414645$var$selectStrategyForPersistence(persistence, initConfiguration) {
    switch(persistence){
        case (0, $5xfjl.SessionPersistence).COOKIE:
            return (0, $iyblG.selectCookieStrategy)(initConfiguration);
        case (0, $5xfjl.SessionPersistence).LOCAL_STORAGE:
            return (0, $24NU9.selectLocalStorageStrategy)();
        case (0, $5xfjl.SessionPersistence).MEMORY:
            return (0, $bhz6Z.selectMemorySessionStoreStrategy)();
        default:
            (0, $5IDGB.display).error(`Invalid session persistence '${String(persistence)}'`);
            return undefined;
    }
}
function $70fa419824414645$export$8a3087d371d1213d(sessionStoreStrategyType, configuration) {
    return sessionStoreStrategyType.type === (0, $5xfjl.SessionPersistence).COOKIE ? (0, $iyblG.initCookieStrategy)(configuration, sessionStoreStrategyType.cookieOptions) : sessionStoreStrategyType.type === (0, $5xfjl.SessionPersistence).LOCAL_STORAGE ? (0, $24NU9.initLocalStorageStrategy)(configuration) : (0, $bhz6Z.initMemorySessionStoreStrategy)(configuration);
}
function $70fa419824414645$export$99eabf0f32a21670(sessionStoreStrategyType, configuration, productKey, computeTrackingType, sessionStoreStrategy = $70fa419824414645$export$8a3087d371d1213d(sessionStoreStrategyType, configuration)) {
    const renewObservable = new (0, $4wc1a.Observable)();
    const expireObservable = new (0, $4wc1a.Observable)();
    const sessionStateUpdateObservable = new (0, $4wc1a.Observable)();
    const watchSessionTimeoutId = (0, $d97UU.setInterval)(watchSession, $70fa419824414645$export$97790393ff416f6c);
    let sessionCache;
    startSession();
    const { throttled: throttledExpandOrRenewSession, cancel: cancelExpandOrRenewSession } = (0, $aed8w.throttle)(()=>{
        (0, $f8aZL.processSessionStoreOperations)({
            process: (sessionState)=>{
                if ((0, $5iH1t.isSessionInNotStartedState)(sessionState)) return;
                const synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: (sessionState)=>{
                if ((0, $5iH1t.isSessionStarted)(sessionState) && !hasSessionInCache()) renewSessionInCache(sessionState);
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }, $70fa419824414645$export$97790393ff416f6c);
    function expandSession() {
        (0, $f8aZL.processSessionStoreOperations)({
            process: (sessionState)=>hasSessionInCache() ? synchronizeSession(sessionState) : undefined
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */ function watchSession() {
        const sessionState = sessionStoreStrategy.retrieveSession();
        if ((0, $5iH1t.isSessionInExpiredState)(sessionState)) (0, $f8aZL.processSessionStoreOperations)({
            process: (sessionState)=>(0, $5iH1t.isSessionInExpiredState)(sessionState) ? (0, $5iH1t.getExpiredSessionState)(sessionState, configuration) : undefined,
            after: synchronizeSession
        }, sessionStoreStrategy);
        else synchronizeSession(sessionState);
    }
    function synchronizeSession(sessionState) {
        if ((0, $5iH1t.isSessionInExpiredState)(sessionState)) sessionState = (0, $5iH1t.getExpiredSessionState)(sessionState, configuration);
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) expireSessionInCache();
            else {
                sessionStateUpdateObservable.notify({
                    previousState: sessionCache,
                    newState: sessionState
                });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        (0, $f8aZL.processSessionStoreOperations)({
            process: (sessionState)=>{
                if ((0, $5iH1t.isSessionInNotStartedState)(sessionState)) {
                    sessionState.anonymousId = (0, $99fDv.generateUUID)();
                    return (0, $5iH1t.getExpiredSessionState)(sessionState, configuration);
                }
            },
            after: (sessionState)=>{
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if ((0, $5iH1t.isSessionInNotStartedState)(sessionState)) return false;
        const trackingType = computeTrackingType(sessionState[productKey]);
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (trackingType !== (0, $5xfjl.SESSION_NOT_TRACKED) && !sessionState.id) {
            sessionState.id = (0, $99fDv.generateUUID)();
            sessionState.created = String((0, $ly0px.dateNow)());
        }
        if (configuration.trackAnonymousUser && !sessionState.anonymousId) sessionState.anonymousId = (0, $99fDv.generateUUID)();
    }
    function hasSessionInCache() {
        return (sessionCache === null || sessionCache === void 0 ? void 0 : sessionCache[productKey]) !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = (0, $5iH1t.getExpiredSessionState)(sessionCache, configuration);
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        (0, $f8aZL.processSessionStoreOperations)({
            process: (sessionState)=>({
                    ...sessionState,
                    ...partialSessionState
                }),
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: ()=>sessionCache,
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStateUpdateObservable,
        restartSession: startSession,
        expire: (hasConsent)=>{
            cancelExpandOrRenewSession();
            if (hasConsent === false && sessionCache) delete sessionCache.anonymousId;
            sessionStoreStrategy.expireSession(sessionCache);
            synchronizeSession((0, $5iH1t.getExpiredSessionState)(sessionCache, configuration));
        },
        stop: ()=>{
            (0, $d97UU.clearInterval)(watchSessionTimeoutId);
        },
        updateSessionState: updateSessionState
    };
}

});
parcelRegister("iyblG", function(module, exports) {

$parcel$export(module.exports, "selectCookieStrategy", () => $d814349331ade12d$export$88fc2ec23ae4ccfd);
$parcel$export(module.exports, "initCookieStrategy", () => $d814349331ade12d$export$96a0082cb9ded337);
$parcel$export(module.exports, "retrieveSessionCookie", () => $d814349331ade12d$export$c60c727ac106716f);

var $8PiRA = parcelRequire("8PiRA");

var $5h91O = parcelRequire("5h91O");

var $4i26u = parcelRequire("4i26u");

var $4DnNL = parcelRequire("4DnNL");

var $5xfjl = parcelRequire("5xfjl");

var $5iH1t = parcelRequire("5iH1t");

var $fQ9VW = parcelRequire("fQ9VW");
const $d814349331ade12d$var$SESSION_COOKIE_VERSION = 0;
function $d814349331ade12d$export$88fc2ec23ae4ccfd(initConfiguration) {
    const cookieOptions = $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration);
    return cookieOptions && (0, $4i26u.areCookiesAuthorized)(cookieOptions) ? {
        type: (0, $5xfjl.SessionPersistence).COOKIE,
        cookieOptions: cookieOptions
    } : undefined;
}
function $d814349331ade12d$export$96a0082cb9ded337(configuration, cookieOptions) {
    const cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */ isLockEnabled: (0, $5h91O.isChromium)(),
        persistSession: (sessionState)=>$d814349331ade12d$var$storeSessionCookie(cookieOptions, configuration, sessionState, (0, $5xfjl.SESSION_EXPIRATION_DELAY)),
        retrieveSession: ()=>$d814349331ade12d$export$c60c727ac106716f(cookieOptions, configuration),
        expireSession: (sessionState)=>$d814349331ade12d$var$storeSessionCookie(cookieOptions, configuration, (0, $5iH1t.getExpiredSessionState)(sessionState, configuration), (0, $5xfjl.SESSION_TIME_OUT_DELAY))
    };
    (0, $4DnNL.tryOldCookiesMigration)(cookieStore);
    return cookieStore;
}
function $d814349331ade12d$var$storeSessionCookie(options, configuration, sessionState, defaultTimeout) {
    let sessionStateString = (0, $5iH1t.toSessionString)(sessionState);
    if (configuration.betaEncodeCookieOptions) sessionStateString = (0, $5iH1t.toSessionString)({
        ...sessionState,
        // deleting a cookie is writing a new cookie with an empty value
        // we don't want to store the cookie options in this case otherwise the cookie will not be deleted
        ...!(0, $8PiRA.isEmptyObject)(sessionState) ? {
            c: $d814349331ade12d$var$encodeCookieOptions(options)
        } : {}
    });
    (0, $4i26u.setCookie)((0, $fQ9VW.SESSION_STORE_KEY), sessionStateString, configuration.trackAnonymousUser ? (0, $5xfjl.SESSION_COOKIE_EXPIRATION_DELAY) : defaultTimeout, options);
}
function $d814349331ade12d$export$c60c727ac106716f(cookieOptions, configuration) {
    if (configuration.betaEncodeCookieOptions) return $d814349331ade12d$var$retrieveSessionCookieFromEncodedCookie(cookieOptions);
    const sessionString = (0, $4i26u.getCookie)((0, $fQ9VW.SESSION_STORE_KEY));
    const sessionState = (0, $5iH1t.toSessionState)(sessionString);
    return sessionState;
}
function $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration) {
    const cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        const currentSite = (0, $4i26u.getCurrentSite)();
        if (!currentSite) return;
        cookieOptions.domain = currentSite;
    }
    return cookieOptions;
}
function $d814349331ade12d$var$encodeCookieOptions(cookieOptions) {
    const domainCount = cookieOptions.domain ? cookieOptions.domain.split('.').length - 1 : 0;
    /* eslint-disable no-bitwise */ let byte = 0;
    byte |= $d814349331ade12d$var$SESSION_COOKIE_VERSION << 5; // Store version in upper 3 bits
    byte |= domainCount << 1; // Store domain count in next 4 bits
    byte |= cookieOptions.crossSite ? 1 : 0; // Store useCrossSiteScripting in next bit
    /* eslint-enable no-bitwise */ return byte.toString(16); // Convert to hex string
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options.
 * If there is no match, fallback to the first cookie, (because that's how `getCookie()` works)
 * and this allows to keep the current session id when we release this feature.
 */ function $d814349331ade12d$var$retrieveSessionCookieFromEncodedCookie(cookieOptions) {
    const cookies = (0, $4i26u.getCookies)((0, $fQ9VW.SESSION_STORE_KEY));
    const opts = $d814349331ade12d$var$encodeCookieOptions(cookieOptions);
    let sessionState;
    // reverse the cookies so that if there is no match, the cookie returned is the first one
    for (const cookie of cookies.reverse()){
        sessionState = (0, $5iH1t.toSessionState)(cookie);
        if (sessionState.c === opts) break;
    }
    // remove the cookie options from the session state as this is not part of the session state
    sessionState === null || sessionState === void 0 || delete sessionState.c;
    return sessionState !== null && sessionState !== void 0 ? sessionState : {};
}

});
parcelRegister("5h91O", function(module, exports) {

$parcel$export(module.exports, "isChromium", () => $3d758b2023765aca$export$dd401a4677e99039);
$parcel$export(module.exports, "isSafari", () => $3d758b2023765aca$export$95df08bae54cb4df);
function $3d758b2023765aca$export$dd401a4677e99039() {
    return $3d758b2023765aca$var$detectBrowserCached() === 0 /* Browser.CHROMIUM */ ;
}
function $3d758b2023765aca$export$95df08bae54cb4df() {
    return $3d758b2023765aca$var$detectBrowserCached() === 1 /* Browser.SAFARI */ ;
}
let $3d758b2023765aca$var$browserCache;
function $3d758b2023765aca$var$detectBrowserCached() {
    return $3d758b2023765aca$var$browserCache !== null && $3d758b2023765aca$var$browserCache !== void 0 ? $3d758b2023765aca$var$browserCache : $3d758b2023765aca$var$browserCache = $3d758b2023765aca$export$2d31490a0c05f094();
}
function $3d758b2023765aca$export$2d31490a0c05f094(browserWindow = window) {
    var _a;
    const userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) return 0 /* Browser.CHROMIUM */ ;
    if (// navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) return 1 /* Browser.SAFARI */ ;
    return 2 /* Browser.OTHER */ ;
}

});

parcelRegister("4DnNL", function(module, exports) {

$parcel$export(module.exports, "tryOldCookiesMigration", () => $35fd447a749f50ce$export$308239c26bbf40d4);

var $4i26u = parcelRequire("4i26u");

var $fQ9VW = parcelRequire("fQ9VW");

var $5iH1t = parcelRequire("5iH1t");
const $35fd447a749f50ce$export$9b0bbb4e1ef88c6d = '_dd';
const $35fd447a749f50ce$export$4231281e64250ad5 = '_dd_r';
const $35fd447a749f50ce$export$381d62e3ee200c01 = '_dd_l';
const $35fd447a749f50ce$export$50ae25e0cd1ada34 = 'rum';
const $35fd447a749f50ce$export$c47fdbea9837fd34 = 'logs';
function $35fd447a749f50ce$export$308239c26bbf40d4(cookieStoreStrategy) {
    const sessionString = (0, $4i26u.getInitCookie)((0, $fQ9VW.SESSION_STORE_KEY));
    if (!sessionString) {
        const oldSessionId = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$9b0bbb4e1ef88c6d);
        const oldRumType = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$4231281e64250ad5);
        const oldLogsType = (0, $4i26u.getInitCookie)($35fd447a749f50ce$export$381d62e3ee200c01);
        const session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$35fd447a749f50ce$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$35fd447a749f50ce$export$50ae25e0cd1ada34] = oldRumType;
        if ((0, $5iH1t.isSessionStarted)(session)) {
            (0, $5iH1t.expandSessionState)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}

});
parcelRegister("fQ9VW", function(module, exports) {

$parcel$export(module.exports, "SESSION_STORE_KEY", () => $b8836af4b2ff7971$export$dce9f2ddeb0efe71);
const $b8836af4b2ff7971$export$dce9f2ddeb0efe71 = '_dd_s';

});

parcelRegister("5iH1t", function(module, exports) {

$parcel$export(module.exports, "getExpiredSessionState", () => $3dc0019fbfe25134$export$551e7155381c0fd);
$parcel$export(module.exports, "isSessionInNotStartedState", () => $3dc0019fbfe25134$export$5ad8724e83865c4);
$parcel$export(module.exports, "isSessionStarted", () => $3dc0019fbfe25134$export$9fbe93df7546a09b);
$parcel$export(module.exports, "isSessionInExpiredState", () => $3dc0019fbfe25134$export$7b5aaa833707368f);
$parcel$export(module.exports, "expandSessionState", () => $3dc0019fbfe25134$export$112e1a1467f7ca28);
$parcel$export(module.exports, "toSessionString", () => $3dc0019fbfe25134$export$df489f56daf61eef);
$parcel$export(module.exports, "toSessionState", () => $3dc0019fbfe25134$export$fa3c08092be8a0e4);

var $8PiRA = parcelRequire("8PiRA");

var $fkj4Q = parcelRequire("fkj4Q");

var $ly0px = parcelRequire("ly0px");

var $5xfjl = parcelRequire("5xfjl");

var $kn1CQ = parcelRequire("kn1CQ");
const $3dc0019fbfe25134$export$4fdc68be9dc4d6b5 = '1';
function $3dc0019fbfe25134$export$551e7155381c0fd(previousSessionState, configuration) {
    const expiredSessionState = {
        isExpired: $3dc0019fbfe25134$export$4fdc68be9dc4d6b5
    };
    if (configuration.trackAnonymousUser && (previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId)) expiredSessionState.anonymousId = previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId;
    return expiredSessionState;
}
function $3dc0019fbfe25134$export$5ad8724e83865c4(session) {
    return (0, $8PiRA.isEmptyObject)(session);
}
function $3dc0019fbfe25134$export$9fbe93df7546a09b(session) {
    return !$3dc0019fbfe25134$export$5ad8724e83865c4(session);
}
function $3dc0019fbfe25134$export$7b5aaa833707368f(session) {
    return session.isExpired !== undefined || !$3dc0019fbfe25134$var$isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function $3dc0019fbfe25134$var$isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return (sessionState.created === undefined || (0, $ly0px.dateNow)() - Number(sessionState.created) < (0, $5xfjl.SESSION_TIME_OUT_DELAY)) && (sessionState.expire === undefined || (0, $ly0px.dateNow)() < Number(sessionState.expire));
}
function $3dc0019fbfe25134$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $ly0px.dateNow)() + (0, $5xfjl.SESSION_EXPIRATION_DELAY));
}
function $3dc0019fbfe25134$export$df489f56daf61eef(session) {
    return (0, $fkj4Q.objectEntries)(session)// we use `aid` as a key for anonymousId
    .map(([key, value])=>key === 'anonymousId' ? `aid=${value}` : `${key}=${value}`).join((0, $kn1CQ.SESSION_ENTRY_SEPARATOR));
}
function $3dc0019fbfe25134$export$fa3c08092be8a0e4(sessionString) {
    const session = {};
    if ((0, $kn1CQ.isValidSessionString)(sessionString)) sessionString.split((0, $kn1CQ.SESSION_ENTRY_SEPARATOR)).forEach((entry)=>{
        const matches = (0, $kn1CQ.SESSION_ENTRY_REGEXP).exec(entry);
        if (matches !== null) {
            const [, key, value] = matches;
            if (key === 'aid') // we use `aid` as a key for anonymousId
            session.anonymousId = value;
            else session[key] = value;
        }
    });
    return session;
}

});
parcelRegister("kn1CQ", function(module, exports) {

$parcel$export(module.exports, "SESSION_ENTRY_REGEXP", () => $ed47376b15a39472$export$d79faf935ae6abec);
$parcel$export(module.exports, "SESSION_ENTRY_SEPARATOR", () => $ed47376b15a39472$export$92d973d0376798f5);
$parcel$export(module.exports, "isValidSessionString", () => $ed47376b15a39472$export$1a6351cc7f3c5cc8);
const $ed47376b15a39472$export$d79faf935ae6abec = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
const $ed47376b15a39472$export$92d973d0376798f5 = '&';
function $ed47376b15a39472$export$1a6351cc7f3c5cc8(sessionString) {
    return !!sessionString && (sessionString.indexOf($ed47376b15a39472$export$92d973d0376798f5) !== -1 || $ed47376b15a39472$export$d79faf935ae6abec.test(sessionString));
}

});




parcelRegister("24NU9", function(module, exports) {

$parcel$export(module.exports, "selectLocalStorageStrategy", () => $1832aa7f8f61a7ea$export$4d20c6f83e85c567);
$parcel$export(module.exports, "initLocalStorageStrategy", () => $1832aa7f8f61a7ea$export$f96a432ca80663c2);
$parcel$export(module.exports, "retrieveSessionFromLocalStorage", () => $1832aa7f8f61a7ea$export$72f11de255f999bb);

var $99fDv = parcelRequire("99fDv");

var $5xfjl = parcelRequire("5xfjl");

var $5iH1t = parcelRequire("5iH1t");

var $fQ9VW = parcelRequire("fQ9VW");
const $1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function $1832aa7f8f61a7ea$export$4d20c6f83e85c567() {
    try {
        const id = (0, $99fDv.generateUUID)();
        const testKey = `${$1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY}${id}`;
        localStorage.setItem(testKey, id);
        const retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: (0, $5xfjl.SessionPersistence).LOCAL_STORAGE
        } : undefined;
    } catch (_a) {
        return undefined;
    }
}
function $1832aa7f8f61a7ea$export$f96a432ca80663c2(configuration) {
    return {
        isLockEnabled: false,
        persistSession: $1832aa7f8f61a7ea$var$persistInLocalStorage,
        retrieveSession: $1832aa7f8f61a7ea$export$72f11de255f999bb,
        expireSession: (sessionState)=>$1832aa7f8f61a7ea$var$expireSessionFromLocalStorage(sessionState, configuration)
    };
}
function $1832aa7f8f61a7ea$var$persistInLocalStorage(sessionState) {
    localStorage.setItem((0, $fQ9VW.SESSION_STORE_KEY), (0, $5iH1t.toSessionString)(sessionState));
}
function $1832aa7f8f61a7ea$export$72f11de255f999bb() {
    const sessionString = localStorage.getItem((0, $fQ9VW.SESSION_STORE_KEY));
    return (0, $5iH1t.toSessionState)(sessionString);
}
function $1832aa7f8f61a7ea$var$expireSessionFromLocalStorage(previousSessionState, configuration) {
    $1832aa7f8f61a7ea$var$persistInLocalStorage((0, $5iH1t.getExpiredSessionState)(previousSessionState, configuration));
}

});

parcelRegister("f8aZL", function(module, exports) {

$parcel$export(module.exports, "processSessionStoreOperations", () => $02d7be7ae3d08a12$export$5efeffeb1c7b84cb);

var $d97UU = parcelRequire("d97UU");

var $99fDv = parcelRequire("99fDv");

var $ly0px = parcelRequire("ly0px");

var $5iH1t = parcelRequire("5iH1t");
const $02d7be7ae3d08a12$export$af5f677cffbf8829 = 10;
const $02d7be7ae3d08a12$export$63e0e5fbdb17b26 = 100;
const $02d7be7ae3d08a12$export$ac2a88fa41f356e2 = (0, $ly0px.ONE_SECOND);
const $02d7be7ae3d08a12$var$LOCK_SEPARATOR = '--';
const $02d7be7ae3d08a12$var$bufferedOperations = [];
let $02d7be7ae3d08a12$var$ongoingOperations;
function $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStoreStrategy, numberOfRetries = 0) {
    var _a;
    const { isLockEnabled: isLockEnabled, persistSession: persistSession, expireSession: expireSession } = sessionStoreStrategy;
    const persistWithLock = (session)=>persistSession({
            ...session,
            lock: currentLock
        });
    const retrieveStore = ()=>{
        const { lock: lock, ...session } = sessionStoreStrategy.retrieveSession();
        return {
            session: session,
            lock: lock && !$02d7be7ae3d08a12$var$isLockExpired(lock) ? lock : undefined
        };
    };
    if (!$02d7be7ae3d08a12$var$ongoingOperations) $02d7be7ae3d08a12$var$ongoingOperations = operations;
    if (operations !== $02d7be7ae3d08a12$var$ongoingOperations) {
        $02d7be7ae3d08a12$var$bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= $02d7be7ae3d08a12$export$63e0e5fbdb17b26) {
        $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
        return;
    }
    let currentLock;
    let currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = $02d7be7ae3d08a12$export$518c5fc2dcb7974b();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    let processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, $5iH1t.isSessionInExpiredState)(processedSession)) expireSession(processedSession);
        else {
            (0, $5iH1t.expandSessionState)(processedSession);
            if (isLockEnabled) persistWithLock(processedSession);
            else persistSession(processedSession);
        }
    }
    if (isLockEnabled) // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    {
        if (!(processedSession && (0, $5iH1t.isSessionInExpiredState)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 || _a.call(operations, processedSession || currentStore.session);
    $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
}
function $02d7be7ae3d08a12$var$retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, $d97UU.setTimeout)(()=>{
        $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStore, currentNumberOfRetries + 1);
    }, $02d7be7ae3d08a12$export$af5f677cffbf8829);
}
function $02d7be7ae3d08a12$var$next(sessionStore) {
    $02d7be7ae3d08a12$var$ongoingOperations = undefined;
    const nextOperations = $02d7be7ae3d08a12$var$bufferedOperations.shift();
    if (nextOperations) $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(nextOperations, sessionStore);
}
function $02d7be7ae3d08a12$export$518c5fc2dcb7974b() {
    return (0, $99fDv.generateUUID)() + $02d7be7ae3d08a12$var$LOCK_SEPARATOR + (0, $ly0px.timeStampNow)();
}
function $02d7be7ae3d08a12$var$isLockExpired(lock) {
    const [, timeStamp] = lock.split($02d7be7ae3d08a12$var$LOCK_SEPARATOR);
    return !timeStamp || (0, $ly0px.elapsed)(Number(timeStamp), (0, $ly0px.timeStampNow)()) > $02d7be7ae3d08a12$export$ac2a88fa41f356e2;
}

});

parcelRegister("bhz6Z", function(module, exports) {

$parcel$export(module.exports, "selectMemorySessionStoreStrategy", () => $836c84b4f17b9866$export$f88572049b46576c);
$parcel$export(module.exports, "initMemorySessionStoreStrategy", () => $836c84b4f17b9866$export$29a94e54ea429ef7);

var $1sTNW = parcelRequire("1sTNW");

var $5xfjl = parcelRequire("5xfjl");

var $5iH1t = parcelRequire("5iH1t");

var $8PiRA = parcelRequire("8PiRA");
const $836c84b4f17b9866$export$dbe6521780060772 = '_DD_SESSION';
function $836c84b4f17b9866$export$f88572049b46576c() {
    return {
        type: (0, $5xfjl.SessionPersistence).MEMORY
    };
}
function $836c84b4f17b9866$export$29a94e54ea429ef7(configuration) {
    return {
        expireSession: (sessionState)=>$836c84b4f17b9866$var$expireSessionFromMemory(sessionState, configuration),
        isLockEnabled: false,
        persistSession: $836c84b4f17b9866$var$persistInMemory,
        retrieveSession: $836c84b4f17b9866$var$retrieveFromMemory
    };
}
function $836c84b4f17b9866$var$retrieveFromMemory() {
    const globalObject = (0, $1sTNW.getGlobalObject)();
    if (!globalObject[$836c84b4f17b9866$export$dbe6521780060772]) globalObject[$836c84b4f17b9866$export$dbe6521780060772] = {};
    return (0, $8PiRA.shallowClone)(globalObject[$836c84b4f17b9866$export$dbe6521780060772]);
}
function $836c84b4f17b9866$var$persistInMemory(state) {
    const globalObject = (0, $1sTNW.getGlobalObject)();
    globalObject[$836c84b4f17b9866$export$dbe6521780060772] = (0, $8PiRA.shallowClone)(state);
}
function $836c84b4f17b9866$var$expireSessionFromMemory(previousSessionState, configuration) {
    $836c84b4f17b9866$var$persistInMemory((0, $5iH1t.getExpiredSessionState)(previousSessionState, configuration));
}

});




parcelRegister("EGbAq", function(module, exports) {

$parcel$export(module.exports, "startLogsAssembly", () => $07a475c731d965b6$export$627391049aa7b21e);

var $hBiX7 = parcelRequire("hBiX7");
var $j9iCm = parcelRequire("j9iCm");
var $axXk6 = parcelRequire("axXk6");
var $i3LOd = parcelRequire("i3LOd");
var $1zKlK = parcelRequire("1zKlK");
var $ly0px = parcelRequire("ly0px");

var $hVbxe = parcelRequire("hVbxe");
function $07a475c731d965b6$export$627391049aa7b21e(configuration, lifeCycle, hooks, getCommonContext, reportError, eventRateLimit) {
    const statusWithCustom = (0, $hVbxe.STATUSES).concat([
        'custom'
    ]);
    const logRateLimiters = {};
    statusWithCustom.forEach((status)=>{
        logRateLimiters[status] = (0, $axXk6.createEventRateLimiter)(status, reportError, eventRateLimit);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , ({ rawLogsEvent: rawLogsEvent, messageContext: messageContext, savedCommonContext: savedCommonContext, domainContext: domainContext, ddtags: ddtags = [] })=>{
        var _a, _b;
        const startTime = (0, $ly0px.getRelativeTime)(rawLogsEvent.date);
        const commonContext = savedCommonContext || getCommonContext();
        const defaultLogsEventAttributes = hooks.triggerHook(0 /* HookNames.Assemble */ , {
            startTime: startTime
        });
        if (defaultLogsEventAttributes === (0, $i3LOd.DISCARDED)) return;
        const defaultDdtags = (0, $hBiX7.buildTags)(configuration);
        const log = (0, $j9iCm.combine)({
            view: commonContext.view
        }, defaultLogsEventAttributes, rawLogsEvent, messageContext, {
            ddtags: defaultDdtags.concat(ddtags).join(',')
        });
        if (((_a = configuration.beforeSend) === null || _a === void 0 ? void 0 : _a.call(configuration, log, domainContext)) === false || log.origin !== (0, $1zKlK.ErrorSource).AGENT && ((_b = logRateLimiters[log.status]) !== null && _b !== void 0 ? _b : logRateLimiters['custom']).isLimitReached()) return;
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */ , log);
    });
}

});
parcelRegister("axXk6", function(module, exports) {

$parcel$export(module.exports, "createEventRateLimiter", () => $7adb00cfa5352eff$export$eafcd5d914e17d69);

var $d97UU = parcelRequire("d97UU");

var $ly0px = parcelRequire("ly0px");

var $1zKlK = parcelRequire("1zKlK");
// Limit the maximum number of actions, errors and logs per minutes
const $7adb00cfa5352eff$var$EVENT_RATE_LIMIT = 3000;
function $7adb00cfa5352eff$export$eafcd5d914e17d69(eventType, onLimitReached, limit = $7adb00cfa5352eff$var$EVENT_RATE_LIMIT) {
    let eventCount = 0;
    let allowNextEvent = false;
    return {
        isLimitReached () {
            if (eventCount === 0) (0, $d97UU.setTimeout)(()=>{
                eventCount = 0;
            }, (0, $ly0px.ONE_MINUTE));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: `Reached max number of ${eventType}s by minute: ${limit}`,
                        source: (0, $1zKlK.ErrorSource).AGENT,
                        startClocks: (0, $ly0px.clocksNow)()
                    });
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}

});


parcelRegister("fzjZY", function(module, exports) {

$parcel$export(module.exports, "startConsoleCollection", () => $b559a32e85b74c64$export$601e91d68ece5c12);

var $5IDGB = parcelRequire("5IDGB");
var $1zKlK = parcelRequire("1zKlK");
var $crBqg = parcelRequire("crBqg");
var $ly0px = parcelRequire("ly0px");

var $lkd4w = parcelRequire("lkd4w");

var $lSUlb = parcelRequire("lSUlb");
const $b559a32e85b74c64$export$aed7c9a1c59f7d58 = {
    [(0, $5IDGB.ConsoleApiName).log]: (0, $lkd4w.StatusType).info,
    [(0, $5IDGB.ConsoleApiName).debug]: (0, $lkd4w.StatusType).debug,
    [(0, $5IDGB.ConsoleApiName).info]: (0, $lkd4w.StatusType).info,
    [(0, $5IDGB.ConsoleApiName).warn]: (0, $lkd4w.StatusType).warn,
    [(0, $5IDGB.ConsoleApiName).error]: (0, $lkd4w.StatusType).error
};
function $b559a32e85b74c64$export$601e91d68ece5c12(configuration, lifeCycle) {
    const consoleSubscription = (0, $crBqg.initConsoleObservable)(configuration.forwardConsoleLogs).subscribe((log)=>{
        var _a;
        const collectedData = {
            rawLogsEvent: {
                date: (0, $ly0px.timeStampNow)(),
                message: log.message,
                origin: (0, $1zKlK.ErrorSource).CONSOLE,
                error: log.error && (0, $lSUlb.createErrorFieldFromRawError)(log.error),
                status: $b559a32e85b74c64$export$aed7c9a1c59f7d58[log.api]
            },
            messageContext: (_a = log.error) === null || _a === void 0 ? void 0 : _a.context,
            domainContext: {
                handlingStack: log.handlingStack
            }
        };
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , collectedData);
    });
    return {
        stop: ()=>{
            consoleSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("crBqg", function(module, exports) {

$parcel$export(module.exports, "initConsoleObservable", () => $90f50905b5952746$export$688fb0189cfcddd4);

var $4Be0w = parcelRequire("4Be0w");

var $4wc1a = parcelRequire("4wc1a");

var $5IDGB = parcelRequire("5IDGB");

var $2wH3Z = parcelRequire("2wH3Z");

var $1RdIU = parcelRequire("1RdIU");

var $1W8NF = parcelRequire("1W8NF");

var $1zKlK = parcelRequire("1zKlK");

var $3aiPa = parcelRequire("3aiPa");

var $6q317 = parcelRequire("6q317");

var $ly0px = parcelRequire("ly0px");
let $90f50905b5952746$var$consoleObservablesByApi = {};
function $90f50905b5952746$export$688fb0189cfcddd4(apis) {
    const consoleObservables = apis.map((api)=>{
        if (!$90f50905b5952746$var$consoleObservablesByApi[api]) $90f50905b5952746$var$consoleObservablesByApi[api] = $90f50905b5952746$var$createConsoleObservable(api); // we are sure that the observable created for this api will yield the expected ConsoleLog type
        return $90f50905b5952746$var$consoleObservablesByApi[api];
    });
    return (0, $4wc1a.mergeObservables)(...consoleObservables);
}
function $90f50905b5952746$export$1356159d86f98c58() {
    $90f50905b5952746$var$consoleObservablesByApi = {};
}
function $90f50905b5952746$var$createConsoleObservable(api) {
    return new (0, $4wc1a.Observable)((observable)=>{
        const originalConsoleApi = (0, $5IDGB.globalConsole)[api];
        (0, $5IDGB.globalConsole)[api] = (...params)=>{
            originalConsoleApi.apply(console, params);
            const handlingStack = (0, $6q317.createHandlingStack)('console error');
            (0, $2wH3Z.callMonitored)(()=>{
                observable.notify($90f50905b5952746$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return ()=>{
            (0, $5IDGB.globalConsole)[api] = originalConsoleApi;
        };
    });
}
function $90f50905b5952746$var$buildConsoleLog(params, api, handlingStack) {
    const message = params.map((param)=>$90f50905b5952746$var$formatConsoleParameters(param)).join(' ');
    if (api === (0, $5IDGB.ConsoleApiName).error) {
        const firstErrorParam = params.find((0, $4Be0w.isError));
        const rawError = (0, $4Be0w.computeRawError)({
            originalError: firstErrorParam,
            handlingStack: handlingStack,
            startClocks: (0, $ly0px.clocksNow)(),
            source: (0, $1zKlK.ErrorSource).CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */ ,
            nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
            // if no good stack is computed from the error, let's not use the fallback stack message
            // advising the user to use an instance of Error, as console.error is commonly used without an
            // Error instance.
            useFallbackStack: false
        });
        // Use the full log message as the error message instead of just the error instance message.
        rawError.message = message;
        return {
            api: api,
            message: message,
            handlingStack: handlingStack,
            error: rawError
        };
    }
    return {
        api: api,
        message: message,
        error: undefined,
        handlingStack: handlingStack
    };
}
function $90f50905b5952746$var$formatConsoleParameters(param) {
    if (typeof param === 'string') return (0, $1RdIU.sanitize)(param);
    if ((0, $4Be0w.isError)(param)) return (0, $6q317.formatErrorMessage)((0, $3aiPa.computeStackTrace)(param));
    return (0, $1W8NF.jsonStringify)((0, $1RdIU.sanitize)(param), undefined, 2);
}

});


parcelRegister("5NDJ0", function(module, exports) {

$parcel$export(module.exports, "startReportCollection", () => $439057e2cef6be3e$export$764db0aca1d0911);

var $1zKlK = parcelRequire("1zKlK");
var $4Be0w = parcelRequire("4Be0w");
var $3LtP9 = parcelRequire("3LtP9");
var $ly0px = parcelRequire("ly0px");

var $lkd4w = parcelRequire("lkd4w");

var $lSUlb = parcelRequire("lSUlb");
function $439057e2cef6be3e$export$764db0aca1d0911(configuration, lifeCycle) {
    const reportSubscription = (0, $3LtP9.initReportObservable)(configuration, configuration.forwardReports).subscribe((rawError)=>{
        let message = rawError.message;
        let error;
        const status = rawError.originalError.type === 'deprecation' ? (0, $lkd4w.StatusType).warn : (0, $lkd4w.StatusType).error;
        if (status === (0, $lkd4w.StatusType).error) error = (0, $lSUlb.createErrorFieldFromRawError)(rawError);
        else if (rawError.stack) message += ` Found in ${(0, $4Be0w.getFileFromStackTraceString)(rawError.stack)}`;
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                date: (0, $ly0px.timeStampNow)(),
                message: message,
                origin: (0, $1zKlK.ErrorSource).REPORT,
                error: error,
                status: status
            }
        });
    });
    return {
        stop: ()=>{
            reportSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("3LtP9", function(module, exports) {

$parcel$export(module.exports, "RawReportType", () => $2bdce5556b3f551d$export$1bd494ac7adbb6ce);
$parcel$export(module.exports, "initReportObservable", () => $2bdce5556b3f551d$export$645a986d81bb5490);

var $6q317 = parcelRequire("6q317");

var $2wH3Z = parcelRequire("2wH3Z");

var $4wc1a = parcelRequire("4wc1a");

var $hXhfS = parcelRequire("hXhfS");

var $99fDv = parcelRequire("99fDv");

var $1zKlK = parcelRequire("1zKlK");

var $ly0px = parcelRequire("ly0px");
const $2bdce5556b3f551d$export$1bd494ac7adbb6ce = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation'
};
function $2bdce5556b3f551d$export$645a986d81bb5490(configuration, apis) {
    const observables = [];
    if (apis.includes($2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation)) observables.push($2bdce5556b3f551d$var$createCspViolationReportObservable(configuration));
    const reportTypes = apis.filter((api)=>api !== $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation);
    if (reportTypes.length) observables.push($2bdce5556b3f551d$var$createReportObservable(reportTypes));
    return (0, $4wc1a.mergeObservables)(...observables);
}
function $2bdce5556b3f551d$var$createReportObservable(reportTypes) {
    return new (0, $4wc1a.Observable)((observable)=>{
        if (!window.ReportingObserver) return;
        const handleReports = (0, $2wH3Z.monitor)((reports, _)=>reports.forEach((report)=>observable.notify($2bdce5556b3f551d$var$buildRawReportErrorFromReport(report))));
        const observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return ()=>{
            observer.disconnect();
        };
    });
}
function $2bdce5556b3f551d$var$createCspViolationReportObservable(configuration) {
    return new (0, $4wc1a.Observable)((observable)=>{
        const { stop: stop } = (0, $hXhfS.addEventListener)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */ , (event)=>{
            observable.notify($2bdce5556b3f551d$var$buildRawReportErrorFromCspViolation(event));
        });
        return stop;
    });
}
function $2bdce5556b3f551d$var$buildRawReportErrorFromReport(report) {
    const { type: type, body: body } = report;
    return $2bdce5556b3f551d$var$buildRawReportError({
        type: body.id,
        message: `${type}: ${body.message}`,
        originalError: report,
        stack: $2bdce5556b3f551d$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
    });
}
function $2bdce5556b3f551d$var$buildRawReportErrorFromCspViolation(event) {
    const message = `'${event.blockedURI}' blocked by '${event.effectiveDirective}' directive`;
    return $2bdce5556b3f551d$var$buildRawReportError({
        type: event.effectiveDirective,
        message: `${$2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation}: ${message}`,
        originalError: event,
        csp: {
            disposition: event.disposition
        },
        stack: $2bdce5556b3f551d$var$buildStack(event.effectiveDirective, event.originalPolicy ? `${message} of the policy "${(0, $99fDv.safeTruncate)(event.originalPolicy, 100, '...')}"` : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber)
    });
}
function $2bdce5556b3f551d$var$buildRawReportError(partial) {
    return {
        startClocks: (0, $ly0px.clocksNow)(),
        source: (0, $1zKlK.ErrorSource).REPORT,
        handling: "unhandled" /* ErrorHandling.UNHANDLED */ ,
        ...partial
    };
}
function $2bdce5556b3f551d$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $6q317.toStackTraceString)({
        name: name,
        message: message,
        stack: [
            {
                func: '?',
                url: sourceFile,
                line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
            }
        ]
    }) : undefined;
}

});


parcelRegister("hJXJf", function(module, exports) {

$parcel$export(module.exports, "startNetworkErrorCollection", () => $cea4f88979234f28$export$d0c7c81096ec95e);

var $3aiPa = parcelRequire("3aiPa");
var $1zKlK = parcelRequire("1zKlK");
var $lEdKn = parcelRequire("lEdKn");
var $dX7m0 = parcelRequire("dX7m0");
var $7yltR = parcelRequire("7yltR");
var $8yLbx = parcelRequire("8yLbx");
var $1sTNW = parcelRequire("1sTNW");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $iSi6B = parcelRequire("iSi6B");
var $99fDv = parcelRequire("99fDv");
var $6q317 = parcelRequire("6q317");

var $lkd4w = parcelRequire("lkd4w");
function $cea4f88979234f28$export$d0c7c81096ec95e(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $aed8w.noop)
    };
    // XHR is not available in web workers, so we use an empty observable that never emits
    const xhrSubscription = ((0, $1sTNW.isWorkerEnvironment) ? new (0, $4wc1a.Observable)() : (0, $dX7m0.initXhrObservable)(configuration)).subscribe((context)=>{
        if (context.state === 'complete') handleResponse((0, $iSi6B.RequestType).XHR, context);
    });
    const fetchSubscription = (0, $lEdKn.initFetchObservable)({
        responseBodyAction: (context)=>isNetworkError(context) ? 2 /* ResponseBodyAction.COLLECT */  : 0 /* ResponseBodyAction.IGNORE */ 
    }).subscribe((context)=>{
        if (context.state === 'resolve') handleResponse((0, $iSi6B.RequestType).FETCH, context);
    });
    function isNetworkError(request) {
        return !(0, $7yltR.isIntakeUrl)(request.url) && ($cea4f88979234f28$var$isRejected(request) || (0, $8yLbx.isServerError)(request.status));
    }
    function handleResponse(type, request) {
        if (!isNetworkError(request)) return;
        const stack = 'error' in request && request.error ? (0, $6q317.toStackTraceString)((0, $3aiPa.computeStackTrace)(request.error)) : request.responseBody || 'Failed to load';
        const domainContext = {
            isAborted: request.isAborted,
            handlingStack: request.handlingStack
        };
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: `${$cea4f88979234f28$var$format(type)} error ${request.method} ${request.url}`,
                date: request.startClocks.timeStamp,
                error: {
                    stack: (0, $99fDv.safeTruncate)(stack, configuration.requestErrorResponseLengthLimit, '...'),
                    // We don't know if the error was handled or not, so we set it to undefined
                    handling: undefined
                },
                http: {
                    method: request.method,
                    status_code: request.status,
                    url: request.url
                },
                status: (0, $lkd4w.StatusType).error,
                origin: (0, $1zKlK.ErrorSource).NETWORK
            },
            domainContext: domainContext
        });
    }
    return {
        stop: ()=>{
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        }
    };
}
function $cea4f88979234f28$var$isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function $cea4f88979234f28$var$format(type) {
    if ((0, $iSi6B.RequestType).XHR === type) return 'XHR';
    return 'Fetch';
}

});
parcelRegister("lEdKn", function(module, exports) {

$parcel$export(module.exports, "initFetchObservable", () => $fc27ff42b956d16d$export$68d940e9b7f5282c);

var $35a54 = parcelRequire("35a54");

var $2wH3Z = parcelRequire("2wH3Z");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");

var $1sTNW = parcelRequire("1sTNW");

var $4igFP = parcelRequire("4igFP");

var $8yLbx = parcelRequire("8yLbx");
let $fc27ff42b956d16d$var$fetchObservable;
const $fc27ff42b956d16d$var$responseBodyActionGetters = [];
function $fc27ff42b956d16d$export$68d940e9b7f5282c({ responseBodyAction: responseBodyAction } = {}) {
    if (responseBodyAction) $fc27ff42b956d16d$var$responseBodyActionGetters.push(responseBodyAction);
    if (!$fc27ff42b956d16d$var$fetchObservable) $fc27ff42b956d16d$var$fetchObservable = $fc27ff42b956d16d$var$createFetchObservable();
    return $fc27ff42b956d16d$var$fetchObservable;
}
function $fc27ff42b956d16d$export$81ee928f11655c0c() {
    $fc27ff42b956d16d$var$fetchObservable = undefined;
    $fc27ff42b956d16d$var$responseBodyActionGetters.length = 0;
}
function $fc27ff42b956d16d$var$createFetchObservable() {
    return new (0, $4wc1a.Observable)((observable)=>{
        // eslint-disable-next-line local-rules/disallow-zone-js-patched-values
        if (!(0, $1sTNW.globalObject).fetch) return;
        const { stop: stop } = (0, $35a54.instrumentMethod)((0, $1sTNW.globalObject), 'fetch', (call)=>$fc27ff42b956d16d$var$beforeSend(call, observable), {
            computeHandlingStack: true
        });
        return stop;
    });
}
function $fc27ff42b956d16d$var$beforeSend({ parameters: parameters, onPostCall: onPostCall, handlingStack: handlingStack }, observable) {
    var _a, _b;
    const [input, init] = parameters;
    let methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) methodFromParams = input.method;
    const method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    const url = input instanceof Request ? input.url : (0, $bVLiF.normalizeUrl)(String(input));
    const startClocks = (0, $ly0px.clocksNow)();
    const context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
        handlingStack: handlingStack,
        isAbortedOnStart: input instanceof Request && ((_a = input.signal) === null || _a === void 0 ? void 0 : _a.aborted) || ((_b = init === null || init === void 0 ? void 0 : init.signal) === null || _b === void 0 ? void 0 : _b.aborted) || false
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall((responsePromise)=>{
        $fc27ff42b956d16d$var$afterSend(observable, responsePromise, context).catch((0, $2wH3Z.monitorError));
    });
}
async function $fc27ff42b956d16d$var$afterSend(observable, responsePromise, startContext) {
    var _a, _b;
    const context = startContext;
    context.state = 'resolve';
    let response;
    try {
        response = await responsePromise;
    } catch (error) {
        context.status = 0;
        context.isAborted = ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || error instanceof DOMException && error.code === DOMException.ABORT_ERR;
        context.error = error;
        observable.notify(context);
        return;
    }
    context.response = response;
    context.status = response.status;
    context.responseType = response.type;
    context.isAborted = false;
    const responseBodyCondition = $fc27ff42b956d16d$var$responseBodyActionGetters.reduce((action, getter)=>Math.max(action, getter(context)), 0 /* ResponseBodyAction.IGNORE */ );
    if (responseBodyCondition !== 0 /* ResponseBodyAction.IGNORE */ ) {
        const clonedResponse = (0, $8yLbx.tryToClone)(response);
        if (clonedResponse && clonedResponse.body) try {
            const bytes = await (0, $4igFP.readBytesFromStream)(clonedResponse.body, {
                collectStreamBody: responseBodyCondition === 2 /* ResponseBodyAction.COLLECT */ 
            });
            context.responseBody = bytes && new TextDecoder().decode(bytes);
        } catch (_c) {
        // Ignore errors when reading the response body (e.g., stream aborted, network errors)
        // This is not critical and should not be reported as an SDK error
        }
    }
    observable.notify(context);
}

});
parcelRegister("4igFP", function(module, exports) {

$parcel$export(module.exports, "readBytesFromStream", () => $3205c6e66a2d76d7$export$ecd154de096317dd);

var $7S2uk = parcelRequire("7S2uk");

var $aed8w = parcelRequire("aed8w");
async function $3205c6e66a2d76d7$export$ecd154de096317dd(stream, options) {
    const reader = stream.getReader();
    const chunks = [];
    while(true){
        const result = await reader.read();
        if (result.done) break;
        if (options.collectStreamBody) chunks.push(result.value);
    }
    reader.cancel().catch(// we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    (0, $aed8w.noop));
    return options.collectStreamBody ? (0, $7S2uk.concatBuffers)(chunks) : undefined;
}

});


parcelRegister("dX7m0", function(module, exports) {

$parcel$export(module.exports, "initXhrObservable", () => $a2867d5cdff4f776$export$1b29a115c614eaec);

var $35a54 = parcelRequire("35a54");

var $4wc1a = parcelRequire("4wc1a");

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");

var $8PiRA = parcelRequire("8PiRA");

var $hXhfS = parcelRequire("hXhfS");
let $a2867d5cdff4f776$var$xhrObservable;
const $a2867d5cdff4f776$var$xhrContexts = new WeakMap();
function $a2867d5cdff4f776$export$1b29a115c614eaec(configuration) {
    if (!$a2867d5cdff4f776$var$xhrObservable) $a2867d5cdff4f776$var$xhrObservable = $a2867d5cdff4f776$var$createXhrObservable(configuration);
    return $a2867d5cdff4f776$var$xhrObservable;
}
function $a2867d5cdff4f776$var$createXhrObservable(configuration) {
    return new (0, $4wc1a.Observable)((observable)=>{
        const { stop: stopInstrumentingStart } = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, 'open', $a2867d5cdff4f776$var$openXhr);
        const { stop: stopInstrumentingSend } = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, 'send', (call)=>{
            $a2867d5cdff4f776$var$sendXhr(call, configuration, observable);
        }, {
            computeHandlingStack: true
        });
        const { stop: stopInstrumentingAbort } = (0, $35a54.instrumentMethod)(XMLHttpRequest.prototype, 'abort', $a2867d5cdff4f776$var$abortXhr);
        return ()=>{
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $a2867d5cdff4f776$var$openXhr({ target: xhr, parameters: [method, url] }) {
    $a2867d5cdff4f776$var$xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: (0, $bVLiF.normalizeUrl)(String(url))
    });
}
function $a2867d5cdff4f776$var$sendXhr({ target: xhr, parameters: [body], handlingStack: handlingStack }, configuration, observable) {
    const context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (!context) return;
    const startContext = context;
    startContext.state = 'start';
    startContext.startClocks = (0, $ly0px.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    startContext.requestBody = body;
    let hasBeenReported = false;
    const { stop: stopInstrumentingOnReadyStateChange } = (0, $35a54.instrumentMethod)(xhr, 'onreadystatechange', ()=>{
        if (xhr.readyState === XMLHttpRequest.DONE) // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
    });
    const onEnd = ()=>{
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        const completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0, $ly0px.elapsed)(startContext.startClocks.timeStamp, (0, $ly0px.timeStampNow)());
        completeContext.status = xhr.status;
        if (typeof xhr.response === 'string') completeContext.responseBody = xhr.response;
        observable.notify((0, $8PiRA.shallowClone)(completeContext));
    };
    const { stop: unsubscribeLoadEndListener } = (0, $hXhfS.addEventListener)(configuration, xhr, 'loadend', onEnd);
    observable.notify(startContext);
}
function $a2867d5cdff4f776$var$abortXhr({ target: xhr }) {
    const context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}
function $a2867d5cdff4f776$export$231d37c9c6026b10() {
    $a2867d5cdff4f776$var$xhrObservable = undefined;
}

});

parcelRegister("7yltR", function(module, exports) {

$parcel$export(module.exports, "computeTransportConfiguration", () => $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6);
$parcel$export(module.exports, "isIntakeUrl", () => $57fc5f00ec8e4fc6$export$8f53a704ec1860b3);

var $iLlhv = parcelRequire("iLlhv");

var $lrgXo = parcelRequire("lrgXo");
function $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6(initConfiguration) {
    const site = initConfiguration.site || (0, $iLlhv.INTAKE_SITE_US1);
    const source = $57fc5f00ec8e4fc6$var$validateSource(initConfiguration.source);
    const endpointBuilders = $57fc5f00ec8e4fc6$var$computeEndpointBuilders({
        ...initConfiguration,
        site: site,
        source: source
    });
    const replicaConfiguration = $57fc5f00ec8e4fc6$var$computeReplicaConfiguration({
        ...initConfiguration,
        site: site,
        source: source
    });
    return {
        replica: replicaConfiguration,
        site: site,
        source: source,
        ...endpointBuilders
    };
}
function $57fc5f00ec8e4fc6$var$validateSource(source) {
    if (source === 'flutter' || source === 'unity') return source;
    return 'browser';
}
function $57fc5f00ec8e4fc6$var$computeEndpointBuilders(initConfiguration) {
    return {
        logsEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'logs'),
        rumEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'rum'),
        profilingEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'profile'),
        sessionReplayEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'replay'),
        exposuresEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'exposures'),
        flagEvaluationEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(initConfiguration, 'flagevaluation')
    };
}
function $57fc5f00ec8e4fc6$var$computeReplicaConfiguration(initConfiguration) {
    if (!initConfiguration.replica) return;
    const replicaConfiguration = {
        ...initConfiguration,
        site: (0, $iLlhv.INTAKE_SITE_US1),
        clientToken: initConfiguration.replica.clientToken
    };
    return {
        logsEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(replicaConfiguration, 'logs'),
        rumEndpointBuilder: (0, $lrgXo.createEndpointBuilder)(replicaConfiguration, 'rum', [
            `application.id=${initConfiguration.replica.applicationId}`
        ])
    };
}
function $57fc5f00ec8e4fc6$export$8f53a704ec1860b3(url) {
    // check if tags is present in the query string
    return (0, $iLlhv.INTAKE_URL_PARAMETERS).every((param)=>url.includes(param));
}

});
parcelRegister("lrgXo", function(module, exports) {

$parcel$export(module.exports, "createEndpointBuilder", () => $f9b945dd035d2e49$export$b84621d9b3dd3f17);
$parcel$export(module.exports, "buildEndpointHost", () => $f9b945dd035d2e49$export$bf02e215bd4a34f);

var $ly0px = parcelRequire("ly0px");

var $bVLiF = parcelRequire("bVLiF");

var $99fDv = parcelRequire("99fDv");

var $iLlhv = parcelRequire("iLlhv");
function $f9b945dd035d2e49$export$b84621d9b3dd3f17(initConfiguration, trackType, extraParameters) {
    const buildUrlWithParameters = $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build (api, payload) {
            const parameters = $f9b945dd035d2e49$var$buildEndpointParameters(initConfiguration, trackType, api, payload, extraParameters);
            return buildUrlWithParameters(parameters);
        },
        trackType: trackType
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */ function $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    const path = `/api/v2/${trackType}`;
    const proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        const normalizedProxyUrl = (0, $bVLiF.normalizeUrl)(proxy);
        return (parameters)=>`${normalizedProxyUrl}?ddforward=${encodeURIComponent(`${path}?${parameters}`)}`;
    }
    if (typeof proxy === 'function') return (parameters)=>proxy({
            path: path,
            parameters: parameters
        });
    const host = $f9b945dd035d2e49$export$bf02e215bd4a34f(trackType, initConfiguration);
    return (parameters)=>`https://${host}${path}?${parameters}`;
}
function $f9b945dd035d2e49$export$bf02e215bd4a34f(trackType, initConfiguration) {
    const { site: site = (0, $iLlhv.INTAKE_SITE_US1), internalAnalyticsSubdomain: internalAnalyticsSubdomain } = initConfiguration;
    if (trackType === 'logs' && initConfiguration.usePciIntake && site === (0, $iLlhv.INTAKE_SITE_US1)) return 0, $iLlhv.PCI_INTAKE_HOST_US1;
    if (internalAnalyticsSubdomain && site === (0, $iLlhv.INTAKE_SITE_US1)) return `${internalAnalyticsSubdomain}.${0, $iLlhv.INTAKE_SITE_US1}`;
    if (site === (0, $iLlhv.INTAKE_SITE_FED_STAGING)) return `http-intake.logs.${site}`;
    const domainParts = site.split('.');
    const extension = domainParts.pop();
    return `browser-intake-${domainParts.join('-')}.${extension}`;
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */ function $f9b945dd035d2e49$var$buildEndpointParameters({ clientToken: clientToken, internalAnalyticsSubdomain: internalAnalyticsSubdomain, source: source = 'browser' }, trackType, api, { retry: retry, encoding: encoding }, extraParameters = []) {
    const parameters = [
        `ddsource=${source}`,
        `dd-api-key=${clientToken}`,
        `dd-evp-origin-version=${encodeURIComponent("6.33.0")}`,
        'dd-evp-origin=browser',
        `dd-request-id=${(0, $99fDv.generateUUID)()}`
    ].concat(extraParameters);
    if (encoding) parameters.push(`dd-evp-encoding=${encoding}`);
    if (trackType === 'rum') {
        parameters.push(`batch_time=${(0, $ly0px.timeStampNow)()}`, `_dd.api=${api}`);
        if (retry) parameters.push(`_dd.retry_count=${retry.count}`, `_dd.retry_after=${retry.lastFailureStatus}`);
    }
    if (internalAnalyticsSubdomain) parameters.reverse();
    return parameters.join('&');
}

});


parcelRegister("iSi6B", function(module, exports) {

$parcel$export(module.exports, "ResourceType", () => $dbdb507f0ac0bbf0$export$c6f9da6f70cfc2eb);
$parcel$export(module.exports, "RequestType", () => $dbdb507f0ac0bbf0$export$8d9ecf8a6190d0ad);
const $dbdb507f0ac0bbf0$export$c6f9da6f70cfc2eb = {
    DOCUMENT: 'document',
    XHR: 'xhr',
    BEACON: 'beacon',
    FETCH: 'fetch',
    CSS: 'css',
    JS: 'js',
    IMAGE: 'image',
    FONT: 'font',
    MEDIA: 'media',
    OTHER: 'other'
};
const $dbdb507f0ac0bbf0$export$8d9ecf8a6190d0ad = {
    FETCH: $dbdb507f0ac0bbf0$export$c6f9da6f70cfc2eb.FETCH,
    XHR: $dbdb507f0ac0bbf0$export$c6f9da6f70cfc2eb.XHR
};

});


parcelRegister("bnyWV", function(module, exports) {

$parcel$export(module.exports, "startRuntimeErrorCollection", () => $848cf3e7ae55d059$export$ae6d2c609a1d871);

var $1zKlK = parcelRequire("1zKlK");
var $aed8w = parcelRequire("aed8w");

var $lkd4w = parcelRequire("lkd4w");

var $lSUlb = parcelRequire("lSUlb");
function $848cf3e7ae55d059$export$ae6d2c609a1d871(configuration, lifeCycle, bufferedDataObservable) {
    if (!configuration.forwardErrorsToLogs) return {
        stop: (0, $aed8w.noop)
    };
    const rawErrorSubscription = bufferedDataObservable.subscribe((bufferedData)=>{
        if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */ ) {
            const error = bufferedData.error;
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
                rawLogsEvent: {
                    message: error.message,
                    date: error.startClocks.timeStamp,
                    error: (0, $lSUlb.createErrorFieldFromRawError)(error),
                    origin: (0, $1zKlK.ErrorSource).SOURCE,
                    status: (0, $lkd4w.StatusType).error
                },
                messageContext: error.context
            });
        }
    });
    return {
        stop: ()=>{
            rawErrorSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("7QcfF", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", () => $5b56e4a7fb4bdb0c$export$6af70476896cbaec);

var $f7eLh = parcelRequire("f7eLh");
const $5b56e4a7fb4bdb0c$export$6af70476896cbaec = (0, $f7eLh.AbstractLifeCycle);

});
parcelRegister("f7eLh", function(module, exports) {

$parcel$export(module.exports, "AbstractLifeCycle", () => $b012f5cc0ca286d9$export$cf0c49d09be0ebd8);
// eslint-disable-next-line no-restricted-syntax
class $b012f5cc0ca286d9$export$cf0c49d09be0ebd8 {
    constructor(){
        this.callbacks = {};
    }
    notify(eventType, data) {
        const eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach((callback)=>callback(data));
    }
    subscribe(eventType, callback) {
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: ()=>{
                this.callbacks[eventType] = this.callbacks[eventType].filter((other)=>callback !== other);
            }
        };
    }
}

});


parcelRegister("f7pcn", function(module, exports) {

$parcel$export(module.exports, "startLoggerCollection", () => $b01b0e680d5d87bb$export$a909fdf2eb14fa81);

var $j9iCm = parcelRequire("j9iCm");
var $5IDGB = parcelRequire("5IDGB");
var $1zKlK = parcelRequire("1zKlK");
var $ly0px = parcelRequire("ly0px");

var $hVbxe = parcelRequire("hVbxe");

var $lkd4w = parcelRequire("lkd4w");
function $b01b0e680d5d87bb$export$a909fdf2eb14fa81(lifeCycle) {
    function handleLog(logsMessage, logger, handlingStack, savedCommonContext, savedDate) {
        const messageContext = (0, $j9iCm.combine)(logger.getContext(), logsMessage.context);
        if ((0, $lkd4w.isAuthorized)(logsMessage.status, (0, $hVbxe.HandlerType).console, logger)) $b01b0e680d5d87bb$var$displayInConsole(logsMessage, messageContext);
        if ((0, $lkd4w.isAuthorized)(logsMessage.status, (0, $hVbxe.HandlerType).http, logger)) {
            const rawLogEventData = {
                rawLogsEvent: {
                    date: savedDate || (0, $ly0px.timeStampNow)(),
                    message: logsMessage.message,
                    status: logsMessage.status,
                    origin: (0, $1zKlK.ErrorSource).LOGGER
                },
                messageContext: messageContext,
                savedCommonContext: savedCommonContext,
                ddtags: logger.getTags()
            };
            if (handlingStack) rawLogEventData.domainContext = {
                handlingStack: handlingStack
            };
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , rawLogEventData);
        }
    }
    return {
        handleLog: handleLog
    };
}
const $b01b0e680d5d87bb$var$loggerToConsoleApiName = {
    [(0, $lkd4w.StatusType).ok]: (0, $5IDGB.ConsoleApiName).debug,
    [(0, $lkd4w.StatusType).debug]: (0, $5IDGB.ConsoleApiName).debug,
    [(0, $lkd4w.StatusType).info]: (0, $5IDGB.ConsoleApiName).info,
    [(0, $lkd4w.StatusType).notice]: (0, $5IDGB.ConsoleApiName).info,
    [(0, $lkd4w.StatusType).warn]: (0, $5IDGB.ConsoleApiName).warn,
    [(0, $lkd4w.StatusType).error]: (0, $5IDGB.ConsoleApiName).error,
    [(0, $lkd4w.StatusType).critical]: (0, $5IDGB.ConsoleApiName).error,
    [(0, $lkd4w.StatusType).alert]: (0, $5IDGB.ConsoleApiName).error,
    [(0, $lkd4w.StatusType).emerg]: (0, $5IDGB.ConsoleApiName).error
};
function $b01b0e680d5d87bb$var$displayInConsole({ status: status, message: message }, messageContext) {
    (0, $5IDGB.originalConsoleMethods)[$b01b0e680d5d87bb$var$loggerToConsoleApiName[status]].call((0, $5IDGB.globalConsole), message, messageContext);
}

});

parcelRegister("gtZEA", function(module, exports) {

$parcel$export(module.exports, "startLogsBatch", () => $bfff2de37815feec$export$e4658c4e9fa6ec0a);

var $c8B2g = parcelRequire("c8B2g");
var $cETgK = parcelRequire("cETgK");
var $3qksw = parcelRequire("3qksw");
var $lTIYX = parcelRequire("lTIYX");
function $bfff2de37815feec$export$e4658c4e9fa6ec0a(configuration, lifeCycle, reportError, pageMayExitObservable, session) {
    const endpoints = [
        configuration.logsEndpointBuilder
    ];
    if (configuration.replica) endpoints.push(configuration.replica.logsEndpointBuilder);
    const batch = (0, $c8B2g.createBatch)({
        encoder: (0, $lTIYX.createIdentityEncoder)(),
        request: (0, $3qksw.createHttpRequest)(endpoints, reportError),
        flushController: (0, $cETgK.createFlushController)({
            pageMayExitObservable: pageMayExitObservable,
            sessionExpireObservable: session.expireObservable
        })
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , (serverLogsEvent)=>{
        batch.add(serverLogsEvent);
    });
    return batch;
}

});

parcelRegister("b4X3T", function(module, exports) {

$parcel$export(module.exports, "startLogsBridge", () => $810de1dcd2ef0be7$export$4849c54cce6266f6);

var $kFaIT = parcelRequire("kFaIT");
function $810de1dcd2ef0be7$export$4849c54cce6266f6(lifeCycle) {
    const bridge = (0, $kFaIT.getEventBridge)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */ , (serverLogsEvent)=>{
        bridge.send('log', serverLogsEvent);
    });
}

});

parcelRegister("bOMs4", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", () => $89a9f2bb377a8f33$export$ee941cf091e8459);
function $89a9f2bb377a8f33$export$ee941cf091e8459(sessionManager) {
    return {
        get: (startTime)=>{
            const trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) return {
                session_id: trackedSession.id
            };
        }
    };
}

});

parcelRegister("cgp7x", function(module, exports) {

$parcel$export(module.exports, "startReportError", () => $8eda770f30771d58$export$ec67f68cd82e645c);

var $fhNdh = parcelRequire("fhNdh");
var $1zKlK = parcelRequire("1zKlK");

var $lkd4w = parcelRequire("lkd4w");
function $8eda770f30771d58$export$ec67f68cd82e645c(lifeCycle) {
    return (error)=>{
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */ , {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: (0, $1zKlK.ErrorSource).AGENT,
                status: (0, $lkd4w.StatusType).error
            }
        });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0, $fhNdh.addTelemetryDebug)('Error reported to customer', {
            'error.message': error.message
        });
    };
}

});

parcelRegister("j6Koz", function(module, exports) {

$parcel$export(module.exports, "startRUMInternalContext", () => $de9291009dc78894$export$dc1587cb7c68e163);

var $1sTNW = parcelRequire("1sTNW");
var $i3LOd = parcelRequire("i3LOd");
var $eA1KP = parcelRequire("eA1KP");
function $de9291009dc78894$export$dc1587cb7c68e163(hooks) {
    const browserWindow = (0, $1sTNW.globalObject);
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime })=>{
        const internalContext = getRUMInternalContext(startTime);
        if (!internalContext) return 0, $i3LOd.SKIPPED;
        return internalContext;
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        var _a, _b;
        const internalContext = getRUMInternalContext(startTime);
        if (!internalContext) return 0, $i3LOd.SKIPPED;
        return {
            application: {
                id: internalContext.application_id
            },
            view: {
                id: (_a = internalContext.view) === null || _a === void 0 ? void 0 : _a.id
            },
            action: {
                id: (_b = internalContext.user_action) === null || _b === void 0 ? void 0 : _b.id
            }
        };
    });
    function getRUMInternalContext(startTime) {
        const willSyntheticsInjectRumResult = (0, $eA1KP.willSyntheticsInjectRum)();
        const rumSource = willSyntheticsInjectRumResult ? browserWindow.DD_RUM_SYNTHETICS : browserWindow.DD_RUM;
        const rumContext = getInternalContextFromRumGlobal(startTime, rumSource);
        if (rumContext) return rumContext;
    }
    function getInternalContextFromRumGlobal(startTime, rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) return rumGlobal.getInternalContext(startTime);
    }
}

});

parcelRegister("4mPVX", function(module, exports) {

$parcel$export(module.exports, "startSessionContext", () => $32e1807e097910dd$export$930c4ba5de05acaa);

var $i3LOd = parcelRequire("i3LOd");
function $32e1807e097910dd$export$930c4ba5de05acaa(hooks, configuration, sessionManager) {
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        const isSessionTracked = sessionManager.findTrackedSession(startTime, {
            returnInactive: true
        });
        if (!isSessionTracked) return 0, $i3LOd.DISCARDED;
        return {
            service: configuration.service,
            session_id: session ? session.id : undefined,
            session: session ? {
                id: session.id
            } : undefined
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        if (!session || !session.id) return 0, $i3LOd.SKIPPED;
        return {
            session: {
                id: session.id
            }
        };
    });
}

});

parcelRegister("fCoJ8", function(module, exports) {

$parcel$export(module.exports, "startTrackingConsentContext", () => $b5ed95e4fca57add$export$43dc707f6931474b);

var $i3LOd = parcelRequire("i3LOd");
function $b5ed95e4fca57add$export$43dc707f6931474b(hooks, trackingConsentState) {
    function isConsented() {
        const wasConsented = trackingConsentState.isGranted();
        if (!wasConsented) return 0, $i3LOd.DISCARDED;
        return 0, $i3LOd.SKIPPED;
    }
    hooks.register(0 /* HookNames.Assemble */ , isConsented);
    hooks.register(1 /* HookNames.AssembleTelemetry */ , isConsented);
}

});


parcelRegister("d5UeM", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $98875d90a6ff917f$export$8f7002373dcc6602);

var $fhNdh = parcelRequire("fhNdh");
var $cJkro = parcelRequire("cJkro");
var $aqcpf = parcelRequire("aqcpf");
var $gZP56 = parcelRequire("gZP56");
var $djpEA = parcelRequire("djpEA");
var $kFaIT = parcelRequire("kFaIT");
var $kSv4n = parcelRequire("kSv4n");
var $7v3G2 = parcelRequire("7v3G2");
var $5IDGB = parcelRequire("5IDGB");
var $gurxr = parcelRequire("gurxr");
var $k2pmh = parcelRequire("k2pmh");
var $lEdKn = parcelRequire("lEdKn");
var $4Umqd = parcelRequire("4Umqd");
var $aed8w = parcelRequire("aed8w");
var $ly0px = parcelRequire("ly0px");

var $6r8bN = parcelRequire("6r8bN");

var $leBZC = parcelRequire("leBZC");
function $98875d90a6ff917f$export$8f7002373dcc6602(getCommonContext, trackingConsentState, doStartLogs) {
    const bufferApiCalls = (0, $kSv4n.createBoundedBuffer)();
    // TODO next major: remove the globalContext, accountContextManager, userContext from preStartStrategy and use an empty context instead
    const globalContext = (0, $gZP56.buildGlobalContextManager)();
    (0, $cJkro.bufferContextCalls)(globalContext, (0, $7v3G2.CustomerContextKey).globalContext, bufferApiCalls);
    const accountContext = (0, $aqcpf.buildAccountContextManager)();
    (0, $cJkro.bufferContextCalls)(accountContext, (0, $7v3G2.CustomerContextKey).accountContext, bufferApiCalls);
    const userContext = (0, $djpEA.buildUserContextManager)();
    (0, $cJkro.bufferContextCalls)(userContext, (0, $7v3G2.CustomerContextKey).userContext, bufferApiCalls);
    let cachedInitConfiguration;
    let cachedConfiguration;
    const hooks = (0, $6r8bN.createHooks)();
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) return;
        (0, $4Umqd.mockable)((0, $fhNdh.startTelemetry))("browser-logs-sdk" /* TelemetryService.LOGS */ , cachedConfiguration, hooks);
        trackingConsentStateSubscription.unsubscribe();
        const startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration, hooks);
        bufferApiCalls.drain(startLogsResult);
    }
    return {
        init (initConfiguration, errorStack) {
            if (!initConfiguration) {
                (0, $5IDGB.display).error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            (0, $k2pmh.initFeatureFlags)(initConfiguration.enableExperimentalFeatures);
            if ((0, $kFaIT.canUseEventBridge)()) initConfiguration = $98875d90a6ff917f$var$overrideInitConfigurationForBridge(initConfiguration);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            (0, $fhNdh.addTelemetryConfiguration)((0, $leBZC.serializeLogsConfiguration)(initConfiguration));
            if (cachedConfiguration) {
                (0, $gurxr.displayAlreadyInitializedError)('DD_LOGS', initConfiguration);
                return;
            }
            const configuration = (0, $leBZC.validateAndBuildLogsConfiguration)(initConfiguration, errorStack);
            if (!configuration) return;
            cachedConfiguration = configuration;
            // Instrument fetch to track network requests
            // This is needed in case the consent is not granted and some customer
            // library (Apollo Client) is storing uninstrumented fetch to be used later
            // The subscrption is needed so that the instrumentation process is completed
            (0, $lEdKn.initFetchObservable)().subscribe((0, $aed8w.noop));
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartLogs();
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        globalContext: globalContext,
        accountContext: accountContext,
        userContext: userContext,
        getInternalContext: (0, $aed8w.noop),
        handleLog (message, statusType, handlingStack, context = getCommonContext(), date = (0, $ly0px.timeStampNow)()) {
            bufferApiCalls.add((startLogsResult)=>startLogsResult.handleLog(message, statusType, handlingStack, context, date));
        }
    };
}
function $98875d90a6ff917f$var$overrideInitConfigurationForBridge(initConfiguration) {
    return {
        ...initConfiguration,
        clientToken: 'empty'
    };
}

});
parcelRegister("kSv4n", function(module, exports) {

$parcel$export(module.exports, "createBoundedBuffer", () => $f330f38d49d59161$export$9724f168e999472b);

var $lHOXU = parcelRequire("lHOXU");
const $f330f38d49d59161$var$BUFFER_LIMIT = 500;
function $f330f38d49d59161$export$9724f168e999472b() {
    const buffer = [];
    const add = (callback)=>{
        const length = buffer.push(callback);
        if (length > $f330f38d49d59161$var$BUFFER_LIMIT) buffer.splice(0, 1);
    };
    const remove = (callback)=>{
        (0, $lHOXU.removeItem)(buffer, callback);
    };
    const drain = (arg)=>{
        buffer.forEach((callback)=>callback(arg));
        buffer.length = 0;
    };
    return {
        add: add,
        remove: remove,
        drain: drain
    };
}

});

parcelRegister("6r8bN", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $4afb9deb65acfa84$export$39c6a2b4dbabca5d);

var $i3LOd = parcelRequire("i3LOd");
const $4afb9deb65acfa84$export$39c6a2b4dbabca5d = (0, $i3LOd.abstractHooks);

});

parcelRegister("leBZC", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildLogsConfiguration", () => $f7586062f738c1b4$export$97b29d6675c29e61);
$parcel$export(module.exports, "serializeLogsConfiguration", () => $f7586062f738c1b4$export$3cd09719b205537a);

var $5IDGB = parcelRequire("5IDGB");
var $fkj4Q = parcelRequire("fkj4Q");
var $7S2uk = parcelRequire("7S2uk");
var $3LtP9 = parcelRequire("3LtP9");
var $lHOXU = parcelRequire("lHOXU");
var $7imKH = parcelRequire("7imKH");
const $f7586062f738c1b4$export$22e00ed24ca2e25e = 32 * (0, $7S2uk.ONE_KIBI_BYTE);
function $f7586062f738c1b4$export$97b29d6675c29e61(initConfiguration, errorStack) {
    if (initConfiguration.usePciIntake === true && initConfiguration.site && initConfiguration.site !== 'datadoghq.com') (0, $5IDGB.display).warn('PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.');
    const baseConfiguration = (0, $7imKH.validateAndBuildConfiguration)(initConfiguration, errorStack);
    const forwardConsoleLogs = $f7586062f738c1b4$export$68e7946e3a1d7eed(initConfiguration.forwardConsoleLogs, (0, $fkj4Q.objectValues)((0, $5IDGB.ConsoleApiName)), 'Forward Console Logs');
    const forwardReports = $f7586062f738c1b4$export$68e7946e3a1d7eed(initConfiguration.forwardReports, (0, $fkj4Q.objectValues)((0, $3LtP9.RawReportType)), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) return;
    if (initConfiguration.forwardErrorsToLogs && !forwardConsoleLogs.includes((0, $5IDGB.ConsoleApiName).error)) forwardConsoleLogs.push((0, $5IDGB.ConsoleApiName).error);
    return {
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: $f7586062f738c1b4$export$22e00ed24ca2e25e,
        ...baseConfiguration
    };
}
function $f7586062f738c1b4$export$68e7946e3a1d7eed(option, allowedValues, label) {
    if (option === undefined) return [];
    if (!(option === 'all' || Array.isArray(option) && option.every((api)=>allowedValues.includes(api)))) {
        (0, $5IDGB.display).error(`${label} should be "all" or an array with allowed values "${allowedValues.join('", "')}"`);
        return;
    }
    return option === 'all' ? allowedValues : (0, $lHOXU.removeDuplicates)(option);
}
function $f7586062f738c1b4$export$3cd09719b205537a(configuration) {
    const baseSerializedInitConfiguration = (0, $7imKH.serializeConfiguration)(configuration);
    return {
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
        use_pci_intake: configuration.usePciIntake,
        ...baseSerializedInitConfiguration
    };
}

});
parcelRegister("7imKH", function(module, exports) {

$parcel$export(module.exports, "DefaultPrivacyLevel", () => $54fbdcf742061e48$export$e8c12a778f5ad67c);
$parcel$export(module.exports, "TraceContextInjection", () => $54fbdcf742061e48$export$d060b603b6f9a5d5);
$parcel$export(module.exports, "isSampleRate", () => $54fbdcf742061e48$export$341d55b7c3150b7f);
$parcel$export(module.exports, "validateAndBuildConfiguration", () => $54fbdcf742061e48$export$bb3dd6b9741fea90);
$parcel$export(module.exports, "serializeConfiguration", () => $54fbdcf742061e48$export$948cb0730656da11);

var $1yDAt = parcelRequire("1yDAt");

var $5IDGB = parcelRequire("5IDGB");

var $bQmeT = parcelRequire("bQmeT");

var $8PiRA = parcelRequire("8PiRA");

var $9HnmS = parcelRequire("9HnmS");

var $95XVG = parcelRequire("95XVG");

var $gRb46 = parcelRequire("gRb46");

var $1sTNW = parcelRequire("1sTNW");

var $7yltR = parcelRequire("7yltR");
const $54fbdcf742061e48$export$e8c12a778f5ad67c = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
    MASK_UNLESS_ALLOWLISTED: 'mask-unless-allowlisted'
};
const $54fbdcf742061e48$export$d060b603b6f9a5d5 = {
    ALL: 'all',
    SAMPLED: 'sampled'
};
function $54fbdcf742061e48$var$isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== 'string') {
        (0, $5IDGB.display).error(`${tagName} must be defined as a string`);
        return false;
    }
    return true;
}
function $54fbdcf742061e48$var$isDatadogSite(site) {
    if (site && typeof site === 'string' && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        (0, $5IDGB.display).error(`Site should be a valid Datadog site. ${(0, $5IDGB.MORE_DETAILS)} ${(0, $5IDGB.DOCS_ORIGIN)}/getting_started/site/.`);
        return false;
    }
    return true;
}
function $54fbdcf742061e48$export$341d55b7c3150b7f(sampleRate, name) {
    if (sampleRate !== undefined && !(0, $bQmeT.isPercentage)(sampleRate)) {
        (0, $5IDGB.display).error(`${name} Sample Rate should be a number between 0 and 100`);
        return false;
    }
    return true;
}
function $54fbdcf742061e48$export$bb3dd6b9741fea90(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!initConfiguration || !initConfiguration.clientToken) {
        (0, $5IDGB.display).error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.allowedTrackingOrigins !== undefined && !Array.isArray(initConfiguration.allowedTrackingOrigins)) {
        (0, $5IDGB.display).error('Allowed Tracking Origins must be an array');
        return;
    }
    if (!$54fbdcf742061e48$var$isDatadogSite(initConfiguration.site) || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.sessionSampleRate, 'Session') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetrySampleRate, 'Telemetry') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetryConfigurationSampleRate, 'Telemetry Configuration') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetryUsageSampleRate, 'Telemetry Usage') || !$54fbdcf742061e48$var$isString(initConfiguration.version, 'Version') || !$54fbdcf742061e48$var$isString(initConfiguration.env, 'Env') || !$54fbdcf742061e48$var$isString(initConfiguration.service, 'Service') || !(0, $gRb46.isAllowedTrackingOrigins)(initConfiguration, errorStack !== null && errorStack !== void 0 ? errorStack : '')) return;
    if (initConfiguration.trackingConsent !== undefined && !(0, $8PiRA.objectHasValue)((0, $95XVG.TrackingConsent), initConfiguration.trackingConsent)) {
        (0, $5IDGB.display).error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return {
        beforeSend: initConfiguration.beforeSend && (0, $1yDAt.catchUserErrors)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0, $1sTNW.isWorkerEnvironment) ? undefined : (0, $9HnmS.selectSessionStoreStrategyType)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: (_e = initConfiguration.service) !== null && _e !== void 0 ? _e : undefined,
        env: (_f = initConfiguration.env) !== null && _f !== void 0 ? _f : undefined,
        version: (_g = initConfiguration.version) !== null && _g !== void 0 ? _g : undefined,
        datacenter: (_h = initConfiguration.datacenter) !== null && _h !== void 0 ? _h : undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_j = initConfiguration.trackingConsent) !== null && _j !== void 0 ? _j : (0, $95XVG.TrackingConsent).GRANTED,
        trackAnonymousUser: (_k = initConfiguration.trackAnonymousUser) !== null && _k !== void 0 ? _k : true,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        betaEncodeCookieOptions: !!initConfiguration.betaEncodeCookieOptions,
        /**
         * The source of the SDK, used for support plugins purposes.
         */ variant: initConfiguration.variant,
        sdkVersion: initConfiguration.sdkVersion,
        ...(0, $7yltR.computeTransportConfiguration)(initConfiguration)
    };
}
function $54fbdcf742061e48$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_anonymous_user: initConfiguration.trackAnonymousUser,
        session_persistence: Array.isArray(initConfiguration.sessionPersistence) ? initConfiguration.sessionPersistence[0] : initConfiguration.sessionPersistence,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent,
        use_allowed_tracking_origins: Array.isArray(initConfiguration.allowedTrackingOrigins),
        beta_encode_cookie_options: initConfiguration.betaEncodeCookieOptions,
        source: initConfiguration.source,
        sdk_version: initConfiguration.sdkVersion,
        variant: initConfiguration.variant
    };
}

});
parcelRegister("gRb46", function(module, exports) {

$parcel$export(module.exports, "isAllowedTrackingOrigins", () => $c45a2de6b16f2a2b$export$535fd1118e4d98ab);

var $5IDGB = parcelRequire("5IDGB");

var $1sTNW = parcelRequire("1sTNW");

var $fzLbJ = parcelRequire("fzLbJ");

var $4Umqd = parcelRequire("4Umqd");

var $13vUy = parcelRequire("13vUy");
const $c45a2de6b16f2a2b$export$58a2d2910fbd692f = 'Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.';
const $c45a2de6b16f2a2b$export$ee1c7410b08fb439 = 'SDK initialized on a non-allowed domain.';
function $c45a2de6b16f2a2b$export$535fd1118e4d98ab(configuration, errorStack) {
    const location = (0, $4Umqd.mockable)((0, $1sTNW.getGlobalObject)().location);
    const windowOrigin = location ? location.origin : '';
    const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
    if (!allowedTrackingOrigins) {
        if ((0, $13vUy.isUnsupportedExtensionEnvironment)(windowOrigin, errorStack)) {
            (0, $5IDGB.display).error($c45a2de6b16f2a2b$export$58a2d2910fbd692f);
            return false;
        }
        return true;
    }
    const isAllowed = (0, $fzLbJ.matchList)(allowedTrackingOrigins, windowOrigin);
    if (!isAllowed) (0, $5IDGB.display).error($c45a2de6b16f2a2b$export$ee1c7410b08fb439);
    return isAllowed;
}

});
parcelRegister("fzLbJ", function(module, exports) {

$parcel$export(module.exports, "isMatchOption", () => $b56eba7faf105c60$export$b620f5b550eaf484);
$parcel$export(module.exports, "matchList", () => $b56eba7faf105c60$export$eb5a30555469227);

var $5IDGB = parcelRequire("5IDGB");

var $5DEie = parcelRequire("5DEie");
function $b56eba7faf105c60$export$b620f5b550eaf484(item) {
    const itemType = (0, $5DEie.getType)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
function $b56eba7faf105c60$export$eb5a30555469227(list, value, useStartsWith = false) {
    return list.some((item)=>{
        try {
            if (typeof item === 'function') return item(value);
            else if (item instanceof RegExp) {
                // Prevent stateful matching
                item.lastIndex = 0;
                return item.test(value);
            } else if (typeof item === 'string') return useStartsWith ? value.startsWith(item) : item === value;
        } catch (e) {
            (0, $5IDGB.display).error(e);
        }
        return false;
    });
}

});

parcelRegister("13vUy", function(module, exports) {

$parcel$export(module.exports, "isUnsupportedExtensionEnvironment", () => $0c4ed3240483a490$export$2234becf7269aa18);
const $0c4ed3240483a490$export$145fc3a465813f29 = [
    'chrome-extension://',
    'moz-extension://'
];
function $0c4ed3240483a490$export$5e93b7e8021af3c3(str) {
    return $0c4ed3240483a490$export$145fc3a465813f29.some((prefix)=>str.includes(prefix));
}
function $0c4ed3240483a490$export$2234becf7269aa18(windowLocation, stack = '') {
    // If the page itself is an extension page.
    if ($0c4ed3240483a490$export$5e93b7e8021af3c3(windowLocation)) return false;
    // Since we generate the error on the init, we check the 2nd frame line.
    const frameLines = stack.split('\n').filter((line)=>{
        const trimmedLine = line.trim();
        return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
    });
    const target = frameLines[1] || '';
    return $0c4ed3240483a490$export$5e93b7e8021af3c3(target);
}

});







parcelRegister("cNbKI", function(module, exports) {

$parcel$export(module.exports, "datadogRum", () => $95032d6edbc0e5a2$export$65cc181beb0d2632);
/**
 * Datadog Browser RUM SDK - Full version with Session Replay and Real User Profiling capabilities.
 * Use this package to monitor your web application's performance and user experience.
 *
 * @packageDocumentation
 * @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
 */ // Keep the following in sync with packages/rum-slim/src/entries/main.ts

var $ewVF5 = parcelRequire("ewVF5");
var $1sTNW = parcelRequire("1sTNW");
parcelRequire("4oXVz");
var $ha0y0 = parcelRequire("ha0y0");

var $3VNwe = parcelRequire("3VNwe");
parcelRequire("l2g7V");
var $3nvYK = parcelRequire("3nvYK");
var $ftUlk = parcelRequire("ftUlk");

var $kQuIw = parcelRequire("kQuIw");
const $95032d6edbc0e5a2$var$recorderApi = (0, $3VNwe.makeRecorderApi)();
const $95032d6edbc0e5a2$var$profilerApi = (0, $kQuIw.makeProfilerApi)();
const $95032d6edbc0e5a2$export$65cc181beb0d2632 = (0, $ha0y0.makeRumPublicApi)($95032d6edbc0e5a2$var$recorderApi, $95032d6edbc0e5a2$var$profilerApi, {
    startDeflateWorker: $ftUlk.startDeflateWorker,
    createDeflateEncoder: $3nvYK.createDeflateEncoder,
    sdkName: 'rum'
});
(0, $ewVF5.defineGlobal)((0, $1sTNW.getGlobalObject)(), 'DD_RUM', $95032d6edbc0e5a2$export$65cc181beb0d2632);

});
parcelRegister("4oXVz", function(module, exports) {
$parcel$export(module.exports, "forEachChildNodes", () => (parcelRequire("4TGNe")).forEachChildNodes);
$parcel$export(module.exports, "getParentNode", () => (parcelRequire("4TGNe")).getParentNode);
$parcel$export(module.exports, "hasChildNodes", () => (parcelRequire("4TGNe")).hasChildNodes);
$parcel$export(module.exports, "isElementNode", () => (parcelRequire("4TGNe")).isElementNode);
$parcel$export(module.exports, "isNodeShadowHost", () => (parcelRequire("4TGNe")).isNodeShadowHost);
$parcel$export(module.exports, "isNodeShadowRoot", () => (parcelRequire("4TGNe")).isNodeShadowRoot);
$parcel$export(module.exports, "getNodePrivacyLevel", () => (parcelRequire("OddO2")).getNodePrivacyLevel);
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", () => (parcelRequire("OddO2")).getNodeSelfPrivacyLevel);
$parcel$export(module.exports, "getTextContent", () => (parcelRequire("OddO2")).getTextContent);
$parcel$export(module.exports, "reducePrivacyLevel", () => (parcelRequire("OddO2")).reducePrivacyLevel);
$parcel$export(module.exports, "shouldMaskAttribute", () => (parcelRequire("OddO2")).shouldMaskAttribute);
$parcel$export(module.exports, "shouldMaskNode", () => (parcelRequire("OddO2")).shouldMaskNode);
$parcel$export(module.exports, "CENSORED_IMG_MARK", () => (parcelRequire("8EzN6")).CENSORED_IMG_MARK);
$parcel$export(module.exports, "CENSORED_STRING_MARK", () => (parcelRequire("8EzN6")).CENSORED_STRING_MARK);
$parcel$export(module.exports, "NodePrivacyLevel", () => (parcelRequire("8EzN6")).NodePrivacyLevel);
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", () => (parcelRequire("8EzN6")).PRIVACY_ATTR_NAME);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", () => (parcelRequire("8EzN6")).PRIVACY_ATTR_VALUE_HIDDEN);

$parcel$export(module.exports, "makeRumPublicApi", () => (parcelRequire("ha0y0")).makeRumPublicApi);
$parcel$export(module.exports, "RumEventType", () => (parcelRequire("kDJMQ")).RumEventType);
$parcel$export(module.exports, "RumLongTaskEntryType", () => (parcelRequire("kDJMQ")).RumLongTaskEntryType);
$parcel$export(module.exports, "getMutationObserverConstructor", () => (parcelRequire("2Bt7w")).getMutationObserverConstructor);
$parcel$export(module.exports, "initViewportObservable", () => (parcelRequire("kom4r")).initViewportObservable);
$parcel$export(module.exports, "getViewportDimension", () => (parcelRequire("kom4r")).getViewportDimension);
$parcel$export(module.exports, "getScrollX", () => (parcelRequire("fvpT8")).getScrollX);
$parcel$export(module.exports, "getScrollY", () => (parcelRequire("fvpT8")).getScrollY);
$parcel$export(module.exports, "getSessionReplayUrl", () => (parcelRequire("dKooA")).getSessionReplayUrl);
$parcel$export(module.exports, "sanitizeIfLongDataUrl", () => (parcelRequire("fisL9")).sanitizeIfLongDataUrl);
$parcel$export(module.exports, "RumPerformanceEntryType", () => (parcelRequire("e6Vsp")).RumPerformanceEntryType);
$parcel$export(module.exports, "isSampled", () => (parcelRequire("2Gs1I")).isSampled);
$parcel$export(module.exports, "createFormDataTransport", () => (parcelRequire("75B79")).createFormDataTransport);

var $ha0y0 = parcelRequire("ha0y0");

var $kDJMQ = parcelRequire("kDJMQ");

var $2q14q = parcelRequire("2q14q");

var $54uGZ = parcelRequire("54uGZ");

var $aJJWw = parcelRequire("aJJWw");

var $2Bt7w = parcelRequire("2Bt7w");

var $kom4r = parcelRequire("kom4r");

var $fvpT8 = parcelRequire("fvpT8");
parcelRequire("4uKwV");
var $dX6Ct = parcelRequire("dX6Ct");

var $8NBqb = parcelRequire("8NBqb");

var $l3o7w = parcelRequire("l3o7w");
parcelRequire("4TGNe");

var $dKooA = parcelRequire("dKooA");

var $fisL9 = parcelRequire("fisL9");
parcelRequire("OddO2");
parcelRequire("8EzN6");

var $e6Vsp = parcelRequire("e6Vsp");

var $YfZsf = parcelRequire("YfZsf");

var $2Gs1I = parcelRequire("2Gs1I");

var $75B79 = parcelRequire("75B79");

});
parcelRegister("ha0y0", function(module, exports) {

$parcel$export(module.exports, "makeRumPublicApi", () => $c7e3cb8a60bc2b2b$export$27595a139f6e6837);

var $fhNdh = parcelRequire("fhNdh");
var $2wH3Z = parcelRequire("2wH3Z");
var $ly0px = parcelRequire("ly0px");
var $7v3G2 = parcelRequire("7v3G2");
var $6q317 = parcelRequire("6q317");
var $lTIYX = parcelRequire("lTIYX");
var $95XVG = parcelRequire("95XVG");
var $j9iCm = parcelRequire("j9iCm");
var $cJkro = parcelRequire("cJkro");
var $gurxr = parcelRequire("gurxr");
var $k2pmh = parcelRequire("k2pmh");
var $99fDv = parcelRequire("99fDv");
var $ewVF5 = parcelRequire("ewVF5");
var $4Umqd = parcelRequire("4Umqd");
var $1RdIU = parcelRequire("1RdIU");
var $ia9TG = parcelRequire("ia9TG");

var $kDJMQ = parcelRequire("kDJMQ");

var $aSnVp = parcelRequire("aSnVp");

var $f1Ads = parcelRequire("f1Ads");

var $e8LWu = parcelRequire("e8LWu");

var $2q14q = parcelRequire("2q14q");
function $c7e3cb8a60bc2b2b$export$27595a139f6e6837(recorderApi, profilerApi, options = {}) {
    const trackingConsentState = (0, $95XVG.createTrackingConsentState)();
    const customVitalsState = (0, $aSnVp.createCustomVitalsState)();
    const bufferedDataObservable = (0, $ia9TG.startBufferingData)().observable;
    let strategy = (0, $e8LWu.createPreStartStrategy)(options, trackingConsentState, customVitalsState, (configuration, deflateWorker, initialViewOptions, telemetry, hooks)=>{
        const createEncoder = deflateWorker && options.createDeflateEncoder ? (streamId)=>options.createDeflateEncoder(configuration, deflateWorker, streamId) : (0, $lTIYX.createIdentityEncoder);
        const startRumResult = (0, $4Umqd.mockable)((0, $2q14q.startRum))(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, trackingConsentState, customVitalsState, bufferedDataObservable, telemetry, hooks, options.sdkName);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewHistory, deflateWorker, startRumResult.telemetry);
        profilerApi.onRumStart(startRumResult.lifeCycle, startRumResult.hooks, configuration, startRumResult.session, startRumResult.viewHistory, createEncoder);
        strategy = $c7e3cb8a60bc2b2b$var$createPostStartStrategy(strategy, startRumResult);
        (0, $f1Ads.callPluginsMethod)(configuration.plugins, 'onRumStart', {
            strategy: strategy,
            addEvent: startRumResult.addEvent,
            addError: startRumResult.addError
        });
        return startRumResult;
    });
    const getStrategy = ()=>strategy;
    const startView = (options)=>{
        const handlingStack = (0, $6q317.createHandlingStack)('view');
        (0, $2wH3Z.callMonitored)(()=>{
            const sanitizedOptions = typeof options === 'object' ? options : {
                name: options
            };
            strategy.startView({
                ...sanitizedOptions,
                handlingStack: handlingStack
            });
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'start-view'
            });
        });
    };
    const rumPublicApi = (0, $ewVF5.makePublicApi)({
        init: (initConfiguration)=>{
            const errorStack = new Error().stack;
            (0, $2wH3Z.callMonitored)(()=>strategy.init(initConfiguration, rumPublicApi, errorStack));
        },
        setTrackingConsent: (0, $2wH3Z.monitor)((trackingConsent)=>{
            trackingConsentState.update(trackingConsent);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-tracking-consent',
                tracking_consent: trackingConsent
            });
        }),
        setViewName: (0, $2wH3Z.monitor)((name)=>{
            strategy.setViewName(name);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-view-name'
            });
        }),
        setViewContext: (0, $2wH3Z.monitor)((context)=>{
            strategy.setViewContext(context);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-view-context'
            });
        }),
        setViewContextProperty: (0, $2wH3Z.monitor)((key, value)=>{
            strategy.setViewContextProperty(key, value);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-view-context-property'
            });
        }),
        getViewContext: (0, $2wH3Z.monitor)(()=>{
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'set-view-context-property'
            });
            return strategy.getViewContext();
        }),
        getInternalContext: (0, $2wH3Z.monitor)((startTime)=>strategy.getInternalContext(startTime)),
        getInitConfiguration: (0, $2wH3Z.monitor)(()=>(0, $j9iCm.deepClone)(strategy.initConfiguration)),
        addAction: (name, context)=>{
            const handlingStack = (0, $6q317.createHandlingStack)('action');
            (0, $2wH3Z.callMonitored)(()=>{
                strategy.addAction({
                    name: (0, $1RdIU.sanitize)(name),
                    context: (0, $1RdIU.sanitize)(context),
                    startClocks: (0, $ly0px.clocksNow)(),
                    type: (0, $kDJMQ.ActionType).CUSTOM,
                    handlingStack: handlingStack
                });
                (0, $fhNdh.addTelemetryUsage)({
                    feature: 'add-action'
                });
            });
        },
        startAction: (0, $2wH3Z.monitor)((name, options)=>{
            // Check feature flag only after init; pre-init calls should be buffered
            if (strategy.initConfiguration && !(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).START_STOP_ACTION)) return;
            // addTelemetryUsage({ feature: 'start-action' })
            strategy.startAction((0, $1RdIU.sanitize)(name), {
                type: (0, $1RdIU.sanitize)(options && options.type),
                context: (0, $1RdIU.sanitize)(options && options.context),
                actionKey: options && options.actionKey
            });
        }),
        stopAction: (0, $2wH3Z.monitor)((name, options)=>{
            if (strategy.initConfiguration && !(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).START_STOP_ACTION)) return;
            // addTelemetryUsage({ feature: 'stop-action' })
            strategy.stopAction((0, $1RdIU.sanitize)(name), {
                type: (0, $1RdIU.sanitize)(options && options.type),
                context: (0, $1RdIU.sanitize)(options && options.context),
                actionKey: options && options.actionKey
            });
        }),
        startResource: (0, $2wH3Z.monitor)((url, options)=>{
            // Check feature flag only after init; pre-init calls should be buffered
            if (strategy.initConfiguration && !(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).START_STOP_RESOURCE)) return;
            // addTelemetryUsage({ feature: 'start-resource' })
            strategy.startResource((0, $1RdIU.sanitize)(url), {
                type: (0, $1RdIU.sanitize)(options && options.type),
                method: (0, $1RdIU.sanitize)(options && options.method),
                context: (0, $1RdIU.sanitize)(options && options.context),
                resourceKey: options && options.resourceKey
            });
        }),
        stopResource: (0, $2wH3Z.monitor)((url, options)=>{
            if (strategy.initConfiguration && !(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).START_STOP_RESOURCE)) return;
            // addTelemetryUsage({ feature: 'stop-resource' })
            strategy.stopResource((0, $1RdIU.sanitize)(url), {
                type: (0, $1RdIU.sanitize)(options && options.type),
                statusCode: options && options.statusCode,
                size: options && options.size,
                context: (0, $1RdIU.sanitize)(options && options.context),
                resourceKey: options && options.resourceKey
            });
        }),
        addError: (error, context)=>{
            const handlingStack = (0, $6q317.createHandlingStack)('error');
            (0, $2wH3Z.callMonitored)(()=>{
                strategy.addError({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, $1RdIU.sanitize)(context),
                    startClocks: (0, $ly0px.clocksNow)()
                });
                (0, $fhNdh.addTelemetryUsage)({
                    feature: 'add-error'
                });
            });
        },
        addTiming: (0, $2wH3Z.monitor)((name, time)=>{
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0, $1RdIU.sanitize)(name), time);
        }),
        setViewLoadingTime: (0, $2wH3Z.monitor)(()=>{
            const callTimestamp = (0, $ly0px.timeStampNow)();
            strategy.setLoadingTime(callTimestamp);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'addViewLoadingTime'
            });
        }),
        setGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).setContext, 'set-global-context'),
        getGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).getContext, 'get-global-context'),
        setGlobalContextProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).setContextProperty, 'set-global-context-property'),
        removeGlobalContextProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty, 'remove-global-context-property'),
        clearGlobalContext: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).globalContext, (0, $7v3G2.ContextManagerMethod).clearContext, 'clear-global-context'),
        setUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).setContext, 'set-user'),
        getUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).getContext, 'get-user'),
        setUserProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).setContextProperty, 'set-user-property'),
        removeUserProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty, 'remove-user-property'),
        clearUser: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).userContext, (0, $7v3G2.ContextManagerMethod).clearContext, 'clear-user'),
        setAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).setContext, 'set-account'),
        getAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).getContext, 'get-account'),
        setAccountProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).setContextProperty, 'set-account-property'),
        removeAccountProperty: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).removeContextProperty, 'remove-account-property'),
        clearAccount: (0, $cJkro.defineContextMethod)(getStrategy, (0, $7v3G2.CustomerContextKey).accountContext, (0, $7v3G2.ContextManagerMethod).clearContext, 'clear-account'),
        startView: startView,
        stopSession: (0, $2wH3Z.monitor)(()=>{
            strategy.stopSession();
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'stop-session'
            });
        }),
        addFeatureFlagEvaluation: (0, $2wH3Z.monitor)((key, value)=>{
            strategy.addFeatureFlagEvaluation((0, $1RdIU.sanitize)(key), (0, $1RdIU.sanitize)(value));
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'add-feature-flag-evaluation'
            });
        }),
        getSessionReplayLink: (0, $2wH3Z.monitor)(()=>recorderApi.getSessionReplayLink()),
        startSessionReplayRecording: (0, $2wH3Z.monitor)((options)=>{
            recorderApi.start(options);
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'start-session-replay-recording',
                force: options && options.force
            });
        }),
        stopSessionReplayRecording: (0, $2wH3Z.monitor)(()=>recorderApi.stop()),
        addDurationVital: (name, options)=>{
            const handlingStack = (0, $6q317.createHandlingStack)('vital');
            (0, $2wH3Z.callMonitored)(()=>{
                (0, $fhNdh.addTelemetryUsage)({
                    feature: 'add-duration-vital'
                });
                strategy.addDurationVital({
                    id: (0, $99fDv.generateUUID)(),
                    name: (0, $1RdIU.sanitize)(name),
                    type: (0, $kDJMQ.VitalType).DURATION,
                    startClocks: (0, $ly0px.timeStampToClocks)(options.startTime),
                    duration: options.duration,
                    context: (0, $1RdIU.sanitize)(options && options.context),
                    description: (0, $1RdIU.sanitize)(options && options.description),
                    handlingStack: handlingStack
                });
            });
        },
        startDurationVital: (name, options)=>{
            const handlingStack = (0, $6q317.createHandlingStack)('vital');
            return (0, $2wH3Z.callMonitored)(()=>{
                (0, $fhNdh.addTelemetryUsage)({
                    feature: 'start-duration-vital'
                });
                return strategy.startDurationVital((0, $1RdIU.sanitize)(name), {
                    context: (0, $1RdIU.sanitize)(options && options.context),
                    description: (0, $1RdIU.sanitize)(options && options.description),
                    handlingStack: handlingStack
                });
            });
        },
        stopDurationVital: (0, $2wH3Z.monitor)((nameOrRef, options)=>{
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'stop-duration-vital'
            });
            strategy.stopDurationVital(typeof nameOrRef === 'string' ? (0, $1RdIU.sanitize)(nameOrRef) : nameOrRef, {
                context: (0, $1RdIU.sanitize)(options && options.context),
                description: (0, $1RdIU.sanitize)(options && options.description)
            });
        }),
        startFeatureOperation: (name, options)=>{
            const handlingStack = (0, $6q317.createHandlingStack)('vital');
            (0, $2wH3Z.callMonitored)(()=>{
                (0, $fhNdh.addTelemetryUsage)({
                    feature: 'add-operation-step-vital',
                    action_type: 'start'
                });
                strategy.addOperationStepVital(name, 'start', {
                    ...options,
                    handlingStack: handlingStack
                });
            });
        },
        succeedFeatureOperation: (0, $2wH3Z.monitor)((name, options)=>{
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'add-operation-step-vital',
                action_type: 'succeed'
            });
            strategy.addOperationStepVital(name, 'end', options);
        }),
        failFeatureOperation: (0, $2wH3Z.monitor)((name, failureReason, options)=>{
            (0, $fhNdh.addTelemetryUsage)({
                feature: 'add-operation-step-vital',
                action_type: 'fail'
            });
            strategy.addOperationStepVital(name, 'end', options, failureReason);
        })
    });
    return rumPublicApi;
}
function $c7e3cb8a60bc2b2b$var$createPostStartStrategy(preStartStrategy, startRumResult) {
    return {
        init: (initConfiguration)=>{
            (0, $gurxr.displayAlreadyInitializedError)('DD_RUM', initConfiguration);
        },
        initConfiguration: preStartStrategy.initConfiguration,
        ...startRumResult
    };
}

});
parcelRegister("kDJMQ", function(module, exports) {

$parcel$export(module.exports, "RumEventType", () => $f06af77fb07910fd$export$ce36bdd8bcd00f70);
$parcel$export(module.exports, "RumLongTaskEntryType", () => $f06af77fb07910fd$export$292a466c44f68ccd);
$parcel$export(module.exports, "ViewLoadingType", () => $f06af77fb07910fd$export$82f61b2f79c8be94);
$parcel$export(module.exports, "ActionType", () => $f06af77fb07910fd$export$e4a712fff93fb00f);
$parcel$export(module.exports, "FrustrationType", () => $f06af77fb07910fd$export$9de4b95bcfcfa4e1);
$parcel$export(module.exports, "VitalType", () => $f06af77fb07910fd$export$e7428258e7ebc9a7);
const $f06af77fb07910fd$export$ce36bdd8bcd00f70 = {
    ACTION: 'action',
    ERROR: 'error',
    LONG_TASK: 'long_task',
    VIEW: 'view',
    RESOURCE: 'resource',
    VITAL: 'vital'
};
const $f06af77fb07910fd$export$292a466c44f68ccd = {
    LONG_TASK: 'long-task',
    LONG_ANIMATION_FRAME: 'long-animation-frame'
};
const $f06af77fb07910fd$export$82f61b2f79c8be94 = {
    INITIAL_LOAD: 'initial_load',
    ROUTE_CHANGE: 'route_change',
    BF_CACHE: 'bf_cache'
};
const $f06af77fb07910fd$export$e4a712fff93fb00f = {
    CLICK: 'click',
    CUSTOM: 'custom',
    TAP: 'tap',
    SCROLL: 'scroll',
    SWIPE: 'swipe',
    APPLICATION_START: 'application_start',
    BACK: 'back'
};
const $f06af77fb07910fd$export$9de4b95bcfcfa4e1 = {
    RAGE_CLICK: 'rage_click',
    ERROR_CLICK: 'error_click',
    DEAD_CLICK: 'dead_click'
};
const $f06af77fb07910fd$export$e7428258e7ebc9a7 = {
    DURATION: 'duration',
    OPERATION_STEP: 'operation_step'
};

});

parcelRegister("aSnVp", function(module, exports) {

$parcel$export(module.exports, "createCustomVitalsState", () => $7eb1818b147a2865$export$10f357105ec5707a);
$parcel$export(module.exports, "startVitalCollection", () => $7eb1818b147a2865$export$1f5a51a997c60d35);
$parcel$export(module.exports, "startDurationVital", () => $7eb1818b147a2865$export$861e77a28cc19266);
$parcel$export(module.exports, "stopDurationVital", () => $7eb1818b147a2865$export$ccd4fac39ed3f334);

var $ly0px = parcelRequire("ly0px");
var $j9iCm = parcelRequire("j9iCm");
var $k2pmh = parcelRequire("k2pmh");
var $99fDv = parcelRequire("99fDv");
var $1RdIU = parcelRequire("1RdIU");

var $kDJMQ = parcelRequire("kDJMQ");
function $7eb1818b147a2865$export$10f357105ec5707a() {
    const vitalsByName = new Map();
    const vitalsByReference = new WeakMap();
    return {
        vitalsByName: vitalsByName,
        vitalsByReference: vitalsByReference
    };
}
function $7eb1818b147a2865$export$1f5a51a997c60d35(lifeCycle, pageStateHistory, customVitalsState) {
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $7eb1818b147a2865$var$processVital(vital));
    }
    function addOperationStepVital(name, stepType, options, failureReason) {
        if (!(0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).FEATURE_OPERATION_VITAL)) return;
        const { operationKey: operationKey, context: context, description: description, handlingStack: handlingStack } = options || {};
        const vital = {
            name: name,
            type: (0, $kDJMQ.VitalType).OPERATION_STEP,
            operationKey: operationKey,
            failureReason: failureReason,
            stepType: stepType,
            startClocks: (0, $ly0px.clocksNow)(),
            context: (0, $1RdIU.sanitize)(context),
            description: description,
            handlingStack: handlingStack
        };
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $7eb1818b147a2865$var$processVital(vital));
    }
    return {
        addOperationStepVital: addOperationStepVital,
        addDurationVital: addDurationVital,
        startDurationVital: (name, options = {})=>{
            const ref = $7eb1818b147a2865$export$861e77a28cc19266(customVitalsState, name, options);
            const vitalState = customVitalsState.vitalsByReference.get(ref);
            if (vitalState) lifeCycle.notify(16 /* LifeCycleEventType.VITAL_STARTED */ , vitalState);
            return ref;
        },
        stopDurationVital: (nameOrRef, options = {})=>{
            $7eb1818b147a2865$export$ccd4fac39ed3f334(addDurationVital, customVitalsState, nameOrRef, options);
        }
    };
}
function $7eb1818b147a2865$export$861e77a28cc19266({ vitalsByName: vitalsByName, vitalsByReference: vitalsByReference }, name, options = {}) {
    const vital = {
        id: (0, $99fDv.generateUUID)(),
        name: name,
        startClocks: (0, $ly0px.clocksNow)(),
        ...options
    };
    // To avoid leaking implementation details of the vital, we return a reference to it.
    const reference = {
        __dd_vital_reference: true
    };
    vitalsByName.set(name, vital);
    // To avoid memory leaks caused by the creation of numerous references (e.g., from improper useEffect implementations), we use a WeakMap.
    vitalsByReference.set(reference, vital);
    return reference;
}
function $7eb1818b147a2865$export$ccd4fac39ed3f334(stopCallback, { vitalsByName: vitalsByName, vitalsByReference: vitalsByReference }, nameOrRef, options = {}) {
    const vitalStart = typeof nameOrRef === 'string' ? vitalsByName.get(nameOrRef) : vitalsByReference.get(nameOrRef);
    if (!vitalStart) return;
    stopCallback($7eb1818b147a2865$var$buildDurationVital(vitalStart, vitalStart.startClocks, options, (0, $ly0px.clocksNow)()));
    if (typeof nameOrRef === 'string') vitalsByName.delete(nameOrRef);
    else vitalsByReference.delete(nameOrRef);
}
function $7eb1818b147a2865$var$buildDurationVital(vitalStart, startClocks, stopOptions, stopClocks) {
    var _a;
    return {
        id: vitalStart.id,
        name: vitalStart.name,
        type: (0, $kDJMQ.VitalType).DURATION,
        startClocks: startClocks,
        duration: (0, $ly0px.elapsed)(startClocks.timeStamp, stopClocks.timeStamp),
        context: (0, $j9iCm.combine)(vitalStart.context, stopOptions.context),
        description: (_a = stopOptions.description) !== null && _a !== void 0 ? _a : vitalStart.description,
        handlingStack: vitalStart.handlingStack
    };
}
function $7eb1818b147a2865$var$processVital(vital) {
    const { startClocks: startClocks, type: type, name: name, description: description, context: context, handlingStack: handlingStack } = vital;
    const vitalId = vital.type === (0, $kDJMQ.VitalType).DURATION ? vital.id : undefined;
    const vitalData = {
        id: vitalId !== null && vitalId !== void 0 ? vitalId : (0, $99fDv.generateUUID)(),
        type: type,
        name: name,
        description: description,
        ...type === (0, $kDJMQ.VitalType).DURATION ? {
            duration: (0, $ly0px.toServerDuration)(vital.duration)
        } : {
            step_type: vital.stepType,
            operation_key: vital.operationKey,
            failure_reason: vital.failureReason
        }
    };
    return {
        rawRumEvent: {
            date: startClocks.timeStamp,
            vital: vitalData,
            type: (0, $kDJMQ.RumEventType).VITAL,
            context: context
        },
        startClocks: startClocks,
        duration: type === (0, $kDJMQ.VitalType).DURATION ? vital.duration : undefined,
        domainContext: handlingStack ? {
            handlingStack: handlingStack
        } : {}
    };
}

});

parcelRegister("f1Ads", function(module, exports) {

$parcel$export(module.exports, "callPluginsMethod", () => $af030ac9e0faa3f9$export$165b46b876b53122);
function $af030ac9e0faa3f9$export$165b46b876b53122(plugins, methodName, parameter) {
    if (!plugins) return;
    for (const plugin of plugins){
        const method = plugin[methodName];
        if (method) method(parameter);
    }
}

});

parcelRegister("e8LWu", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $a4b70066dfc326ec$export$8f7002373dcc6602);

var $fhNdh = parcelRequire("fhNdh");
var $aqcpf = parcelRequire("aqcpf");
var $gZP56 = parcelRequire("gZP56");
var $djpEA = parcelRequire("djpEA");
var $kFaIT = parcelRequire("kFaIT");
var $ly0px = parcelRequire("ly0px");
var $kSv4n = parcelRequire("kSv4n");
var $7v3G2 = parcelRequire("7v3G2");
var $5IDGB = parcelRequire("5IDGB");
var $gurxr = parcelRequire("gurxr");
var $k2pmh = parcelRequire("k2pmh");
var $lEdKn = parcelRequire("lEdKn");
var $4Umqd = parcelRequire("4Umqd");
var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
var $1RdIU = parcelRequire("1RdIU");
var $eA1KP = parcelRequire("eA1KP");

var $YfZsf = parcelRequire("YfZsf");
parcelRequire("4uKwV");
var $eLMiS = parcelRequire("eLMiS");
var $dX6Ct = parcelRequire("dX6Ct");

var $aSnVp = parcelRequire("aSnVp");

var $f1Ads = parcelRequire("f1Ads");
function $a4b70066dfc326ec$export$8f7002373dcc6602({ ignoreInitIfSyntheticsWillInjectRum: ignoreInitIfSyntheticsWillInjectRum = true, startDeflateWorker: startDeflateWorker }, trackingConsentState, customVitalsState, doStartRum) {
    const bufferApiCalls = (0, $kSv4n.createBoundedBuffer)();
    // TODO next major: remove the globalContextManager, userContextManager and accountContextManager from preStartStrategy and use an empty context instead
    const globalContext = (0, $gZP56.buildGlobalContextManager)();
    $a4b70066dfc326ec$var$bufferContextCalls(globalContext, (0, $7v3G2.CustomerContextKey).globalContext, bufferApiCalls);
    const userContext = (0, $djpEA.buildUserContextManager)();
    $a4b70066dfc326ec$var$bufferContextCalls(userContext, (0, $7v3G2.CustomerContextKey).userContext, bufferApiCalls);
    const accountContext = (0, $aqcpf.buildAccountContextManager)();
    $a4b70066dfc326ec$var$bufferContextCalls(accountContext, (0, $7v3G2.CustomerContextKey).accountContext, bufferApiCalls);
    let firstStartViewCall;
    let deflateWorker;
    let cachedInitConfiguration;
    let cachedConfiguration;
    let telemetry;
    const hooks = (0, $YfZsf.createHooks)();
    const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    const emptyContext = {};
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) return;
        // Start telemetry only once, when we have consent and configuration
        if (!telemetry) telemetry = (0, $4Umqd.mockable)((0, $fhNdh.startTelemetry))("browser-rum-sdk" /* TelemetryService.RUM */ , cachedConfiguration, hooks);
        trackingConsentStateSubscription.unsubscribe();
        let initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) return;
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        const startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions, telemetry, hooks);
        bufferApiCalls.drain(startRumResult);
    }
    function doInit(initConfiguration, errorStack) {
        const eventBridgeAvailable = (0, $kFaIT.canUseEventBridge)();
        if (eventBridgeAvailable) initConfiguration = $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration);
        // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
        cachedInitConfiguration = initConfiguration;
        (0, $fhNdh.addTelemetryConfiguration)((0, $dX6Ct.serializeRumConfiguration)(initConfiguration));
        if (cachedConfiguration) {
            (0, $gurxr.displayAlreadyInitializedError)('DD_RUM', initConfiguration);
            return;
        }
        const configuration = (0, $dX6Ct.validateAndBuildRumConfiguration)(initConfiguration, errorStack);
        if (!configuration) return;
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            (0, $5IDGB.display).warn('No storage available for session. We will not send any data.');
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            (0, $aed8w.noop));
            if (!deflateWorker) // `startDeflateWorker` should have logged an error message explaining the issue
            return;
        }
        cachedConfiguration = configuration;
        // Instrument fetch to track network requests
        // This is needed in case the consent is not granted and some customer
        // library (Apollo Client) is storing uninstrumented fetch to be used later
        // The subscription is needed so that the instrumentation process is completed
        (0, $lEdKn.initFetchObservable)().subscribe((0, $aed8w.noop));
        trackingConsentState.tryToInit(configuration.trackingConsent);
        tryStartRum();
    }
    const addDurationVital = (vital)=>{
        bufferApiCalls.add((startRumResult)=>startRumResult.addDurationVital(vital));
    };
    const addOperationStepVital = (name, stepType, options, failureReason)=>{
        bufferApiCalls.add((startRumResult)=>startRumResult.addOperationStepVital((0, $1RdIU.sanitize)(name), stepType, (0, $1RdIU.sanitize)(options), (0, $1RdIU.sanitize)(failureReason)));
    };
    const strategy = {
        init (initConfiguration, publicApi, errorStack) {
            if (!initConfiguration) {
                (0, $5IDGB.display).error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            (0, $k2pmh.initFeatureFlags)(initConfiguration.enableExperimentalFeatures);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && (0, $eA1KP.willSyntheticsInjectRum)()) return;
            (0, $f1Ads.callPluginsMethod)(initConfiguration.plugins, 'onInit', {
                initConfiguration: initConfiguration,
                publicApi: publicApi
            });
            if (initConfiguration.remoteConfigurationId) (0, $eLMiS.fetchAndApplyRemoteConfiguration)(initConfiguration, {
                user: userContext,
                context: globalContext
            }).then((initConfiguration)=>{
                if (initConfiguration) doInit(initConfiguration, errorStack);
            }).catch((0, $2wH3Z.monitorError));
            else doInit(initConfiguration, errorStack);
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $aed8w.noop),
        stopSession: (0, $aed8w.noop),
        addTiming (name, time = (0, $ly0px.timeStampNow)()) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addTiming(name, time));
        },
        setLoadingTime: (callTimestamp)=>{
            bufferApiCalls.add((startRumResult)=>startRumResult.setLoadingTime(callTimestamp));
        },
        startView (options, startClocks = (0, $ly0px.clocksNow)()) {
            const callback = (startRumResult)=>{
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = {
                    options: options,
                    callback: callback
                };
                tryStartRum();
            }
        },
        setViewName (name) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewName(name));
        },
        // View context APIs
        setViewContext (context) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewContext(context));
        },
        setViewContextProperty (key, value) {
            bufferApiCalls.add((startRumResult)=>startRumResult.setViewContextProperty(key, value));
        },
        getViewContext: ()=>emptyContext,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        addAction (action) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addAction(action));
        },
        startAction (name, options) {
            const startClocks = (0, $ly0px.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.startAction(name, options, startClocks));
        },
        stopAction (name, options) {
            const stopClocks = (0, $ly0px.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.stopAction(name, options, stopClocks));
        },
        startResource (url, options) {
            const startClocks = (0, $ly0px.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.startResource(url, options, startClocks));
        },
        stopResource (url, options) {
            const stopClocks = (0, $ly0px.clocksNow)();
            bufferApiCalls.add((startRumResult)=>startRumResult.stopResource(url, options, stopClocks));
        },
        addError (providedError) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addError(providedError));
        },
        addFeatureFlagEvaluation (key, value) {
            bufferApiCalls.add((startRumResult)=>startRumResult.addFeatureFlagEvaluation(key, value));
        },
        startDurationVital (name, options) {
            return (0, $aSnVp.startDurationVital)(customVitalsState, name, options);
        },
        stopDurationVital (name, options) {
            (0, $aSnVp.stopDurationVital)(addDurationVital, customVitalsState, name, options);
        },
        addDurationVital: addDurationVital,
        addOperationStepVital: addOperationStepVital
    };
    return strategy;
}
function $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return {
        ...initConfiguration,
        applicationId: '00000000-aaaa-0000-aaaa-000000000000',
        clientToken: 'empty',
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = (0, $kFaIT.getEventBridge)()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
    };
}
function $a4b70066dfc326ec$var$bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
    preStartContextManager.changeObservable.subscribe(()=>{
        const context = preStartContextManager.getContext();
        bufferApiCalls.add((startRumResult)=>startRumResult[name].setContext(context));
    });
}

});
parcelRegister("YfZsf", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $0b52020850d5b661$export$39c6a2b4dbabca5d);

var $i3LOd = parcelRequire("i3LOd");
const $0b52020850d5b661$export$39c6a2b4dbabca5d = (0, $i3LOd.abstractHooks);

});

parcelRegister("4uKwV", function(module, exports) {
$parcel$export(module.exports, "serializeRumConfiguration", () => (parcelRequire("dX6Ct")).serializeRumConfiguration);
$parcel$export(module.exports, "validateAndBuildRumConfiguration", () => (parcelRequire("dX6Ct")).validateAndBuildRumConfiguration);
$parcel$export(module.exports, "fetchAndApplyRemoteConfiguration", () => (parcelRequire("eLMiS")).fetchAndApplyRemoteConfiguration);
parcelRequire("dX6Ct");
parcelRequire("eLMiS");

});
parcelRegister("dX6Ct", function(module, exports) {

$parcel$export(module.exports, "validateAndBuildRumConfiguration", () => $a285eb8854056411$export$4f016a753eca1880);
$parcel$export(module.exports, "serializeRumConfiguration", () => $a285eb8854056411$export$937b8b43e93f9c22);

var $7imKH = parcelRequire("7imKH");
var $5IDGB = parcelRequire("5IDGB");
var $5DEie = parcelRequire("5DEie");
var $fzLbJ = parcelRequire("fzLbJ");
var $lHOXU = parcelRequire("lHOXU");
var $bQmeT = parcelRequire("bQmeT");
var $8PiRA = parcelRequire("8PiRA");
const $a285eb8854056411$export$6fcd8876d4ab74f5 = [
    'tracecontext',
    'datadog'
];
const $a285eb8854056411$export$64881634f73a51ad = [
    'cache-control',
    'etag',
    'age',
    'expires',
    'content-type',
    'content-encoding',
    'vary',
    'content-length',
    'server-timing',
    'x-cache'
];
function $a285eb8854056411$export$4f016a753eca1880(initConfiguration, errorStack) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (initConfiguration.trackFeatureFlagsForEvents !== undefined && !Array.isArray(initConfiguration.trackFeatureFlagsForEvents)) (0, $5IDGB.display).warn('trackFeatureFlagsForEvents should be an array');
    if (!initConfiguration.applicationId) {
        (0, $5IDGB.display).error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (!(0, $7imKH.isSampleRate)(initConfiguration.sessionReplaySampleRate, 'Session Replay') || !(0, $7imKH.isSampleRate)(initConfiguration.traceSampleRate, 'Trace')) return;
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        (0, $5IDGB.display).error('Excluded Activity Urls should be an array');
        return;
    }
    const allowedTracingUrls = $a285eb8854056411$var$validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) return;
    const baseConfiguration = (0, $7imKH.validateAndBuildConfiguration)(initConfiguration, errorStack);
    const allowedGraphQlUrls = $a285eb8854056411$var$validateAndBuildGraphQlOptions(initConfiguration);
    if (!baseConfiguration) return;
    const sessionReplaySampleRate = (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0;
    return {
        applicationId: initConfiguration.applicationId,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        betaTrackActionsInShadowDom: !!initConfiguration.betaTrackActionsInShadowDom,
        sessionReplaySampleRate: sessionReplaySampleRate,
        startSessionReplayRecordingManually: initConfiguration.startSessionReplayRecordingManually !== undefined ? !!initConfiguration.startSessionReplayRecordingManually : sessionReplaySampleRate === 0,
        traceSampleRate: (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : 100,
        rulePsr: (0, $bQmeT.isNumber)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : undefined,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_c = initConfiguration.excludedActivityUrls) !== null && _c !== void 0 ? _c : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!((_d = initConfiguration.trackUserInteractions) !== null && _d !== void 0 ? _d : true),
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!((_e = initConfiguration.trackResources) !== null && _e !== void 0 ? _e : true),
        trackResourceHeaders: $a285eb8854056411$var$validateAndBuildTrackResourceHeaders(initConfiguration),
        trackLongTasks: !!((_f = initConfiguration.trackLongTasks) !== null && _f !== void 0 ? _f : true),
        trackBfcacheViews: !!initConfiguration.trackBfcacheViews,
        trackEarlyRequests: !!initConfiguration.trackEarlyRequests,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0, $8PiRA.objectHasValue)((0, $7imKH.DefaultPrivacyLevel), initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : (0, $7imKH.DefaultPrivacyLevel).MASK,
        enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
        traceContextInjection: (0, $8PiRA.objectHasValue)((0, $7imKH.TraceContextInjection), initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : (0, $7imKH.TraceContextInjection).SAMPLED,
        plugins: initConfiguration.plugins || [],
        trackFeatureFlagsForEvents: initConfiguration.trackFeatureFlagsForEvents || [],
        profilingSampleRate: (_g = initConfiguration.profilingSampleRate) !== null && _g !== void 0 ? _g : 0,
        propagateTraceBaggage: !!initConfiguration.propagateTraceBaggage,
        allowedGraphQlUrls: allowedGraphQlUrls,
        ...baseConfiguration
    };
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */ function $a285eb8854056411$var$validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls === undefined) return [];
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
        (0, $5IDGB.display).error('Allowed Tracing URLs should be an array');
        return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
        (0, $5IDGB.display).error('Service needs to be configured when tracing is enabled');
        return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    const tracingOptions = [];
    initConfiguration.allowedTracingUrls.forEach((option)=>{
        const normalizedOption = $a285eb8854056411$var$normalizeTracingOption(option);
        if (normalizedOption) tracingOptions.push(normalizedOption);
        else (0, $5IDGB.display).warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
    });
    return tracingOptions;
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */ function $a285eb8854056411$var$getSelectedTracingPropagators(configuration) {
    const usedTracingPropagators = new Set();
    if ((0, $lHOXU.isNonEmptyArray)(configuration.allowedTracingUrls)) configuration.allowedTracingUrls.forEach((option)=>{
        var _a;
        (_a = $a285eb8854056411$var$normalizeTracingOption(option)) === null || _a === void 0 || _a.propagatorTypes.forEach((propagatorType)=>usedTracingPropagators.add(propagatorType));
    });
    return Array.from(usedTracingPropagators);
}
function $a285eb8854056411$var$normalizeTracingOption(option) {
    if ((0, $fzLbJ.isMatchOption)(option)) return {
        match: option,
        propagatorTypes: $a285eb8854056411$export$6fcd8876d4ab74f5
    };
    if ((0, $5DEie.isIndexableObject)(option) && (0, $fzLbJ.isMatchOption)(option.match) && (option.propagatorTypes === null || option.propagatorTypes === undefined || Array.isArray(option.propagatorTypes))) return {
        match: option.match,
        propagatorTypes: option.propagatorTypes || $a285eb8854056411$export$6fcd8876d4ab74f5
    };
}
/**
 * Build GraphQL options from configuration
 */ function $a285eb8854056411$var$validateAndBuildGraphQlOptions(initConfiguration) {
    if (!initConfiguration.allowedGraphQlUrls) return [];
    if (!Array.isArray(initConfiguration.allowedGraphQlUrls)) {
        (0, $5IDGB.display).warn('allowedGraphQlUrls should be an array');
        return [];
    }
    const graphQlOptions = [];
    initConfiguration.allowedGraphQlUrls.forEach((option)=>{
        if ((0, $fzLbJ.isMatchOption)(option)) graphQlOptions.push({
            match: option,
            trackPayload: false,
            trackResponseErrors: false
        });
        else if ((0, $5DEie.isIndexableObject)(option) && (0, $fzLbJ.isMatchOption)(option.match)) graphQlOptions.push({
            match: option.match,
            trackPayload: !!option.trackPayload,
            trackResponseErrors: !!option.trackResponseErrors
        });
    });
    return graphQlOptions;
}
const $a285eb8854056411$var$VALID_HEADER_LOCATIONS = [
    'request',
    'response',
    'any'
];
function $a285eb8854056411$var$validateAndBuildTrackResourceHeaders(initConfiguration) {
    const option = initConfiguration.trackResourceHeaders;
    if (option === undefined || option === false) return [];
    if (option === true) return $a285eb8854056411$export$64881634f73a51ad.map((name)=>({
            name: name
        }));
    if (!Array.isArray(option)) {
        (0, $5IDGB.display).warn('trackResourceHeaders should be true or an array of MatchHeader');
        return [];
    }
    if (option.length === 0) {
        (0, $5IDGB.display).warn('trackResourceHeaders is an empty array, no headers will be captured');
        return [];
    }
    const result = [];
    option.forEach((item, index)=>{
        if (!(0, $5DEie.isIndexableObject)(item) || !(0, $fzLbJ.isMatchOption)(item.name)) {
            (0, $5IDGB.display).warn(`trackResourceHeaders[${index}] should be a MatchHeader object with a 'name' property`);
            return;
        }
        if (item.url !== undefined && !(0, $fzLbJ.isMatchOption)(item.url)) {
            (0, $5IDGB.display).warn(`trackResourceHeaders[${index}].url should be a MatchOption`);
            return;
        }
        if (item.extractor !== undefined && !(item.extractor instanceof RegExp)) {
            (0, $5IDGB.display).warn(`trackResourceHeaders[${index}].extractor should be a RegExp`);
            return;
        }
        if (item.location !== undefined && !$a285eb8854056411$var$VALID_HEADER_LOCATIONS.includes(item.location)) {
            (0, $5IDGB.display).warn(`trackResourceHeaders[${index}].location should be 'request', 'response', or 'any'`);
            return;
        }
        result.push({
            ...item,
            name: typeof item.name === 'string' ? item.name.toLowerCase() : item.name
        });
    });
    return result;
}
function $a285eb8854056411$var$hasGraphQlPayloadTracking(allowedGraphQlUrls) {
    return (0, $lHOXU.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $5DEie.isIndexableObject)(option) && option.trackPayload);
}
function $a285eb8854056411$var$hasGraphQlResponseErrorsTracking(allowedGraphQlUrls) {
    return (0, $lHOXU.isNonEmptyArray)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option)=>(0, $5DEie.isIndexableObject)(option) && option.trackResponseErrors);
}
function $a285eb8854056411$var$getTrackResourceHeadersTelemetryValue(trackResourceHeaders) {
    if (trackResourceHeaders === true) return 'default_headers';
    if (Array.isArray(trackResourceHeaders)) return 'custom';
}
function $a285eb8854056411$export$937b8b43e93f9c22(configuration) {
    var _a;
    const baseSerializedConfiguration = (0, $7imKH.serializeConfiguration)(configuration);
    // `use_` prefix is for telemetry options that track usage of a configuration option as a boolean to avoid capturing customer data
    return {
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        propagate_trace_baggage: configuration.propagateTraceBaggage,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: (0, $lHOXU.isNonEmptyArray)(configuration.allowedTracingUrls),
        use_allowed_graph_ql_urls: (0, $lHOXU.isNonEmptyArray)(configuration.allowedGraphQlUrls),
        use_track_graph_ql_payload: $a285eb8854056411$var$hasGraphQlPayloadTracking(configuration.allowedGraphQlUrls),
        use_track_graph_ql_response_errors: $a285eb8854056411$var$hasGraphQlResponseErrorsTracking(configuration.allowedGraphQlUrls),
        selected_tracing_propagators: $a285eb8854056411$var$getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: (0, $lHOXU.isNonEmptyArray)(configuration.excludedActivityUrls),
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        track_bfcache_views: configuration.trackBfcacheViews,
        track_early_requests: configuration.trackEarlyRequests,
        plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map((plugin)=>{
            var _a;
            return {
                name: plugin.name,
                ...(_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin)
            };
        }),
        track_feature_flags_for_events: configuration.trackFeatureFlagsForEvents,
        remote_configuration_id: configuration.remoteConfigurationId,
        profiling_sample_rate: configuration.profilingSampleRate,
        use_remote_configuration_proxy: !!configuration.remoteConfigurationProxy,
        track_resource_headers: $a285eb8854056411$var$getTrackResourceHeadersTelemetryValue(configuration.trackResourceHeaders),
        ...baseSerializedConfiguration
    };
}

});

parcelRegister("eLMiS", function(module, exports) {

$parcel$export(module.exports, "fetchAndApplyRemoteConfiguration", () => $02c65ea76566f8d8$export$cfd957a7abf0b7b5);

var $fhNdh = parcelRequire("fhNdh");
var $lrgXo = parcelRequire("lrgXo");
var $5IDGB = parcelRequire("5IDGB");
var $7NaKU = parcelRequire("7NaKU");
var $4i26u = parcelRequire("4i26u");
var $5DEie = parcelRequire("5DEie");
var $8PiRA = parcelRequire("8PiRA");

var $46ybh = parcelRequire("46ybh");

var $9P2va = parcelRequire("9P2va");
const $02c65ea76566f8d8$var$REMOTE_CONFIGURATION_VERSION = 'v1';
const $02c65ea76566f8d8$var$SUPPORTED_FIELDS = [
    'applicationId',
    'service',
    'env',
    'version',
    'sessionSampleRate',
    'sessionReplaySampleRate',
    'defaultPrivacyLevel',
    'enablePrivacyForActionName',
    'traceSampleRate',
    'trackSessionAcrossSubdomains',
    'allowedTracingUrls',
    'allowedTrackingOrigins'
];
async function $02c65ea76566f8d8$export$cfd957a7abf0b7b5(initConfiguration, supportedContextManagers) {
    let rumInitConfiguration;
    const metrics = $02c65ea76566f8d8$export$844c6120e74e95ac();
    const fetchResult = await $02c65ea76566f8d8$export$4e57f2d70ec375f7(initConfiguration);
    if (!fetchResult.ok) {
        metrics.increment('fetch', 'failure');
        (0, $5IDGB.display).error(fetchResult.error);
    } else {
        metrics.increment('fetch', 'success');
        rumInitConfiguration = $02c65ea76566f8d8$export$8fe2215bb479e811(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
    }
    // monitor-until: forever
    (0, $fhNdh.addTelemetryMetrics)("remote configuration metrics" /* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */ , {
        metrics: metrics.get()
    });
    return rumInitConfiguration;
}
function $02c65ea76566f8d8$export$8fe2215bb479e811(initConfiguration, rumRemoteConfiguration, supportedContextManagers, metrics) {
    // intents:
    // - explicitly set each supported field to limit risk in case an attacker can create configurations
    // - check the existence in the remote config to avoid clearing a provided init field
    const appliedConfiguration = {
        ...initConfiguration
    };
    $02c65ea76566f8d8$var$SUPPORTED_FIELDS.forEach((option)=>{
        if (option in rumRemoteConfiguration) appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
    });
    Object.keys(supportedContextManagers).forEach((context)=>{
        if (rumRemoteConfiguration[context] !== undefined) resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
    });
    return appliedConfiguration;
    // share context to access metrics
    function resolveConfigurationProperty(property) {
        if (Array.isArray(property)) return property.map(resolveConfigurationProperty);
        if ((0, $5DEie.isIndexableObject)(property)) {
            if ($02c65ea76566f8d8$var$isSerializedOption(property)) {
                const type = property.rcSerializedType;
                switch(type){
                    case 'string':
                        return property.value;
                    case 'regex':
                        return $02c65ea76566f8d8$var$resolveRegex(property.value);
                    case 'dynamic':
                        return resolveDynamicOption(property);
                    default:
                        (0, $5IDGB.display).error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
                        return;
                }
            }
            return (0, $8PiRA.mapValues)(property, resolveConfigurationProperty);
        }
        return property;
    }
    function resolveContextProperty(contextManager, contextItems) {
        contextItems.forEach(({ key: key, value: value })=>{
            contextManager.setContextProperty(key, resolveConfigurationProperty(value));
        });
    }
    function resolveDynamicOption(property) {
        const strategy = property.strategy;
        let resolvedValue;
        switch(strategy){
            case 'cookie':
                resolvedValue = resolveCookieValue(property);
                break;
            case 'dom':
                resolvedValue = resolveDomValue(property);
                break;
            case 'js':
                resolvedValue = resolveJsValue(property);
                break;
            case 'localStorage':
                resolvedValue = resolveLocalStorageValue(property);
                break;
            default:
                (0, $5IDGB.display).error(`Unsupported remote configuration: "strategy": "${strategy}"`);
                return;
        }
        const extractor = property.extractor;
        if (extractor !== undefined && typeof resolvedValue === 'string') return $02c65ea76566f8d8$var$extractValue(extractor, resolvedValue);
        return resolvedValue;
    }
    function resolveCookieValue({ name: name }) {
        const value = (0, $4i26u.getCookie)(name);
        metrics.increment('cookie', value !== undefined ? 'success' : 'missing');
        return value;
    }
    function resolveLocalStorageValue({ key: key }) {
        let value;
        try {
            value = localStorage.getItem(key);
        } catch (_a) {
            metrics.increment('localStorage', 'failure');
            return;
        }
        metrics.increment('localStorage', value !== null ? 'success' : 'missing');
        return value !== null && value !== void 0 ? value : undefined;
    }
    function resolveDomValue({ selector: selector, attribute: attribute }) {
        let element;
        try {
            element = document.querySelector(selector);
        } catch (_a) {
            (0, $5IDGB.display).error(`Invalid selector in the remote configuration: '${selector}'`);
            metrics.increment('dom', 'failure');
            return;
        }
        if (!element) {
            metrics.increment('dom', 'missing');
            return;
        }
        if (isForbidden(element, attribute)) {
            (0, $5IDGB.display).error(`Forbidden element selected by the remote configuration: '${selector}'`);
            metrics.increment('dom', 'failure');
            return;
        }
        const domValue = attribute !== undefined ? element.getAttribute(attribute) : element.textContent;
        if (domValue === null) {
            metrics.increment('dom', 'missing');
            return;
        }
        metrics.increment('dom', 'success');
        return domValue;
    }
    function isForbidden(element, attribute) {
        return element.getAttribute('type') === 'password' && attribute === 'value';
    }
    function resolveJsValue({ path: path }) {
        let current = window;
        const pathParts = (0, $9P2va.parseJsonPath)(path);
        if (pathParts.length === 0) {
            (0, $5IDGB.display).error(`Invalid JSON path in the remote configuration: '${path}'`);
            metrics.increment('js', 'failure');
            return;
        }
        for (const pathPart of pathParts){
            if (!(pathPart in current)) {
                metrics.increment('js', 'missing');
                return;
            }
            try {
                current = current[pathPart];
            } catch (e) {
                (0, $5IDGB.display).error(`Error accessing: '${path}'`, e);
                metrics.increment('js', 'failure');
                return;
            }
        }
        metrics.increment('js', 'success');
        return current;
    }
}
function $02c65ea76566f8d8$export$844c6120e74e95ac() {
    const metrics = {
        fetch: {}
    };
    return {
        get: ()=>metrics,
        increment: (metricName, type)=>{
            if (!metrics[metricName]) metrics[metricName] = {};
            if (!metrics[metricName][type]) metrics[metricName][type] = 0;
            metrics[metricName][type] = metrics[metricName][type] + 1;
        }
    };
}
function $02c65ea76566f8d8$var$isSerializedOption(value) {
    return 'rcSerializedType' in value;
}
function $02c65ea76566f8d8$var$resolveRegex(pattern) {
    try {
        return new RegExp(pattern);
    } catch (_a) {
        (0, $5IDGB.display).error(`Invalid regex in the remote configuration: '${pattern}'`);
    }
}
function $02c65ea76566f8d8$var$extractValue(extractor, candidate) {
    const resolvedExtractor = $02c65ea76566f8d8$var$resolveRegex(extractor.value);
    if (resolvedExtractor === undefined) return;
    return (0, $46ybh.extractRegexMatch)(candidate, resolvedExtractor);
}
async function $02c65ea76566f8d8$export$4e57f2d70ec375f7(configuration) {
    let response;
    try {
        response = await (0, $7NaKU.fetch)($02c65ea76566f8d8$export$a18226397bb190d3(configuration));
    } catch (_a) {
        response = undefined;
    }
    if (!response || !response.ok) return {
        ok: false,
        error: new Error('Error fetching the remote configuration.')
    };
    const remoteConfiguration = await response.json();
    if (remoteConfiguration.rum) return {
        ok: true,
        value: remoteConfiguration.rum
    };
    return {
        ok: false,
        error: new Error('No remote configuration for RUM.')
    };
}
function $02c65ea76566f8d8$export$a18226397bb190d3(configuration) {
    if (configuration.remoteConfigurationProxy) return configuration.remoteConfigurationProxy;
    return `https://sdk-configuration.${(0, $lrgXo.buildEndpointHost)('rum', configuration)}/${$02c65ea76566f8d8$var$REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(configuration.remoteConfigurationId)}.json`;
}

});
parcelRegister("46ybh", function(module, exports) {

$parcel$export(module.exports, "extractRegexMatch", () => $2fd23c96e83eb297$export$e3179c144dd71295);
/**
 * Executes a RegExp against a string and returns the first capture group, or the full match if
 * there is no capture group. Returns undefined when the pattern does not match.
 */ function $2fd23c96e83eb297$export$e3179c144dd71295(candidate, extractor) {
    // Prevent stateful matching when the RegExp has the global or sticky flag
    extractor.lastIndex = 0;
    const regexResult = extractor.exec(candidate);
    if (!regexResult) return undefined;
    const [match, capture] = regexResult;
    return capture ? capture : match;
}

});

parcelRegister("9P2va", function(module, exports) {

$parcel$export(module.exports, "parseJsonPath", () => $726ad14239c99c3d$export$3bcc3f8beb4316ae);
/**
 * Terminology inspired from https://www.rfc-editor.org/rfc/rfc9535.html
 *
 * jsonpath-query      = segment*
 * segment             = .name-shorthand / bracketed-selection
 * bracketed-selection = ['name-selector'] / ["name-selector"] / [index-selector]
 *
 * Useful references:
 * - https://goessner.net/articles/JsonPath/
 * - https://jsonpath.com/
 * - https://github.com/jsonpath-standard
 */ /**
 * Extract selectors from a simple JSON path expression, return [] for an invalid path
 *
 * Supports:
 * - Dot notation: `foo.bar.baz`
 * - Bracket notation: `['foo']["bar"]`
 * - Array indices: `items[0]`, `data['users'][1]`
 *
 * Examples:
 * parseJsonPath("['foo'].bar[12]")
 * => ['foo', 'bar', '12']
 *
 * parseJsonPath("['foo")
 * => []
 */ function $726ad14239c99c3d$export$3bcc3f8beb4316ae(path) {
    const selectors = [];
    let previousToken = 0 /* Token.START */ ;
    let currentToken;
    const parsingContext = {
        quote: undefined,
        escapeSequence: undefined
    };
    let currentSelector = '';
    for (const char of path){
        // find which kind of token is this char
        currentToken = $726ad14239c99c3d$var$ALLOWED_NEXT_TOKENS[previousToken].find((token)=>$726ad14239c99c3d$var$TOKEN_PREDICATE[token](char, parsingContext));
        if (!currentToken) return [];
        if (parsingContext.escapeSequence !== undefined && currentToken !== 12 /* Token.ESCAPE_SEQUENCE_CHAR */ ) {
            if (!$726ad14239c99c3d$var$isValidEscapeSequence(parsingContext.escapeSequence)) return [];
            currentSelector += $726ad14239c99c3d$var$resolveEscapeSequence(parsingContext.escapeSequence);
            parsingContext.escapeSequence = undefined;
        }
        if ($726ad14239c99c3d$var$ALLOWED_SELECTOR_TOKENS.includes(currentToken)) // buffer the char if it belongs to the selector
        // ex: foo['bar']
        //      ^    ^
        currentSelector += char;
        else if ($726ad14239c99c3d$var$ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== '') {
            // close the current path part if we have reach a path part delimiter
            // ex: foo.bar['qux']
            //        ^   ^     ^
            selectors.push(currentSelector);
            currentSelector = '';
        } else if (currentToken === 12 /* Token.ESCAPE_SEQUENCE_CHAR */ ) parsingContext.escapeSequence = parsingContext.escapeSequence ? `${parsingContext.escapeSequence}${char}` : char;
        else if (currentToken === 8 /* Token.QUOTE_START */ ) parsingContext.quote = char;
        else if (currentToken === 9 /* Token.QUOTE_END */ ) parsingContext.quote = undefined;
        previousToken = currentToken;
    }
    if (!$726ad14239c99c3d$var$ALLOWED_NEXT_TOKENS[previousToken].includes(1 /* Token.END */ )) return [];
    if (currentSelector !== '') selectors.push(currentSelector);
    return selectors;
}
const $726ad14239c99c3d$var$NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
const $726ad14239c99c3d$var$NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
const $726ad14239c99c3d$var$DIGIT_REGEX = /[0-9]/;
const $726ad14239c99c3d$var$UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
const $726ad14239c99c3d$var$QUOTE_CHARS = '\'"';
const $726ad14239c99c3d$var$TOKEN_PREDICATE = {
    // no char should match to START or END
    [0 /* Token.START */ ]: ()=>false,
    [1 /* Token.END */ ]: ()=>false,
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ]: (char)=>$726ad14239c99c3d$var$NAME_SHORTHAND_FIRST_CHAR_REGEX.test(char),
    [3 /* Token.NAME_SHORTHAND_CHAR */ ]: (char)=>$726ad14239c99c3d$var$NAME_SHORTHAND_CHAR_REGEX.test(char),
    [4 /* Token.DOT */ ]: (char)=>char === '.',
    [5 /* Token.BRACKET_START */ ]: (char)=>char === '[',
    [6 /* Token.BRACKET_END */ ]: (char)=>char === ']',
    [7 /* Token.DIGIT */ ]: (char)=>$726ad14239c99c3d$var$DIGIT_REGEX.test(char),
    [8 /* Token.QUOTE_START */ ]: (char)=>$726ad14239c99c3d$var$QUOTE_CHARS.includes(char),
    [9 /* Token.QUOTE_END */ ]: (char, parsingContext)=>char === parsingContext.quote,
    [10 /* Token.NAME_SELECTOR_CHAR */ ]: ()=>true,
    [11 /* Token.ESCAPE */ ]: (char)=>char === '\\',
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */ ]: (char, parsingContext)=>{
        if (parsingContext.escapeSequence === undefined) // see https://www.rfc-editor.org/rfc/rfc9535.html#name-semantics-3
        return `${parsingContext.quote}/\\bfnrtu`.includes(char);
        else if (parsingContext.escapeSequence.startsWith('u') && parsingContext.escapeSequence.length < 5) return $726ad14239c99c3d$var$UNICODE_CHAR_REGEX.test(char);
        return false;
    }
};
const $726ad14239c99c3d$var$ALLOWED_NEXT_TOKENS = {
    [0 /* Token.START */ ]: [
        2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ,
        5 /* Token.BRACKET_START */ 
    ],
    [1 /* Token.END */ ]: [],
    [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ]: [
        3 /* Token.NAME_SHORTHAND_CHAR */ ,
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [3 /* Token.NAME_SHORTHAND_CHAR */ ]: [
        3 /* Token.NAME_SHORTHAND_CHAR */ ,
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [4 /* Token.DOT */ ]: [
        2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ 
    ],
    [5 /* Token.BRACKET_START */ ]: [
        8 /* Token.QUOTE_START */ ,
        7 /* Token.DIGIT */ 
    ],
    [6 /* Token.BRACKET_END */ ]: [
        4 /* Token.DOT */ ,
        5 /* Token.BRACKET_START */ ,
        1 /* Token.END */ 
    ],
    [7 /* Token.DIGIT */ ]: [
        7 /* Token.DIGIT */ ,
        6 /* Token.BRACKET_END */ 
    ],
    [8 /* Token.QUOTE_START */ ]: [
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ],
    [9 /* Token.QUOTE_END */ ]: [
        6 /* Token.BRACKET_END */ 
    ],
    [10 /* Token.NAME_SELECTOR_CHAR */ ]: [
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ],
    [11 /* Token.ESCAPE */ ]: [
        12 /* Token.ESCAPE_SEQUENCE_CHAR */ 
    ],
    [12 /* Token.ESCAPE_SEQUENCE_CHAR */ ]: [
        12 /* Token.ESCAPE_SEQUENCE_CHAR */ ,
        11 /* Token.ESCAPE */ ,
        9 /* Token.QUOTE_END */ ,
        10 /* Token.NAME_SELECTOR_CHAR */ 
    ]
};
// foo['bar\n'][12]
// ^^    ^ ^^   ^
const $726ad14239c99c3d$var$ALLOWED_SELECTOR_TOKENS = [
    2 /* Token.NAME_SHORTHAND_FIRST_CHAR */ ,
    3 /* Token.NAME_SHORTHAND_CHAR */ ,
    7 /* Token.DIGIT */ ,
    10 /* Token.NAME_SELECTOR_CHAR */ 
];
// foo.bar['qux']
//    ^   ^     ^
const $726ad14239c99c3d$var$ALLOWED_SELECTOR_DELIMITER_TOKENS = [
    4 /* Token.DOT */ ,
    5 /* Token.BRACKET_START */ ,
    6 /* Token.BRACKET_END */ 
];
function $726ad14239c99c3d$var$isValidEscapeSequence(escapeSequence) {
    return '"\'/\\bfnrt'.includes(escapeSequence) || escapeSequence.startsWith('u') && escapeSequence.length === 5;
}
const $726ad14239c99c3d$var$ESCAPED_CHARS = {
    '"': '"',
    "'": "'",
    '/': '/',
    '\\': '\\',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
};
function $726ad14239c99c3d$var$resolveEscapeSequence(escapeSequence) {
    if (escapeSequence.startsWith('u')) // build Unicode char from code
    return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
    return $726ad14239c99c3d$var$ESCAPED_CHARS[escapeSequence];
}

});




parcelRegister("2q14q", function(module, exports) {

$parcel$export(module.exports, "startRum", () => $1c2ed706f8c64922$export$3215a7cbec5ac3e0);

var $fhNdh = parcelRequire("fhNdh");
var $kFaIT = parcelRequire("kFaIT");
var $70xdd = parcelRequire("70xdd");
var $cfGi1 = parcelRequire("cfGi1");
var $aqcpf = parcelRequire("aqcpf");
var $gZP56 = parcelRequire("gZP56");
var $62z74 = parcelRequire("62z74");
var $djpEA = parcelRequire("djpEA");

var $2Bt7w = parcelRequire("2Bt7w");

var $7i9lO = parcelRequire("7i9lO");

var $f2Ka5 = parcelRequire("f2Ka5");

var $54uGZ = parcelRequire("54uGZ");

var $aJJWw = parcelRequire("aJJWw");

var $gQkiu = parcelRequire("gQkiu");

var $bbPM0 = parcelRequire("bbPM0");

var $lpjMX = parcelRequire("lpjMX");

var $4JFG9 = parcelRequire("4JFG9");

var $3GTFW = parcelRequire("3GTFW");

var $eptxg = parcelRequire("eptxg");

var $degsG = parcelRequire("degsG");

var $axlOu = parcelRequire("axlOu");

var $kXNZh = parcelRequire("kXNZh");

var $3OSU7 = parcelRequire("3OSU7");

var $7hyCT = parcelRequire("7hyCT");

var $lTMQC = parcelRequire("lTMQC");

var $eZzeR = parcelRequire("eZzeR");

var $btrZp = parcelRequire("btrZp");

var $aSnVp = parcelRequire("aSnVp");

var $5FzGr = parcelRequire("5FzGr");

var $lWJEv = parcelRequire("lWJEv");

var $e4z7O = parcelRequire("e4z7O");

var $8NjHX = parcelRequire("8NjHX");

var $9tDnN = parcelRequire("9tDnN");

var $cCTtu = parcelRequire("cCTtu");

var $3Irm0 = parcelRequire("3Irm0");

var $4Xhld = parcelRequire("4Xhld");

var $fmXhG = parcelRequire("fmXhG");

var $kf8Yt = parcelRequire("kf8Yt");

var $asij6 = parcelRequire("asij6");
function $1c2ed706f8c64922$export$3215a7cbec5ac3e0(configuration, recorderApi, profilerApi, initialViewOptions, createEncoder, // `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, customVitalsState, bufferedDataObservable, telemetry, hooks, sdkName) {
    const cleanupTasks = [];
    const lifeCycle = new (0, $54uGZ.LifeCycle)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (event)=>(0, $cfGi1.sendToExtension)('rum', event));
    const reportError = (error)=>{
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0, $fhNdh.addTelemetryDebug)('Error reported to customer', {
            'error.message': error.message
        });
    };
    const pageMayExitObservable = (0, $70xdd.createPageMayExitObservable)(configuration);
    const session = !(0, $kFaIT.canUseEventBridge)() ? (0, $eptxg.startRumSessionManager)(configuration, lifeCycle, trackingConsentState) : (0, $eptxg.startRumSessionManagerStub)();
    if (!(0, $kFaIT.canUseEventBridge)()) {
        const batch = (0, $degsG.startRumBatch)(configuration, lifeCycle, reportError, pageMayExitObservable, session.expireObservable, createEncoder);
        const preparePageExitSubscription = batch.flushController.preparePageExitFlushObservable.subscribe((reason)=>{
            lifeCycle.notify(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , {
                reason: reason
            });
        });
        cleanupTasks.push(()=>preparePageExitSubscription.unsubscribe());
        cleanupTasks.push(()=>batch.stop());
        (0, $lTMQC.startCustomerDataTelemetry)(telemetry, lifeCycle, batch.flushController.flushObservable);
    } else {
        (0, $axlOu.startRumEventBridge)(lifeCycle);
        const pageMayExitSubscription = pageMayExitObservable.subscribe((event)=>{
            lifeCycle.notify(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , event);
        });
        cleanupTasks.push(()=>pageMayExitSubscription.unsubscribe());
    }
    (0, $4Xhld.startTrackingConsentContext)(hooks, trackingConsentState);
    const { stop: stopInitialViewMetricsTelemetry } = (0, $kf8Yt.startInitialViewMetricsTelemetry)(lifeCycle, telemetry);
    cleanupTasks.push(stopInitialViewMetricsTelemetry);
    const { stop: stopRumEventCollection, ...startRumEventCollectionResult } = $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError);
    cleanupTasks.push(stopRumEventCollection);
    bufferedDataObservable.unbuffer();
    // Add Clean-up tasks for Profiler API.
    cleanupTasks.push(()=>profilerApi.stop());
    return {
        ...startRumEventCollectionResult,
        lifeCycle: lifeCycle,
        session: session,
        stopSession: ()=>session.expire(),
        telemetry: telemetry,
        stop: ()=>{
            cleanupTasks.forEach((task)=>task());
        },
        hooks: hooks
    };
}
function $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, hooks, configuration, session, recorderApi, initialViewOptions, customVitalsState, bufferedDataObservable, sdkName, reportError) {
    const cleanupTasks = [];
    const domMutationObservable = (0, $2Bt7w.createDOMMutationObservable)();
    const locationChangeObservable = (0, $3OSU7.createLocationChangeObservable)(configuration);
    const { observable: windowOpenObservable, stop: stopWindowOpen } = (0, $7i9lO.createWindowOpenObservable)();
    cleanupTasks.push(stopWindowOpen);
    (0, $3Irm0.startDefaultContext)(hooks, configuration, sdkName);
    const pageStateHistory = (0, $eZzeR.startPageStateHistory)(hooks, configuration);
    cleanupTasks.push(()=>pageStateHistory.stop());
    const viewHistory = (0, $aJJWw.startViewHistory)(lifeCycle);
    cleanupTasks.push(()=>viewHistory.stop());
    const urlContexts = (0, $kXNZh.startUrlContexts)(lifeCycle, hooks, locationChangeObservable);
    cleanupTasks.push(()=>urlContexts.stop());
    const featureFlagContexts = (0, $7hyCT.startFeatureFlagContexts)(lifeCycle, hooks, configuration);
    (0, $9tDnN.startSessionContext)(hooks, session, recorderApi, viewHistory);
    (0, $cCTtu.startConnectivityContext)(hooks);
    (0, $62z74.startTabContext)(hooks);
    const globalContext = (0, $gZP56.startGlobalContext)(hooks, configuration, 'rum', true);
    const userContext = (0, $djpEA.startUserContext)(hooks, configuration, session, 'rum');
    const accountContext = (0, $aqcpf.startAccountContext)(hooks, configuration, 'rum');
    const actionCollection = (0, $bbPM0.startActionCollection)(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
    cleanupTasks.push(actionCollection.stop);
    const eventCollection = (0, $fmXhG.startEventCollection)(lifeCycle);
    const displayContext = (0, $btrZp.startDisplayContext)(hooks, configuration);
    cleanupTasks.push(displayContext.stop);
    const ciVisibilityContext = (0, $5FzGr.startCiVisibilityContext)(configuration, hooks);
    cleanupTasks.push(ciVisibilityContext.stop);
    (0, $e4z7O.startSyntheticsContext)(hooks);
    (0, $8NjHX.startRumAssembly)(configuration, lifeCycle, hooks, reportError);
    const { addTiming: addTiming, setLoadingTime: setLoadingTime, startView: startView, setViewName: setViewName, setViewContext: setViewContext, setViewContextProperty: setViewContextProperty, getViewContext: getViewContext, stop: stopViewCollection } = (0, $3GTFW.startViewCollection)(lifeCycle, hooks, configuration, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions);
    (0, $asij6.startSourceCodeContext)(hooks);
    cleanupTasks.push(stopViewCollection);
    const resourceCollection = (0, $4JFG9.startResourceCollection)(lifeCycle, configuration, pageStateHistory);
    cleanupTasks.push(resourceCollection.stop);
    const { stop: stopLongTaskCollection } = (0, $lWJEv.startLongTaskCollection)(lifeCycle, configuration);
    cleanupTasks.push(stopLongTaskCollection);
    const { addError: addError } = (0, $lpjMX.startErrorCollection)(lifeCycle, configuration, bufferedDataObservable);
    (0, $gQkiu.startRequestCollection)(lifeCycle, configuration, session, userContext, accountContext);
    const vitalCollection = (0, $aSnVp.startVitalCollection)(lifeCycle, pageStateHistory, customVitalsState);
    const internalContext = (0, $f2Ka5.startInternalContext)(configuration.applicationId, session, viewHistory, actionCollection.actionContexts, urlContexts);
    return {
        addAction: actionCollection.addAction,
        startAction: actionCollection.startAction,
        stopAction: actionCollection.stopAction,
        startResource: resourceCollection.startResource,
        stopResource: resourceCollection.stopResource,
        addEvent: eventCollection.addEvent,
        addError: addError,
        addTiming: addTiming,
        setLoadingTime: setLoadingTime,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        setViewContext: setViewContext,
        setViewContextProperty: setViewContextProperty,
        getViewContext: getViewContext,
        setViewName: setViewName,
        viewHistory: viewHistory,
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        addOperationStepVital: vitalCollection.addOperationStepVital,
        globalContext: globalContext,
        userContext: userContext,
        accountContext: accountContext,
        stop: ()=>cleanupTasks.forEach((task)=>task())
    };
}

});
parcelRegister("2Bt7w", function(module, exports) {

$parcel$export(module.exports, "createDOMMutationObservable", () => $1e55a02d0fb92a5e$export$e0f9a2ab04194dff);
$parcel$export(module.exports, "getMutationObserverConstructor", () => $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982);

var $5sf7S = parcelRequire("5sf7S");
var $2wH3Z = parcelRequire("2wH3Z");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
function $1e55a02d0fb92a5e$export$e0f9a2ab04194dff() {
    const MutationObserver = $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982();
    return new (0, $4wc1a.Observable)((observable)=>{
        if (!MutationObserver) return;
        const observer = new MutationObserver((0, $2wH3Z.monitor)((records)=>observable.notify(records)));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    });
}
function $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982() {
    let constructor;
    const browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, $5sf7S.getZoneJsOriginalValue)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            const patchedInstance = new browserWindow.MutationObserver((0, $aed8w.noop));
            const originalInstance = (0, $5sf7S.getZoneJsOriginalValue)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}

});

parcelRegister("7i9lO", function(module, exports) {

$parcel$export(module.exports, "createWindowOpenObservable", () => $54f177b32de8aa24$export$7c27c71faac0cc07);

var $35a54 = parcelRequire("35a54");
var $4wc1a = parcelRequire("4wc1a");
function $54f177b32de8aa24$export$7c27c71faac0cc07() {
    const observable = new (0, $4wc1a.Observable)();
    const { stop: stop } = (0, $35a54.instrumentMethod)(window, 'open', ()=>observable.notify());
    return {
        observable: observable,
        stop: stop
    };
}

});

parcelRegister("f2Ka5", function(module, exports) {

$parcel$export(module.exports, "startInternalContext", () => $af3ad9afe3848d81$export$ee941cf091e8459);
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */ function $af3ad9afe3848d81$export$ee941cf091e8459(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
    return {
        get: (startTime)=>{
            const viewContext = viewHistory.findView(startTime);
            const urlContext = urlContexts.findUrl(startTime);
            const session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                const actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? {
                        id: actionId
                    } : undefined,
                    view: {
                        id: viewContext.id,
                        name: viewContext.name,
                        referrer: urlContext.referrer,
                        url: urlContext.url
                    }
                };
            }
        }
    };
}

});

parcelRegister("54uGZ", function(module, exports) {

$parcel$export(module.exports, "LifeCycle", () => $3b152250b13a0137$export$6af70476896cbaec);

var $f7eLh = parcelRequire("f7eLh");
const $3b152250b13a0137$export$6af70476896cbaec = (0, $f7eLh.AbstractLifeCycle);

});

parcelRegister("aJJWw", function(module, exports) {

$parcel$export(module.exports, "startViewHistory", () => $7d11beaaee8c1142$export$268034a9c98ba695);

var $80mka = parcelRequire("80mka");
var $5xfjl = parcelRequire("5xfjl");
const $7d11beaaee8c1142$export$f12c747a768c817c = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $7d11beaaee8c1142$export$268034a9c98ba695(lifeCycle) {
    const viewValueHistory = (0, $80mka.createValueHistory)({
        expireDelay: $7d11beaaee8c1142$export$f12c747a768c817c
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , (view)=>{
        viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        viewValueHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , (viewUpdate)=>{
        const currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
        if (!currentView) return;
        if (viewUpdate.name) currentView.name = viewUpdate.name;
        if (viewUpdate.context) currentView.context = viewUpdate.context;
        currentView.sessionIsActive = viewUpdate.sessionIsActive;
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
        viewValueHistory.reset();
    });
    function buildViewHistoryEntry(view) {
        return {
            service: view.service,
            version: view.version,
            context: view.context,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks
        };
    }
    return {
        findView: (startTime)=>viewValueHistory.find(startTime),
        stop: ()=>{
            viewValueHistory.stop();
        }
    };
}

});

parcelRegister("gQkiu", function(module, exports) {

$parcel$export(module.exports, "startRequestCollection", () => $c4313f4d150a5ffa$export$254c90b445eb4949);

var $ly0px = parcelRequire("ly0px");
var $lEdKn = parcelRequire("lEdKn");
var $dX7m0 = parcelRequire("dX7m0");
var $iSi6B = parcelRequire("iSi6B");

var $fisL9 = parcelRequire("fisL9");

var $3IcTI = parcelRequire("3IcTI");

var $lIbnJ = parcelRequire("lIbnJ");
let $c4313f4d150a5ffa$var$nextRequestIndex = 1;
function $c4313f4d150a5ffa$export$254c90b445eb4949(lifeCycle, configuration, sessionManager, userContext, accountContext) {
    const tracer = (0, $3IcTI.startTracer)(configuration, sessionManager, userContext, accountContext);
    $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer);
    $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, configuration, tracer);
}
function $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer) {
    const subscription = (0, $dX7m0.initXhrObservable)(configuration).subscribe((rawContext)=>{
        const context = rawContext;
        if (!(0, $fisL9.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    ...context,
                    type: (0, $iSi6B.RequestType).XHR,
                    isAbortedOnStart: false
                });
                break;
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, configuration, tracer) {
    const subscription = (0, $lEdKn.initFetchObservable)({
        responseBodyAction: (context)=>{
            var _a;
            if ((_a = (0, $lIbnJ.findGraphQlConfiguration)(context.url, configuration)) === null || _a === void 0 ? void 0 : _a.trackResponseErrors) return 2 /* ResponseBodyAction.COLLECT */ ;
            return 1 /* ResponseBodyAction.WAIT */ ;
        }
    }).subscribe((rawContext)=>{
        var _a;
        const context = rawContext;
        if (!(0, $fisL9.isAllowedRequestUrl)(context.url)) return;
        switch(context.state){
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case 'resolve':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    ...context,
                    duration: (0, $ly0px.elapsed)(context.startClocks.timeStamp, (0, $ly0px.timeStampNow)()),
                    type: (0, $iSi6B.RequestType).FETCH,
                    requestBody: (_a = context.init) === null || _a === void 0 ? void 0 : _a.body
                });
                break;
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $c4313f4d150a5ffa$var$getNextRequestIndex() {
    const result = $c4313f4d150a5ffa$var$nextRequestIndex;
    $c4313f4d150a5ffa$var$nextRequestIndex += 1;
    return result;
}

});
parcelRegister("fisL9", function(module, exports) {

$parcel$export(module.exports, "FAKE_INITIAL_DOCUMENT", () => $b22ed8845addf22a$export$dc5d43db6d9a2bce);
$parcel$export(module.exports, "computeResourceEntryType", () => $b22ed8845addf22a$export$874b6cde352e515a);
$parcel$export(module.exports, "isResourceEntryRequestType", () => $b22ed8845addf22a$export$a5878f59e3ee2e9f);
$parcel$export(module.exports, "computeResourceEntryDuration", () => $b22ed8845addf22a$export$e10d69e2d9b371b6);
$parcel$export(module.exports, "computeResourceEntryDetails", () => $b22ed8845addf22a$export$a8cdd6a8741b9542);
$parcel$export(module.exports, "hasValidResourceEntryTimings", () => $b22ed8845addf22a$export$c07d151c23cfeb06);
$parcel$export(module.exports, "hasValidResourceEntryDuration", () => $b22ed8845addf22a$export$bb48f5f5ee2d8ac6);
$parcel$export(module.exports, "computeResourceEntryProtocol", () => $b22ed8845addf22a$export$628529093947cac8);
$parcel$export(module.exports, "computeResourceEntryDeliveryType", () => $b22ed8845addf22a$export$f83ec67aa945dcf6);
$parcel$export(module.exports, "computeResourceEntrySize", () => $b22ed8845addf22a$export$9207ac338b648dd5);
$parcel$export(module.exports, "isAllowedRequestUrl", () => $b22ed8845addf22a$export$c298da523d6ed600);
$parcel$export(module.exports, "sanitizeIfLongDataUrl", () => $b22ed8845addf22a$export$a7d3956fe6ae6a3d);

var $ly0px = parcelRequire("ly0px");
var $k2pmh = parcelRequire("k2pmh");
var $bVLiF = parcelRequire("bVLiF");
var $7yltR = parcelRequire("7yltR");
var $iSi6B = parcelRequire("iSi6B");
const $b22ed8845addf22a$export$dc5d43db6d9a2bce = 'initial_document';
const $b22ed8845addf22a$var$RESOURCE_TYPES = [
    [
        (0, $iSi6B.ResourceType).DOCUMENT,
        (initiatorType)=>$b22ed8845addf22a$export$dc5d43db6d9a2bce === initiatorType
    ],
    [
        (0, $iSi6B.ResourceType).XHR,
        (initiatorType)=>'xmlhttprequest' === initiatorType
    ],
    [
        (0, $iSi6B.ResourceType).FETCH,
        (initiatorType)=>'fetch' === initiatorType
    ],
    [
        (0, $iSi6B.ResourceType).BEACON,
        (initiatorType)=>'beacon' === initiatorType
    ],
    [
        (0, $iSi6B.ResourceType).CSS,
        (_, path)=>/\.css$/i.test(path)
    ],
    [
        (0, $iSi6B.ResourceType).JS,
        (_, path)=>/\.js$/i.test(path)
    ],
    [
        (0, $iSi6B.ResourceType).IMAGE,
        (initiatorType, path)=>[
                'image',
                'img',
                'icon'
            ].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null
    ],
    [
        (0, $iSi6B.ResourceType).FONT,
        (_, path)=>/\.(woff|eot|woff2|ttf)$/i.exec(path) !== null
    ],
    [
        (0, $iSi6B.ResourceType).MEDIA,
        (initiatorType, path)=>[
                'audio',
                'video'
            ].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null
    ]
];
function $b22ed8845addf22a$export$874b6cde352e515a(entry) {
    const url = entry.name;
    if (!(0, $bVLiF.isValidUrl)(url)) return (0, $iSi6B.ResourceType).OTHER;
    const path = (0, $bVLiF.getPathName)(url);
    for (const [type, isType] of $b22ed8845addf22a$var$RESOURCE_TYPES){
        if (isType(entry.initiatorType, path)) return type;
    }
    return (0, $iSi6B.ResourceType).OTHER;
}
function $b22ed8845addf22a$var$areInOrder(...numbers) {
    for(let i = 1; i < numbers.length; i += 1){
        if (numbers[i - 1] > numbers[i]) return false;
    }
    return true;
}
function $b22ed8845addf22a$export$a5878f59e3ee2e9f(entry) {
    return entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch';
}
function $b22ed8845addf22a$export$e10d69e2d9b371b6(entry) {
    const { duration: duration, startTime: startTime, responseEnd: responseEnd } = entry;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) return (0, $ly0px.elapsed)(startTime, responseEnd);
    return duration;
}
function $b22ed8845addf22a$export$a8cdd6a8741b9542(entry) {
    if (!$b22ed8845addf22a$export$c07d151c23cfeb06(entry)) return undefined;
    const { startTime: startTime, fetchStart: fetchStart, workerStart: workerStart, redirectStart: redirectStart, redirectEnd: redirectEnd, domainLookupStart: domainLookupStart, domainLookupEnd: domainLookupEnd, connectStart: connectStart, secureConnectionStart: secureConnectionStart, connectEnd: connectEnd, requestStart: requestStart, responseStart: responseStart, responseEnd: responseEnd } = entry;
    const details = {
        download: $b22ed8845addf22a$var$formatTiming(startTime, responseStart, responseEnd),
        first_byte: $b22ed8845addf22a$var$formatTiming(startTime, requestStart, responseStart)
    };
    // Make sure a worker processing time is recorded
    if (0 < workerStart && workerStart < fetchStart) details.worker = $b22ed8845addf22a$var$formatTiming(startTime, workerStart, fetchStart);
    // Make sure a connection occurred
    if (fetchStart < connectEnd) {
        details.connect = $b22ed8845addf22a$var$formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) details.ssl = $b22ed8845addf22a$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    // Make sure a domain lookup occurred
    if (fetchStart < domainLookupEnd) details.dns = $b22ed8845addf22a$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    // Make sure a redirection occurred
    if (startTime < redirectEnd) details.redirect = $b22ed8845addf22a$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
function $b22ed8845addf22a$export$bb48f5f5ee2d8ac6(entry) {
    return entry.duration >= 0;
}
function $b22ed8845addf22a$export$c07d151c23cfeb06(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    const areCommonTimingsInOrder = $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    const areRedirectionTimingsInOrder = $b22ed8845addf22a$var$hasRedirection(entry) ? $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function $b22ed8845addf22a$var$hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function $b22ed8845addf22a$var$formatTiming(origin, start, end) {
    if (origin <= start && start <= end) return {
        duration: (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(start, end)),
        start: (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(origin, start))
    };
}
function $b22ed8845addf22a$export$628529093947cac8(entry) {
    return entry.nextHopProtocol === '' ? undefined : entry.nextHopProtocol;
}
function $b22ed8845addf22a$export$f83ec67aa945dcf6(entry) {
    return entry.deliveryType === '' ? 'other' : entry.deliveryType;
}
function $b22ed8845addf22a$export$9207ac338b648dd5(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        const { encodedBodySize: encodedBodySize, decodedBodySize: decodedBodySize, transferSize: transferSize } = entry;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined
    };
}
function $b22ed8845addf22a$export$c298da523d6ed600(url) {
    return url && (!(0, $7yltR.isIntakeUrl)(url) || (0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).TRACK_INTAKE_REQUESTS));
}
const $b22ed8845addf22a$var$DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
const $b22ed8845addf22a$export$c9b94c34a00de3eb = 24000;
function $b22ed8845addf22a$export$a7d3956fe6ae6a3d(url, lengthLimit = $b22ed8845addf22a$export$c9b94c34a00de3eb) {
    if (url.length <= lengthLimit || !url.startsWith('data:')) return url;
    // truncate url first to a random length to prevent match error when the url is too long
    const dataUrlMatchArray = url.substring(0, 100).match($b22ed8845addf22a$var$DATA_URL_REGEX);
    if (!dataUrlMatchArray) return url;
    return `${dataUrlMatchArray[0]}[...]`;
}

});

parcelRegister("3IcTI", function(module, exports) {

$parcel$export(module.exports, "startTracer", () => $2b3f7c5bb3826872$export$faa83af43a19aa4b);

var $fzLbJ = parcelRequire("fzLbJ");
var $fkj4Q = parcelRequire("fkj4Q");
var $8PiRA = parcelRequire("8PiRA");
var $7imKH = parcelRequire("7imKH");

var $2Gs1I = parcelRequire("2Gs1I");

var $7WfB9 = parcelRequire("7WfB9");
function $2b3f7c5bb3826872$export$5fcd137715d2568d(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function $2b3f7c5bb3826872$export$faa83af43a19aa4b(configuration, sessionManager, userContext, accountContext) {
    return {
        clearTracingIfNeeded: $2b3f7c5bb3826872$export$5fcd137715d2568d,
        traceFetch: (context)=>$2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach((key)=>{
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                } else {
                    context.init = (0, $8PiRA.shallowClone)(context.init);
                    const headers = [];
                    if (context.init.headers instanceof Headers) context.init.headers.forEach((value, key)=>{
                        headers.push([
                            key,
                            value
                        ]);
                    });
                    else if (Array.isArray(context.init.headers)) context.init.headers.forEach((header)=>{
                        headers.push(header);
                    });
                    else if (context.init.headers) Object.keys(context.init.headers).forEach((key)=>{
                        headers.push([
                            key,
                            context.init.headers[key]
                        ]);
                    });
                    context.init.headers = headers.concat((0, $fkj4Q.objectEntries)(tracingHeaders));
                }
            }),
        traceXhr: (context, xhr)=>$2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders)=>{
                Object.keys(tracingHeaders).forEach((name)=>{
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            })
    };
}
function $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, inject) {
    const session = sessionManager.findTrackedSession();
    if (!session) return;
    const tracingOption = configuration.allowedTracingUrls.find((tracingOption)=>(0, $fzLbJ.matchList)([
            tracingOption.match
        ], context.url, true));
    if (!tracingOption) return;
    const traceSampled = (0, $2Gs1I.isSampled)(session.id, configuration.traceSampleRate);
    const shouldInjectHeaders = traceSampled || configuration.traceContextInjection === (0, $7imKH.TraceContextInjection).ALL;
    if (!shouldInjectHeaders) return;
    context.traceSampled = traceSampled;
    context.traceId = (0, $7WfB9.createTraceIdentifier)();
    context.spanId = (0, $7WfB9.createSpanIdentifier)();
    inject($2b3f7c5bb3826872$var$makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, session.id, tracingOption.propagatorTypes, userContext, accountContext, configuration));
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */ function $2b3f7c5bb3826872$var$makeTracingHeaders(traceId, spanId, traceSampled, sessionId, propagatorTypes, userContext, accountContext, configuration) {
    const tracingHeaders = {};
    propagatorTypes.forEach((propagatorType)=>{
        switch(propagatorType){
            case 'datadog':
                Object.assign(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toString()
                });
                break;
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext':
                Object.assign(tracingHeaders, {
                    traceparent: `00-0000000000000000${(0, $7WfB9.toPaddedHexadecimalString)(traceId)}-${(0, $7WfB9.toPaddedHexadecimalString)(spanId)}-0${traceSampled ? '1' : '0'}`,
                    tracestate: `dd=s:${traceSampled ? '1' : '0'};o:rum`
                });
                break;
            // https://github.com/openzipkin/b3-propagation
            case 'b3':
                Object.assign(tracingHeaders, {
                    b3: `${(0, $7WfB9.toPaddedHexadecimalString)(traceId)}-${(0, $7WfB9.toPaddedHexadecimalString)(spanId)}-${traceSampled ? '1' : '0'}`
                });
                break;
            case 'b3multi':
                Object.assign(tracingHeaders, {
                    'X-B3-TraceId': (0, $7WfB9.toPaddedHexadecimalString)(traceId),
                    'X-B3-SpanId': (0, $7WfB9.toPaddedHexadecimalString)(spanId),
                    'X-B3-Sampled': traceSampled ? '1' : '0'
                });
                break;
        }
    });
    if (configuration.propagateTraceBaggage) {
        const baggageItems = {
            'session.id': sessionId
        };
        const userId = userContext.getContext().id;
        if (typeof userId === 'string') baggageItems['user.id'] = userId;
        const accountId = accountContext.getContext().id;
        if (typeof accountId === 'string') baggageItems['account.id'] = accountId;
        const baggageHeader = Object.entries(baggageItems).map(([key, value])=>`${key}=${encodeURIComponent(value)}`).join(',');
        if (baggageHeader) tracingHeaders['baggage'] = baggageHeader;
    }
    return tracingHeaders;
}

});
parcelRegister("2Gs1I", function(module, exports) {

$parcel$export(module.exports, "isSampled", () => $1f453e80c2790817$export$ed7a494f7df966be);

var $bQmeT = parcelRequire("bQmeT");
const $1f453e80c2790817$var$sampleDecisionCache = new Map();
function $1f453e80c2790817$export$ed7a494f7df966be(sessionId, sampleRate) {
    // Shortcuts for common cases. This is not strictly necessary, but it makes the code faster for
    // customers willing to ingest all traces.
    if (sampleRate === 100) return true;
    if (sampleRate === 0) return false;
    const cachedDecision = $1f453e80c2790817$var$sampleDecisionCache.get(sampleRate);
    if (cachedDecision && sessionId === cachedDecision.sessionId) return cachedDecision.decision;
    let decision;
    // @ts-expect-error BigInt might not be defined in every browser we support
    if (window.BigInt) decision = $1f453e80c2790817$export$63da09b47e2ee93a(BigInt(`0x${sessionId.split('-')[4]}`), sampleRate);
    else // For simplicity, we don't use consistent sampling for browser without BigInt support
    // TODO: remove this when all browser we support have BigInt support
    decision = (0, $bQmeT.performDraw)(sampleRate);
    $1f453e80c2790817$var$sampleDecisionCache.set(sampleRate, {
        sessionId: sessionId,
        decision: decision
    });
    return decision;
}
function $1f453e80c2790817$export$5ffa6f8189c2cad3() {
    $1f453e80c2790817$var$sampleDecisionCache.clear();
}
function $1f453e80c2790817$export$63da09b47e2ee93a(identifier, sampleRate) {
    // The formula is:
    //
    //   (identifier * knuthFactor) % 2^64 < sampleRate * 2^64
    //
    // Because JavaScript numbers are 64-bit floats, we can't represent 64-bit integers, and the
    // modulo would be incorrect. Thus, we are using BigInts here.
    //
    // Implementation in other languages:
    // * Go     https://github.com/DataDog/dd-trace-go/blob/ec6fbb1f2d517b7b8e69961052adf7136f3af773/ddtrace/tracer/sampler.go#L86-L91
    // * Python https://github.com/DataDog/dd-trace-py/blob/0cee2f066fb6e79aa15947c1514c0f406dea47c5/ddtrace/sampling_rule.py#L197
    // * Ruby   https://github.com/DataDog/dd-trace-rb/blob/1a6e255cdcb7e7e22235ea5955f90f6dfa91045d/lib/datadog/tracing/sampling/rate_sampler.rb#L42
    // * C++    https://github.com/DataDog/dd-trace-cpp/blob/159629edc438ae45f2bb318eb7bd51abd05e94b5/src/datadog/trace_sampler.cpp#L58
    // * Java   https://github.com/DataDog/dd-trace-java/blob/896dd6b380533216e0bdee59614606c8272d313e/dd-trace-core/src/main/java/datadog/trace/common/sampling/DeterministicSampler.java#L48
    //
    // Note: All implementations have slight variations. Some of them use '<=' instead of '<', and
    // use `sampleRate * 2^64 - 1` instead of `sampleRate * 2^64`. The following implementation
    // should adhere to the spec and is a bit simpler than using a 2^64-1 limit as there are less
    // BigInt arithmetic to write. In practice this does not matter, as we are using floating point
    // numbers in the end, and Number(2n**64n-1n) === Number(2n**64n).
    const knuthFactor = BigInt('1111111111111111111');
    const twoPow64 = BigInt('0x10000000000000000'); // 2n ** 64n
    const hash = identifier * knuthFactor % twoPow64;
    return Number(hash) <= sampleRate / 100 * Number(twoPow64);
}

});

parcelRegister("7WfB9", function(module, exports) {

$parcel$export(module.exports, "createTraceIdentifier", () => $5c7a0ca9cf77c393$export$d0df1a1c84fa9037);
$parcel$export(module.exports, "createSpanIdentifier", () => $5c7a0ca9cf77c393$export$42e322be3a41cf8f);
$parcel$export(module.exports, "toPaddedHexadecimalString", () => $5c7a0ca9cf77c393$export$8c28a7bcd86c533);
function $5c7a0ca9cf77c393$export$d0df1a1c84fa9037() {
    return $5c7a0ca9cf77c393$var$createIdentifier(64);
}
function $5c7a0ca9cf77c393$export$42e322be3a41cf8f() {
    return $5c7a0ca9cf77c393$var$createIdentifier(63);
}
function $5c7a0ca9cf77c393$var$createIdentifier(bits) {
    const buffer = crypto.getRandomValues(new Uint32Array(2));
    if (bits === 63) // eslint-disable-next-line no-bitwise
    buffer[buffer.length - 1] >>>= 1; // force 63-bit
    // The `.toString` function is intentionally similar to Number and BigInt `.toString` method.
    //
    // JavaScript numbers can represent integers up to 48 bits, this is why we need two of them to
    // represent a 64 bits identifier. But BigInts don't have this limitation and can represent larger
    // integer values.
    //
    // In the future, when we drop browsers without BigInts support, we could use BigInts directly
    // represent identifiers by simply returning a BigInt from this function (as all we need is a
    // value with a `.toString` method).
    //
    // Examples:
    //   const buffer = getCrypto().getRandomValues(new Uint32Array(2))
    //   return BigInt(buffer[0]) + BigInt(buffer[1]) << 32n
    //
    //   // Alternative with BigUint64Array (different Browser support than plain bigints!):
    //   return crypto.getRandomValues(new BigUint64Array(1))[0]
    //
    // For now, let's keep using two plain numbers as having two different implementations (one for
    // browsers with BigInt support and one for older browsers) don't bring much value.
    return {
        toString (radix = 10) {
            let high = buffer[1];
            let low = buffer[0];
            let str = '';
            do {
                const mod = high % radix * 4294967296 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
            }while (high || low);
            return str;
        }
    };
}
function $5c7a0ca9cf77c393$export$8c28a7bcd86c533(id) {
    return id.toString(16).padStart(16, '0');
}

});


parcelRegister("lIbnJ", function(module, exports) {

$parcel$export(module.exports, "extractGraphQlMetadata", () => $fce6893543861ca1$export$9cb22fe4fb9b2782);
$parcel$export(module.exports, "findGraphQlConfiguration", () => $fce6893543861ca1$export$8356908c1c4aedc8);

var $bVLiF = parcelRequire("bVLiF");
var $lHOXU = parcelRequire("lHOXU");
var $fzLbJ = parcelRequire("fzLbJ");
var $7S2uk = parcelRequire("7S2uk");
var $99fDv = parcelRequire("99fDv");
var $8PiRA = parcelRequire("8PiRA");
/**
 * arbitrary value, byte precision not needed
 */ const $fce6893543861ca1$var$GRAPHQL_PAYLOAD_LIMIT = 32 * (0, $7S2uk.ONE_KIBI_BYTE);
function $fce6893543861ca1$export$9cb22fe4fb9b2782(request, graphQlConfig) {
    const metadata = $fce6893543861ca1$export$a90c538f03fea897(request, graphQlConfig.trackPayload);
    if (!metadata) return;
    if (graphQlConfig.trackResponseErrors && request.responseBody) {
        const responseErrors = $fce6893543861ca1$export$8e9c0b4437eedbc6(request.responseBody);
        if (responseErrors) {
            metadata.error_count = responseErrors.length;
            metadata.errors = responseErrors;
        }
    }
    return metadata;
}
function $fce6893543861ca1$export$8e9c0b4437eedbc6(responseText) {
    const response = (0, $8PiRA.tryJsonParse)(responseText);
    if (!response || typeof response !== 'object') return;
    const responseObj = response;
    if (!(0, $lHOXU.isNonEmptyArray)(responseObj.errors)) return;
    const errors = responseObj.errors.map((error)=>{
        var _a;
        const graphqlError = {
            message: error.message,
            path: error.path,
            locations: error.locations,
            code: (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code
        };
        return graphqlError;
    });
    return errors;
}
function $fce6893543861ca1$export$8356908c1c4aedc8(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption)=>(0, $fzLbJ.matchList)([
            graphQlOption.match
        ], url));
}
function $fce6893543861ca1$export$a90c538f03fea897(request, trackPayload = false) {
    let rawMetadata;
    if (request.method === 'POST') rawMetadata = $fce6893543861ca1$var$extractFromBody(request.requestBody);
    else if (request.method === 'GET') rawMetadata = $fce6893543861ca1$var$extractFromUrlQueryParams(request.url);
    if (!rawMetadata) return;
    return $fce6893543861ca1$var$sanitizeGraphQlMetadata(rawMetadata, trackPayload);
}
function $fce6893543861ca1$var$extractFromBody(requestBody) {
    if (!requestBody || typeof requestBody !== 'string') return;
    const graphqlBody = (0, $8PiRA.tryJsonParse)(requestBody);
    if (!graphqlBody) return;
    return {
        query: graphqlBody.query,
        operationName: graphqlBody.operationName,
        variables: graphqlBody.variables ? JSON.stringify(graphqlBody.variables) : undefined
    };
}
function $fce6893543861ca1$var$extractFromUrlQueryParams(url) {
    const searchParams = (0, $bVLiF.buildUrl)(url).searchParams;
    const variablesParam = searchParams.get('variables');
    const variables = variablesParam && (0, $8PiRA.tryJsonParse)(variablesParam) !== undefined ? variablesParam : undefined;
    return {
        query: searchParams.get('query') || undefined,
        operationName: searchParams.get('operationName') || undefined,
        variables: variables
    };
}
function $fce6893543861ca1$var$sanitizeGraphQlMetadata(rawMetadata, trackPayload) {
    let operationType;
    let payload;
    let variables;
    if (rawMetadata.query) {
        const trimmedQuery = rawMetadata.query.trim();
        operationType = $fce6893543861ca1$var$getOperationType(trimmedQuery);
        if (trackPayload) payload = (0, $99fDv.safeTruncate)(trimmedQuery, $fce6893543861ca1$var$GRAPHQL_PAYLOAD_LIMIT, '...');
    }
    if (rawMetadata.variables) variables = rawMetadata.variables;
    return {
        operationType: operationType,
        operationName: rawMetadata.operationName,
        variables: variables,
        payload: payload
    };
}
function $fce6893543861ca1$var$getOperationType(query) {
    var _a;
    return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}

});


parcelRegister("bbPM0", function(module, exports) {

$parcel$export(module.exports, "startActionCollection", () => $8258e1e2c7bf35c9$export$195095f773513078);

var $ly0px = parcelRequire("ly0px");
var $aed8w = parcelRequire("aed8w");
var $i3LOd = parcelRequire("i3LOd");

var $lECZH = parcelRequire("lECZH");

var $kDJMQ = parcelRequire("kDJMQ");

var $6L7jR = parcelRequire("6L7jR");

var $4y5SX = parcelRequire("4y5SX");
const $8258e1e2c7bf35c9$export$eae8d50a338ec80d = 1;
function $8258e1e2c7bf35c9$export$195095f773513078(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
    const { unsubscribe: unsubscribeAutoAction } = lifeCycle.subscribe(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , (action)=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $8258e1e2c7bf35c9$var$processAction(action));
    });
    const stopClickActions = (0, $aed8w.noop);
    let clickActions;
    if (configuration.trackUserInteractions) clickActions = (0, $6L7jR.trackClickActions)(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    const manualActions = (0, $4y5SX.trackManualActions)(lifeCycle, (action)=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $8258e1e2c7bf35c9$var$processAction(action));
    });
    const actionContexts = {
        findActionId: (startTime)=>{
            var _a;
            const manualActionId = manualActions.findActionId(startTime);
            const clickActionId = (_a = clickActions === null || clickActions === void 0 ? void 0 : clickActions.findActionId(startTime)) !== null && _a !== void 0 ? _a : [];
            return manualActionId.concat(clickActionId);
        }
    };
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        if (eventType !== (0, $kDJMQ.RumEventType).ERROR && eventType !== (0, $kDJMQ.RumEventType).RESOURCE && eventType !== (0, $kDJMQ.RumEventType).LONG_TASK) return 0, $i3LOd.SKIPPED;
        // Long tasks triggered by interaction handlers (pointerup, click, etc.)
        // can have a start time slightly before the interaction timestamp (long_task.start_time < action.start_time).
        // This likely happens because the interaction timestamp is recorded during the event dispatch,
        // not at the beginning of the rendering frame. I observed a difference of < 1 ms in my tests.
        // Fixes flakiness in test: "associates long tasks to interaction actions"
        const correctedStartTime = eventType === (0, $kDJMQ.RumEventType).LONG_TASK ? (0, $ly0px.addDuration)(startTime, $8258e1e2c7bf35c9$export$eae8d50a338ec80d) : startTime;
        const actionId = actionContexts.findActionId(correctedStartTime);
        if (!actionId.length) return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            action: {
                id: actionId
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>({
            // todo: fix telemetry event type
            action: {
                id: actionContexts.findActionId(startTime)
            }
        }));
    return {
        addAction: manualActions.addAction,
        startAction: manualActions.startAction,
        stopAction: manualActions.stopAction,
        actionContexts: actionContexts,
        stop: ()=>{
            unsubscribeAutoAction();
            stopClickActions();
            manualActions.stop();
            clickActions === null || clickActions === void 0 || clickActions.stop();
        }
    };
}
function $8258e1e2c7bf35c9$var$processAction(action) {
    var _a, _b, _c, _d;
    const isAuto = $8258e1e2c7bf35c9$var$isAutoAction(action);
    const loadingTime = (0, $lECZH.discardNegativeDuration)((0, $ly0px.toServerDuration)(action.duration));
    return {
        rawRumEvent: {
            type: (0, $kDJMQ.RumEventType).ACTION,
            date: action.startClocks.timeStamp,
            action: {
                id: action.id,
                target: {
                    name: action.name
                },
                type: action.type,
                ...loadingTime !== undefined && {
                    loading_time: loadingTime
                },
                ...action.counts && {
                    error: {
                        count: action.counts.errorCount
                    },
                    long_task: {
                        count: action.counts.longTaskCount
                    },
                    resource: {
                        count: action.counts.resourceCount
                    }
                },
                frustration: {
                    type: action.frustrationTypes
                }
            },
            ...isAuto ? {
                _dd: {
                    action: {
                        target: {
                            selector: ((_a = action.target) === null || _a === void 0 ? void 0 : _a.selector) || undefined,
                            width: ((_b = action.target) === null || _b === void 0 ? void 0 : _b.width) || undefined,
                            height: ((_c = action.target) === null || _c === void 0 ? void 0 : _c.height) || undefined,
                            composed_path_selector: (_d = action.target) === null || _d === void 0 ? void 0 : _d.composedPathSelector
                        },
                        position: action.position,
                        name_source: action.nameSource
                    }
                }
            } : {
                context: action.context
            }
        },
        duration: action.duration,
        startClocks: action.startClocks,
        domainContext: isAuto ? {
            events: action.events
        } : {
            handlingStack: action.handlingStack
        }
    };
}
function $8258e1e2c7bf35c9$var$isAutoAction(action) {
    return 'events' in action;
}

});
parcelRegister("lECZH", function(module, exports) {

$parcel$export(module.exports, "discardNegativeDuration", () => $fc3b94d36e42b5cc$export$e8fc7a7e81732139);

var $bQmeT = parcelRequire("bQmeT");
function $fc3b94d36e42b5cc$export$e8fc7a7e81732139(duration) {
    return (0, $bQmeT.isNumber)(duration) && duration < 0 ? undefined : duration;
}

});

parcelRegister("6L7jR", function(module, exports) {

$parcel$export(module.exports, "trackClickActions", () => $4ebccf53af8f3992$export$ce3e012cf7d342e2);

var $99fDv = parcelRequire("99fDv");
var $4wc1a = parcelRequire("4wc1a");
var $ly0px = parcelRequire("ly0px");

var $4TGNe = parcelRequire("4TGNe");

var $kDJMQ = parcelRequire("kDJMQ");

var $7oXOv = parcelRequire("7oXOv");

var $l3o7w = parcelRequire("l3o7w");

var $OddO2 = parcelRequire("OddO2");

var $8EzN6 = parcelRequire("8EzN6");

var $2ZNES = parcelRequire("2ZNES");

var $bWXC7 = parcelRequire("bWXC7");

var $cNHb8 = parcelRequire("cNHb8");

var $2dzye = parcelRequire("2dzye");

var $fVsF7 = parcelRequire("fVsF7");

var $eV1gO = parcelRequire("eV1gO");

var $2NQWL = parcelRequire("2NQWL");

var $rPcCT = parcelRequire("rPcCT");
function $4ebccf53af8f3992$export$ce3e012cf7d342e2(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    const actionTracker = (0, $2ZNES.startEventTracker)(lifeCycle);
    const stopObservable = new (0, $4wc1a.Observable)();
    let currentClickChain;
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , stopClickChain);
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , stopClickChain);
    const { stop: stopActionEventsListener } = (0, $fVsF7.listenActionEvents)(configuration, {
        onPointerDown: (pointerDownEvent)=>$4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable),
        onPointerUp: ({ clickActionBase: clickActionBase, hadActivityOnPointerDown: hadActivityOnPointerDown }, startEvent, getUserActivity)=>{
            $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        }
    });
    return {
        stop: ()=>{
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
            actionTracker.stopAll();
        },
        findActionId: actionTracker.findId
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            const rageClick = click.clone();
            currentClickChain = (0, $cNHb8.createClickChain)(click, (clicks)=>{
                $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick);
                // Clear the reference to allow garbage collection. Without this, the finalize callback
                // retains a closure reference to the old click chain, preventing it from being cleaned up
                // and causing a memory leak as click chains accumulate over time.
                currentClickChain = undefined;
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) currentClickChain.stop();
    }
}
function $4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
    const targetForPrivacy = configuration.betaTrackActionsInShadowDom ? $4ebccf53af8f3992$var$getEventTarget(pointerDownEvent) : pointerDownEvent.target;
    let nodePrivacyLevel;
    if (configuration.enablePrivacyForActionName) nodePrivacyLevel = (0, $OddO2.getNodePrivacyLevel)(targetForPrivacy, configuration.defaultPrivacyLevel);
    else nodePrivacyLevel = (0, $8EzN6.NodePrivacyLevel).ALLOW;
    if (nodePrivacyLevel === (0, $8EzN6.NodePrivacyLevel).HIDDEN) return undefined;
    const clickActionBase = $4ebccf53af8f3992$var$computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    let hadActivityOnPointerDown = false;
    (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    (0, $7oXOv.PAGE_ACTIVITY_VALIDATION_DELAY));
    return {
        clickActionBase: clickActionBase,
        hadActivityOnPointerDown: ()=>hadActivityOnPointerDown
    };
}
function $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var _a;
    const click = $4ebccf53af8f3992$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    const selector = (_a = clickActionBase === null || clickActionBase === void 0 ? void 0 : clickActionBase.target) === null || _a === void 0 ? void 0 : _a.selector;
    if (selector) (0, $2NQWL.updateInteractionSelector)(startEvent.timeStamp, selector);
    const { stop: stopWaitPageActivityEnd } = (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent)=>{
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) // If the clock is looking weird, just discard the click
        click.discard();
        else {
            if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
            else if (hadActivityOnPointerDown()) click.stop(// using the click start as activity end, so the click will have some activity but its
            // duration will be 0 (as the activity started before the click start)
            click.startClocks.timeStamp);
            else click.stop();
        }
    }, (0, $2NQWL.CLICK_ACTION_MAX_DURATION));
    const viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        click.stop(endClocks.timeStamp);
    });
    const pageMayExitSubscription = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , ()=>{
        click.stop((0, $ly0px.timeStampNow)());
    });
    const stopSubscription = stopObservable.subscribe(()=>{
        click.stop();
    });
    click.stopObservable.subscribe(()=>{
        pageMayExitSubscription.unsubscribe();
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function $4ebccf53af8f3992$var$computeClickActionBase(event, nodePrivacyLevel, configuration) {
    const target = configuration.betaTrackActionsInShadowDom ? $4ebccf53af8f3992$var$getEventTarget(event) : event.target;
    const rect = target.getBoundingClientRect();
    const selector = (0, $l3o7w.getSelectorFromElement)(target, configuration.actionNameAttribute);
    const composedPathSelector = (0, $bWXC7.getComposedPathSelector)(event.composedPath(), configuration.actionNameAttribute);
    if (selector) (0, $2NQWL.updateInteractionSelector)(event.timeStamp, selector);
    const { name: name, nameSource: nameSource } = (0, $2dzye.getActionNameFromElement)(target, configuration, nodePrivacyLevel);
    return {
        type: (0, $kDJMQ.ActionType).CLICK,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: selector,
            composedPathSelector: composedPathSelector || undefined
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top)
        },
        name: name,
        nameSource: nameSource
    };
}
function $4ebccf53af8f3992$var$getEventTarget(event) {
    if (event.composed && (0, $4TGNe.isNodeShadowHost)(event.target) && typeof event.composedPath === 'function') {
        const composedPath = event.composedPath();
        if (composedPath.length > 0 && composedPath[0] instanceof Element) return composedPath[0];
    }
    return event.target;
}
function $4ebccf53af8f3992$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent) {
    const clickKey = (0, $99fDv.generateUUID)();
    const startClocks = (0, $ly0px.relativeToClocks)(startEvent.timeStamp);
    const startedClickAction = actionTracker.start(clickKey, startClocks, clickActionBase, {
        isChildEvent: (0, $rPcCT.isActionChildEvent)
    });
    lifeCycle.notify(15 /* LifeCycleEventType.ACTION_STARTED */ , startedClickAction);
    let status = 0 /* ClickStatus.ONGOING */ ;
    let actionTrackerFinishedEvent;
    const frustrationTypes = [];
    const stopObservable = new (0, $4wc1a.Observable)();
    function stop(activityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */ ) return;
        status = 1 /* ClickStatus.STOPPED */ ;
        actionTrackerFinishedEvent = activityEndTime ? actionTracker.stop(clickKey, (0, $ly0px.timeStampToClocks)(activityEndTime)) : actionTracker.discard(clickKey);
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError () {
            var _a;
            const currentCounts = (_a = actionTrackerFinishedEvent === null || actionTrackerFinishedEvent === void 0 ? void 0 : actionTrackerFinishedEvent.counts) !== null && _a !== void 0 ? _a : actionTracker.getCounts(clickKey);
            return currentCounts ? currentCounts.errorCount > 0 : false;
        },
        get hasPageActivity () {
            return actionTrackerFinishedEvent && 'duration' in actionTrackerFinishedEvent;
        },
        getUserActivity: getUserActivity,
        addFrustration: (frustrationType)=>{
            frustrationTypes.push(frustrationType);
        },
        get startClocks () {
            return startClocks;
        },
        isStopped: ()=>status === 1 /* ClickStatus.STOPPED */  || status === 2 /* ClickStatus.FINALIZED */ ,
        clone: ()=>$4ebccf53af8f3992$var$newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent),
        validate: (domEvents)=>{
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */ ) return;
            if (!actionTrackerFinishedEvent) return;
            const clickAction = {
                frustrationTypes: frustrationTypes,
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [
                    startEvent
                ],
                event: startEvent,
                ...actionTrackerFinishedEvent,
                counts: actionTrackerFinishedEvent.counts
            };
            lifeCycle.notify(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , clickAction);
            status = 2 /* ClickStatus.FINALIZED */ ;
        },
        discard: ()=>{
            stop();
            status = 2 /* ClickStatus.FINALIZED */ ;
        }
    };
}
function $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick) {
    const { isRage: isRage } = (0, $eV1gO.computeFrustration)(clicks, rageClick);
    if (isRage) {
        clicks.forEach((click)=>click.discard());
        rageClick.stop((0, $ly0px.timeStampNow)());
        rageClick.validate(clicks.map((click)=>click.event));
    } else {
        rageClick.discard();
        clicks.forEach((click)=>click.validate());
    }
}

});
parcelRegister("4TGNe", function(module, exports) {

$parcel$export(module.exports, "isTextNode", () => $390d7e44cf00bd59$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "isCommentNode", () => $390d7e44cf00bd59$export$575485136eb1b1f);
$parcel$export(module.exports, "isElementNode", () => $390d7e44cf00bd59$export$95fe5d3c5526a812);
$parcel$export(module.exports, "isNodeShadowHost", () => $390d7e44cf00bd59$export$1fde2ba54cd81850);
$parcel$export(module.exports, "isNodeShadowRoot", () => $390d7e44cf00bd59$export$3a98bd54c2ced0bf);
$parcel$export(module.exports, "hasChildNodes", () => $390d7e44cf00bd59$export$13782f450ac5e09a);
$parcel$export(module.exports, "forEachChildNodes", () => $390d7e44cf00bd59$export$522badb50a8fb0b);
$parcel$export(module.exports, "getParentNode", () => $390d7e44cf00bd59$export$4e12058fc4d51d56);
$parcel$export(module.exports, "getParentElement", () => $390d7e44cf00bd59$export$169e5491001d3ed6);
function $390d7e44cf00bd59$export$ccbedd67ef6e9417(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $390d7e44cf00bd59$export$575485136eb1b1f(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function $390d7e44cf00bd59$export$95fe5d3c5526a812(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $390d7e44cf00bd59$export$1fde2ba54cd81850(node) {
    return $390d7e44cf00bd59$export$95fe5d3c5526a812(node) && Boolean(node.shadowRoot);
}
function $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) {
    const shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && $390d7e44cf00bd59$export$95fe5d3c5526a812(shadowRoot.host);
}
function $390d7e44cf00bd59$export$13782f450ac5e09a(node) {
    return node.childNodes.length > 0 || $390d7e44cf00bd59$export$1fde2ba54cd81850(node);
}
function $390d7e44cf00bd59$export$522badb50a8fb0b(node, callback) {
    let child = node.firstChild;
    while(child){
        callback(child);
        child = child.nextSibling;
    }
    if ($390d7e44cf00bd59$export$1fde2ba54cd81850(node)) callback(node.shadowRoot);
}
function $390d7e44cf00bd59$export$4e12058fc4d51d56(node) {
    return $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) ? node.host : node.parentNode;
}
function $390d7e44cf00bd59$export$169e5491001d3ed6(element) {
    if (element.parentElement) return element.parentElement;
    const parentNode = element.parentNode;
    if (parentNode && $390d7e44cf00bd59$export$3a98bd54c2ced0bf(parentNode)) return parentNode.host;
    return null;
}

});

parcelRegister("7oXOv", function(module, exports) {

$parcel$export(module.exports, "PAGE_ACTIVITY_VALIDATION_DELAY", () => $56392c0d6d718cf0$export$a59477b089b98865);
$parcel$export(module.exports, "waitPageActivityEnd", () => $56392c0d6d718cf0$export$4a886e0e421b0302);

var $d97UU = parcelRequire("d97UU");
var $fzLbJ = parcelRequire("fzLbJ");
var $4Umqd = parcelRequire("4Umqd");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");
var $ly0px = parcelRequire("ly0px");

var $e6Vsp = parcelRequire("e6Vsp");

var $4TGNe = parcelRequire("4TGNe");
const $56392c0d6d718cf0$export$a59477b089b98865 = 100;
const $56392c0d6d718cf0$export$daa5d178ead00ab = 100;
const $56392c0d6d718cf0$export$ba7660fe1e727fd2 = 'data-dd-excluded-activity-mutations';
function $56392c0d6d718cf0$export$4a886e0e421b0302(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
    const pageActivityObservable = (0, $4Umqd.mockable)($56392c0d6d718cf0$export$48867124286069d5)(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    let pageActivityEndTimeoutId;
    let hasCompleted = false;
    const validationTimeoutId = (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(()=>complete({
            hadActivity: false
        })), $56392c0d6d718cf0$export$a59477b089b98865);
    const maxDurationTimeoutId = maxDuration !== undefined ? (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(()=>complete({
            hadActivity: true,
            end: (0, $ly0px.timeStampNow)()
        })), maxDuration) : undefined;
    const pageActivitySubscription = pageActivityObservable.subscribe(({ isBusy: isBusy })=>{
        (0, $d97UU.clearTimeout)(validationTimeoutId);
        (0, $d97UU.clearTimeout)(pageActivityEndTimeoutId);
        const lastChangeTime = (0, $ly0px.timeStampNow)();
        if (!isBusy) pageActivityEndTimeoutId = (0, $d97UU.setTimeout)((0, $2wH3Z.monitor)(()=>complete({
                hadActivity: true,
                end: lastChangeTime
            })), $56392c0d6d718cf0$export$daa5d178ead00ab);
    });
    const stop = ()=>{
        hasCompleted = true;
        (0, $d97UU.clearTimeout)(validationTimeoutId);
        (0, $d97UU.clearTimeout)(pageActivityEndTimeoutId);
        (0, $d97UU.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) return;
        stop();
        pageActivityEndCallback(event);
    }
    return {
        stop: stop
    };
}
function $56392c0d6d718cf0$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    return new (0, $4wc1a.Observable)((observable)=>{
        const subscriptions = [];
        let firstRequestIndex;
        let pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe((mutations)=>{
            if (!mutations.every($56392c0d6d718cf0$var$isExcludedMutation)) notifyPageActivity();
        }), windowOpenObservable.subscribe(notifyPageActivity), (0, $e6Vsp.createPerformanceObservable)(configuration, {
            type: (0, $e6Vsp.RumPerformanceEntryType).RESOURCE
        }).subscribe((entries)=>{
            if (entries.some((entry)=>!$56392c0d6d718cf0$var$isExcludedUrl(configuration, entry.name))) notifyPageActivity();
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */ , (startEvent)=>{
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, startEvent.url)) return;
            if (firstRequestIndex === undefined) firstRequestIndex = startEvent.requestIndex;
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined || // If the request started before the tracking start, ignore it
            request.requestIndex < firstRequestIndex) return;
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        return ()=>{
            subscriptions.forEach((s)=>s.unsubscribe());
        };
        function notifyPageActivity() {
            observable.notify({
                isBusy: pendingRequestsCount > 0
            });
        }
    });
}
function $56392c0d6d718cf0$var$isExcludedUrl(configuration, requestUrl) {
    return (0, $fzLbJ.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function $56392c0d6d718cf0$var$isExcludedMutation(mutation) {
    const targetElement = mutation.type === 'characterData' ? mutation.target.parentElement : mutation.target;
    return Boolean(targetElement && (0, $4TGNe.isElementNode)(targetElement) && targetElement.matches(`[${$56392c0d6d718cf0$export$ba7660fe1e727fd2}], [${$56392c0d6d718cf0$export$ba7660fe1e727fd2}] *`));
}

});
parcelRegister("e6Vsp", function(module, exports) {

$parcel$export(module.exports, "RumPerformanceEntryType", () => $a45e320ac0fe2c4f$export$5241bfb054a2a291);
$parcel$export(module.exports, "createPerformanceObservable", () => $a45e320ac0fe2c4f$export$f3f6554c84596077);
$parcel$export(module.exports, "supportPerformanceTimingEvent", () => $a45e320ac0fe2c4f$export$c6967607cdac15e8);

var $hXhfS = parcelRequire("hXhfS");
var $d97UU = parcelRequire("d97UU");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");

var $fisL9 = parcelRequire("fisL9");

var $3HAaw = parcelRequire("3HAaw");
var $a45e320ac0fe2c4f$export$5241bfb054a2a291;
(function(RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
    RumPerformanceEntryType["VISIBILITY_STATE"] = "visibility-state";
})($a45e320ac0fe2c4f$export$5241bfb054a2a291 || ($a45e320ac0fe2c4f$export$5241bfb054a2a291 = {}));
function $a45e320ac0fe2c4f$export$f3f6554c84596077(configuration, options) {
    return new (0, $4wc1a.Observable)((observable)=>{
        if (!window.PerformanceObserver) return;
        const handlePerformanceEntries = (entries)=>{
            const rumPerformanceEntries = $a45e320ac0fe2c4f$var$filterRumPerformanceEntries(entries);
            if (rumPerformanceEntries.length > 0) observable.notify(rumPerformanceEntries);
        };
        let timeoutId;
        let isObserverInitializing = true;
        const observer = new PerformanceObserver((0, $2wH3Z.monitor)((entries)=>{
            // In Safari the performance observer callback is synchronous.
            // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
            if (isObserverInitializing) timeoutId = (0, $d97UU.setTimeout)(()=>handlePerformanceEntries(entries.getEntries()));
            else handlePerformanceEntries(entries.getEntries());
        }));
        try {
            observer.observe(options);
        } catch (_a) {
            // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
            // TODO: remove this fallback in the next major version
            const fallbackSupportedEntryTypes = [
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.RESOURCE,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.NAVIGATION,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.LONG_TASK,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.PAINT
            ];
            if (fallbackSupportedEntryTypes.includes(options.type)) {
                if (options.buffered) timeoutId = (0, $d97UU.setTimeout)(()=>handlePerformanceEntries(performance.getEntriesByType(options.type)));
                try {
                    observer.observe({
                        entryTypes: [
                            options.type
                        ]
                    });
                } catch (_b) {
                    // Old versions of Safari are throwing "entryTypes contained only unsupported types"
                    // errors when observing only unsupported entry types.
                    //
                    // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
                    // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
                    // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
                    // even if they do support the entry type.
                    return;
                }
            }
        }
        isObserverInitializing = false;
        $a45e320ac0fe2c4f$var$manageResourceTimingBufferFull(configuration);
        let stopFirstInputTiming;
        if (!$a45e320ac0fe2c4f$export$c6967607cdac15e8($a45e320ac0fe2c4f$export$5241bfb054a2a291.FIRST_INPUT) && options.type === $a45e320ac0fe2c4f$export$5241bfb054a2a291.FIRST_INPUT) ({ stop: stopFirstInputTiming } = (0, $3HAaw.retrieveFirstInputTiming)(configuration, (timing)=>{
            handlePerformanceEntries([
                timing
            ]);
        }));
        return ()=>{
            observer.disconnect();
            if (stopFirstInputTiming) stopFirstInputTiming();
            (0, $d97UU.clearTimeout)(timeoutId);
        };
    });
}
let $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener;
function $a45e320ac0fe2c4f$var$manageResourceTimingBufferFull(configuration) {
    if (!$a45e320ac0fe2c4f$var$resourceTimingBufferFullListener && $a45e320ac0fe2c4f$var$supportPerformanceObject() && 'addEventListener' in performance) // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener = (0, $hXhfS.addEventListener)(configuration, performance, 'resourcetimingbufferfull', ()=>{
        performance.clearResourceTimings();
    });
}
function $a45e320ac0fe2c4f$export$b54bee7507caa0fa() {
    if ($a45e320ac0fe2c4f$var$resourceTimingBufferFullListener) {
        $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener.stop();
        $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener = undefined;
    }
}
function $a45e320ac0fe2c4f$var$supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function $a45e320ac0fe2c4f$export$c6967607cdac15e8(entryType) {
    return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $a45e320ac0fe2c4f$var$filterRumPerformanceEntries(entries) {
    return entries.filter((entry)=>!$a45e320ac0fe2c4f$var$isForbiddenResource(entry));
}
function $a45e320ac0fe2c4f$var$isForbiddenResource(entry) {
    return entry.entryType === $a45e320ac0fe2c4f$export$5241bfb054a2a291.RESOURCE && (!(0, $fisL9.isAllowedRequestUrl)(entry.name) || !(0, $fisL9.hasValidResourceEntryDuration)(entry));
}

});
parcelRegister("3HAaw", function(module, exports) {

$parcel$export(module.exports, "retrieveFirstInputTiming", () => $2b21719c0559c4ac$export$2c9064660d4f1caa);

var $hXhfS = parcelRequire("hXhfS");
var $ly0px = parcelRequire("ly0px");
function $2b21719c0559c4ac$export$2c9064660d4f1caa(configuration, callback) {
    const startTimeStamp = (0, $ly0px.dateNow)();
    let timingSent = false;
    const { stop: removeEventListeners } = (0, $hXhfS.addEventListeners)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "mousedown" /* DOM_EVENT.MOUSE_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ 
    ], (evt)=>{
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) return;
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        const timing = {
            entryType: 'first-input',
            processingStart: (0, $ly0px.relativeNow)(),
            processingEnd: (0, $ly0px.relativeNow)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: '',
            cancelable: false,
            target: null,
            interactionId: 0,
            toJSON: ()=>({})
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ) sendTimingIfPointerIsNotCancelled(configuration, timing);
        else sendTiming(timing);
    }, {
        passive: true,
        capture: true
    });
    return {
        stop: removeEventListeners
    };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */ function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0, $hXhfS.addEventListeners)(configuration, window, [
            "pointerup" /* DOM_EVENT.POINTER_UP */ ,
            "pointercancel" /* DOM_EVENT.POINTER_CANCEL */ 
        ], (event)=>{
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */ ) sendTiming(timing);
        }, {
            once: true
        });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            const delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, $ly0px.dateNow)() - startTimeStamp) callback(timing);
        }
    }
}

});



parcelRegister("l3o7w", function(module, exports) {

$parcel$export(module.exports, "STABLE_ATTRIBUTES", () => $f53c969915647662$export$4ab9e1b4853d6dd7);
$parcel$export(module.exports, "getIDSelector", () => $f53c969915647662$export$810c85d2e109892a);
$parcel$export(module.exports, "getTagNameSelector", () => $f53c969915647662$export$e8aa1d92284ab2dc);
$parcel$export(module.exports, "getSelectorFromElement", () => $f53c969915647662$export$2a298c6a007e5e40);
$parcel$export(module.exports, "isGeneratedValue", () => $f53c969915647662$export$76ae048df570c708);
$parcel$export(module.exports, "getAttributeValueSelector", () => $f53c969915647662$export$ab51fe52b0621f44);
$parcel$export(module.exports, "getNthOfTypeSelector", () => $f53c969915647662$export$551b85403f3bee6);

var $4TGNe = parcelRequire("4TGNe");

var $8NBqb = parcelRequire("8NBqb");
const $f53c969915647662$export$5786d969a307d4df = '::shadow ';
const $f53c969915647662$export$4ab9e1b4853d6dd7 = [
    (0, $8NBqb.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE),
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file'
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
const $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$export$810c85d2e109892a
];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
const $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$var$getClassSelector,
    $f53c969915647662$export$e8aa1d92284ab2dc
];
function $f53c969915647662$export$2a298c6a007e5e40(targetElement, actionNameAttribute) {
    if (!targetElement.isConnected) // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
    const subtrees = $f53c969915647662$var$getAllSubtreeTargets(targetElement);
    const selectorParts = [];
    for (const { rootNode: rootNode, target: target } of subtrees){
        const selector = $f53c969915647662$var$getSelectorFromElementWithinSubtree(target, rootNode, actionNameAttribute);
        if (!selector) return undefined;
        selectorParts.push(selector);
    }
    return selectorParts.join($f53c969915647662$export$5786d969a307d4df);
}
/**
 * Returns all (rootNode, target) pairs from the document down to the element.
 */ function $f53c969915647662$var$getAllSubtreeTargets(element) {
    const result = [];
    let currentTarget = element;
    while(currentTarget){
        const rootNode = currentTarget.getRootNode();
        result.push({
            rootNode: rootNode,
            target: currentTarget
        });
        if ((0, $4TGNe.isNodeShadowRoot)(rootNode)) currentTarget = rootNode.host;
        else break;
    }
    return result.reverse();
}
/**
 * Computes a CSS selector for an element within a specific subtree (document or shadow root).
 */ function $f53c969915647662$var$getSelectorFromElementWithinSubtree(targetElement, rootNode, actionNameAttribute) {
    let currentSelector;
    let currentElement = targetElement;
    while(currentElement && currentElement.nodeName !== 'HTML'){
        const globallyUniqueSelector = $f53c969915647662$var$findSelector(currentElement, rootNode, $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS, $f53c969915647662$var$isSelectorUniqueWithinRoot, actionNameAttribute, currentSelector);
        if (globallyUniqueSelector) return $f53c969915647662$var$combineSelector(globallyUniqueSelector, currentSelector);
        const uniqueSelectorAmongChildren = $f53c969915647662$var$findSelector(currentElement, rootNode, $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, $f53c969915647662$export$feed9c87b437f926, actionNameAttribute, currentSelector);
        const elementSelector = uniqueSelectorAmongChildren || $f53c969915647662$var$getPositionSelector(currentElement);
        currentSelector = $f53c969915647662$var$combineSelector(elementSelector, currentSelector);
        currentElement = currentElement.parentElement;
    }
    return currentSelector;
}
function $f53c969915647662$export$76ae048df570c708(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time.
    return /[0-9]/.test(value);
}
function $f53c969915647662$export$810c85d2e109892a(element) {
    if (element.id && !$f53c969915647662$export$76ae048df570c708(element.id)) return `#${CSS.escape(element.id)}`;
}
function $f53c969915647662$var$getClassSelector(element) {
    if (element.tagName === 'BODY') return;
    const classList = element.classList;
    for(let i = 0; i < classList.length; i += 1){
        const className = classList[i];
        if ($f53c969915647662$export$76ae048df570c708(className)) continue;
        return `${CSS.escape(element.tagName)}.${CSS.escape(className)}`;
    }
}
function $f53c969915647662$export$e8aa1d92284ab2dc(element) {
    return CSS.escape(element.tagName);
}
function $f53c969915647662$var$getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        const selector = getAttributeSelector(actionNameAttribute);
        if (selector) return selector;
    }
    for (const attributeName of $f53c969915647662$export$4ab9e1b4853d6dd7){
        const selector = getAttributeSelector(attributeName);
        if (selector) return selector;
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) return `${CSS.escape(element.tagName)}${$f53c969915647662$export$ab51fe52b0621f44(attributeName, element.getAttribute(attributeName))}`;
    }
}
function $f53c969915647662$export$ab51fe52b0621f44(attributeName, attributeValue) {
    return `[${attributeName}="${CSS.escape(attributeValue)}"]`;
}
function $f53c969915647662$var$getPositionSelector(element) {
    const nthOfType = $f53c969915647662$export$551b85403f3bee6(element);
    return `${CSS.escape(element.tagName)}:nth-of-type(${nthOfType})`;
}
function $f53c969915647662$export$551b85403f3bee6(element) {
    const parent = element.parentNode;
    let sibling = parent.firstElementChild;
    let nthOfType = 1;
    while(sibling && sibling !== element){
        if (sibling.tagName === element.tagName) nthOfType += 1;
        sibling = sibling.nextElementSibling;
    }
    return nthOfType;
}
function $f53c969915647662$var$findSelector(element, rootNode, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (const selectorGetter of selectorGetters){
        const elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) continue;
        if (predicate(element, rootNode, elementSelector, childSelector)) return elementSelector;
    }
}
/**
 * Check whether the selector is unique within the root node (document or shadow root).
 */ function $f53c969915647662$var$isSelectorUniqueWithinRoot(_element, rootNode, elementSelector, childSelector) {
    return rootNode.querySelectorAll($f53c969915647662$var$combineSelector(elementSelector, childSelector)).length === 1;
}
function $f53c969915647662$export$feed9c87b437f926(currentElement, _rootNode, currentElementSelector, childSelector) {
    let isSiblingMatching;
    if (childSelector === undefined) // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = (sibling)=>sibling.matches(currentElementSelector);
    else {
        const scopedSelector = $f53c969915647662$var$combineSelector(`${currentElementSelector}:scope`, childSelector);
        isSiblingMatching = (sibling)=>sibling.querySelector(scopedSelector) !== null;
    }
    // Check siblings by iterating directly through previousElementSibling and nextElementSibling.
    // This works even when parentElement is null (e.g., when parent is a DocumentFragment).
    // Check previous siblings
    let sibling = currentElement.previousElementSibling;
    while(sibling){
        if (isSiblingMatching(sibling)) return false;
        sibling = sibling.previousElementSibling;
    }
    // Check next siblings
    sibling = currentElement.nextElementSibling;
    while(sibling){
        if (isSiblingMatching(sibling)) return false;
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function $f53c969915647662$var$combineSelector(parent, child) {
    return child ? `${parent}>${child}` : parent;
}

});
parcelRegister("8NBqb", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", () => $667fed6c666b9914$export$e3a045a56698d3f9);
$parcel$export(module.exports, "ACTION_NAME_PLACEHOLDER", () => $667fed6c666b9914$export$23b90ecb4143a9ad);
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */ const $667fed6c666b9914$export$e3a045a56698d3f9 = 'data-dd-action-name';
const $667fed6c666b9914$export$23b90ecb4143a9ad = 'Masked Element';
const $667fed6c666b9914$export$a3416a6a36105e6e = 'xxx';

});


parcelRegister("OddO2", function(module, exports) {

$parcel$export(module.exports, "getNodePrivacyLevel", () => $096eed2d25f26114$export$da439d4b145972be);
$parcel$export(module.exports, "getNodeSelfPrivacyLevel", () => $096eed2d25f26114$export$c417e854a5c24a6f);
$parcel$export(module.exports, "reducePrivacyLevel", () => $096eed2d25f26114$export$3e5e4c23b3787dea);
$parcel$export(module.exports, "shouldMaskNode", () => $096eed2d25f26114$export$f97c617afddc1089);
$parcel$export(module.exports, "shouldMaskAttribute", () => $096eed2d25f26114$export$15e4315f0331c4e9);
$parcel$export(module.exports, "getTextContent", () => $096eed2d25f26114$export$132e79e4118a78e0);
$parcel$export(module.exports, "maskDisallowedTextContent", () => $096eed2d25f26114$export$1520fe27573fdbd3);

var $4TGNe = parcelRequire("4TGNe");

var $8EzN6 = parcelRequire("8EzN6");

var $l3o7w = parcelRequire("l3o7w");
function $096eed2d25f26114$export$da439d4b145972be(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) return cache.get(node);
    const parentNode = (0, $4TGNe.getParentNode)(node);
    const parentNodePrivacyLevel = parentNode ? $096eed2d25f26114$export$da439d4b145972be(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
    const selfNodePrivacyLevel = $096eed2d25f26114$export$c417e854a5c24a6f(node);
    const nodePrivacyLevel = $096eed2d25f26114$export$3e5e4c23b3787dea(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) cache.set(node, nodePrivacyLevel);
    return nodePrivacyLevel;
}
function $096eed2d25f26114$export$3e5e4c23b3787dea(childPrivacyLevel, parentNodePrivacyLevel) {
    switch(parentNodePrivacyLevel){
        // These values cannot be overridden
        case (0, $8EzN6.NodePrivacyLevel).HIDDEN:
        case (0, $8EzN6.NodePrivacyLevel).IGNORE:
            return parentNodePrivacyLevel;
    }
    switch(childPrivacyLevel){
        case (0, $8EzN6.NodePrivacyLevel).ALLOW:
        case (0, $8EzN6.NodePrivacyLevel).MASK:
        case (0, $8EzN6.NodePrivacyLevel).MASK_USER_INPUT:
        case (0, $8EzN6.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
        case (0, $8EzN6.NodePrivacyLevel).HIDDEN:
        case (0, $8EzN6.NodePrivacyLevel).IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
function $096eed2d25f26114$export$c417e854a5c24a6f(node) {
    // Only Element types can have a privacy level set
    if (!(0, $4TGNe.isElementNode)(node)) return;
    // Overrules for replay purpose
    if (node.tagName === 'BASE') return (0, $8EzN6.NodePrivacyLevel).ALLOW;
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        const inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') return (0, $8EzN6.NodePrivacyLevel).MASK;
        if (inputElement.type === 'hidden') return (0, $8EzN6.NodePrivacyLevel).MASK;
        const autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year/new-password/current-password]
        if (autocomplete && (autocomplete.startsWith('cc-') || autocomplete.endsWith('-password'))) return (0, $8EzN6.NodePrivacyLevel).MASK;
    }
    // Check HTML privacy attributes and classes
    if (node.matches((0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).HIDDEN))) return (0, $8EzN6.NodePrivacyLevel).HIDDEN;
    if (node.matches((0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).MASK))) return (0, $8EzN6.NodePrivacyLevel).MASK;
    if (node.matches((0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED))) return (0, $8EzN6.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED;
    if (node.matches((0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).MASK_USER_INPUT))) return (0, $8EzN6.NodePrivacyLevel).MASK_USER_INPUT;
    if (node.matches((0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).ALLOW))) return (0, $8EzN6.NodePrivacyLevel).ALLOW;
    if ($096eed2d25f26114$export$15d4213dc9444b1(node)) return (0, $8EzN6.NodePrivacyLevel).IGNORE;
}
function $096eed2d25f26114$export$f97c617afddc1089(node, privacyLevel) {
    switch(privacyLevel){
        case (0, $8EzN6.NodePrivacyLevel).MASK:
        case (0, $8EzN6.NodePrivacyLevel).HIDDEN:
        case (0, $8EzN6.NodePrivacyLevel).IGNORE:
            return true;
        case (0, $8EzN6.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED:
            if ((0, $4TGNe.isTextNode)(node)) // Always return true if our parent is a form element, like MASK_USER_INPUT.
            // Otherwise, decide whether to mask based on the allowlist.
            return $096eed2d25f26114$var$isFormElement(node.parentNode) ? true : !$096eed2d25f26114$export$204f2b4e8040eb90(node.textContent || '');
            // Always return true if we're a form element, like MASK_USER_INPUT.
            // Otherwise, return false; MASK_UNLESS_ALLOWLISTED only directly masks text nodes.
            return $096eed2d25f26114$var$isFormElement(node);
        case (0, $8EzN6.NodePrivacyLevel).MASK_USER_INPUT:
            return (0, $4TGNe.isTextNode)(node) ? $096eed2d25f26114$var$isFormElement(node.parentNode) : $096eed2d25f26114$var$isFormElement(node);
        default:
            return false;
    }
}
function $096eed2d25f26114$export$15e4315f0331c4e9(tagName, attributeName, attributeValue, nodePrivacyLevel, configuration) {
    if (nodePrivacyLevel !== (0, $8EzN6.NodePrivacyLevel).MASK && nodePrivacyLevel !== (0, $8EzN6.NodePrivacyLevel).MASK_UNLESS_ALLOWLISTED) return false;
    if (attributeName === (0, $8EzN6.PRIVACY_ATTR_NAME) || (0, $l3o7w.STABLE_ATTRIBUTES).includes(attributeName) || attributeName === configuration.actionNameAttribute) return false;
    switch(attributeName){
        case 'title':
        case 'alt':
        case 'placeholder':
        case 'aria-label':
        case 'name':
            return true;
    }
    if (tagName === 'A' && attributeName === 'href') return true;
    if (tagName === 'IFRAME' && attributeName === 'srcdoc') return true;
    if (attributeValue && attributeName.startsWith('data-')) return true;
    if ((tagName === 'IMG' || tagName === 'SOURCE') && (attributeName === 'src' || attributeName === 'srcset')) return true;
    return false;
}
function $096eed2d25f26114$var$isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
    const element = node;
    if (element.tagName === 'INPUT') switch(element.type){
        case 'button':
        case 'color':
        case 'reset':
        case 'submit':
            return false;
    }
    return !!(0, $8EzN6.FORM_PRIVATE_TAG_NAMES)[element.tagName];
}
function $096eed2d25f26114$export$7aa14ef9d0a56a45(text) {
    return text.replace(/\S/g, (0, $8EzN6.TEXT_MASKING_CHAR));
}
function $096eed2d25f26114$export$132e79e4118a78e0(textNode, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    const parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    let textContent = textNode.textContent || '';
    const shouldIgnoreWhiteSpace = parentTagName === 'HEAD';
    if (shouldIgnoreWhiteSpace && !textContent.trim()) return;
    const nodePrivacyLevel = parentNodePrivacyLevel;
    const isScript = parentTagName === 'SCRIPT';
    if (isScript) // For perf reasons, we don't record script (heuristic)
    textContent = (0, $8EzN6.CENSORED_STRING_MARK);
    else if (nodePrivacyLevel === (0, $8EzN6.NodePrivacyLevel).HIDDEN) // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = (0, $8EzN6.CENSORED_STRING_MARK);
    else if ($096eed2d25f26114$export$f97c617afddc1089(textNode, nodePrivacyLevel)) {
        if (// Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) return;
        } else if (parentTagName === 'OPTION') // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
        textContent = (0, $8EzN6.CENSORED_STRING_MARK);
        else textContent = $096eed2d25f26114$export$7aa14ef9d0a56a45(textContent);
    }
    return textContent;
}
function $096eed2d25f26114$export$15d4213dc9444b1(element) {
    if (element.nodeName === 'SCRIPT') return true;
    if (element.nodeName === 'LINK') {
        const relAttribute = getLowerCaseAttribute('rel');
        return(// Link as script - Ignore only when rel=preload, modulepreload or prefetch
        /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script' || // Favicons
        relAttribute === 'shortcut icon' || relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        const nameAttribute = getLowerCaseAttribute('name');
        const relAttribute = getLowerCaseAttribute('rel');
        const propertyAttribute = getLowerCaseAttribute('property');
        return(// Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' || // Description
        nameAttribute === 'keywords' || nameAttribute === 'description' || // Social
        /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' || // Robots
        nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
        // X-Translated-By
        element.hasAttribute('http-equiv') || // Authorship
        nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || // Verification
        nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
function $096eed2d25f26114$export$204f2b4e8040eb90(text) {
    var _a;
    if (!text || !text.trim()) return true;
    // We are using toLocaleLowerCase when adding to the allowlist to avoid case sensitivity
    // so we need to do the same here
    return ((_a = window.$DD_ALLOW) === null || _a === void 0 ? void 0 : _a.has(text.toLocaleLowerCase())) || false;
}
function $096eed2d25f26114$export$1520fe27573fdbd3(text, fixedMask) {
    if ($096eed2d25f26114$export$204f2b4e8040eb90(text)) return text;
    return fixedMask || $096eed2d25f26114$export$7aa14ef9d0a56a45(text);
}

});
parcelRegister("8EzN6", function(module, exports) {

$parcel$export(module.exports, "NodePrivacyLevel", () => $64cdd2813fc6cb3a$export$92940eb5f25d0fc5);
$parcel$export(module.exports, "PRIVACY_ATTR_NAME", () => $64cdd2813fc6cb3a$export$ff33c64c78e35b2b);
$parcel$export(module.exports, "PRIVACY_ATTR_VALUE_HIDDEN", () => $64cdd2813fc6cb3a$export$e41cc9b2bd72efb8);
$parcel$export(module.exports, "CENSORED_STRING_MARK", () => $64cdd2813fc6cb3a$export$76054905c0914783);
$parcel$export(module.exports, "CENSORED_IMG_MARK", () => $64cdd2813fc6cb3a$export$4ab830af01a1bf7e);
$parcel$export(module.exports, "FORM_PRIVATE_TAG_NAMES", () => $64cdd2813fc6cb3a$export$b6dba6f930ee071f);
$parcel$export(module.exports, "TEXT_MASKING_CHAR", () => $64cdd2813fc6cb3a$export$338da8c573d46a97);
$parcel$export(module.exports, "getPrivacySelector", () => $64cdd2813fc6cb3a$export$8af88c85d388edd6);

var $7imKH = parcelRequire("7imKH");
const $64cdd2813fc6cb3a$export$92940eb5f25d0fc5 = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: (0, $7imKH.DefaultPrivacyLevel).ALLOW,
    MASK: (0, $7imKH.DefaultPrivacyLevel).MASK,
    MASK_USER_INPUT: (0, $7imKH.DefaultPrivacyLevel).MASK_USER_INPUT,
    MASK_UNLESS_ALLOWLISTED: (0, $7imKH.DefaultPrivacyLevel).MASK_UNLESS_ALLOWLISTED
};
const $64cdd2813fc6cb3a$export$ff33c64c78e35b2b = 'data-dd-privacy';
const $64cdd2813fc6cb3a$export$a5095f6ae8c6493c = 'allow';
const $64cdd2813fc6cb3a$export$faf6990c986cc1eb = 'mask';
const $64cdd2813fc6cb3a$export$b06f6b91aa78d012 = 'mask-user-input';
const $64cdd2813fc6cb3a$export$bb9ad7f5163289ba = 'mask-unless-allowlisted';
const $64cdd2813fc6cb3a$export$e41cc9b2bd72efb8 = 'hidden';
const $64cdd2813fc6cb3a$export$bee0efbfde2065b1 = 'dd-privacy-';
const $64cdd2813fc6cb3a$export$76054905c0914783 = '***';
const $64cdd2813fc6cb3a$export$4ab830af01a1bf7e = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
const $64cdd2813fc6cb3a$export$b6dba6f930ee071f = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true
};
const $64cdd2813fc6cb3a$export$338da8c573d46a97 = 'x';
function $64cdd2813fc6cb3a$export$8af88c85d388edd6(privacyLevel) {
    return `[${$64cdd2813fc6cb3a$export$ff33c64c78e35b2b}="${privacyLevel}"], .${$64cdd2813fc6cb3a$export$bee0efbfde2065b1}${privacyLevel}`;
}

});


parcelRegister("2ZNES", function(module, exports) {

$parcel$export(module.exports, "startEventTracker", () => $22e7cc6453e0834f$export$adf9d423257cdcbe);

var $j9iCm = parcelRequire("j9iCm");
var $80mka = parcelRequire("80mka");
var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");

var $WzabW = parcelRequire("WzabW");
const $22e7cc6453e0834f$export$7dd0e2af89dbbfc9 = 5 * (0, $ly0px.ONE_MINUTE); // arbitrary
function $22e7cc6453e0834f$export$adf9d423257cdcbe(lifeCycle) {
    // Used by actions to associate events with actions.
    const history = (0, $80mka.createValueHistory)({
        expireDelay: $22e7cc6453e0834f$export$7dd0e2af89dbbfc9
    });
    // Used by manual actions and resources that use named keys to match the start and stop calls.
    const keyedEvents = new Map();
    function cleanUpEvent(event) {
        var _a;
        keyedEvents.delete(event.key);
        (_a = event.eventCounts) === null || _a === void 0 || _a.stop();
    }
    function discardAll() {
        keyedEvents.forEach((event)=>{
            cleanUpEvent(event);
        });
        history.reset();
    }
    const sessionRenewalSubscription = lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , discardAll);
    function start(key, startClocks, data, options) {
        const id = (0, $99fDv.generateUUID)();
        const historyEntry = history.add(id, startClocks.relative);
        const existing = keyedEvents.get(key);
        if (existing) cleanUpEvent(existing);
        const eventCounts = (options === null || options === void 0 ? void 0 : options.isChildEvent) ? (0, $WzabW.trackEventCounts)({
            lifeCycle: lifeCycle,
            isChildEvent: options.isChildEvent(id)
        }) : undefined;
        const trackedEventData = {
            id: id,
            key: key,
            startClocks: startClocks,
            data: data,
            historyEntry: historyEntry,
            eventCounts: eventCounts
        };
        keyedEvents.set(key, trackedEventData);
        return trackedEventData;
    }
    function stop(key, stopClocks, extraData) {
        var _a;
        const event = keyedEvents.get(key);
        if (!event) return undefined;
        const finalData = extraData ? (0, $j9iCm.combine)(event.data, extraData) : event.data;
        event.historyEntry.close(stopClocks.relative);
        const duration = (0, $ly0px.elapsed)(event.startClocks.timeStamp, stopClocks.timeStamp);
        const counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
        cleanUpEvent(event);
        return {
            ...finalData,
            id: event.id,
            startClocks: event.startClocks,
            duration: duration,
            counts: counts
        };
    }
    function discard(key) {
        var _a;
        const event = keyedEvents.get(key);
        if (!event) return undefined;
        const counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
        cleanUpEvent(event);
        event.historyEntry.remove();
        return {
            ...event.data,
            id: event.id,
            startClocks: event.startClocks,
            counts: counts
        };
    }
    function findId(startTime) {
        return history.findAll(startTime);
    }
    function getCounts(key) {
        var _a, _b;
        return (_b = (_a = keyedEvents.get(key)) === null || _a === void 0 ? void 0 : _a.eventCounts) === null || _b === void 0 ? void 0 : _b.eventCounts;
    }
    function stopTracker() {
        sessionRenewalSubscription.unsubscribe();
        discardAll();
        history.stop();
    }
    return {
        start: start,
        stop: stop,
        discard: discard,
        getCounts: getCounts,
        findId: findId,
        stopAll: stopTracker
    };
}

});
parcelRegister("WzabW", function(module, exports) {

$parcel$export(module.exports, "trackEventCounts", () => $0b00b19bfaa2355c$export$a50549f6fbbed49b);

var $aed8w = parcelRequire("aed8w");

var $kDJMQ = parcelRequire("kDJMQ");
function $0b00b19bfaa2355c$export$a50549f6fbbed49b({ lifeCycle: lifeCycle, isChildEvent: isChildEvent, onChange: callback = (0, $aed8w.noop) }) {
    const eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0
    };
    const subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (event)=>{
        var _a;
        if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) return;
        switch(event.type){
            case (0, $kDJMQ.RumEventType).ERROR:
                eventCounts.errorCount += 1;
                callback();
                break;
            case (0, $kDJMQ.RumEventType).ACTION:
                eventCounts.actionCount += 1;
                if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
                callback();
                break;
            case (0, $kDJMQ.RumEventType).LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case (0, $kDJMQ.RumEventType).RESOURCE:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: ()=>{
            subscription.unsubscribe();
        },
        eventCounts: eventCounts
    };
}

});


parcelRegister("bWXC7", function(module, exports) {

$parcel$export(module.exports, "getComposedPathSelector", () => $8b335a91f0da985d$export$c780826a82a9e923);

var $7S2uk = parcelRequire("7S2uk");
var $99fDv = parcelRequire("99fDv");

var $l3o7w = parcelRequire("l3o7w");
const $8b335a91f0da985d$var$FILTERED_TAGNAMES = [
    'HTML',
    'BODY'
];
const $8b335a91f0da985d$export$850d7233a25b9ac1 = 2 * (0, $7S2uk.ONE_KIBI_BYTE);
const $8b335a91f0da985d$export$f14a1f46a83c3bed = (0, $l3o7w.STABLE_ATTRIBUTES).concat([
    'role',
    'type',
    'disabled',
    'readonly',
    'tabindex',
    'draggable',
    'target',
    'rel',
    'download',
    'method',
    'action',
    'enctype',
    'autocomplete'
]);
function $8b335a91f0da985d$export$c780826a82a9e923(composedPath, actionNameAttribute) {
    // Filter to only include Element nodes
    const elements = composedPath.filter((el)=>el instanceof Element && !$8b335a91f0da985d$var$FILTERED_TAGNAMES.includes(el.tagName));
    if (elements.length === 0) return '';
    const allowedAttributes = actionNameAttribute ? [
        actionNameAttribute
    ].concat($8b335a91f0da985d$export$f14a1f46a83c3bed) : $8b335a91f0da985d$export$f14a1f46a83c3bed;
    let result = '';
    for (const element of elements){
        const part = $8b335a91f0da985d$var$getSelectorStringFromElement(element, allowedAttributes);
        result += part;
        if (result.length >= $8b335a91f0da985d$export$850d7233a25b9ac1) return (0, $99fDv.safeTruncate)(result, $8b335a91f0da985d$export$850d7233a25b9ac1);
    }
    return result;
}
/**
 * Extracts a selector string from an element.
 */ function $8b335a91f0da985d$var$getSelectorStringFromElement(element, allowedAttributes) {
    const tagName = (0, $l3o7w.getTagNameSelector)(element);
    const id = (0, $l3o7w.getIDSelector)(element);
    const classes = $8b335a91f0da985d$var$getElementClassesString(element);
    const attributes = $8b335a91f0da985d$var$extractSafeAttributesString(element, allowedAttributes);
    const positionData = $8b335a91f0da985d$var$computePositionDataString(element);
    return `${tagName}${id || ''}${attributes}${classes}${positionData};`;
}
function $8b335a91f0da985d$var$getElementClassesString(element) {
    return Array.from(element.classList).filter((c)=>!(0, $l3o7w.isGeneratedValue)(c)).sort().map((c)=>`.${CSS.escape(c)}`).join('');
}
/**
 * Computes the nthChild and nthOfType positions for an element.
 *
 * @param element - The element to compute the position data for
 * @returns A string of the form ":nth-child(1):nth-of-type(1)"
 */ function $8b335a91f0da985d$var$computePositionDataString(element) {
    const siblings = Array.from(element.parentNode.children);
    if (siblings.length <= 1) return '';
    const sameTypeSiblings = siblings.filter((sibling)=>sibling.tagName === element.tagName);
    const nthChild = siblings.indexOf(element);
    const nthOfType = (0, $l3o7w.getNthOfTypeSelector)(element);
    return `:nth-child(${nthChild + 1})${sameTypeSiblings.length > 1 ? `:nth-of-type(${nthOfType})` : ''}`;
}
/**
 * Extracts only the safe (allowlisted) attributes from an element.
 * The attributes are sorted alphabetically by name.
 */ function $8b335a91f0da985d$var$extractSafeAttributesString(element, allowedAttributes) {
    const result = [];
    const attributes = Array.from(element.attributes);
    for (const attribute of attributes)if (allowedAttributes.includes(attribute.name)) result.push((0, $l3o7w.getAttributeValueSelector)(attribute.name, attribute.value));
    return result.sort().join('');
}

});

parcelRegister("cNHb8", function(module, exports) {

$parcel$export(module.exports, "createClickChain", () => $951b8e01832faf5b$export$864c62f6b0bc947);

var $d97UU = parcelRequire("d97UU");
var $ly0px = parcelRequire("ly0px");
const $951b8e01832faf5b$export$1505b1def7b874c6 = (0, $ly0px.ONE_SECOND);
const $951b8e01832faf5b$export$30c5966f4862d434 = 100;
function $951b8e01832faf5b$export$864c62f6b0bc947(firstClick, onFinalize) {
    const bufferedClicks = [];
    let status = 0 /* ClickChainStatus.WaitingForMoreClicks */ ;
    let maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, $d97UU.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, $d97UU.setTimeout)(dontAcceptMoreClick, $951b8e01832faf5b$export$1505b1def7b874c6);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */  && bufferedClicks.every((click)=>click.isStopped())) {
            status = 2 /* ClickChainStatus.Finalized */ ;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, $d97UU.clearTimeout)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */ ) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */ ;
            tryFinalize();
        }
    }
    return {
        tryAppend: (click)=>{
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */ ) return false;
            if (bufferedClicks.length > 0 && !$951b8e01832faf5b$var$areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: ()=>{
            dontAcceptMoreClick();
        }
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */ function $951b8e01832faf5b$var$areEventsSimilar(first, second) {
    return first.target === second.target && $951b8e01832faf5b$var$mouseEventDistance(first, second) <= $951b8e01832faf5b$export$30c5966f4862d434 && first.timeStamp - second.timeStamp <= $951b8e01832faf5b$export$1505b1def7b874c6;
}
function $951b8e01832faf5b$var$mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

});

parcelRegister("2dzye", function(module, exports) {

$parcel$export(module.exports, "getActionNameFromElement", () => $19d85f6358de8c0d$export$9c46f8d96b9f088f);

var $k2pmh = parcelRequire("k2pmh");
var $99fDv = parcelRequire("99fDv");

var $8EzN6 = parcelRequire("8EzN6");

var $OddO2 = parcelRequire("OddO2");

var $4TGNe = parcelRequire("4TGNe");

var $8NBqb = parcelRequire("8NBqb");
function $19d85f6358de8c0d$export$9c46f8d96b9f088f(element, rumConfiguration, nodePrivacyLevel = (0, $8EzN6.NodePrivacyLevel).ALLOW) {
    const nodePrivacyLevelCache = new Map();
    const { actionNameAttribute: userProgrammaticAttribute } = rumConfiguration;
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, if privacy is set to mask, return a placeholder for the undefined.
    // * if privacy is not set to mask, use strategies that are known to return good results.
    //   Those strategies will be used on the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    const defaultActionName = $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, (0, $8NBqb.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)) || userProgrammaticAttribute && $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
    if (defaultActionName) return {
        name: defaultActionName,
        nameSource: "custom_attribute" /* ActionNameSource.CUSTOM_ATTRIBUTE */ 
    };
    else if (nodePrivacyLevel === (0, $8EzN6.NodePrivacyLevel).MASK) return {
        name: (0, $8NBqb.ACTION_NAME_PLACEHOLDER),
        nameSource: "mask_placeholder" /* ActionNameSource.MASK_PLACEHOLDER */ 
    };
    return $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, $19d85f6358de8c0d$var$priorityStrategies, rumConfiguration, nodePrivacyLevelCache) || $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, $19d85f6358de8c0d$var$fallbackStrategies, rumConfiguration, nodePrivacyLevelCache) || {
        name: '',
        nameSource: "blank" /* ActionNameSource.BLANK */ 
    };
}
function $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    const elementWithAttribute = $19d85f6358de8c0d$var$closestShadowAware(targetElement, `[${programmaticAttribute}]`);
    if (!elementWithAttribute) return;
    const name = elementWithAttribute.getAttribute(programmaticAttribute);
    return $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(name.trim()));
}
function $19d85f6358de8c0d$var$closestShadowAware(element, selector) {
    let current = element;
    while(current){
        if (current.matches(selector)) return current;
        current = (0, $4TGNe.getParentElement)(current);
    }
    return null;
}
const $19d85f6358de8c0d$var$priorityStrategies = [
    // associated LABEL text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ('labels' in element && element.labels && element.labels.length > 0) return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element.labels[0], rumConfiguration, nodePrivacyLevelCache);
    },
    // INPUT button (and associated) value
    (element)=>{
        if (element.nodeName === 'INPUT') {
            const input = element;
            const type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') return {
                name: input.value,
                nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
            };
        }
    },
    // BUTTON, LABEL or button-like element text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache);
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'aria-label', rumConfiguration, nodePrivacyLevelCache),
    // associated element text designated by the aria-labelledby attribute
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        const labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) return {
            name: labelledByAttribute.split(/\s+/).map((id)=>$19d85f6358de8c0d$var$getElementById(element, id)).filter((label)=>Boolean(label)).map((element)=>$19d85f6358de8c0d$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache)).join(' '),
            nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
        };
    },
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'alt', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'name', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'title', rumConfiguration, nodePrivacyLevelCache),
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'placeholder', rumConfiguration, nodePrivacyLevelCache),
    // SELECT first OPTION text
    (element, rumConfiguration, nodePrivacyLevelCache)=>{
        if ('options' in element && element.options.length > 0) return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element.options[0], rumConfiguration, nodePrivacyLevelCache);
    }
];
const $19d85f6358de8c0d$var$fallbackStrategies = [
    (element, rumConfiguration, nodePrivacyLevelCache)=>$19d85f6358de8c0d$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache)
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */ const $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER = 10;
function $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(targetElement, strategies, rumConfiguration, nodePrivacyLevelCache) {
    let element = targetElement;
    let recursionCounter = 0;
    while(recursionCounter <= $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD'){
        for (const strategy of strategies){
            const actionName = strategy(element, rumConfiguration, nodePrivacyLevelCache);
            if (actionName) {
                const { name: name, nameSource: nameSource } = actionName;
                const trimmedName = name && name.trim();
                if (trimmedName) return {
                    name: $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(trimmedName)),
                    nameSource: nameSource
                };
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') break;
        element = (0, $4TGNe.getParentElement)(element);
        recursionCounter += 1;
    }
}
function $19d85f6358de8c0d$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function $19d85f6358de8c0d$var$truncate(s) {
    return s.length > 100 ? `${(0, $99fDv.safeTruncate)(s, 100)} [...]` : s;
}
function $19d85f6358de8c0d$var$getElementById(refElement, id) {
    const rootNode = refElement.getRootNode();
    if (rootNode instanceof ShadowRoot) {
        const shadowElement = rootNode.getElementById(id);
        if (shadowElement) return shadowElement;
    }
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, attribute, rumConfiguration, nodePrivacyLevelCache) {
    const { enablePrivacyForActionName: enablePrivacyForActionName, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    let attributeValue = element.getAttribute(attribute);
    if (attributeValue && enablePrivacyForActionName) {
        const nodePrivacyLevel = (0, $OddO2.getNodePrivacyLevel)(element, defaultPrivacyLevel, nodePrivacyLevelCache);
        if ((0, $OddO2.shouldMaskAttribute)(element.tagName, attribute, attributeValue, nodePrivacyLevel, rumConfiguration)) attributeValue = (0, $OddO2.maskDisallowedTextContent)(attributeValue, (0, $8NBqb.ACTION_NAME_PLACEHOLDER));
    } else if (!attributeValue) attributeValue = '';
    return {
        name: attributeValue,
        nameSource: "standard_attribute" /* ActionNameSource.STANDARD_ATTRIBUTE */ 
    };
}
function $19d85f6358de8c0d$var$getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    return {
        name: $19d85f6358de8c0d$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) || '',
        nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
    };
}
function $19d85f6358de8c0d$var$getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
    if (element.isContentEditable) return;
    const { enablePrivacyForActionName: enablePrivacyForActionName, actionNameAttribute: userProgrammaticAttribute, defaultPrivacyLevel: defaultPrivacyLevel } = rumConfiguration;
    if ((0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).USE_TREE_WALKER_FOR_ACTION_NAME)) return $19d85f6358de8c0d$var$getTextualContentWithTreeWalker(element, userProgrammaticAttribute, enablePrivacyForActionName, defaultPrivacyLevel, nodePrivacyLevelCache);
    if ('innerText' in element) {
        let text = element.innerText;
        const removeTextFromElements = (query)=>{
            const list = element.querySelectorAll(query);
            for(let index = 0; index < list.length; index += 1){
                const element = list[index];
                if ('innerText' in element) {
                    const textToReplace = element.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) text = text.replace(textToReplace, '');
                }
            }
        };
        // remove the text of elements with programmatic attribute value
        removeTextFromElements(`[${(0, $8NBqb.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)}]`);
        if (userProgrammaticAttribute) removeTextFromElements(`[${userProgrammaticAttribute}]`);
        if (enablePrivacyForActionName) // remove the text of elements with privacy override
        removeTextFromElements(`${(0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).HIDDEN)}, ${(0, $8EzN6.getPrivacySelector)((0, $8EzN6.NodePrivacyLevel).MASK)}`);
        return text;
    }
    return element.textContent;
}
function $19d85f6358de8c0d$var$getTextualContentWithTreeWalker(element, userProgrammaticAttribute, privacyEnabledActionName, defaultPrivacyLevel, nodePrivacyLevelCache) {
    const walker = document.createTreeWalker(element, // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, rejectInvisibleOrMaskedElementsFilter);
    let text = '';
    while(walker.nextNode()){
        const node = walker.currentNode;
        if ((0, $4TGNe.isElementNode)(node)) {
            if (// Following InnerText rendering spec https://html.spec.whatwg.org/multipage/dom.html#rendered-text-collection-steps
            node.nodeName === 'BR' || node.nodeName === 'P' || [
                'block',
                'flex',
                'grid',
                'list-item',
                'table',
                'table-caption'
            ].includes(getComputedStyle(node).display)) text += ' ';
            continue; // skip element nodes
        }
        text += node.textContent || '';
    }
    return text.replace(/\s+/g, ' ').trim();
    function rejectInvisibleOrMaskedElementsFilter(node) {
        const nodeSelfPrivacyLevel = (0, $OddO2.getNodePrivacyLevel)(node, defaultPrivacyLevel, nodePrivacyLevelCache);
        if (privacyEnabledActionName && nodeSelfPrivacyLevel && (0, $OddO2.shouldMaskNode)(node, nodeSelfPrivacyLevel)) return NodeFilter.FILTER_REJECT;
        if ((0, $4TGNe.isElementNode)(node)) {
            if (node.hasAttribute((0, $8NBqb.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE)) || userProgrammaticAttribute && node.hasAttribute(userProgrammaticAttribute)) return NodeFilter.FILTER_REJECT;
            const style = getComputedStyle(node);
            if (style.visibility !== 'visible' || style.display === 'none' || style.contentVisibility && style.contentVisibility !== 'visible') return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
    }
}

});

parcelRegister("fVsF7", function(module, exports) {

$parcel$export(module.exports, "listenActionEvents", () => $b9826997efb4807d$export$8c9c528e477216a0);

var $hXhfS = parcelRequire("hXhfS");
function $b9826997efb4807d$export$8c9c528e477216a0(configuration, { onPointerDown: onPointerDown, onPointerUp: onPointerUp }) {
    let selectionEmptyAtPointerDown;
    let userActivity = {
        selection: false,
        input: false,
        scroll: false
    };
    let clickContext;
    const listeners = [
        (0, $hXhfS.addEventListener)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */ , (event)=>{
            if ($b9826997efb4807d$var$isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = $b9826997efb4807d$var$isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false
                };
                clickContext = onPointerDown(event);
            }
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */ , ()=>{
            if (!selectionEmptyAtPointerDown || !$b9826997efb4807d$var$isSelectionEmpty()) userActivity.selection = true;
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , ()=>{
            userActivity.scroll = true;
        }, {
            capture: true,
            passive: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */ , (event)=>{
            if ($b9826997efb4807d$var$isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                const localUserActivity = userActivity;
                onPointerUp(clickContext, event, ()=>localUserActivity);
                clickContext = undefined;
            }
        }, {
            capture: true
        }),
        (0, $hXhfS.addEventListener)(configuration, window, "input" /* DOM_EVENT.INPUT */ , ()=>{
            userActivity.input = true;
        }, {
            capture: true
        })
    ];
    return {
        stop: ()=>{
            listeners.forEach((listener)=>listener.stop());
        }
    };
}
function $b9826997efb4807d$var$isSelectionEmpty() {
    const selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function $b9826997efb4807d$var$isValidPointerEvent(event) {
    return event.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
    // the future.
    event.isPrimary !== false;
}

});

parcelRegister("eV1gO", function(module, exports) {

$parcel$export(module.exports, "computeFrustration", () => $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c);

var $ly0px = parcelRequire("ly0px");

var $kDJMQ = parcelRequire("kDJMQ");
const $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c(clicks, rageClick) {
    if ($adc75fc4cdc76a78$export$225704fb2a185e45(clicks)) {
        rageClick.addFrustration((0, $kDJMQ.FrustrationType).RAGE_CLICK);
        if (clicks.some($adc75fc4cdc76a78$export$e4a368a4d2e950a3)) rageClick.addFrustration((0, $kDJMQ.FrustrationType).DEAD_CLICK);
        if (rageClick.hasError) rageClick.addFrustration((0, $kDJMQ.FrustrationType).ERROR_CLICK);
        return {
            isRage: true
        };
    }
    const hasSelectionChanged = clicks.some((click)=>click.getUserActivity().selection);
    clicks.forEach((click)=>{
        if (click.hasError) click.addFrustration((0, $kDJMQ.FrustrationType).ERROR_CLICK);
        if ($adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
        !hasSelectionChanged) click.addFrustration((0, $kDJMQ.FrustrationType).DEAD_CLICK);
    });
    return {
        isRage: false
    };
}
function $adc75fc4cdc76a78$export$225704fb2a185e45(clicks) {
    if (clicks.some((click)=>click.getUserActivity().selection || click.getUserActivity().scroll)) return false;
    for(let i = 0; i < clicks.length - ($adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1){
        if (clicks[i + $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= (0, $ly0px.ONE_SECOND)) return true;
    }
    return false;
}
const $adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR = // inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *';
function $adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
    let target = click.event.target;
    if (target.tagName === 'LABEL' && target.hasAttribute('for')) target = document.getElementById(target.getAttribute('for'));
    return !target || !target.matches($adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR);
}

});

parcelRegister("2NQWL", function(module, exports) {

$parcel$export(module.exports, "CLICK_ACTION_MAX_DURATION", () => $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3);
$parcel$export(module.exports, "getInteractionSelector", () => $20a93a7c6e2d8a89$export$54553eb1afcc5093);
$parcel$export(module.exports, "updateInteractionSelector", () => $20a93a7c6e2d8a89$export$49ad699d303b84c);

var $ly0px = parcelRequire("ly0px");
const $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3 = 10 * (0, $ly0px.ONE_SECOND);
const $20a93a7c6e2d8a89$export$921921d3d73df8fe = new Map();
function $20a93a7c6e2d8a89$export$54553eb1afcc5093(relativeTimestamp) {
    const selector = $20a93a7c6e2d8a89$export$921921d3d73df8fe.get(relativeTimestamp);
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.delete(relativeTimestamp);
    return selector;
}
function $20a93a7c6e2d8a89$export$49ad699d303b84c(relativeTimestamp, selector) {
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.set(relativeTimestamp, selector);
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.forEach((_, relativeTimestamp)=>{
        if ((0, $ly0px.elapsed)(relativeTimestamp, (0, $ly0px.relativeNow)()) > $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3) $20a93a7c6e2d8a89$export$921921d3d73df8fe.delete(relativeTimestamp);
    });
}

});

parcelRegister("rPcCT", function(module, exports) {

$parcel$export(module.exports, "isActionChildEvent", () => $053a3d82bbf75c91$export$cce53c8a96c99749);
function $053a3d82bbf75c91$export$cce53c8a96c99749(id) {
    return (event)=>event.action !== undefined && event.action.id !== undefined && event.action.id.includes(id);
}

});


parcelRegister("4y5SX", function(module, exports) {

$parcel$export(module.exports, "trackManualActions", () => $34fee72034f38db9$export$87a2e3ac9fea3df6);

var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");

var $kDJMQ = parcelRequire("kDJMQ");

var $2ZNES = parcelRequire("2ZNES");

var $rPcCT = parcelRequire("rPcCT");
function $34fee72034f38db9$export$87a2e3ac9fea3df6(lifeCycle, onManualActionCompleted) {
    const actionTracker = (0, $2ZNES.startEventTracker)(lifeCycle);
    function startManualAction(name, options = {}, startClocks = (0, $ly0px.clocksNow)()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const startedManualAction = actionTracker.start(lookupKey, startClocks, {
            name: name,
            ...options
        }, {
            isChildEvent: (0, $rPcCT.isActionChildEvent)
        });
        lifeCycle.notify(15 /* LifeCycleEventType.ACTION_STARTED */ , startedManualAction);
    }
    function stopManualAction(name, options = {}, stopClocks = (0, $ly0px.clocksNow)()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const stopped = actionTracker.stop(lookupKey, stopClocks, options);
        if (!stopped) return;
        const frustrationTypes = [];
        if (stopped.counts && stopped.counts.errorCount > 0) frustrationTypes.push((0, $kDJMQ.FrustrationType).ERROR_CLICK);
        const manualAction = {
            ...stopped,
            type: stopped.type || (0, $kDJMQ.ActionType).CUSTOM,
            frustrationTypes: frustrationTypes
        };
        onManualActionCompleted(manualAction);
    }
    function addInstantAction(action) {
        onManualActionCompleted({
            id: (0, $99fDv.generateUUID)(),
            frustrationTypes: [],
            ...action
        });
    }
    return {
        addAction: addInstantAction,
        startAction: startManualAction,
        stopAction: stopManualAction,
        findActionId: actionTracker.findId,
        stop: actionTracker.stopAll
    };
}

});


parcelRegister("lpjMX", function(module, exports) {

$parcel$export(module.exports, "startErrorCollection", () => $f95b485e6c21537b$export$243c2bf7ff6b9330);

var $j9iCm = parcelRequire("j9iCm");
var $4Be0w = parcelRequire("4Be0w");
var $1zKlK = parcelRequire("1zKlK");
var $99fDv = parcelRequire("99fDv");
var $4wc1a = parcelRequire("4wc1a");

var $kDJMQ = parcelRequire("kDJMQ");

var $kuCii = parcelRequire("kuCii");

var $lkFYV = parcelRequire("lkFYV");
function $f95b485e6c21537b$export$243c2bf7ff6b9330(lifeCycle, configuration, bufferedDataObservable) {
    const errorObservable = new (0, $4wc1a.Observable)();
    bufferedDataObservable.subscribe((bufferedData)=>{
        if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */ ) errorObservable.notify(bufferedData.error);
    });
    (0, $kuCii.trackConsoleError)(errorObservable);
    (0, $lkFYV.trackReportError)(configuration, errorObservable);
    errorObservable.subscribe((error)=>lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        }));
    return $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle);
}
function $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , ({ error: error })=>{
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $f95b485e6c21537b$var$processError(error));
    });
    return {
        addError: ({ error: error, handlingStack: handlingStack, componentStack: componentStack, startClocks: startClocks, context: context })=>{
            const rawError = (0, $4Be0w.computeRawError)({
                originalError: error,
                handlingStack: handlingStack,
                componentStack: componentStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $1zKlK.ErrorSource).CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */ 
            });
            rawError.context = (0, $j9iCm.combine)(rawError.context, context);
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
                error: rawError
            });
        }
    };
}
function $f95b485e6c21537b$var$processError(error) {
    const rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, $99fDv.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            component_stack: error.componentStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
            csp: error.csp
        },
        type: (0, $kDJMQ.RumEventType).ERROR,
        context: error.context
    };
    const domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack
    };
    return {
        rawRumEvent: rawRumEvent,
        startClocks: error.startClocks,
        domainContext: domainContext
    };
}

});
parcelRegister("kuCii", function(module, exports) {

$parcel$export(module.exports, "trackConsoleError", () => $eeb45063442903a5$export$fe4ab68ea26fba82);

var $5IDGB = parcelRequire("5IDGB");
var $crBqg = parcelRequire("crBqg");
function $eeb45063442903a5$export$fe4ab68ea26fba82(errorObservable) {
    const subscription = (0, $crBqg.initConsoleObservable)([
        (0, $5IDGB.ConsoleApiName).error
    ]).subscribe((consoleLog)=>errorObservable.notify(consoleLog.error));
    return {
        stop: ()=>{
            subscription.unsubscribe();
        }
    };
}

});

parcelRegister("lkFYV", function(module, exports) {

$parcel$export(module.exports, "trackReportError", () => $f87c07eca9e767df$export$532a6c6a36756d07);

var $3LtP9 = parcelRequire("3LtP9");
function $f87c07eca9e767df$export$532a6c6a36756d07(configuration, errorObservable) {
    const subscription = (0, $3LtP9.initReportObservable)(configuration, [
        (0, $3LtP9.RawReportType).cspViolation,
        (0, $3LtP9.RawReportType).intervention
    ]).subscribe((rawError)=>errorObservable.notify(rawError));
    return {
        stop: ()=>{
            subscription.unsubscribe();
        }
    };
}

});


parcelRegister("4JFG9", function(module, exports) {

$parcel$export(module.exports, "startResourceCollection", () => $372bb1efffad81cc$export$7a0c7e0d79d84977);

var $fhNdh = parcelRequire("fhNdh");
var $j9iCm = parcelRequire("j9iCm");
var $7UWRZ = parcelRequire("7UWRZ");
var $5IDGB = parcelRequire("5IDGB");
var $k2pmh = parcelRequire("k2pmh");
var $99fDv = parcelRequire("99fDv");
var $fzLbJ = parcelRequire("fzLbJ");
var $4Umqd = parcelRequire("4Umqd");
var $ly0px = parcelRequire("ly0px");
var $iSi6B = parcelRequire("iSi6B");

var $e6Vsp = parcelRequire("e6Vsp");

var $kDJMQ = parcelRequire("kDJMQ");

var $7WfB9 = parcelRequire("7WfB9");

var $2ZNES = parcelRequire("2ZNES");

var $46ybh = parcelRequire("46ybh");

var $hr0C3 = parcelRequire("hr0C3");

var $fisL9 = parcelRequire("fisL9");

var $hyx5f = parcelRequire("hyx5f");

var $lIIGR = parcelRequire("lIIGR");

var $lIbnJ = parcelRequire("lIbnJ");

var $X67Wl = parcelRequire("X67Wl");
function $372bb1efffad81cc$export$7a0c7e0d79d84977(lifeCycle, configuration, pageStateHistory) {
    const taskQueue = (0, $4Umqd.mockable)((0, $7UWRZ.createTaskQueue))();
    let requestRegistry;
    const isEarlyRequestCollectionEnabled = configuration.trackEarlyRequests;
    if (isEarlyRequestCollectionEnabled) requestRegistry = (0, $lIIGR.createRequestRegistry)(lifeCycle);
    else lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
        handleResource(()=>$372bb1efffad81cc$var$processRequest(request, configuration, pageStateHistory));
    });
    const performanceResourceSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).RESOURCE,
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries)if (isEarlyRequestCollectionEnabled || !(0, $fisL9.isResourceEntryRequestType)(entry)) handleResource(()=>$372bb1efffad81cc$var$processResourceEntry(entry, configuration, pageStateHistory, requestRegistry));
    });
    (0, $4Umqd.mockable)((0, $hyx5f.retrieveInitialDocumentResourceTiming))(configuration, (timing)=>{
        handleResource(()=>$372bb1efffad81cc$var$processResourceEntry(timing, configuration, pageStateHistory, requestRegistry));
    });
    function handleResource(computeRawEvent) {
        taskQueue.push(()=>{
            const rawEvent = computeRawEvent();
            if (rawEvent) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , rawEvent);
        });
    }
    const resourceTracker = (0, $2ZNES.startEventTracker)(lifeCycle);
    const manualResources = (0, $X67Wl.trackManualResources)(lifeCycle, resourceTracker);
    return {
        startResource: manualResources.startResource,
        stopResource: manualResources.stopResource,
        stop: ()=>{
            taskQueue.stop();
            performanceResourceSubscription.unsubscribe();
            resourceTracker.stopAll();
        }
    };
}
function $372bb1efffad81cc$var$processRequest(request, configuration, pageStateHistory) {
    const matchingTiming = (0, $hr0C3.matchRequestResourceEntry)(request);
    return $372bb1efffad81cc$var$assembleResource(matchingTiming, request, pageStateHistory, configuration);
}
function $372bb1efffad81cc$var$processResourceEntry(entry, configuration, pageStateHistory, requestRegistry) {
    const matchingRequest = (0, $fisL9.isResourceEntryRequestType)(entry) && requestRegistry ? requestRegistry.getMatchingRequest(entry) : undefined;
    return $372bb1efffad81cc$var$assembleResource(entry, matchingRequest, pageStateHistory, configuration);
}
// TODO: In the future, the `entry` parameter should be required, making things simpler.
function $372bb1efffad81cc$var$assembleResource(entry, request, pageStateHistory, configuration) {
    if (!entry && !request) return;
    const tracingInfo = request ? $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration) : $372bb1efffad81cc$var$computeResourceEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) return;
    const startClocks = entry ? (0, $ly0px.relativeToClocks)(entry.startTime) : request.startClocks;
    const duration = entry ? (0, $fisL9.computeResourceEntryDuration)(entry) : $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, request.duration);
    const networkHeaders = (0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).TRACK_RESOURCE_HEADERS) ? $372bb1efffad81cc$var$computeNetworkHeaders(request, configuration) : undefined;
    const graphql = request && $372bb1efffad81cc$var$computeGraphQlMetaData(request, configuration);
    const contentTypeFromPerformanceEntry = entry && $372bb1efffad81cc$var$computeContentTypeFromPerformanceEntry(entry);
    const resourceEvent = (0, $j9iCm.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $99fDv.generateUUID)(),
            duration: (0, $ly0px.toServerDuration)(duration),
            // TODO: in the future when `entry` is required, we can probably only rely on `computeResourceEntryType`
            type: request ? request.type === (0, $iSi6B.RequestType).XHR ? (0, $iSi6B.ResourceType).XHR : (0, $iSi6B.ResourceType).FETCH : (0, $fisL9.computeResourceEntryType)(entry),
            method: request ? request.method : undefined,
            status_code: request ? request.status : $372bb1efffad81cc$var$discardZeroStatus(entry.responseStatus),
            url: request ? (0, $fisL9.sanitizeIfLongDataUrl)(request.url) : entry.name,
            protocol: entry && (0, $fisL9.computeResourceEntryProtocol)(entry),
            delivery_type: entry && (0, $fisL9.computeResourceEntryDeliveryType)(entry),
            graphql: graphql
        },
        type: (0, $kDJMQ.RumEventType).RESOURCE,
        _dd: {
            discarded: !configuration.trackResources
        }
    }, tracingInfo, entry && $372bb1efffad81cc$var$computeResourceEntryMetrics(entry), contentTypeFromPerformanceEntry, networkHeaders);
    return {
        startClocks: startClocks,
        duration: duration,
        rawRumEvent: resourceEvent,
        domainContext: $372bb1efffad81cc$var$getResourceDomainContext(entry, request)
    };
}
function $372bb1efffad81cc$var$computeGraphQlMetaData(request, configuration) {
    const graphQlConfig = (0, $lIbnJ.findGraphQlConfiguration)(request.url, configuration);
    if (!graphQlConfig) return;
    return (0, $lIbnJ.extractGraphQlMetadata)(request, graphQlConfig);
}
function $372bb1efffad81cc$var$computeContentTypeFromPerformanceEntry(entry) {
    const contentType = entry.contentType;
    if (contentType) return {
        resource: {
            response: {
                headers: {
                    'content-type': contentType
                }
            }
        }
    };
    return undefined;
}
function $372bb1efffad81cc$var$getResourceDomainContext(entry, request) {
    if (request) {
        const baseDomainContext = {
            performanceEntry: entry,
            isAborted: request.isAborted,
            handlingStack: request.handlingStack
        };
        if (request.type === (0, $iSi6B.RequestType).XHR) return {
            xhr: request.xhr,
            ...baseDomainContext
        };
        return {
            requestInput: request.input,
            requestInit: request.init,
            response: request.response,
            error: request.error,
            ...baseDomainContext
        };
    }
    return {
        // Currently, at least one of `entry` or `request` must be defined when calling this function.
        // So `entry` is guaranteed to be defined here. In the future, when `entry` is required, we can
        // remove the `!` assertion.
        performanceEntry: entry
    };
}
function $372bb1efffad81cc$var$computeResourceEntryMetrics(entry) {
    const { renderBlockingStatus: renderBlockingStatus } = entry;
    return {
        resource: {
            render_blocking_status: renderBlockingStatus,
            ...(0, $fisL9.computeResourceEntrySize)(entry),
            ...(0, $fisL9.computeResourceEntryDetails)(entry)
        }
    };
}
function $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration) {
    const hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            span_id: request.spanId.toString(),
            trace_id: request.traceId.toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $372bb1efffad81cc$var$computeResourceEntryTracingInfo(entry, configuration) {
    const hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            trace_id: entry.traceId,
            span_id: (0, $7WfB9.createSpanIdentifier)().toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , startClocks.relative, duration) ? duration : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */ function $372bb1efffad81cc$var$discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}
function $372bb1efffad81cc$var$computeNetworkHeaders(request, configuration) {
    const matchers = configuration.trackResourceHeaders;
    if (matchers.length === 0 || !request) return undefined;
    const urlMatchers = matchers.filter((m)=>m.url !== undefined ? (0, $fzLbJ.matchList)([
            m.url
        ], request.url, true) : true);
    if (urlMatchers.length === 0) return undefined;
    const responseMatchers = urlMatchers.filter((m)=>m.location === undefined || m.location === 'any' || m.location === 'response');
    const requestMatchers = urlMatchers.filter((m)=>m.location === undefined || m.location === 'any' || m.location === 'request');
    const responseHeaders = responseMatchers.length > 0 ? $372bb1efffad81cc$var$getResponseHeaders(request, responseMatchers) : undefined;
    const requestHeaders = requestMatchers.length > 0 ? $372bb1efffad81cc$var$getRequestHeaders(request, requestMatchers) : undefined;
    if (!responseHeaders && !requestHeaders) return undefined;
    return {
        resource: {
            request: requestHeaders ? {
                headers: requestHeaders
            } : undefined,
            response: responseHeaders ? {
                headers: responseHeaders
            } : undefined
        }
    };
}
function $372bb1efffad81cc$var$getResponseHeaders(request, matchers) {
    if (request.type === (0, $iSi6B.RequestType).FETCH && request.response) return $372bb1efffad81cc$var$filterHeaders(request.response.headers, matchers);
    if (request.type === (0, $iSi6B.RequestType).XHR && request.xhr) {
        const rawXhrHeaders = request.xhr.getAllResponseHeaders();
        if (rawXhrHeaders) try {
            return $372bb1efffad81cc$var$filterHeaders(new Headers($372bb1efffad81cc$var$parseRawXhrHeaders(rawXhrHeaders)), matchers);
        } catch (_a) {
        // Ignore parsing errors
        }
    }
    return undefined;
}
function $372bb1efffad81cc$var$getRequestHeaders(request, matchers) {
    var _a;
    if (request.type !== (0, $iSi6B.RequestType).FETCH) return undefined;
    let headers;
    if ((_a = request.init) === null || _a === void 0 ? void 0 : _a.headers) headers = new Headers(request.init.headers);
    else if (request.input instanceof Request) headers = request.input.headers;
    return headers ? $372bb1efffad81cc$var$filterHeaders(headers, matchers) : undefined;
}
const $372bb1efffad81cc$var$FORBIDDEN_HEADER_PATTERN = /(token|cookie|secret|authorization|(api|secret|access|app).?key|(client|connecting|real).?ip|forwarded)/;
const $372bb1efffad81cc$var$MAX_HEADER_COUNT = 100;
const $372bb1efffad81cc$var$MAX_HEADER_VALUE_LENGTH = 128;
function $372bb1efffad81cc$var$filterHeaders(headers, matchers) {
    const result = {};
    let collectedHeaderCount = 0;
    let totalHeaderCount = 0;
    let hasReachedMaxHeaderCount = false;
    headers.forEach((value, name)=>{
        totalHeaderCount++;
        if (collectedHeaderCount >= $372bb1efffad81cc$var$MAX_HEADER_COUNT) {
            if (!hasReachedMaxHeaderCount) {
                (0, $5IDGB.display).warn(`Maximum number of headers (${$372bb1efffad81cc$var$MAX_HEADER_COUNT}) has been reached. Further headers are dropped.`);
                hasReachedMaxHeaderCount = true;
            }
            return;
        }
        const lowerName = name.toLowerCase();
        if ($372bb1efffad81cc$var$FORBIDDEN_HEADER_PATTERN.test(lowerName)) return;
        const matchHeader = matchers.find((m)=>(0, $fzLbJ.matchList)([
                m.name
            ], lowerName));
        if (!matchHeader) return;
        const { extractor: extractor } = matchHeader;
        const capturedValue = extractor ? (0, $46ybh.extractRegexMatch)(value, extractor) : value;
        if (capturedValue === undefined) return;
        if (capturedValue.length > $372bb1efffad81cc$var$MAX_HEADER_VALUE_LENGTH) {
            (0, $5IDGB.display).warn(`Header "${lowerName}" value was truncated from ${capturedValue.length} to ${$372bb1efffad81cc$var$MAX_HEADER_VALUE_LENGTH} characters.`);
            // monitor-until: 2026-05-23
            (0, $fhNdh.addTelemetryDebug)('Resource header value was truncated', {
                header_name: lowerName,
                original_length: capturedValue.length,
                limit: $372bb1efffad81cc$var$MAX_HEADER_VALUE_LENGTH
            });
        }
        result[lowerName] = (0, $99fDv.safeTruncate)(capturedValue, $372bb1efffad81cc$var$MAX_HEADER_VALUE_LENGTH);
        collectedHeaderCount++;
    });
    if (hasReachedMaxHeaderCount) // monitor-until: 2026-05-23
    (0, $fhNdh.addTelemetryDebug)('Maximum number of resource headers reached', {
        collectedHeaderCount: collectedHeaderCount,
        totalHeaderCount: totalHeaderCount
    });
    return collectedHeaderCount > 0 ? result : undefined;
}
// Input:  "content-type: application/json\r\ncache-control: no-cache"
// Output: [["content-type", "application/json"], ["cache-control", "no-cache"]]
function $372bb1efffad81cc$var$parseRawXhrHeaders(rawXhrheaders) {
    const pairs = [];
    const lines = rawXhrheaders.trim().split(/\r\n/);
    for (const line of lines){
        const colonIndex = line.indexOf(':');
        if (colonIndex > 0) pairs.push([
            line.substring(0, colonIndex).trim(),
            line.substring(colonIndex + 1).trim()
        ]);
    }
    return pairs;
}

});
parcelRegister("7UWRZ", function(module, exports) {

$parcel$export(module.exports, "createTaskQueue", () => $5c3b6dadc4a2654c$export$e1c4294b917c2b7b);

var $ly0px = parcelRequire("ly0px");

var $i1WJH = parcelRequire("i1WJH");
/**
 * Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
 * before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
 * the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
 * performance.
 */ const $5c3b6dadc4a2654c$var$IDLE_CALLBACK_TIMEOUT = (0, $ly0px.ONE_SECOND);
const $5c3b6dadc4a2654c$export$85114d25709d11dc = 30;
function $5c3b6dadc4a2654c$export$e1c4294b917c2b7b() {
    const pendingTasks = [];
    function run(deadline) {
        let executionTimeRemaining;
        // `deadline` can be null when `requestIdleCallback` is replaced by a page-injected polyfill
        // (e.g. `setTimeout(cb, 0)` in some WKWebViews) that invokes the callback with no argument.
        if (!deadline || deadline.didTimeout) {
            const start = performance.now();
            executionTimeRemaining = ()=>$5c3b6dadc4a2654c$export$85114d25709d11dc - (performance.now() - start);
        } else executionTimeRemaining = deadline.timeRemaining.bind(deadline);
        while(executionTimeRemaining() > 0 && pendingTasks.length)pendingTasks.shift()();
        if (pendingTasks.length) scheduleNextRun();
    }
    function scheduleNextRun() {
        (0, $i1WJH.requestIdleCallback)(run, {
            timeout: $5c3b6dadc4a2654c$var$IDLE_CALLBACK_TIMEOUT
        });
    }
    return {
        push (task) {
            if (pendingTasks.push(task) === 1) scheduleNextRun();
        },
        stop () {
            pendingTasks.length = 0;
        }
    };
}

});
parcelRegister("i1WJH", function(module, exports) {

$parcel$export(module.exports, "requestIdleCallback", () => $d205e1c6fda43570$export$9288a5d956b3efbe);

var $d97UU = parcelRequire("d97UU");

var $2wH3Z = parcelRequire("2wH3Z");

var $ly0px = parcelRequire("ly0px");
function $d205e1c6fda43570$export$9288a5d956b3efbe(callback, opts) {
    // Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        const id = window.requestIdleCallback((0, $2wH3Z.monitor)(callback), opts);
        return ()=>window.cancelIdleCallback(id);
    }
    return $d205e1c6fda43570$export$fc768205f0931253(callback);
}
const $d205e1c6fda43570$export$37cda3af96f93c33 = 50;
function $d205e1c6fda43570$export$fc768205f0931253(callback) {
    const start = (0, $ly0px.dateNow)();
    const timeoutId = (0, $d97UU.setTimeout)(()=>{
        callback({
            didTimeout: false,
            timeRemaining: ()=>Math.max(0, $d205e1c6fda43570$export$37cda3af96f93c33 - ((0, $ly0px.dateNow)() - start))
        });
    }, 0);
    return ()=>(0, $d97UU.clearTimeout)(timeoutId);
}

});


parcelRegister("hr0C3", function(module, exports) {

$parcel$export(module.exports, "matchRequestResourceEntry", () => $cb156ef466274200$export$daf52a30543584f);

var $ly0px = parcelRequire("ly0px");

var $fisL9 = parcelRequire("fisL9");
const $cb156ef466274200$var$alreadyMatchedEntries = new WeakSet();
function $cb156ef466274200$export$daf52a30543584f(request) {
    if (!performance || !('getEntriesByName' in performance)) return;
    const sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) return;
    const candidates = sameNameEntries.filter((entry)=>!$cb156ef466274200$var$alreadyMatchedEntries.has(entry)).filter((entry)=>(0, $fisL9.hasValidResourceEntryDuration)(entry) && (0, $fisL9.hasValidResourceEntryTimings)(entry)).filter((entry)=>$cb156ef466274200$var$isBetween(entry, request.startClocks.relative, $cb156ef466274200$var$endTime({
            startTime: request.startClocks.relative,
            duration: request.duration
        })));
    if (candidates.length === 1) {
        $cb156ef466274200$var$alreadyMatchedEntries.add(candidates[0]);
        return candidates[0].toJSON();
    }
    return;
}
function $cb156ef466274200$var$endTime(timing) {
    return (0, $ly0px.addDuration)(timing.startTime, timing.duration);
}
function $cb156ef466274200$var$isBetween(timing, start, end) {
    const errorMargin = 1;
    return timing.startTime >= start - errorMargin && $cb156ef466274200$var$endTime(timing) <= (0, $ly0px.addDuration)(end, errorMargin);
}

});

parcelRegister("hyx5f", function(module, exports) {

$parcel$export(module.exports, "retrieveInitialDocumentResourceTiming", () => $cc7f465fe0e06d73$export$7eb7526e9416e27a);

var $4Umqd = parcelRequire("4Umqd");
var $9h4jO = parcelRequire("9h4jO");

var $e6Vsp = parcelRequire("e6Vsp");

var $cOzWl = parcelRequire("cOzWl");

var $4hwJy = parcelRequire("4hwJy");

var $fisL9 = parcelRequire("fisL9");
function $cc7f465fe0e06d73$export$7eb7526e9416e27a(configuration, callback) {
    (0, $9h4jO.runOnReadyState)(configuration, 'interactive', ()=>{
        const navigationEntry = (0, $4Umqd.mockable)((0, $4hwJy.getNavigationEntry))();
        const entry = Object.assign(navigationEntry.toJSON(), {
            entryType: (0, $e6Vsp.RumPerformanceEntryType).RESOURCE,
            initiatorType: (0, $fisL9.FAKE_INITIAL_DOCUMENT),
            // The ResourceTiming duration entry should be `responseEnd - startTime`. With
            // NavigationTiming entries, `startTime` is always 0, so set it to `responseEnd`.
            duration: navigationEntry.responseEnd,
            traceId: (0, $cOzWl.getDocumentTraceId)(document),
            toJSON: ()=>({
                    ...entry,
                    toJSON: undefined
                })
        });
        callback(entry);
    });
}

});
parcelRegister("9h4jO", function(module, exports) {

$parcel$export(module.exports, "runOnReadyState", () => $6c090d2d29937490$export$12cb733fc911e4f7);
$parcel$export(module.exports, "asyncRunOnReadyState", () => $6c090d2d29937490$export$67f00e1a0f1478a8);

var $aed8w = parcelRequire("aed8w");

var $hXhfS = parcelRequire("hXhfS");
function $6c090d2d29937490$export$12cb733fc911e4f7(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
        return {
            stop: (0, $aed8w.noop)
        };
    }
    const eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */  : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */ ;
    return (0, $hXhfS.addEventListener)(configuration, window, eventName, callback, {
        once: true
    });
}
function $6c090d2d29937490$export$67f00e1a0f1478a8(configuration, expectedReadyState) {
    return new Promise((resolve)=>{
        $6c090d2d29937490$export$12cb733fc911e4f7(configuration, expectedReadyState, resolve);
    });
}

});

parcelRegister("cOzWl", function(module, exports) {

$parcel$export(module.exports, "getDocumentTraceId", () => $9546088253798c5a$export$9600d3c1068ac02c);

var $ly0px = parcelRequire("ly0px");
var $99fDv = parcelRequire("99fDv");

var $4TGNe = parcelRequire("4TGNe");
const $9546088253798c5a$export$f1b0e1c95ecb6961 = 2 * (0, $ly0px.ONE_MINUTE);
function $9546088253798c5a$export$9600d3c1068ac02c(document) {
    const data = $9546088253798c5a$export$cabe353a895a405f(document) || $9546088253798c5a$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= (0, $ly0px.dateNow)() - $9546088253798c5a$export$f1b0e1c95ecb6961) return undefined;
    return data.traceId;
}
function $9546088253798c5a$export$cabe353a895a405f(document) {
    const traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    const traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return $9546088253798c5a$export$10b75f215ee15e0e(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function $9546088253798c5a$export$70f194456d3a8998(document) {
    const comment = $9546088253798c5a$export$4d376e42fa08c24d(document);
    if (!comment) return undefined;
    return $9546088253798c5a$export$10b75f215ee15e0e((0, $99fDv.findCommaSeparatedValue)(comment, 'trace-id'), (0, $99fDv.findCommaSeparatedValue)(comment, 'trace-time'));
}
function $9546088253798c5a$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    const traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return undefined;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $9546088253798c5a$export$4d376e42fa08c24d(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for(let i = 0; i < document.childNodes.length; i += 1){
        const comment = $9546088253798c5a$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) for(let i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        const node = document.body.childNodes[i];
        const comment = $9546088253798c5a$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!(0, $4TGNe.isTextNode)(node)) break;
    }
}
function $9546088253798c5a$var$getTraceCommentFromNode(node) {
    if (node && (0, $4TGNe.isCommentNode)(node)) {
        const match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) return match[1];
    }
}

});

parcelRegister("4hwJy", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $31e2242c7dc25f3b$export$6431553786c94949);
$parcel$export(module.exports, "sanitizeFirstByte", () => $31e2242c7dc25f3b$export$4e297b8162c99df9);
$parcel$export(module.exports, "findLcpResourceEntry", () => $31e2242c7dc25f3b$export$f575d1cc2a00f708);

var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");
var $bQmeT = parcelRequire("bQmeT");

var $e6Vsp = parcelRequire("e6Vsp");
function $31e2242c7dc25f3b$export$6431553786c94949() {
    if ((0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).NAVIGATION)) {
        const navigationEntry = performance.getEntriesByType((0, $e6Vsp.RumPerformanceEntryType).NAVIGATION)[0];
        if (navigationEntry) return navigationEntry;
    }
    const timings = $31e2242c7dc25f3b$export$feb5c3ed98a58355();
    const entry = {
        entryType: (0, $e6Vsp.RumPerformanceEntryType).NAVIGATION,
        initiatorType: 'navigation',
        name: window.location.href,
        startTime: 0,
        duration: timings.loadEventEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: ()=>({
                ...entry,
                toJSON: undefined
            }),
        ...timings
    };
    return entry;
}
function $31e2242c7dc25f3b$export$feb5c3ed98a58355() {
    const result = {};
    const timing = performance.timing;
    for(const key in timing)if ((0, $bQmeT.isNumber)(timing[key])) {
        const numberKey = key;
        const timingElement = timing[numberKey];
        result[numberKey] = timingElement === 0 ? 0 : (0, $ly0px.getRelativeTime)(timingElement);
    }
    return result;
}
function $31e2242c7dc25f3b$export$4e297b8162c99df9(entry) {
    // In some cases the value reported is negative or is larger
    // than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    return entry.responseStart >= 0 && entry.responseStart <= (0, $ly0px.relativeNow)() ? entry.responseStart : undefined;
}
function $31e2242c7dc25f3b$export$d585e13c7167efb5() {
    if ((0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).RESOURCE)) return performance.getEntriesByType((0, $e6Vsp.RumPerformanceEntryType).RESOURCE);
    return undefined;
}
function $31e2242c7dc25f3b$export$f575d1cc2a00f708(resourceUrl, lcpStartTime) {
    const entries = $31e2242c7dc25f3b$export$d585e13c7167efb5();
    if (!entries) return undefined;
    return (0, $fkj4Q.findLast)(entries, (entry)=>entry.name === resourceUrl && entry.startTime <= lcpStartTime);
}

});


parcelRegister("lIIGR", function(module, exports) {

$parcel$export(module.exports, "createRequestRegistry", () => $fd005f95e8c9cdc5$export$b1ac79667d658120);

var $fhNdh = parcelRequire("fhNdh");
var $k2pmh = parcelRequire("k2pmh");
var $iSi6B = parcelRequire("iSi6B");
var $ly0px = parcelRequire("ly0px");
const $fd005f95e8c9cdc5$export$dc11d21111e5acb8 = 1000;
function $fd005f95e8c9cdc5$export$b1ac79667d658120(lifeCycle) {
    const requests = new Set();
    let tooManyRequestsReported = false;
    const subscription = lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , (request)=>{
        requests.add(request);
        if (requests.size > $fd005f95e8c9cdc5$export$dc11d21111e5acb8) {
            const oldestRequest = requests.values().next().value;
            if (!tooManyRequestsReported) {
                tooManyRequestsReported = true;
                let debugContext;
                if ((0, $k2pmh.isExperimentalFeatureEnabled)((0, $k2pmh.ExperimentalFeature).TOO_MANY_REQUESTS_INVESTIGATION)) {
                    let abortedCount = 0;
                    let abortedOnStartCount = 0;
                    let xhrCount = 0;
                    let withoutMatchingEntryCount = 0;
                    for (const r of requests){
                        if (r.isAborted) abortedCount++;
                        if (r.isAbortedOnStart) abortedOnStartCount++;
                        if (r.type === (0, $iSi6B.RequestType).XHR) xhrCount++;
                        const entries = performance.getEntriesByName(r.url, 'resource');
                        const hasMatchingEntry = entries.some((e)=>e.startTime >= r.startClocks.relative);
                        if (!hasMatchingEntry) withoutMatchingEntryCount++;
                    }
                    const oldestRequestAge = (0, $ly0px.timeStampNow)() - oldestRequest.startClocks.timeStamp;
                    debugContext = {
                        abortedCount: abortedCount,
                        abortedOnStartCount: abortedOnStartCount,
                        xhrCount: xhrCount,
                        fetchCount: requests.size - xhrCount,
                        oldestRequestAge: oldestRequestAge,
                        oldestRequestEndAge: oldestRequestAge - oldestRequest.duration,
                        withoutMatchingEntryCount: withoutMatchingEntryCount
                    };
                }
                // monitor-until: 2026-06-01, after early request collection is the default in v7
                (0, $fhNdh.addTelemetryDebug)('Too many requests', debugContext);
            }
            requests.delete(oldestRequest);
        }
    });
    return {
        getMatchingRequest (entry) {
            // Returns the closest request object that happened before the entry
            let minTimeDifference = Infinity;
            let closestRequest;
            for (const request of requests){
                const timeDifference = entry.startTime - request.startClocks.relative;
                if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
                    minTimeDifference = Math.abs(timeDifference);
                    closestRequest = request;
                }
            }
            if (closestRequest) requests.delete(closestRequest);
            return closestRequest;
        },
        stop () {
            subscription.unsubscribe();
        }
    };
}

});

parcelRegister("X67Wl", function(module, exports) {

$parcel$export(module.exports, "trackManualResources", () => $0b1a4382c3b52f82$export$578c6c69d18434b4);

var $ly0px = parcelRequire("ly0px");
var $iSi6B = parcelRequire("iSi6B");

var $kDJMQ = parcelRequire("kDJMQ");

var $fisL9 = parcelRequire("fisL9");
function $0b1a4382c3b52f82$export$578c6c69d18434b4(lifeCycle, resourceTracker) {
    function startManualResource(url, options = {}, startClocks = (0, $ly0px.clocksNow)()) {
        var _a;
        const lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
        resourceTracker.start(lookupKey, startClocks, {
            url: url,
            ...options
        });
    }
    function stopManualResource(url, options = {}, stopClocks = (0, $ly0px.clocksNow)()) {
        var _a;
        const lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
        const stopped = resourceTracker.stop(lookupKey, stopClocks, {
            context: options.context,
            type: options.type
        });
        if (!stopped) return;
        const duration = (0, $ly0px.elapsed)(stopped.startClocks.relative, stopClocks.relative);
        const rawRumEvent = {
            date: stopped.startClocks.timeStamp,
            type: (0, $kDJMQ.RumEventType).RESOURCE,
            resource: {
                id: stopped.id,
                type: stopped.type || (0, $iSi6B.ResourceType).OTHER,
                url: (0, $fisL9.sanitizeIfLongDataUrl)(stopped.url),
                duration: (0, $ly0px.toServerDuration)(duration),
                method: stopped.method,
                status_code: options.statusCode,
                size: options.size
            },
            _dd: {},
            context: stopped.context
        };
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
            rawRumEvent: rawRumEvent,
            startClocks: stopped.startClocks,
            duration: duration,
            domainContext: {
                isManual: true
            }
        });
    }
    return {
        startResource: startManualResource,
        stopResource: stopManualResource
    };
}

});


parcelRegister("3GTFW", function(module, exports) {

$parcel$export(module.exports, "startViewCollection", () => $2b007b506741de80$export$794a32d201ece359);

var $i3LOd = parcelRequire("i3LOd");
var $kluxS = parcelRequire("kluxS");
var $8PiRA = parcelRequire("8PiRA");
var $ly0px = parcelRequire("ly0px");

var $lECZH = parcelRequire("lECZH");

var $kDJMQ = parcelRequire("kDJMQ");

var $dCrat = parcelRequire("dCrat");
function $2b007b506741de80$export$794a32d201ece359(lifeCycle, hooks, configuration, domMutationObservable, pageOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , (view)=>lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $2b007b506741de80$var$processViewUpdate(view, configuration, recorderApi)));
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const view = viewHistory.findView(startTime);
        if (!view) return 0, $i3LOd.DISCARDED;
        return {
            type: eventType,
            service: view.service,
            version: view.version,
            context: view.context,
            view: {
                id: view.id,
                name: view.name
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        var _a;
        return {
            view: {
                id: (_a = viewHistory.findView(startTime)) === null || _a === void 0 ? void 0 : _a.id
            }
        };
    });
    return (0, $dCrat.trackViews)(lifeCycle, domMutationObservable, pageOpenObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function $2b007b506741de80$var$processViewUpdate(view, configuration, recorderApi) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const replayStats = recorderApi.getReplayStats(view.id);
    const clsDevicePixelRatio = (_b = (_a = view.commonViewMetrics) === null || _a === void 0 ? void 0 : _a.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.devicePixelRatio;
    const viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            cls: clsDevicePixelRatio ? {
                device_pixel_ratio: clsDevicePixelRatio
            } : undefined,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
            }
        },
        date: view.startClocks.timeStamp,
        type: (0, $kDJMQ.RumEventType).VIEW,
        view: {
            action: {
                count: view.eventCounts.actionCount
            },
            frustration: {
                count: view.eventCounts.frustrationCount
            },
            cumulative_layout_shift: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.value,
            cumulative_layout_shift_time: (0, $ly0px.toServerDuration)((_d = view.commonViewMetrics.cumulativeLayoutShift) === null || _d === void 0 ? void 0 : _d.time),
            cumulative_layout_shift_target_selector: (_e = view.commonViewMetrics.cumulativeLayoutShift) === null || _e === void 0 ? void 0 : _e.targetSelector,
            first_byte: (0, $ly0px.toServerDuration)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.firstByte),
            dom_complete: (0, $ly0px.toServerDuration)((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domComplete),
            dom_content_loaded: (0, $ly0px.toServerDuration)((_h = view.initialViewMetrics.navigationTimings) === null || _h === void 0 ? void 0 : _h.domContentLoaded),
            dom_interactive: (0, $ly0px.toServerDuration)((_j = view.initialViewMetrics.navigationTimings) === null || _j === void 0 ? void 0 : _j.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            first_contentful_paint: (0, $ly0px.toServerDuration)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0, $ly0px.toServerDuration)((_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.delay),
            first_input_time: (0, $ly0px.toServerDuration)((_l = view.initialViewMetrics.firstInput) === null || _l === void 0 ? void 0 : _l.time),
            first_input_target_selector: (_m = view.initialViewMetrics.firstInput) === null || _m === void 0 ? void 0 : _m.targetSelector,
            interaction_to_next_paint: (0, $ly0px.toServerDuration)((_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.value),
            interaction_to_next_paint_time: (0, $ly0px.toServerDuration)((_p = view.commonViewMetrics.interactionToNextPaint) === null || _p === void 0 ? void 0 : _p.time),
            interaction_to_next_paint_target_selector: (_q = view.commonViewMetrics.interactionToNextPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, $ly0px.toServerDuration)((_r = view.initialViewMetrics.largestContentfulPaint) === null || _r === void 0 ? void 0 : _r.value),
            largest_contentful_paint_target_selector: (_s = view.initialViewMetrics.largestContentfulPaint) === null || _s === void 0 ? void 0 : _s.targetSelector,
            load_event: (0, $ly0px.toServerDuration)((_t = view.initialViewMetrics.navigationTimings) === null || _t === void 0 ? void 0 : _t.loadEvent),
            loading_time: (0, $lECZH.discardNegativeDuration)((0, $ly0px.toServerDuration)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount
            },
            performance: $2b007b506741de80$var$computeViewPerformanceData(view.commonViewMetrics, view.initialViewMetrics),
            resource: {
                count: view.eventCounts.resourceCount
            },
            time_spent: (0, $ly0px.toServerDuration)(view.duration)
        },
        display: view.commonViewMetrics.scroll ? {
            scroll: {
                max_depth: view.commonViewMetrics.scroll.maxDepth,
                max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                max_scroll_height_time: (0, $ly0px.toServerDuration)(view.commonViewMetrics.scroll.maxScrollHeightTime)
            }
        } : undefined,
        privacy: {
            replay_level: configuration.defaultPrivacyLevel
        },
        device: {
            locale: navigator.language,
            locales: navigator.languages,
            time_zone: (0, $kluxS.getTimeZone)()
        }
    };
    if (!(0, $8PiRA.isEmptyObject)(view.customTimings)) viewEvent.view.custom_timings = (0, $8PiRA.mapValues)(view.customTimings, (0, $ly0px.toServerDuration));
    return {
        rawRumEvent: viewEvent,
        startClocks: view.startClocks,
        duration: view.duration,
        domainContext: {
            location: view.location,
            handlingStack: view.handlingStack
        }
    };
}
function $2b007b506741de80$var$computeViewPerformanceData({ cumulativeLayoutShift: cumulativeLayoutShift, interactionToNextPaint: interactionToNextPaint }, { firstContentfulPaint: firstContentfulPaint, firstInput: firstInput, largestContentfulPaint: largestContentfulPaint }) {
    return {
        cls: cumulativeLayoutShift && {
            score: cumulativeLayoutShift.value,
            timestamp: (0, $ly0px.toServerDuration)(cumulativeLayoutShift.time),
            target_selector: cumulativeLayoutShift.targetSelector,
            previous_rect: cumulativeLayoutShift.previousRect,
            current_rect: cumulativeLayoutShift.currentRect
        },
        fcp: firstContentfulPaint && {
            timestamp: (0, $ly0px.toServerDuration)(firstContentfulPaint)
        },
        fid: firstInput && {
            duration: (0, $ly0px.toServerDuration)(firstInput.delay),
            timestamp: (0, $ly0px.toServerDuration)(firstInput.time),
            target_selector: firstInput.targetSelector
        },
        inp: interactionToNextPaint && {
            duration: (0, $ly0px.toServerDuration)(interactionToNextPaint.value),
            timestamp: (0, $ly0px.toServerDuration)(interactionToNextPaint.time),
            target_selector: interactionToNextPaint.targetSelector,
            sub_parts: interactionToNextPaint.subParts ? {
                input_delay: (0, $ly0px.toServerDuration)(interactionToNextPaint.subParts.inputDelay),
                processing_duration: (0, $ly0px.toServerDuration)(interactionToNextPaint.subParts.processingDuration),
                presentation_delay: (0, $ly0px.toServerDuration)(interactionToNextPaint.subParts.presentationDelay)
            } : undefined
        },
        lcp: largestContentfulPaint && {
            timestamp: (0, $ly0px.toServerDuration)(largestContentfulPaint.value),
            target_selector: largestContentfulPaint.targetSelector,
            resource_url: largestContentfulPaint.resourceUrl,
            sub_parts: largestContentfulPaint.subParts ? {
                load_delay: (0, $ly0px.toServerDuration)(largestContentfulPaint.subParts.loadDelay),
                load_time: (0, $ly0px.toServerDuration)(largestContentfulPaint.subParts.loadTime),
                render_delay: (0, $ly0px.toServerDuration)(largestContentfulPaint.subParts.renderDelay)
            } : undefined
        }
    };
}

});
parcelRegister("kluxS", function(module, exports) {

$parcel$export(module.exports, "getTimeZone", () => $ecfd76788f33b389$export$c3133dbc11f66777);
function $ecfd76788f33b389$export$c3133dbc11f66777() {
    try {
        const intl = new Intl.DateTimeFormat();
        return intl.resolvedOptions().timeZone;
    } catch (_a) {
        return undefined;
    }
}

});

parcelRegister("dCrat", function(module, exports) {

$parcel$export(module.exports, "trackViews", () => $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf);

var $d97UU = parcelRequire("d97UU");
var $ly0px = parcelRequire("ly0px");
var $el7hs = parcelRequire("el7hs");
var $5IDGB = parcelRequire("5IDGB");
var $99fDv = parcelRequire("99fDv");
var $4Umqd = parcelRequire("4Umqd");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $70xdd = parcelRequire("70xdd");
var $8PiRA = parcelRequire("8PiRA");

var $kDJMQ = parcelRequire("kDJMQ");

var $izjjT = parcelRequire("izjjT");

var $eiU7B = parcelRequire("eiU7B");

var $8pGpX = parcelRequire("8pGpX");

var $dt9qY = parcelRequire("dt9qY");

var $eHDcA = parcelRequire("eHDcA");
const $9ea3e5f0d6b2c477$export$547e59d66cff6939 = 3000;
const $9ea3e5f0d6b2c477$export$466344df8256a878 = 5 * (0, $ly0px.ONE_MINUTE);
const $9ea3e5f0d6b2c477$export$41ad004d27ab927 = 5 * (0, $ly0px.ONE_MINUTE);
function $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf(lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    const activeViews = new Set();
    let currentView = startNewView((0, $kDJMQ.ViewLoadingType).INITIAL_LOAD, (0, $ly0px.clocksOrigin)(), initialViewOptions);
    let stopOnBFCacheRestore;
    startViewLifeCycle();
    let locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
        if (configuration.trackBfcacheViews) stopOnBFCacheRestore = (0, $dt9qY.onBFCacheRestore)(configuration, (pageshowEvent)=>{
            currentView.end();
            const startClocks = (0, $ly0px.relativeToClocks)(pageshowEvent.timeStamp);
            currentView = startNewView((0, $kDJMQ.ViewLoadingType).BF_CACHE, startClocks, undefined);
        });
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        const newlyCreatedView = $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(()=>{
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
            // Renew view on session renewal
            currentView = startNewView((0, $kDJMQ.ViewLoadingType).ROUTE_CHANGE, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
                context: currentView.contextManager.getContext()
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , ()=>{
            currentView.end({
                sessionIsActive: false
            });
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(({ oldLocation: oldLocation, newLocation: newLocation })=>{
            if ($9ea3e5f0d6b2c477$var$areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView((0, $kDJMQ.ViewLoadingType).ROUTE_CHANGE);
            }
        });
    }
    return {
        addTiming: (name, time = (0, $ly0px.timeStampNow)())=>{
            currentView.addTiming(name, time);
        },
        setLoadingTime: (callTimestamp)=>currentView.setLoadingTime(callTimestamp),
        startView: (options, startClocks)=>{
            currentView.end({
                endClocks: startClocks
            });
            currentView = startNewView((0, $kDJMQ.ViewLoadingType).ROUTE_CHANGE, startClocks, options);
        },
        setViewContext: (context)=>{
            currentView.contextManager.setContext(context);
        },
        setViewContextProperty: (key, value)=>{
            currentView.contextManager.setContextProperty(key, value);
        },
        setViewName: (name)=>{
            currentView.setViewName(name);
        },
        getViewContext: ()=>currentView.contextManager.getContext(),
        stop: ()=>{
            if (locationChangeSubscription) locationChangeSubscription.unsubscribe();
            if (stopOnBFCacheRestore) stopOnBFCacheRestore();
            currentView.end();
            activeViews.forEach((view)=>view.stop());
        }
    };
}
function $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks = (0, $ly0px.clocksNow)(), viewOptions) {
    // Setup initial values
    const id = (0, $99fDv.generateUUID)();
    const stopObservable = new (0, $4wc1a.Observable)();
    const customTimings = {};
    let documentVersion = 0;
    let endClocks;
    const location = (0, $8PiRA.shallowClone)((0, $4Umqd.mockable)(window.location));
    const contextManager = (0, $el7hs.createContextManager)();
    let sessionIsActive = true;
    let name = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.name;
    const service = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.service) || configuration.service;
    const version = (viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.version) || configuration.version;
    const context = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.context;
    const handlingStack = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.handlingStack;
    if (context) contextManager.setContext(context);
    const viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
        context: context,
        url: viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.url
    };
    lifeCycle.notify(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , viewCreatedEvent);
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */ , viewCreatedEvent);
    // Update the view every time the measures are changing
    const { throttled: throttled, cancel: cancelScheduleViewUpdate } = (0, $aed8w.throttle)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$547e59d66cff6939, {
        leading: false
    });
    const { setLoadEvent: setLoadEvent, setViewEnd: setViewEnd, stop: stopCommonViewMetricsTracking, stopINPTracking: stopINPTracking, getCommonViewMetrics: getCommonViewMetrics, setLoadingTime: setLoadingTime } = (0, $8pGpX.trackCommonViewMetrics)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks);
    const { stop: stopInitialViewMetricsTracking, initialViewMetrics: initialViewMetrics } = loadingType === (0, $kDJMQ.ViewLoadingType).INITIAL_LOAD ? (0, $eiU7B.trackInitialViewMetrics)(configuration, startClocks, setLoadEvent, scheduleViewUpdate) : {
        stop: (0, $aed8w.noop),
        initialViewMetrics: {}
    };
    // Start BFCache-specific metrics when restoring from BFCache
    if (loadingType === (0, $kDJMQ.ViewLoadingType).BF_CACHE) (0, $eHDcA.trackBfcacheMetrics)(startClocks, initialViewMetrics, scheduleViewUpdate);
    const { stop: stopEventCountsTracking, eventCounts: eventCounts } = (0, $izjjT.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate);
    // Session keep alive
    const keepAliveIntervalId = (0, $d97UU.setInterval)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$466344df8256a878);
    const pageMayExitSubscription = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_MAY_EXIT */ , (pageMayExitEvent)=>{
        if (pageMayExitEvent.reason === (0, $70xdd.PageExitReason).UNLOADING) triggerViewUpdate();
    });
    // Initial view update
    triggerViewUpdate();
    // View context update should always be throttled
    contextManager.changeObservable.subscribe(scheduleViewUpdate);
    function triggerBeforeViewUpdate() {
        lifeCycle.notify(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , {
            id: id,
            name: name,
            context: contextManager.getContext(),
            startClocks: startClocks,
            sessionIsActive: sessionIsActive
        });
    }
    function scheduleViewUpdate() {
        triggerBeforeViewUpdate();
        throttled();
    }
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        triggerBeforeViewUpdate();
        documentVersion += 1;
        const currentEnd = endClocks === undefined ? (0, $ly0px.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */ , {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            context: contextManager.getContext(),
            loadingType: loadingType,
            location: location,
            handlingStack: handlingStack,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, $ly0px.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts
        });
    }
    return {
        get name () {
            return name;
        },
        service: service,
        version: version,
        contextManager: contextManager,
        stopObservable: stopObservable,
        end (options = {}) {
            var _a, _b;
            if (endClocks) // view already ended
            return;
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0, $ly0px.clocksNow)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */ , {
                endClocks: endClocks
            });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , {
                endClocks: endClocks
            });
            (0, $d97UU.clearInterval)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            pageMayExitSubscription.unsubscribe();
            triggerViewUpdate();
            (0, $d97UU.setTimeout)(()=>{
                this.stop();
            }, $9ea3e5f0d6b2c477$export$41ad004d27ab927);
        },
        stop () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming (name, time) {
            if (endClocks) return;
            const relativeTime = (0, $ly0px.looksLikeRelativeTime)(time) ? time : (0, $ly0px.elapsed)(startClocks.timeStamp, time);
            customTimings[$9ea3e5f0d6b2c477$var$sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        setLoadingTime: setLoadingTime,
        setViewName (updatedName) {
            name = updatedName;
            triggerViewUpdate();
        }
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */ function $9ea3e5f0d6b2c477$var$sanitizeTiming(name) {
    const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) (0, $5IDGB.display).warn(`Invalid timing name: ${name}, sanitized to: ${sanitized}`);
    return sanitized;
}
function $9ea3e5f0d6b2c477$var$areDifferentLocation(currentLocation, otherLocation) {
    return currentLocation.pathname !== otherLocation.pathname || !$9ea3e5f0d6b2c477$var$isHashAnAnchor(otherLocation.hash) && $9ea3e5f0d6b2c477$var$getPathFromHash(otherLocation.hash) !== $9ea3e5f0d6b2c477$var$getPathFromHash(currentLocation.hash);
}
function $9ea3e5f0d6b2c477$var$isHashAnAnchor(hash) {
    const correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function $9ea3e5f0d6b2c477$var$getPathFromHash(hash) {
    const index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}

});
parcelRegister("izjjT", function(module, exports) {

$parcel$export(module.exports, "trackViewEventCounts", () => $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b);

var $WzabW = parcelRequire("WzabW");
function $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b(lifeCycle, viewId, onChange) {
    const { stop: stop, eventCounts: eventCounts } = (0, $WzabW.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: (event)=>event.view.id === viewId,
        onChange: onChange
    });
    return {
        stop: stop,
        eventCounts: eventCounts
    };
}

});

parcelRegister("eiU7B", function(module, exports) {

$parcel$export(module.exports, "trackInitialViewMetrics", () => $a69e47b74eda2325$export$e0159acaad53a4f8);

var $dFFvN = parcelRequire("dFFvN");

var $1YAhO = parcelRequire("1YAhO");

var $6ScpO = parcelRequire("6ScpO");

var $iSkz6 = parcelRequire("iSkz6");

var $7ODjH = parcelRequire("7ODjH");
function $a69e47b74eda2325$export$e0159acaad53a4f8(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
    const initialViewMetrics = {};
    const { stop: stopNavigationTracking } = (0, $6ScpO.trackNavigationTimings)(configuration, (navigationTimings)=>{
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    });
    const firstHidden = (0, $7ODjH.trackFirstHidden)(configuration, viewStart);
    const { stop: stopFCPTracking } = (0, $dFFvN.trackFirstContentfulPaint)(configuration, firstHidden, (firstContentfulPaint)=>{
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopLCPTracking } = (0, $iSkz6.trackLargestContentfulPaint)(configuration, firstHidden, window, (largestContentfulPaint)=>{
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    });
    const { stop: stopFIDTracking } = (0, $1YAhO.trackFirstInput)(configuration, firstHidden, (firstInput)=>{
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    });
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics
    };
}

});
parcelRegister("dFFvN", function(module, exports) {

$parcel$export(module.exports, "trackFirstContentfulPaint", () => $9f3f4e1acb2d1077$export$a43e15ae3a012adf);
$parcel$export(module.exports, "trackRestoredFirstContentfulPaint", () => $9f3f4e1acb2d1077$export$d019b707386eb55c);

var $ly0px = parcelRequire("ly0px");

var $e6Vsp = parcelRequire("e6Vsp");
const $9f3f4e1acb2d1077$export$2f95fa37b4a92d63 = 10 * (0, $ly0px.ONE_MINUTE);
function $9f3f4e1acb2d1077$export$a43e15ae3a012adf(configuration, firstHidden, callback) {
    const performanceSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).PAINT,
        buffered: true
    }).subscribe((entries)=>{
        const fcpEntry = entries.find((entry)=>entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < $9f3f4e1acb2d1077$export$2f95fa37b4a92d63);
        if (fcpEntry) callback(fcpEntry.startTime);
    });
    return {
        stop: performanceSubscription.unsubscribe
    };
}
function $9f3f4e1acb2d1077$export$d019b707386eb55c(viewStartRelative, callback) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback((0, $ly0px.elapsed)(viewStartRelative, (0, $ly0px.relativeNow)()));
        });
    });
}

});

parcelRegister("1YAhO", function(module, exports) {

$parcel$export(module.exports, "trackFirstInput", () => $17078abdd4b8eaf3$export$1de7804f73e53e9a);

var $ly0px = parcelRequire("ly0px");

var $4TGNe = parcelRequire("4TGNe");

var $e6Vsp = parcelRequire("e6Vsp");

var $l3o7w = parcelRequire("l3o7w");
function $17078abdd4b8eaf3$export$1de7804f73e53e9a(configuration, firstHidden, callback) {
    const performanceFirstInputSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).FIRST_INPUT,
        buffered: true
    }).subscribe((entries)=>{
        const firstInputEntry = entries.find((entry)=>entry.startTime < firstHidden.timeStamp);
        if (firstInputEntry) {
            const firstInputDelay = (0, $ly0px.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
            let firstInputTargetSelector;
            if (firstInputEntry.target && (0, $4TGNe.isElementNode)(firstInputEntry.target)) firstInputTargetSelector = (0, $l3o7w.getSelectorFromElement)(firstInputEntry.target, configuration.actionNameAttribute);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector
            });
        }
    });
    return {
        stop: ()=>{
            performanceFirstInputSubscription.unsubscribe();
        }
    };
}

});

parcelRegister("6ScpO", function(module, exports) {

$parcel$export(module.exports, "trackNavigationTimings", () => $50116aa6c1259cb4$export$8e38110c52840b40);

var $d97UU = parcelRequire("d97UU");
var $4Umqd = parcelRequire("4Umqd");
var $9h4jO = parcelRequire("9h4jO");

var $4hwJy = parcelRequire("4hwJy");
function $50116aa6c1259cb4$export$8e38110c52840b40(configuration, callback) {
    return $50116aa6c1259cb4$var$waitAfterLoadEvent(configuration, ()=>{
        const entry = (0, $4Umqd.mockable)((0, $4hwJy.getNavigationEntry))();
        if (!$50116aa6c1259cb4$var$isIncompleteNavigation(entry)) callback($50116aa6c1259cb4$var$processNavigationEntry(entry));
    });
}
function $50116aa6c1259cb4$var$processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        firstByte: (0, $4hwJy.sanitizeFirstByte)(entry)
    };
}
function $50116aa6c1259cb4$var$isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function $50116aa6c1259cb4$var$waitAfterLoadEvent(configuration, callback) {
    let timeoutId;
    const { stop: stopOnReadyState } = (0, $9h4jO.runOnReadyState)(configuration, 'complete', ()=>{
        // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timeoutId = (0, $d97UU.setTimeout)(()=>callback());
    });
    return {
        stop: ()=>{
            stopOnReadyState();
            (0, $d97UU.clearTimeout)(timeoutId);
        }
    };
}

});

parcelRegister("iSkz6", function(module, exports) {

$parcel$export(module.exports, "trackLargestContentfulPaint", () => $dbdd38f12feaea8d$export$e39d61369fabf03f);

var $hXhfS = parcelRequire("hXhfS");
var $fkj4Q = parcelRequire("fkj4Q");
var $ly0px = parcelRequire("ly0px");

var $e6Vsp = parcelRequire("e6Vsp");

var $4hwJy = parcelRequire("4hwJy");

var $l3o7w = parcelRequire("l3o7w");
const $dbdd38f12feaea8d$export$5486837c6e61d9ac = 10 * (0, $ly0px.ONE_MINUTE);
function $dbdd38f12feaea8d$export$e39d61369fabf03f(configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    let firstInteractionTimestamp = Infinity;
    const { stop: stopEventListener } = (0, $hXhfS.addEventListeners)(configuration, eventTarget, [
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ 
    ], (event)=>{
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    });
    let biggestLcpSize = 0;
    const performanceLcpSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT,
        buffered: true
    }).subscribe((entries)=>{
        const lcpEntry = (0, $fkj4Q.findLast)(entries, (entry)=>entry.entryType === (0, $e6Vsp.RumPerformanceEntryType).LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < $dbdd38f12feaea8d$export$5486837c6e61d9ac && // Ensure to get the LCP entry with the biggest size, see
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
            entry.size > biggestLcpSize);
        if (lcpEntry) {
            let lcpTargetSelector;
            if (lcpEntry.element) lcpTargetSelector = (0, $l3o7w.getSelectorFromElement)(lcpEntry.element, configuration.actionNameAttribute);
            const resourceUrl = $dbdd38f12feaea8d$var$computeLcpEntryUrl(lcpEntry);
            const lcpValue = lcpEntry.startTime;
            const subParts = $dbdd38f12feaea8d$var$computeLcpSubParts(resourceUrl, lcpValue);
            callback({
                value: lcpValue,
                targetSelector: lcpTargetSelector,
                resourceUrl: resourceUrl,
                subParts: subParts
            });
            biggestLcpSize = lcpEntry.size;
        }
    });
    return {
        stop: ()=>{
            stopEventListener();
            performanceLcpSubscription.unsubscribe();
        }
    };
}
// The property url report an empty string if the value is not available, we shouldn't report it in this case.
function $dbdd38f12feaea8d$var$computeLcpEntryUrl(entry) {
    return entry.url === '' ? undefined : entry.url;
}
/**
 * Compute the LCP sub-parts breakdown (loadDelay, loadTime, renderDelay).
 * Returns undefined if navigation timing data or TTFB is unavailable.
 */ function $dbdd38f12feaea8d$var$computeLcpSubParts(resourceUrl, lcpValue) {
    const firstByte = (0, $4hwJy.sanitizeFirstByte)((0, $4hwJy.getNavigationEntry)());
    if (firstByte === undefined) return undefined;
    const lcpResourceEntry = resourceUrl ? (0, $4hwJy.findLcpResourceEntry)(resourceUrl, lcpValue) : undefined;
    const lcpRequestStart = lcpResourceEntry ? Math.max(firstByte, lcpResourceEntry.requestStart || lcpResourceEntry.startTime) : firstByte;
    // Cap at LCP time to handle resources that continue downloading after LCP (e.g., videos)
    const lcpResponseEnd = Math.min(lcpValue, Math.max(lcpRequestStart, (lcpResourceEntry === null || lcpResourceEntry === void 0 ? void 0 : lcpResourceEntry.responseEnd) || 0));
    return {
        loadDelay: lcpRequestStart - firstByte,
        loadTime: lcpResponseEnd - lcpRequestStart,
        renderDelay: lcpValue - lcpResponseEnd
    };
}

});

parcelRegister("7ODjH", function(module, exports) {

$parcel$export(module.exports, "trackFirstHidden", () => $5b0bb36cbb3dba14$export$42b1d249aa2dee14);

var $hXhfS = parcelRequire("hXhfS");
var $aed8w = parcelRequire("aed8w");

var $e6Vsp = parcelRequire("e6Vsp");
function $5b0bb36cbb3dba14$export$42b1d249aa2dee14(configuration, viewStart, eventTarget = window) {
    if (document.visibilityState === 'hidden') return {
        timeStamp: 0,
        stop: (0, $aed8w.noop)
    };
    if ((0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).VISIBILITY_STATE)) {
        const firstHiddenEntry = performance.getEntriesByType((0, $e6Vsp.RumPerformanceEntryType).VISIBILITY_STATE).filter((entry)=>entry.name === 'hidden').find((entry)=>entry.startTime >= viewStart.relative);
        if (firstHiddenEntry) return {
            timeStamp: firstHiddenEntry.startTime,
            stop: (0, $aed8w.noop)
        };
    }
    let timeStamp = Infinity;
    const { stop: stop } = (0, $hXhfS.addEventListeners)(configuration, eventTarget, [
        "pagehide" /* DOM_EVENT.PAGE_HIDE */ ,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ 
    ], (event)=>{
        if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */  || document.visibilityState === 'hidden') {
            timeStamp = event.timeStamp;
            stop();
        }
    }, {
        capture: true
    });
    return {
        get timeStamp () {
            return timeStamp;
        },
        stop: stop
    };
}

});


parcelRegister("8pGpX", function(module, exports) {

$parcel$export(module.exports, "trackCommonViewMetrics", () => $62018fc84db9011a$export$b84f637a03e61a8d);

var $ly0px = parcelRequire("ly0px");

var $b27o3 = parcelRequire("b27o3");

var $eoPDb = parcelRequire("eoPDb");

var $8I4iK = parcelRequire("8I4iK");

var $fc9Xx = parcelRequire("fc9Xx");
function $62018fc84db9011a$export$b84f637a03e61a8d(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    const commonViewMetrics = {};
    let hasManualLoadingTime = false;
    let viewEnded = false;
    const { stop: stopLoadingTimeTracking, setLoadEvent: setLoadEvent } = (0, $8I4iK.trackLoadingTime)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime)=>{
        if (!hasManualLoadingTime) {
            commonViewMetrics.loadingTime = newLoadingTime;
            scheduleViewUpdate();
        }
    });
    const { stop: stopScrollMetricsTracking } = (0, $fc9Xx.trackScrollMetrics)(configuration, viewStart, (newScrollMetrics)=>{
        commonViewMetrics.scroll = newScrollMetrics;
    });
    const { stop: stopCLSTracking } = (0, $b27o3.trackCumulativeLayoutShift)(configuration, viewStart.relative, (cumulativeLayoutShift)=>{
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    });
    const { stop: stopINPTracking, getInteractionToNextPaint: getInteractionToNextPaint, setViewEnd: setINPViewEnd } = (0, $eoPDb.trackInteractionToNextPaint)(configuration, viewStart.relative, loadingType);
    return {
        stop: ()=>{
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: (viewEndTime)=>{
            viewEnded = true;
            setINPViewEnd(viewEndTime);
        },
        getCommonViewMetrics: ()=>{
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
        setLoadingTime: (callTimestamp)=>{
            if (viewEnded) return;
            const loadingTime = (0, $ly0px.elapsed)(viewStart.timeStamp, callTimestamp !== null && callTimestamp !== void 0 ? callTimestamp : (0, $ly0px.timeStampNow)());
            if (!hasManualLoadingTime) stopLoadingTimeTracking();
            hasManualLoadingTime = true;
            commonViewMetrics.loadingTime = loadingTime;
            scheduleViewUpdate();
        }
    };
}

});
parcelRegister("b27o3", function(module, exports) {

$parcel$export(module.exports, "trackCumulativeLayoutShift", () => $80859c8865436c7c$export$da6e6ed807ae3512);

var $ly0px = parcelRequire("ly0px");
var $aed8w = parcelRequire("aed8w");
var $bQmeT = parcelRequire("bQmeT");

var $4TGNe = parcelRequire("4TGNe");

var $e6Vsp = parcelRequire("e6Vsp");

var $l3o7w = parcelRequire("l3o7w");

var $cQ0eH = parcelRequire("cQ0eH");
function $80859c8865436c7c$export$da6e6ed807ae3512(configuration, viewStart, callback) {
    if (!$80859c8865436c7c$export$fc2cd0a8db29c298()) return {
        stop: (0, $aed8w.noop)
    };
    let maxClsValue = 0;
    let biggestShift;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0
    });
    const slidingWindow = $80859c8865436c7c$var$slidingSessionWindow();
    const performanceSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).LAYOUT_SHIFT,
        buffered: true
    }).subscribe((entries)=>{
        var _a;
        for (const entry of entries){
            if (entry.hadRecentInput || entry.startTime < viewStart) continue;
            const { cumulatedValue: cumulatedValue, isMaxValue: isMaxValue } = slidingWindow.update(entry);
            if (isMaxValue) {
                const attribution = $80859c8865436c7c$var$getTopImpactedElement(entry.sources);
                biggestShift = {
                    target: (attribution === null || attribution === void 0 ? void 0 : attribution.node) ? new WeakRef(attribution.node) : undefined,
                    time: (0, $ly0px.elapsed)(viewStart, entry.startTime),
                    previousRect: attribution === null || attribution === void 0 ? void 0 : attribution.previousRect,
                    currentRect: attribution === null || attribution === void 0 ? void 0 : attribution.currentRect,
                    devicePixelRatio: window.devicePixelRatio
                };
            }
            if (cumulatedValue > maxClsValue) {
                maxClsValue = cumulatedValue;
                const target = (_a = biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.target) === null || _a === void 0 ? void 0 : _a.deref();
                callback({
                    value: (0, $bQmeT.round)(maxClsValue, 4),
                    targetSelector: target && (0, $l3o7w.getSelectorFromElement)(target, configuration.actionNameAttribute),
                    time: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.time,
                    previousRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.previousRect) ? $80859c8865436c7c$var$asRumRect(biggestShift.previousRect) : undefined,
                    currentRect: (biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.currentRect) ? $80859c8865436c7c$var$asRumRect(biggestShift.currentRect) : undefined,
                    devicePixelRatio: biggestShift === null || biggestShift === void 0 ? void 0 : biggestShift.devicePixelRatio
                });
            }
        }
    });
    return {
        stop: ()=>{
            performanceSubscription.unsubscribe();
        }
    };
}
function $80859c8865436c7c$var$getTopImpactedElement(sources) {
    let topImpactedSource;
    for (const source of sources)if (source.node && (0, $4TGNe.isElementNode)(source.node)) {
        const currentImpactedArea = (0, $cQ0eH.getClsAttributionImpactedArea)(source);
        if (!topImpactedSource || (0, $cQ0eH.getClsAttributionImpactedArea)(topImpactedSource) < currentImpactedArea) topImpactedSource = source;
    }
    return topImpactedSource;
}
function $80859c8865436c7c$var$asRumRect({ x: x, y: y, width: width, height: height }) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
const $80859c8865436c7c$export$d03c32743ed6c027 = 5 * (0, $ly0px.ONE_SECOND);
const $80859c8865436c7c$var$MAX_UPDATE_GAP = (0, $ly0px.ONE_SECOND);
function $80859c8865436c7c$var$slidingSessionWindow() {
    let cumulatedValue = 0;
    let startTime;
    let endTime;
    let maxValue = 0;
    return {
        update: (entry)=>{
            const shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= $80859c8865436c7c$var$MAX_UPDATE_GAP || entry.startTime - startTime >= $80859c8865436c7c$export$d03c32743ed6c027;
            let isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            } else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) maxValue = entry.value;
            }
            return {
                cumulatedValue: cumulatedValue,
                isMaxValue: isMaxValue
            };
        }
    };
}
function $80859c8865436c7c$export$fc2cd0a8db29c298() {
    return (0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).LAYOUT_SHIFT) && 'WeakRef' in window;
}

});
parcelRegister("cQ0eH", function(module, exports) {

$parcel$export(module.exports, "getClsAttributionImpactedArea", () => $958a863e1a6841f7$export$6fff176b782d9306);
/**
 * Calculates the area of a rectangle given its width and height
 */ const $958a863e1a6841f7$var$calculateArea = (width, height)=>width * height;
/**
 * Calculates the intersection area between two rectangles
 */ const $958a863e1a6841f7$var$calculateIntersectionArea = (rect1, rect2)=>{
    const left = Math.max(rect1.left, rect2.left);
    const top = Math.max(rect1.top, rect2.top);
    const right = Math.min(rect1.right, rect2.right);
    const bottom = Math.min(rect1.bottom, rect2.bottom);
    if (left >= right || top >= bottom) return 0;
    return $958a863e1a6841f7$var$calculateArea(right - left, bottom - top);
};
const $958a863e1a6841f7$export$6fff176b782d9306 = (source)=>{
    const previousArea = $958a863e1a6841f7$var$calculateArea(source.previousRect.width, source.previousRect.height);
    const currentArea = $958a863e1a6841f7$var$calculateArea(source.currentRect.width, source.currentRect.height);
    const intersectionArea = $958a863e1a6841f7$var$calculateIntersectionArea(source.previousRect, source.currentRect);
    return previousArea + currentArea - intersectionArea;
};

});


parcelRegister("eoPDb", function(module, exports) {

$parcel$export(module.exports, "trackInteractionToNextPaint", () => $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9);

var $ly0px = parcelRequire("ly0px");
var $aed8w = parcelRequire("aed8w");

var $e6Vsp = parcelRequire("e6Vsp");

var $kDJMQ = parcelRequire("kDJMQ");

var $l3o7w = parcelRequire("l3o7w");

var $4TGNe = parcelRequire("4TGNe");

var $2NQWL = parcelRequire("2NQWL");

var $iu7w6 = parcelRequire("iu7w6");
// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
const $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES = 10;
const $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad = 1 * (0, $ly0px.ONE_MINUTE);
// Event Timing API rounds duration values to the nearest 8 ms
const $a7bb5b6dbe4d2a3a$var$RENDER_TIME_GROUPING_THRESHOLD = 8;
function $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9(configuration, viewStart, viewLoadingType) {
    if (!$a7bb5b6dbe4d2a3a$export$8abc245381a65a8f()) return {
        getInteractionToNextPaint: ()=>undefined,
        setViewEnd: (0, $aed8w.noop),
        stop: (0, $aed8w.noop)
    };
    let viewEnd = Infinity;
    let currentInp;
    const { getViewInteractionCount: getViewInteractionCount, stopViewInteractionCount: stopViewInteractionCount } = $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType);
    const longestInteractions = $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount);
    const subPartsTracker = $a7bb5b6dbe4d2a3a$var$createSubPartsTracker(longestInteractions);
    const firstInputSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).FIRST_INPUT,
        buffered: true
    }).subscribe(handleEntries);
    const eventSubscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: (0, $e6Vsp.RumPerformanceEntryType).EVENT,
        // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
        // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
        durationThreshold: 40,
        buffered: true
    }).subscribe(handleEntries);
    function handleEntries(entries) {
        for (const entry of entries)if (entry.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
        entry.startTime >= viewStart && entry.startTime <= viewEnd) {
            longestInteractions.process(entry);
            subPartsTracker.process(entry);
        }
        subPartsTracker.pruneUntracked();
        const candidate = longestInteractions.estimateP98Interaction();
        if (candidate) updateCurrentInp(candidate);
    }
    function updateCurrentInp(candidate) {
        const newStartTime = (0, $ly0px.elapsed)(viewStart, candidate.startTime);
        // startTime catches identity changes when the p98 switches to a different interaction with the same duration,
        // ensuring targetSelector and subParts always describe the same interaction.
        if (!currentInp || candidate.duration !== currentInp.duration || newStartTime !== currentInp.startTime) {
            let targetSelector = (0, $2NQWL.getInteractionSelector)(candidate.startTime);
            if (!targetSelector && candidate.target && (0, $4TGNe.isElementNode)(candidate.target)) targetSelector = (0, $l3o7w.getSelectorFromElement)(candidate.target, configuration.actionNameAttribute);
            currentInp = {
                duration: candidate.duration,
                startTime: newStartTime,
                targetSelector: targetSelector
            };
        }
        // Recomputed on every batch: the group for the p98 interaction may have been updated
        // with new min/max timing even when the p98 identity (duration, startTime) is unchanged.
        currentInp.subParts = subPartsTracker.computeSubParts(candidate, $a7bb5b6dbe4d2a3a$var$sanitizeInpValue(currentInp.duration));
    }
    return {
        getInteractionToNextPaint: ()=>{
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (currentInp) return {
                value: $a7bb5b6dbe4d2a3a$var$sanitizeInpValue(currentInp.duration),
                targetSelector: currentInp.targetSelector,
                time: currentInp.startTime,
                subParts: currentInp.subParts
            };
            else if (getViewInteractionCount()) return {
                value: 0
            };
        },
        setViewEnd: (viewEndTime)=>{
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: ()=>{
            eventSubscription.unsubscribe();
            firstInputSubscription.unsubscribe();
            subPartsTracker.stop();
        }
    };
}
/**
 * Maintains a bounded list of the slowest interactions seen so far, used to estimate the p98
 * interaction duration without keeping every entry in memory.
 */ function $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount) {
    const longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort((a, b)=>b.duration - a.duration).splice($a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */ process (entry) {
            const interactionIndex = longestInteractions.findIndex((interaction)=>entry.interactionId === interaction.interactionId);
            const minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            } else if (longestInteractions.length < $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */ estimateP98Interaction () {
            const interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
        isTracked (interactionId) {
            return longestInteractions.some((i)=>i.interactionId === interactionId);
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType) {
    (0, $iu7w6.initInteractionCountPolyfill)();
    const previousInteractionCount = viewLoadingType === (0, $kDJMQ.ViewLoadingType).INITIAL_LOAD ? 0 : (0, $iu7w6.getInteractionCount)();
    let state = {
        stopped: false
    };
    function computeViewInteractionCount() {
        return (0, $iu7w6.getInteractionCount)() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: ()=>{
            if (state.stopped) return state.interactionCount;
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: ()=>{
            state = {
                stopped: true,
                interactionCount: computeViewInteractionCount()
            };
        }
    };
}
/**
 * Groups performance entries by interaction and render time to compute INP subparts
 * (input delay, processing duration, presentation delay). Entries sharing the same
 * interactionId, or whose render time falls within the 8 ms Event Timing rounding window,
 * are merged into a single group so that subparts always sum to the reported INP duration.
 */ function $a7bb5b6dbe4d2a3a$var$createSubPartsTracker(longestInteractions) {
    const groupsByInteractionId = new Map();
    function updateGroupWithEntry(group, entry) {
        group.startTime = Math.min(entry.startTime, group.startTime);
        // For each group, we keep the biggest interval possible between processingStart and processingEnd
        group.processingStart = Math.min(entry.processingStart, group.processingStart);
        group.processingEnd = Math.max(entry.processingEnd, group.processingEnd);
    }
    return {
        process (entry) {
            if (entry.interactionId === undefined || !entry.processingStart || !entry.processingEnd) return;
            const renderTime = entry.startTime + entry.duration;
            const existingGroup = groupsByInteractionId.get(entry.interactionId);
            if (existingGroup) {
                // Update existing group with MIN/MAX values (keep original referenceRenderTime)
                updateGroupWithEntry(existingGroup, entry);
                return;
            }
            // Try to find a group within 8ms window to merge with (different interactionId, same frame)
            for (const [, group] of groupsByInteractionId.entries())if (Math.abs(renderTime - group.referenceRenderTime) <= $a7bb5b6dbe4d2a3a$var$RENDER_TIME_GROUPING_THRESHOLD) {
                updateGroupWithEntry(group, entry);
                // Also store under this entry's interactionId for easy lookup
                groupsByInteractionId.set(entry.interactionId, group);
                return;
            }
            // Create new group
            groupsByInteractionId.set(entry.interactionId, {
                startTime: entry.startTime,
                processingStart: entry.processingStart,
                processingEnd: entry.processingEnd,
                referenceRenderTime: renderTime
            });
        },
        // Prune after all entries are grouped: groups not in longestInteractions can never affect p98 subparts.
        // Keeps groupsByInteractionId capped at MAX_INTERACTION_ENTRIES
        pruneUntracked () {
            for (const [interactionId] of groupsByInteractionId)if (!longestInteractions.isTracked(interactionId)) groupsByInteractionId.delete(interactionId);
        },
        computeSubParts (entry, inpDuration) {
            if (!entry.processingStart || !entry.processingEnd || entry.interactionId === undefined) return undefined;
            const group = groupsByInteractionId.get(entry.interactionId);
            // Shouldn't happen since entries are grouped before p98 calculation.
            if (!group) return undefined;
            // Use group.startTime consistently to ensure subparts sum to inpDuration
            // Math.max prevents nextPaintTime from being before processingStart (Chrome implementation)
            const nextPaintTime = Math.max(group.startTime + inpDuration, group.processingStart);
            // Clamp processingEnd to not exceed nextPaintTime
            const processingEnd = Math.min(group.processingEnd, nextPaintTime);
            return {
                inputDelay: (0, $ly0px.elapsed)(group.startTime, group.processingStart),
                processingDuration: (0, $ly0px.elapsed)(group.processingStart, processingEnd),
                presentationDelay: (0, $ly0px.elapsed)(processingEnd, nextPaintTime)
            };
        },
        stop () {
            groupsByInteractionId.clear();
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$8abc245381a65a8f() {
    return (0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).EVENT) && window.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype;
}
function $a7bb5b6dbe4d2a3a$var$sanitizeInpValue(inpValue) {
    return Math.min(inpValue, $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad);
}

});
parcelRegister("iu7w6", function(module, exports) {

$parcel$export(module.exports, "initInteractionCountPolyfill", () => $d750dc04d0ff821b$export$67d90cda6b78a2eb);
$parcel$export(module.exports, "getInteractionCount", () => $d750dc04d0ff821b$export$8a962f2683a476d1);
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */ 
var $2wH3Z = parcelRequire("2wH3Z");
let $d750dc04d0ff821b$var$observer;
let $d750dc04d0ff821b$var$interactionCountEstimate = 0;
let $d750dc04d0ff821b$var$minKnownInteractionId = Infinity;
let $d750dc04d0ff821b$var$maxKnownInteractionId = 0;
function $d750dc04d0ff821b$export$67d90cda6b78a2eb() {
    if ('interactionCount' in performance || $d750dc04d0ff821b$var$observer) return;
    $d750dc04d0ff821b$var$observer = new window.PerformanceObserver((0, $2wH3Z.monitor)((entries)=>{
        entries.getEntries().forEach((e)=>{
            const entry = e;
            if (entry.interactionId) {
                $d750dc04d0ff821b$var$minKnownInteractionId = Math.min($d750dc04d0ff821b$var$minKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$maxKnownInteractionId = Math.max($d750dc04d0ff821b$var$maxKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$interactionCountEstimate = ($d750dc04d0ff821b$var$maxKnownInteractionId - $d750dc04d0ff821b$var$minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    $d750dc04d0ff821b$var$observer.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
}
const $d750dc04d0ff821b$export$8a962f2683a476d1 = ()=>$d750dc04d0ff821b$var$observer ? $d750dc04d0ff821b$var$interactionCountEstimate : window.performance.interactionCount || 0;
function $d750dc04d0ff821b$export$921e3cabfd419ba3() {
    if ($d750dc04d0ff821b$var$observer) {
        $d750dc04d0ff821b$var$observer.disconnect();
        $d750dc04d0ff821b$var$observer = undefined;
        $d750dc04d0ff821b$var$interactionCountEstimate = 0;
        $d750dc04d0ff821b$var$minKnownInteractionId = Infinity;
        $d750dc04d0ff821b$var$maxKnownInteractionId = 0;
    }
}

});


parcelRegister("8I4iK", function(module, exports) {

$parcel$export(module.exports, "trackLoadingTime", () => $6575c4fa5823a893$export$58b2b8bfa724cb6f);

var $ly0px = parcelRequire("ly0px");

var $7oXOv = parcelRequire("7oXOv");

var $kDJMQ = parcelRequire("kDJMQ");

var $7ODjH = parcelRequire("7ODjH");
function $6575c4fa5823a893$export$58b2b8bfa724cb6f(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
    let isWaitingForLoadEvent = loadType === (0, $kDJMQ.ViewLoadingType).INITIAL_LOAD;
    let isWaitingForActivityLoadingTime = true;
    const loadingTimeCandidates = [];
    const firstHidden = (0, $7ODjH.trackFirstHidden)(configuration, viewStart);
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            const loadingTime = Math.max(...loadingTimeCandidates);
            // firstHidden is a relative time from time origin, so we use the relative start time of the view to compare with the loading time
            if (loadingTime < firstHidden.timeStamp - viewStart.relative) callback(loadingTime);
        }
    }
    const { stop: stop } = (0, $7oXOv.waitPageActivityEnd)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (event)=>{
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) loadingTimeCandidates.push((0, $ly0px.elapsed)(viewStart.timeStamp, event.end));
            invokeCallbackIfAllCandidatesAreReceived();
        }
    });
    return {
        stop: ()=>{
            stop();
            firstHidden.stop();
        },
        setLoadEvent: (loadEvent)=>{
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}

});

parcelRegister("fc9Xx", function(module, exports) {

$parcel$export(module.exports, "trackScrollMetrics", () => $b0ffb3bb8ad90457$export$eeec767135e98c85);

var $hXhfS = parcelRequire("hXhfS");
var $ly0px = parcelRequire("ly0px");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");
var $aed8w = parcelRequire("aed8w");

var $fvpT8 = parcelRequire("fvpT8");

var $kom4r = parcelRequire("kom4r");
const $b0ffb3bb8ad90457$export$f01db56fd078c3a8 = (0, $ly0px.ONE_SECOND);
function $b0ffb3bb8ad90457$export$eeec767135e98c85(configuration, viewStart, callback, scrollValues = $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration)) {
    let maxScrollDepth = 0;
    let maxScrollHeight = 0;
    let maxScrollHeightTime = 0;
    const subscription = scrollValues.subscribe(({ scrollDepth: scrollDepth, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
        let shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            const now = (0, $ly0px.relativeNow)();
            maxScrollHeightTime = (0, $ly0px.elapsed)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) callback({
            maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
            maxDepthScrollTop: scrollTop,
            maxScrollHeight: maxScrollHeight,
            maxScrollHeightTime: maxScrollHeightTime
        });
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $b0ffb3bb8ad90457$export$7819cf13be3ef65c() {
    const scrollTop = (0, $fvpT8.getScrollY)();
    const { height: height } = (0, $kom4r.getViewportDimension)();
    const scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    const scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop
    };
}
function $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration, throttleDuration = $b0ffb3bb8ad90457$export$f01db56fd078c3a8) {
    return new (0, $4wc1a.Observable)((observable)=>{
        function notify() {
            observable.notify($b0ffb3bb8ad90457$export$7819cf13be3ef65c());
        }
        if (window.ResizeObserver) {
            const throttledNotify = (0, $aed8w.throttle)(notify, throttleDuration, {
                leading: false,
                trailing: true
            });
            const observerTarget = document.scrollingElement || document.documentElement;
            const resizeObserver = new ResizeObserver((0, $2wH3Z.monitor)(throttledNotify.throttled));
            if (observerTarget) resizeObserver.observe(observerTarget);
            const eventListener = (0, $hXhfS.addEventListener)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , throttledNotify.throttled, {
                passive: true
            });
            return ()=>{
                throttledNotify.cancel();
                resizeObserver.disconnect();
                eventListener.stop();
            };
        }
    });
}

});
parcelRegister("fvpT8", function(module, exports) {

$parcel$export(module.exports, "getScrollX", () => $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2);
$parcel$export(module.exports, "getScrollY", () => $b49dd51dc1e7c0f8$export$91aaad5752ba6e7);
function $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2() {
    let scrollX;
    const visual = window.visualViewport;
    if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
    else if (window.scrollX !== undefined) scrollX = window.scrollX;
    else scrollX = window.pageXOffset || 0;
    return Math.round(scrollX);
}
function $b49dd51dc1e7c0f8$export$91aaad5752ba6e7() {
    let scrollY;
    const visual = window.visualViewport;
    if (visual) scrollY = visual.pageTop - visual.offsetTop;
    else if (window.scrollY !== undefined) scrollY = window.scrollY;
    else scrollY = window.pageYOffset || 0;
    return Math.round(scrollY);
}

});

parcelRegister("kom4r", function(module, exports) {

$parcel$export(module.exports, "initViewportObservable", () => $ed872b54a9ace364$export$2c24cc613e51a50f);
$parcel$export(module.exports, "getViewportDimension", () => $ed872b54a9ace364$export$e79021d67c61dfbd);

var $hXhfS = parcelRequire("hXhfS");
var $4wc1a = parcelRequire("4wc1a");
var $aed8w = parcelRequire("aed8w");
let $ed872b54a9ace364$var$viewportObservable;
function $ed872b54a9ace364$export$2c24cc613e51a50f(configuration) {
    if (!$ed872b54a9ace364$var$viewportObservable) $ed872b54a9ace364$var$viewportObservable = $ed872b54a9ace364$export$36388875a0cf8990(configuration);
    return $ed872b54a9ace364$var$viewportObservable;
}
function $ed872b54a9ace364$export$36388875a0cf8990(configuration) {
    return new (0, $4wc1a.Observable)((observable)=>{
        const { throttled: updateDimension } = (0, $aed8w.throttle)(()=>{
            observable.notify($ed872b54a9ace364$export$e79021d67c61dfbd());
        }, 200);
        return (0, $hXhfS.addEventListener)(configuration, window, "resize" /* DOM_EVENT.RESIZE */ , updateDimension, {
            capture: true,
            passive: true
        }).stop;
    });
}
function $ed872b54a9ace364$export$e79021d67c61dfbd() {
    const visual = window.visualViewport;
    if (visual) return {
        width: Number(visual.width * visual.scale),
        height: Number(visual.height * visual.scale)
    };
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0)
    };
}

});



parcelRegister("dt9qY", function(module, exports) {

$parcel$export(module.exports, "onBFCacheRestore", () => $9ce54d320c6f36af$export$8776175fdff4a422);

var $hXhfS = parcelRequire("hXhfS");
function $9ce54d320c6f36af$export$8776175fdff4a422(configuration, callback) {
    const { stop: stop } = (0, $hXhfS.addEventListener)(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */ , (event)=>{
        if (event.persisted) callback(event);
    }, {
        capture: true
    });
    return stop;
}

});

parcelRegister("eHDcA", function(module, exports) {

$parcel$export(module.exports, "trackBfcacheMetrics", () => $ab437d8e4cb1dafd$export$3047835c299420b6);

var $dFFvN = parcelRequire("dFFvN");
function $ab437d8e4cb1dafd$export$3047835c299420b6(viewStart, metrics, scheduleViewUpdate) {
    (0, $dFFvN.trackRestoredFirstContentfulPaint)(viewStart.relative, (paintTime)=>{
        metrics.firstContentfulPaint = paintTime;
        metrics.largestContentfulPaint = {
            value: paintTime
        };
        scheduleViewUpdate();
    });
}

});



parcelRegister("eptxg", function(module, exports) {

$parcel$export(module.exports, "startRumSessionManager", () => $a7da4f9da803eca2$export$8d80e7032209d4ab);
$parcel$export(module.exports, "startRumSessionManagerStub", () => $a7da4f9da803eca2$export$d66a130e714b81c0);

var $kFaIT = parcelRequire("kFaIT");
var $aed8w = parcelRequire("aed8w");
var $4wc1a = parcelRequire("4wc1a");
var $bQmeT = parcelRequire("bQmeT");
var $1q2aX = parcelRequire("1q2aX");
const $a7da4f9da803eca2$export$50ae25e0cd1ada34 = 'rum';
function $a7da4f9da803eca2$export$8d80e7032209d4ab(configuration, lifeCycle, trackingConsentState) {
    const sessionManager = (0, $1q2aX.startSessionManager)(configuration, $a7da4f9da803eca2$export$50ae25e0cd1ada34, (rawTrackingType)=>$a7da4f9da803eca2$var$computeTrackingType(configuration, rawTrackingType), trackingConsentState);
    sessionManager.expireObservable.subscribe(()=>{
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */ );
    });
    sessionManager.renewObservable.subscribe(()=>{
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */ );
    });
    sessionManager.sessionStateUpdateObservable.subscribe(({ previousState: previousState, newState: newState })=>{
        if (!previousState.forcedReplay && newState.forcedReplay) {
            const sessionEntity = sessionManager.findSession();
            if (sessionEntity) sessionEntity.isReplayForced = true;
        }
    });
    return {
        findTrackedSession: (startTime)=>{
            const session = sessionManager.findSession(startTime);
            if (!session || session.trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ) return;
            return {
                id: session.id,
                sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  ? 1 /* SessionReplayState.SAMPLED */  : session.isReplayForced ? 2 /* SessionReplayState.FORCED */  : 0 /* SessionReplayState.OFF */ ,
                anonymousId: session.anonymousId
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
        setForcedReplay: ()=>sessionManager.updateSessionState({
                forcedReplay: '1'
            })
    };
}
function $a7da4f9da803eca2$export$d66a130e714b81c0() {
    const session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplay: (0, $kFaIT.bridgeSupports)("records" /* BridgeCapability.RECORDS */ ) ? 1 /* SessionReplayState.SAMPLED */  : 0 /* SessionReplayState.OFF */ 
    };
    return {
        findTrackedSession: ()=>session,
        expire: (0, $aed8w.noop),
        expireObservable: new (0, $4wc1a.Observable)(),
        setForcedReplay: (0, $aed8w.noop)
    };
}
function $a7da4f9da803eca2$var$computeTrackingType(configuration, rawTrackingType) {
    if ($a7da4f9da803eca2$var$hasValidRumSession(rawTrackingType)) return rawTrackingType;
    if (!(0, $bQmeT.performDraw)(configuration.sessionSampleRate)) return "0" /* RumTrackingType.NOT_TRACKED */ ;
    if (!(0, $bQmeT.performDraw)(configuration.sessionReplaySampleRate)) return "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
    return "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
}
function $a7da4f9da803eca2$var$hasValidRumSession(trackingType) {
    return trackingType === "0" /* RumTrackingType.NOT_TRACKED */  || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
}

});

parcelRegister("degsG", function(module, exports) {

$parcel$export(module.exports, "startRumBatch", () => $027c47a5a8d86b5f$export$33e6a2986ce7483);

var $c8B2g = parcelRequire("c8B2g");
var $cETgK = parcelRequire("cETgK");
var $3qksw = parcelRequire("3qksw");

var $kDJMQ = parcelRequire("kDJMQ");
function $027c47a5a8d86b5f$export$33e6a2986ce7483(configuration, lifeCycle, reportError, pageMayExitObservable, sessionExpireObservable, createEncoder) {
    const endpoints = [
        configuration.rumEndpointBuilder
    ];
    if (configuration.replica) endpoints.push(configuration.replica.rumEndpointBuilder);
    const batch = (0, $c8B2g.createBatch)({
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */ ),
        request: (0, $3qksw.createHttpRequest)(endpoints, reportError),
        flushController: (0, $cETgK.createFlushController)({
            pageMayExitObservable: pageMayExitObservable,
            sessionExpireObservable: sessionExpireObservable
        })
    });
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (serverRumEvent)=>{
        if (serverRumEvent.type === (0, $kDJMQ.RumEventType).VIEW) batch.upsert(serverRumEvent, serverRumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    return batch;
}

});

parcelRegister("axlOu", function(module, exports) {

$parcel$export(module.exports, "startRumEventBridge", () => $7abde8201394e230$export$38cafc1b8954ea9d);

var $kFaIT = parcelRequire("kFaIT");
function $7abde8201394e230$export$38cafc1b8954ea9d(lifeCycle) {
    const bridge = (0, $kFaIT.getEventBridge)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , (serverRumEvent)=>{
        bridge.send('rum', serverRumEvent);
    });
}

});

parcelRegister("kXNZh", function(module, exports) {

$parcel$export(module.exports, "startUrlContexts", () => $f43017d046384f22$export$a9a4d4dde99a99fd);

var $bVLiF = parcelRequire("bVLiF");
var $80mka = parcelRequire("80mka");
var $i3LOd = parcelRequire("i3LOd");
var $4Umqd = parcelRequire("4Umqd");
var $ly0px = parcelRequire("ly0px");
var $5xfjl = parcelRequire("5xfjl");
const $f43017d046384f22$export$e5d2b82a8e642e14 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $f43017d046384f22$export$a9a4d4dde99a99fd(lifeCycle, hooks, locationChangeObservable) {
    const urlContextHistory = (0, $80mka.createValueHistory)({
        expireDelay: $f43017d046384f22$export$e5d2b82a8e642e14
    });
    let previousViewUrl;
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , ({ startClocks: startClocks, url: url })=>{
        const locationHref = (0, $4Umqd.mockable)(location).href;
        const viewUrl = url !== undefined ? (0, $bVLiF.buildUrl)(url, locationHref).href : locationHref;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        urlContextHistory.closeActive(endClocks.relative);
    });
    const locationChangeSubscription = locationChangeObservable.subscribe(({ newLocation: newLocation })=>{
        const current = urlContextHistory.find();
        if (current) {
            const changeTime = (0, $ly0px.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer
            }), changeTime);
        }
    });
    function buildUrlContext({ url: url, referrer: referrer }) {
        return {
            url: url,
            referrer: referrer
        };
    }
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const urlContext = urlContextHistory.find(startTime);
        if (!urlContext) return 0, $i3LOd.DISCARDED;
        return {
            type: eventType,
            view: {
                url: urlContext.url,
                referrer: urlContext.referrer
            }
        };
    });
    return {
        findUrl: (startTime)=>urlContextHistory.find(startTime),
        stop: ()=>{
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        }
    };
}

});

parcelRegister("3OSU7", function(module, exports) {

$parcel$export(module.exports, "createLocationChangeObservable", () => $2c80a16a9ac8d387$export$c2da1b41b3b918ce);

var $hXhfS = parcelRequire("hXhfS");
var $35a54 = parcelRequire("35a54");
var $4wc1a = parcelRequire("4wc1a");
var $8PiRA = parcelRequire("8PiRA");
function $2c80a16a9ac8d387$export$c2da1b41b3b918ce(configuration) {
    let currentLocation = (0, $8PiRA.shallowClone)(location);
    return new (0, $4wc1a.Observable)((observable)=>{
        const { stop: stopHistoryTracking } = $2c80a16a9ac8d387$var$trackHistory(configuration, onLocationChange);
        const { stop: stopHashTracking } = $2c80a16a9ac8d387$var$trackHash(configuration, onLocationChange);
        function onLocationChange() {
            if (currentLocation.href === location.href) return;
            const newLocation = (0, $8PiRA.shallowClone)(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation
            });
            currentLocation = newLocation;
        }
        return ()=>{
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function $2c80a16a9ac8d387$var$trackHistory(configuration, onHistoryChange) {
    const { stop: stopInstrumentingPushState } = (0, $35a54.instrumentMethod)($2c80a16a9ac8d387$var$getHistoryInstrumentationTarget('pushState'), 'pushState', ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: stopInstrumentingReplaceState } = (0, $35a54.instrumentMethod)($2c80a16a9ac8d387$var$getHistoryInstrumentationTarget('replaceState'), 'replaceState', ({ onPostCall: onPostCall })=>{
        onPostCall(onHistoryChange);
    });
    const { stop: removeListener } = (0, $hXhfS.addEventListener)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */ , onHistoryChange);
    return {
        stop: ()=>{
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        }
    };
}
function $2c80a16a9ac8d387$var$trackHash(configuration, onHashChange) {
    return (0, $hXhfS.addEventListener)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */ , onHashChange);
}
function $2c80a16a9ac8d387$var$getHistoryInstrumentationTarget(methodName) {
    // Ideally we should always instument the method on the prototype, however some frameworks (e.g [Next.js](https://github.com/vercel/next.js/blob/d3f5532065f3e3bb84fb54bd2dfd1a16d0f03a21/packages/next/src/client/components/app-router.tsx#L429))
    // are wrapping the instance method. In that case we should also wrap the instance method.
    return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}

});

parcelRegister("7hyCT", function(module, exports) {

$parcel$export(module.exports, "startFeatureFlagContexts", () => $54d4fafd542dd21e$export$9125b974ef9cfd53);

var $80mka = parcelRequire("80mka");
var $8PiRA = parcelRequire("8PiRA");
var $5xfjl = parcelRequire("5xfjl");
var $i3LOd = parcelRequire("i3LOd");

var $kDJMQ = parcelRequire("kDJMQ");
const $54d4fafd542dd21e$export$205c45090af638e0 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
const $54d4fafd542dd21e$export$e4441139afa265bd = 200;
function $54d4fafd542dd21e$export$9125b974ef9cfd53(lifeCycle, hooks, configuration) {
    const featureFlagContexts = (0, $80mka.createValueHistory)({
        expireDelay: $54d4fafd542dd21e$export$205c45090af638e0
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , ({ startClocks: startClocks })=>{
        featureFlagContexts.add({}, startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , ({ endClocks: endClocks })=>{
        featureFlagContexts.closeActive(endClocks.relative);
    });
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, eventType: eventType })=>{
        const trackFeatureFlagsForEvents = configuration.trackFeatureFlagsForEvents.concat([
            (0, $kDJMQ.RumEventType).VIEW,
            (0, $kDJMQ.RumEventType).ERROR
        ]);
        if (!trackFeatureFlagsForEvents.includes(eventType)) return 0, $i3LOd.SKIPPED;
        const featureFlagContext = featureFlagContexts.find(startTime);
        if (!featureFlagContext || (0, $8PiRA.isEmptyObject)(featureFlagContext)) return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            feature_flags: featureFlagContext
        };
    });
    return {
        addFeatureFlagEvaluation: (key, value)=>{
            const currentContext = featureFlagContexts.find();
            if (currentContext) currentContext[key] = value;
        }
    };
}

});

parcelRegister("lTMQC", function(module, exports) {

$parcel$export(module.exports, "startCustomerDataTelemetry", () => $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2);

var $fhNdh = parcelRequire("fhNdh");
var $ly0px = parcelRequire("ly0px");
var $d97UU = parcelRequire("d97UU");
const $ff14a02fd6cd1ddd$export$e9b7b62aafe04389 = 10 * (0, $ly0px.ONE_SECOND);
let $ff14a02fd6cd1ddd$var$currentPeriodMeasures;
let $ff14a02fd6cd1ddd$var$batchHasRumEvent;
function $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2(telemetry, lifeCycle, batchFlushObservable) {
    if (!telemetry.metricsEnabled) return;
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
    $ff14a02fd6cd1ddd$var$batchHasRumEvent = false;
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , ()=>{
        $ff14a02fd6cd1ddd$var$batchHasRumEvent = true;
    });
    batchFlushObservable.subscribe(({ bytesCount: bytesCount, messagesCount: messagesCount })=>{
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!$ff14a02fd6cd1ddd$var$batchHasRumEvent) return;
        $ff14a02fd6cd1ddd$var$batchHasRumEvent = false;
        $ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount += 1;
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchBytesCount, bytesCount);
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchMessagesCount, messagesCount);
    });
    (0, $d97UU.setInterval)($ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures, $ff14a02fd6cd1ddd$export$e9b7b62aafe04389);
}
function $ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures() {
    if ($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount === 0) return;
    // monitor-until: forever
    (0, $fhNdh.addTelemetryMetrics)("Customer data measures" /* TelemetryMetrics.CUSTOMER_DATA_METRIC_NAME */ , $ff14a02fd6cd1ddd$var$currentPeriodMeasures);
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
}
function $ff14a02fd6cd1ddd$var$createMeasure() {
    return {
        min: Infinity,
        max: 0,
        sum: 0
    };
}
function $ff14a02fd6cd1ddd$var$updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures() {
    $ff14a02fd6cd1ddd$var$currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: $ff14a02fd6cd1ddd$var$createMeasure(),
        batchMessagesCount: $ff14a02fd6cd1ddd$var$createMeasure()
    };
}

});

parcelRegister("eZzeR", function(module, exports) {

$parcel$export(module.exports, "startPageStateHistory", () => $aea218dde2c0f936$export$7f01c272948a14b1);

var $hXhfS = parcelRequire("hXhfS");
var $80mka = parcelRequire("80mka");
var $ly0px = parcelRequire("ly0px");
var $5xfjl = parcelRequire("5xfjl");
var $i3LOd = parcelRequire("i3LOd");

var $e6Vsp = parcelRequire("e6Vsp");

var $kDJMQ = parcelRequire("kDJMQ");
const $aea218dde2c0f936$export$491f01a0e9b8b208 = 4000;
const $aea218dde2c0f936$export$b92c7553d298d075 = 500;
const $aea218dde2c0f936$export$20f880bb2b8d10f6 = (0, $5xfjl.SESSION_TIME_OUT_DELAY);
function $aea218dde2c0f936$export$7f01c272948a14b1(hooks, configuration, maxPageStateEntriesSelectable = $aea218dde2c0f936$export$b92c7553d298d075) {
    const pageStateEntryHistory = (0, $80mka.createValueHistory)({
        expireDelay: $aea218dde2c0f936$export$20f880bb2b8d10f6,
        maxEntries: $aea218dde2c0f936$export$491f01a0e9b8b208
    });
    let currentPageState;
    if ((0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).VISIBILITY_STATE)) {
        const visibilityEntries = performance.getEntriesByType((0, $e6Vsp.RumPerformanceEntryType).VISIBILITY_STATE);
        visibilityEntries.forEach((entry)=>{
            const state = entry.name === 'hidden' ? "hidden" /* PageState.HIDDEN */  : "active" /* PageState.ACTIVE */ ;
            addPageState(state, entry.startTime);
        });
    }
    addPageState($aea218dde2c0f936$var$getPageState(), (0, $ly0px.relativeNow)());
    const { stop: stopEventListeners } = (0, $hXhfS.addEventListeners)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */ ,
        "focus" /* DOM_EVENT.FOCUS */ ,
        "blur" /* DOM_EVENT.BLUR */ ,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
        "resume" /* DOM_EVENT.RESUME */ ,
        "freeze" /* DOM_EVENT.FREEZE */ ,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */ 
    ], (event)=>{
        addPageState($aea218dde2c0f936$var$computePageState(event), event.timeStamp);
    }, {
        capture: true
    });
    function addPageState(nextPageState, startTime = (0, $ly0px.relativeNow)()) {
        if (nextPageState === currentPageState) return;
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({
            state: currentPageState,
            startTime: startTime
        }, startTime);
    }
    function wasInPageStateDuringPeriod(state, startTime, duration) {
        return pageStateEntryHistory.findAll(startTime, duration).some((pageState)=>pageState.state === state);
    }
    hooks.register(0 /* HookNames.Assemble */ , ({ startTime: startTime, duration: duration = 0, eventType: eventType })=>{
        if (eventType === (0, $kDJMQ.RumEventType).VIEW) {
            const pageStates = pageStateEntryHistory.findAll(startTime, duration);
            return {
                type: eventType,
                _dd: {
                    page_states: $aea218dde2c0f936$var$processPageStates(pageStates, startTime, maxPageStateEntriesSelectable)
                }
            };
        }
        if (eventType === (0, $kDJMQ.RumEventType).ACTION || eventType === (0, $kDJMQ.RumEventType).ERROR) return {
            type: eventType,
            view: {
                in_foreground: wasInPageStateDuringPeriod("active" /* PageState.ACTIVE */ , startTime, 0)
            }
        };
        return 0, $i3LOd.SKIPPED;
    });
    return {
        wasInPageStateDuringPeriod: wasInPageStateDuringPeriod,
        addPageState: addPageState,
        stop: ()=>{
            stopEventListeners();
            pageStateEntryHistory.stop();
        }
    };
}
function $aea218dde2c0f936$var$processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
    if (pageStateEntries.length === 0) return;
    return pageStateEntries.slice(-maxPageStateEntriesSelectable).reverse().map(({ state: state, startTime: startTime })=>({
            state: state,
            start: (0, $ly0px.toServerDuration)((0, $ly0px.elapsed)(eventStartTime, startTime))
        }));
}
function $aea218dde2c0f936$var$computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) return "frozen" /* PageState.FROZEN */ ;
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ ) return event.persisted ? "frozen" /* PageState.FROZEN */  : "terminated" /* PageState.TERMINATED */ ;
    return $aea218dde2c0f936$var$getPageState();
}
function $aea218dde2c0f936$var$getPageState() {
    if (document.visibilityState === 'hidden') return "hidden" /* PageState.HIDDEN */ ;
    if (document.hasFocus()) return "active" /* PageState.ACTIVE */ ;
    return "passive" /* PageState.PASSIVE */ ;
}

});

parcelRegister("btrZp", function(module, exports) {

$parcel$export(module.exports, "startDisplayContext", () => $85a81d4aa7a689fa$export$9b255c0d165a033f);

var $2wH3Z = parcelRequire("2wH3Z");

var $kom4r = parcelRequire("kom4r");
function $85a81d4aa7a689fa$export$9b255c0d165a033f(hooks, configuration) {
    let viewport;
    // Use requestAnimationFrame to delay the calculation of viewport dimensions until after SDK initialization, preventing long tasks.
    const animationFrameId = requestAnimationFrame((0, $2wH3Z.monitor)(()=>{
        viewport = (0, $kom4r.getViewportDimension)();
    }));
    const unsubscribeViewport = (0, $kom4r.initViewportObservable)(configuration).subscribe((viewportDimension)=>{
        viewport = viewportDimension;
    }).unsubscribe;
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>({
            type: eventType,
            display: viewport ? {
                viewport: viewport
            } : undefined
        }));
    return {
        stop: ()=>{
            unsubscribeViewport();
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        }
    };
}

});

parcelRegister("5FzGr", function(module, exports) {

$parcel$export(module.exports, "startCiVisibilityContext", () => $420c7617b51dc43d$export$121aef6278f2cce8);

var $4i26u = parcelRequire("4i26u");
var $i3LOd = parcelRequire("i3LOd");

var $6vNTK = parcelRequire("6vNTK");
const $420c7617b51dc43d$export$f848217ffff2b290 = 'datadog-ci-visibility-test-execution-id';
function $420c7617b51dc43d$export$121aef6278f2cce8(configuration, hooks, cookieObservable = (0, $6vNTK.createCookieObservable)(configuration, $420c7617b51dc43d$export$f848217ffff2b290)) {
    var _a;
    let testExecutionId = (0, $4i26u.getInitCookie)($420c7617b51dc43d$export$f848217ffff2b290) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
    const cookieObservableSubscription = cookieObservable.subscribe((value)=>{
        testExecutionId = value;
    });
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (typeof testExecutionId !== 'string') return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            session: {
                type: "ci_test" /* SessionType.CI_TEST */ 
            },
            ci_test: {
                test_execution_id: testExecutionId
            }
        };
    });
    return {
        stop: ()=>{
            cookieObservableSubscription.unsubscribe();
        }
    };
}

});
parcelRegister("6vNTK", function(module, exports) {

$parcel$export(module.exports, "createCookieObservable", () => $4bdc5815cbedd0b5$export$346054de39969c66);

var $hXhfS = parcelRequire("hXhfS");
var $d97UU = parcelRequire("d97UU");
var $99fDv = parcelRequire("99fDv");
var $4wc1a = parcelRequire("4wc1a");
var $ly0px = parcelRequire("ly0px");
function $4bdc5815cbedd0b5$export$346054de39969c66(configuration, cookieName) {
    const detectCookieChangeStrategy = window.cookieStore ? $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) : $4bdc5815cbedd0b5$var$watchCookieFallback;
    return new (0, $4wc1a.Observable)((observable)=>detectCookieChangeStrategy(cookieName, (event)=>observable.notify(event)));
}
function $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) {
    return (cookieName, callback)=>{
        const listener = (0, $hXhfS.addEventListener)(configuration, window.cookieStore, "change" /* DOM_EVENT.CHANGE */ , (event)=>{
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            const changeEvent = event.changed.find((event)=>event.name === cookieName) || event.deleted.find((event)=>event.name === cookieName);
            if (changeEvent) callback(changeEvent.value);
        });
        return listener.stop;
    };
}
const $4bdc5815cbedd0b5$export$541bea9a14448c32 = (0, $ly0px.ONE_SECOND);
function $4bdc5815cbedd0b5$var$watchCookieFallback(cookieName, callback) {
    let previousCookieValue = (0, $99fDv.findCommaSeparatedValue)(document.cookie, cookieName);
    const watchCookieIntervalId = (0, $d97UU.setInterval)(()=>{
        const cookieValue = (0, $99fDv.findCommaSeparatedValue)(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) {
            previousCookieValue = cookieValue;
            callback(cookieValue);
        }
    }, $4bdc5815cbedd0b5$export$541bea9a14448c32);
    return ()=>{
        (0, $d97UU.clearInterval)(watchCookieIntervalId);
    };
}

});


parcelRegister("lWJEv", function(module, exports) {

$parcel$export(module.exports, "startLongTaskCollection", () => $ffa26d5dc219f735$export$52c09388c428dadc);

var $99fDv = parcelRequire("99fDv");
var $ly0px = parcelRequire("ly0px");

var $kDJMQ = parcelRequire("kDJMQ");

var $e6Vsp = parcelRequire("e6Vsp");
function $ffa26d5dc219f735$export$52c09388c428dadc(lifeCycle, configuration) {
    const entryType = (0, $e6Vsp.supportPerformanceTimingEvent)((0, $e6Vsp.RumPerformanceEntryType).LONG_ANIMATION_FRAME) ? (0, $e6Vsp.RumPerformanceEntryType).LONG_ANIMATION_FRAME : (0, $e6Vsp.RumPerformanceEntryType).LONG_TASK;
    const subscription = (0, $e6Vsp.createPerformanceObservable)(configuration, {
        type: entryType,
        buffered: true
    }).subscribe((entries)=>{
        for (const entry of entries){
            if (!configuration.trackLongTasks) break;
            const startClocks = (0, $ly0px.relativeToClocks)(entry.startTime);
            const rawRumEvent = $ffa26d5dc219f735$var$processEntry(entry, startClocks);
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                rawRumEvent: rawRumEvent,
                startClocks: startClocks,
                duration: entry.duration,
                domainContext: {
                    performanceEntry: entry
                }
            });
        }
    });
    return {
        stop: ()=>subscription.unsubscribe()
    };
}
function $ffa26d5dc219f735$var$processEntry(entry, startClocks) {
    const id = (0, $99fDv.generateUUID)();
    const duration = (0, $ly0px.toServerDuration)(entry.duration);
    const baseEvent = {
        date: startClocks.timeStamp,
        type: (0, $kDJMQ.RumEventType).LONG_TASK,
        _dd: {
            discarded: false
        }
    };
    if (entry.entryType === (0, $e6Vsp.RumPerformanceEntryType).LONG_TASK) return {
        ...baseEvent,
        long_task: {
            id: id,
            entry_type: (0, $kDJMQ.RumLongTaskEntryType).LONG_TASK,
            duration: duration
        }
    };
    return {
        ...baseEvent,
        long_task: {
            id: id,
            entry_type: (0, $kDJMQ.RumLongTaskEntryType).LONG_ANIMATION_FRAME,
            duration: duration,
            blocking_duration: (0, $ly0px.toServerDuration)(entry.blockingDuration),
            first_ui_event_timestamp: (0, $ly0px.toServerDuration)(entry.firstUIEventTimestamp),
            render_start: (0, $ly0px.toServerDuration)(entry.renderStart),
            style_and_layout_start: (0, $ly0px.toServerDuration)(entry.styleAndLayoutStart),
            start_time: (0, $ly0px.toServerDuration)(entry.startTime),
            scripts: entry.scripts.map((script)=>({
                    duration: (0, $ly0px.toServerDuration)(script.duration),
                    pause_duration: (0, $ly0px.toServerDuration)(script.pauseDuration),
                    forced_style_and_layout_duration: (0, $ly0px.toServerDuration)(script.forcedStyleAndLayoutDuration),
                    start_time: (0, $ly0px.toServerDuration)(script.startTime),
                    execution_start: (0, $ly0px.toServerDuration)(script.executionStart),
                    source_url: script.sourceURL,
                    source_function_name: script.sourceFunctionName,
                    source_char_position: script.sourceCharPosition,
                    invoker: script.invoker,
                    invoker_type: script.invokerType,
                    window_attribution: script.windowAttribution
                }))
        }
    };
}

});

parcelRegister("e4z7O", function(module, exports) {

$parcel$export(module.exports, "startSyntheticsContext", () => $a3ecaf80187f9bbd$export$cbd80c79c0d9a191);

var $eA1KP = parcelRequire("eA1KP");
var $i3LOd = parcelRequire("i3LOd");
function $a3ecaf80187f9bbd$export$cbd80c79c0d9a191(hooks) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (!(0, $eA1KP.isSyntheticsTest)()) return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            session: {
                type: "synthetics" /* SessionType.SYNTHETICS */ 
            },
            synthetics: {
                ...(0, $eA1KP.getSyntheticsContext)(),
                injected: (0, $eA1KP.willSyntheticsInjectRum)()
            }
        };
    });
}

});

parcelRegister("8NjHX", function(module, exports) {

$parcel$export(module.exports, "startRumAssembly", () => $66722fe8d7cbabe1$export$1a0bc162690d6539);

var $hBiX7 = parcelRequire("hBiX7");
var $j9iCm = parcelRequire("j9iCm");
var $axXk6 = parcelRequire("axXk6");
var $i3LOd = parcelRequire("i3LOd");
var $5IDGB = parcelRequire("5IDGB");
var $8PiRA = parcelRequire("8PiRA");

var $kDJMQ = parcelRequire("kDJMQ");

var $iajsC = parcelRequire("iajsC");
const $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string'
};
const $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object'
};
const $66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS = {
    service: 'string',
    version: 'string'
};
let $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent;
function $66722fe8d7cbabe1$export$1a0bc162690d6539(configuration, lifeCycle, hooks, reportError, eventRateLimit) {
    $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent = {
        [(0, $kDJMQ.RumEventType).VIEW]: {
            'view.performance.lcp.resource_url': 'string',
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $kDJMQ.RumEventType).ERROR]: {
            'error.message': 'string',
            'error.stack': 'string',
            'error.handling_stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $kDJMQ.RumEventType).RESOURCE]: {
            'resource.url': 'string',
            'resource.graphql.variables': 'string',
            'resource.request.headers': 'object',
            'resource.response.headers': 'object',
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $kDJMQ.RumEventType).ACTION]: {
            'action.target.name': 'string',
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $kDJMQ.RumEventType).LONG_TASK]: {
            'long_task.scripts[].source_url': 'string',
            'long_task.scripts[].invoker': 'string',
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        },
        [(0, $kDJMQ.RumEventType).VITAL]: {
            ...$66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS,
            ...$66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS
        }
    };
    const eventRateLimiters = {
        [(0, $kDJMQ.RumEventType).ERROR]: (0, $axXk6.createEventRateLimiter)((0, $kDJMQ.RumEventType).ERROR, reportError, eventRateLimit),
        [(0, $kDJMQ.RumEventType).ACTION]: (0, $axXk6.createEventRateLimiter)((0, $kDJMQ.RumEventType).ACTION, reportError, eventRateLimit),
        [(0, $kDJMQ.RumEventType).VITAL]: (0, $axXk6.createEventRateLimiter)((0, $kDJMQ.RumEventType).VITAL, reportError, eventRateLimit)
    };
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , ({ startClocks: startClocks, duration: duration, rawRumEvent: rawRumEvent, domainContext: domainContext })=>{
        const defaultRumEventAttributes = hooks.triggerHook(0 /* HookNames.Assemble */ , {
            eventType: rawRumEvent.type,
            rawRumEvent: rawRumEvent,
            domainContext: domainContext,
            startTime: startClocks.relative,
            duration: duration
        });
        if (defaultRumEventAttributes === (0, $i3LOd.DISCARDED)) return;
        const serverRumEvent = (0, $j9iCm.combine)(defaultRumEventAttributes, rawRumEvent, {
            ddtags: (0, $hBiX7.buildTags)(configuration).join(',')
        });
        if ($66722fe8d7cbabe1$var$shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
            if ((0, $8PiRA.isEmptyObject)(serverRumEvent.context)) delete serverRumEvent.context;
            lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , serverRumEvent);
        }
    });
}
function $66722fe8d7cbabe1$var$shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        const result = (0, $iajsC.limitModification)(event, $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent[event.type], (event)=>beforeSend(event, domainContext));
        if (result === false && event.type !== (0, $kDJMQ.RumEventType).VIEW) return false;
        if (result === false) (0, $5IDGB.display).warn("Can't dismiss view events using beforeSend!");
    }
    const rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}

});
parcelRegister("iajsC", function(module, exports) {

$parcel$export(module.exports, "limitModification", () => $d39841a7da10ef40$export$a1733aa00dfb01);

var $j9iCm = parcelRequire("j9iCm");
var $5DEie = parcelRequire("5DEie");
var $fkj4Q = parcelRequire("fkj4Q");
var $1RdIU = parcelRequire("1RdIU");
function $d39841a7da10ef40$export$a1733aa00dfb01(object, modifiableFieldPaths, modifier) {
    const clone = (0, $j9iCm.deepClone)(object);
    const result = modifier(clone);
    (0, $fkj4Q.objectEntries)(modifiableFieldPaths).forEach(([fieldPath, fieldType])=>// Traverse both object and clone simultaneously up to the path and apply the modification from the clone to the original object when the type is valid
        $d39841a7da10ef40$var$setValueAtPath(object, clone, fieldPath.split(/\.|(?=\[\])/), fieldType));
    return result;
}
function $d39841a7da10ef40$var$setValueAtPath(object, clone, pathSegments, fieldType) {
    const [field, ...restPathSegments] = pathSegments;
    if (field === '[]') {
        if (Array.isArray(object) && Array.isArray(clone)) object.forEach((item, i)=>$d39841a7da10ef40$var$setValueAtPath(item, clone[i], restPathSegments, fieldType));
        return;
    }
    if (!$d39841a7da10ef40$var$isValidObject(object) || !$d39841a7da10ef40$var$isValidObject(clone)) return;
    if (restPathSegments.length > 0) return $d39841a7da10ef40$var$setValueAtPath(object[field], clone[field], restPathSegments, fieldType);
    $d39841a7da10ef40$var$setNestedValue(object, field, clone[field], fieldType);
}
function $d39841a7da10ef40$var$setNestedValue(object, field, value, fieldType) {
    if (object[field] === value) return;
    const newType = (0, $5DEie.getType)(value);
    if (newType === fieldType) object[field] = (0, $1RdIU.sanitize)(value);
    else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) object[field] = {};
}
function $d39841a7da10ef40$var$isValidObject(object) {
    return (0, $5DEie.getType)(object) === 'object';
}

});


parcelRegister("9tDnN", function(module, exports) {

$parcel$export(module.exports, "startSessionContext", () => $6e655f1bd0ae2306$export$930c4ba5de05acaa);

var $i3LOd = parcelRequire("i3LOd");

var $kDJMQ = parcelRequire("kDJMQ");
function $6e655f1bd0ae2306$export$930c4ba5de05acaa(hooks, sessionManager, recorderApi, viewHistory) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType, startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        const view = viewHistory.findView(startTime);
        if (!session || !view) return 0, $i3LOd.DISCARDED;
        let hasReplay;
        let sampledForReplay;
        let isActive;
        if (eventType === (0, $kDJMQ.RumEventType).VIEW) {
            hasReplay = recorderApi.getReplayStats(view.id) ? true : undefined;
            sampledForReplay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */ ;
            isActive = view.sessionIsActive ? undefined : false;
        } else hasReplay = recorderApi.isRecording() ? true : undefined;
        return {
            type: eventType,
            session: {
                id: session.id,
                type: "user" /* SessionType.USER */ ,
                has_replay: hasReplay,
                sampled_for_replay: sampledForReplay,
                is_active: isActive
            }
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ({ startTime: startTime })=>{
        const session = sessionManager.findTrackedSession(startTime);
        if (!session) return 0, $i3LOd.SKIPPED;
        return {
            session: {
                id: session.id
            }
        };
    });
}

});

parcelRegister("cCTtu", function(module, exports) {

$parcel$export(module.exports, "startConnectivityContext", () => $931410bf1db52cdf$export$e80ceed9d1147534);

var $82OHb = parcelRequire("82OHb");
function $931410bf1db52cdf$export$e80ceed9d1147534(hooks) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>({
            type: eventType,
            connectivity: (0, $82OHb.getConnectivity)()
        }));
}

});

parcelRegister("3Irm0", function(module, exports) {

$parcel$export(module.exports, "startDefaultContext", () => $2b4ab3178736d9fb$export$4349d78965f7073b);

var $kFaIT = parcelRequire("kFaIT");
var $ly0px = parcelRequire("ly0px");
var $bQmeT = parcelRequire("bQmeT");
function $2b4ab3178736d9fb$export$4349d78965f7073b(hooks, configuration, sdkName) {
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        const source = configuration.source;
        return {
            type: eventType,
            _dd: {
                format_version: 2,
                drift: (0, $ly0px.currentDrift)(),
                configuration: {
                    session_sample_rate: (0, $bQmeT.round)(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: (0, $bQmeT.round)(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: (0, $bQmeT.round)(configuration.profilingSampleRate, 3),
                    trace_sample_rate: (0, $bQmeT.round)(configuration.traceSampleRate, 3),
                    beta_encode_cookie_options: configuration.betaEncodeCookieOptions
                },
                browser_sdk_version: (0, $kFaIT.canUseEventBridge)() ? "6.33.0" : undefined,
                sdk_name: sdkName
            },
            application: {
                id: configuration.applicationId
            },
            date: (0, $ly0px.timeStampNow)(),
            source: source
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ()=>({
            application: {
                id: configuration.applicationId
            }
        }));
}

});

parcelRegister("4Xhld", function(module, exports) {

$parcel$export(module.exports, "startTrackingConsentContext", () => $39ba1fb8e8d46c1d$export$43dc707f6931474b);

var $i3LOd = parcelRequire("i3LOd");
function $39ba1fb8e8d46c1d$export$43dc707f6931474b(hooks, trackingConsentState) {
    hooks.register(1 /* HookNames.AssembleTelemetry */ , ()=>{
        const wasConsented = trackingConsentState.isGranted();
        if (!wasConsented) return 0, $i3LOd.DISCARDED;
        return 0, $i3LOd.SKIPPED;
    });
}

});

parcelRegister("fmXhG", function(module, exports) {

$parcel$export(module.exports, "startEventCollection", () => $b306e5b0cdad1074$export$8fba5d6b972d9291);

var $ly0px = parcelRequire("ly0px");

var $kDJMQ = parcelRequire("kDJMQ");
const $b306e5b0cdad1074$var$allowedEventTypes = [
    (0, $kDJMQ.RumEventType).ACTION,
    (0, $kDJMQ.RumEventType).ERROR,
    (0, $kDJMQ.RumEventType).LONG_TASK,
    (0, $kDJMQ.RumEventType).RESOURCE,
    (0, $kDJMQ.RumEventType).VITAL
];
function $b306e5b0cdad1074$export$8fba5d6b972d9291(lifeCycle) {
    return {
        addEvent: (startTime, event, domainContext, duration)=>{
            if (!$b306e5b0cdad1074$var$allowedEventTypes.includes(event.type)) return;
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                startClocks: (0, $ly0px.relativeToClocks)(startTime),
                rawRumEvent: event,
                domainContext: domainContext,
                duration: duration
            });
        }
    };
}

});

parcelRegister("kf8Yt", function(module, exports) {

$parcel$export(module.exports, "startInitialViewMetricsTelemetry", () => $ebcc2b7c7b98c9b0$export$73001881cbfb26e9);

var $fhNdh = parcelRequire("fhNdh");
var $aed8w = parcelRequire("aed8w");
function $ebcc2b7c7b98c9b0$export$73001881cbfb26e9(lifeCycle, telemetry) {
    if (!telemetry.metricsEnabled) return {
        stop: (0, $aed8w.noop)
    };
    const { unsubscribe: unsubscribe } = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , ({ initialViewMetrics: initialViewMetrics })=>{
        if (!initialViewMetrics.largestContentfulPaint || !initialViewMetrics.navigationTimings) return;
        // The navigation timings become available shortly after the load event fires, so
        // we're snapshotting the LCP value available at that point. However, more LCP values
        // can be emitted until the page is scrolled or interacted with, so it's possible that
        // the final LCP value may differ. These metrics are intended to help diagnose
        // performance issues early in the page load process, and using LCP-at-page-load is a
        // good fit for that use case, but it's important to be aware that this is not
        // necessarily equivalent to the normal LCP metric.
        // monitor-until: 2026-07-01
        (0, $fhNdh.addTelemetryMetrics)("Initial view metrics" /* TelemetryMetrics.INITIAL_VIEW_METRICS_TELEMETRY_NAME */ , {
            metrics: $ebcc2b7c7b98c9b0$var$createCoreInitialViewMetrics(initialViewMetrics.largestContentfulPaint, initialViewMetrics.navigationTimings)
        });
        unsubscribe();
    });
    return {
        stop: unsubscribe
    };
}
function $ebcc2b7c7b98c9b0$var$createCoreInitialViewMetrics(lcp, navigation) {
    return {
        lcp: {
            value: lcp.value
        },
        navigation: {
            domComplete: navigation.domComplete,
            domContentLoaded: navigation.domContentLoaded,
            domInteractive: navigation.domInteractive,
            firstByte: navigation.firstByte,
            loadEvent: navigation.loadEvent
        }
    };
}

});

parcelRegister("asij6", function(module, exports) {

$parcel$export(module.exports, "startSourceCodeContext", () => $79cab852700ff2d9$export$ae341c65ec6091c);

var $fhNdh = parcelRequire("fhNdh");
var $3aiPa = parcelRequire("3aiPa");
var $fkj4Q = parcelRequire("fkj4Q");
var $i3LOd = parcelRequire("i3LOd");
function $79cab852700ff2d9$export$ae341c65ec6091c(hooks) {
    const browserWindow = window;
    const contextByFile = new Map();
    function buildContextByFile() {
        if (!browserWindow.DD_SOURCE_CODE_CONTEXT) return;
        (0, $fkj4Q.objectEntries)(browserWindow.DD_SOURCE_CODE_CONTEXT).forEach(([stack, context])=>{
            const stackTrace = (0, $3aiPa.computeStackTrace)({
                stack: stack
            });
            const firstFrame = stackTrace.stack[0];
            if (!firstFrame.url) {
                (0, $fhNdh.addTelemetryError)('Source code context: missing frame url', {
                    stack: stack
                });
                return;
            }
            // don't overwrite existing context
            if (!contextByFile.has(firstFrame.url)) contextByFile.set(firstFrame.url, context);
        });
        browserWindow.DD_SOURCE_CODE_CONTEXT = {};
    }
    buildContextByFile();
    hooks.register(0 /* HookNames.Assemble */ , ({ domainContext: domainContext, rawRumEvent: rawRumEvent })=>{
        buildContextByFile();
        if (contextByFile.size === 0) return 0, $i3LOd.SKIPPED;
        const url = $79cab852700ff2d9$var$getSourceUrl(domainContext, rawRumEvent);
        const context = url && contextByFile.get(url);
        if (!context) return 0, $i3LOd.SKIPPED;
        return {
            type: rawRumEvent.type,
            service: context.service,
            version: context.version
        };
    });
}
function $79cab852700ff2d9$var$getSourceUrl(domainContext, rawRumEvent) {
    var _a, _b;
    if (rawRumEvent.type === 'long_task' && rawRumEvent.long_task.entry_type === 'long-animation-frame') return (_a = rawRumEvent.long_task.scripts[0]) === null || _a === void 0 ? void 0 : _a.source_url;
    let stack;
    if ('handlingStack' in domainContext) stack = domainContext.handlingStack;
    if (rawRumEvent.type === 'error' && rawRumEvent.error.stack) stack = rawRumEvent.error.stack;
    const stackTrace = (0, $3aiPa.computeStackTrace)({
        stack: stack
    });
    return (_b = stackTrace.stack[0]) === null || _b === void 0 ? void 0 : _b.url;
}

});



parcelRegister("dKooA", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayUrl", () => $a0227eab1dbc844e$export$58d09b88d0d4cf52);

var $iLlhv = parcelRequire("iLlhv");
function $a0227eab1dbc844e$export$58d09b88d0d4cf52(configuration, { session: session, viewContext: viewContext, errorType: errorType }) {
    const sessionId = session ? session.id : 'no-session-id';
    const parameters = [];
    if (errorType !== undefined) parameters.push(`error-type=${errorType}`);
    if (viewContext) {
        parameters.push(`seed=${viewContext.id}`);
        parameters.push(`from=${viewContext.startClocks.timeStamp}`);
    }
    const origin = $a0227eab1dbc844e$export$63276db6097e2435(configuration);
    const path = `/rum/replay/sessions/${sessionId}`;
    return `${origin}${path}?${parameters.join('&')}`;
}
function $a0227eab1dbc844e$export$63276db6097e2435(rumConfiguration) {
    const site = rumConfiguration.site;
    const subdomain = rumConfiguration.subdomain || $a0227eab1dbc844e$var$getSiteDefaultSubdomain(rumConfiguration);
    return `https://${subdomain ? `${subdomain}.` : ''}${site}`;
}
function $a0227eab1dbc844e$var$getSiteDefaultSubdomain(configuration) {
    switch(configuration.site){
        case 0, $iLlhv.INTAKE_SITE_US1:
        case 0, $iLlhv.INTAKE_SITE_EU1:
            return 'app';
        case 0, $iLlhv.INTAKE_SITE_STAGING:
            return 'dd';
        default:
            return undefined;
    }
}

});

parcelRegister("75B79", function(module, exports) {

$parcel$export(module.exports, "createFormDataTransport", () => $0154ff21c68b4450$export$602e019c0da77727);

var $fhNdh = parcelRequire("fhNdh");
var $3qksw = parcelRequire("3qksw");
var $1W8NF = parcelRequire("1W8NF");
var $fkj4Q = parcelRequire("fkj4Q");
function $0154ff21c68b4450$export$602e019c0da77727(configuration, lifeCycle, createEncoder, streamId) {
    const reportError = (error)=>{
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        // monitor-until: forever, to keep an eye on the errors reported to customers
        (0, $fhNdh.addTelemetryDebug)('Error reported to customer', {
            'error.message': error.message
        });
    };
    const httpRequest = (0, $3qksw.createHttpRequest)([
        configuration.profilingEndpointBuilder
    ], reportError);
    const encoder = createEncoder(streamId);
    return {
        async send ({ event: event, ...attachments }) {
            const formData = new FormData();
            const serializedEvent = (0, $1W8NF.jsonStringify)(event);
            if (!serializedEvent) throw new Error('Failed to serialize event');
            formData.append('event', new Blob([
                serializedEvent
            ], {
                type: 'application/json'
            }), 'event.json');
            let bytesCount = serializedEvent.length;
            for (const [key, value] of (0, $fkj4Q.objectEntries)(attachments)){
                const serializedValue = (0, $1W8NF.jsonStringify)(value);
                if (!serializedValue) throw new Error('Failed to serialize attachment');
                const result = await $0154ff21c68b4450$var$encode(encoder, serializedValue);
                bytesCount += result.outputBytesCount;
                formData.append(key, new Blob([
                    result.output
                ]), key);
            }
            httpRequest.send({
                data: formData,
                bytesCount: bytesCount
            });
        }
    };
}
function $0154ff21c68b4450$var$encode(encoder, data) {
    return new Promise((resolve)=>{
        encoder.write(data);
        encoder.finish((encoderResult)=>{
            resolve(encoderResult);
        });
    });
}

});


parcelRegister("3VNwe", function(module, exports) {

$parcel$export(module.exports, "makeRecorderApi", () => $2dcd1b6060126fce$export$e9b5b20eb46e0952);

var $kFaIT = parcelRequire("kFaIT");
var $aed8w = parcelRequire("aed8w");

var $j4d5H = parcelRequire("j4d5H");
parcelRequire("l2g7V");
var $3nvYK = parcelRequire("3nvYK");
var $ftUlk = parcelRequire("ftUlk");

var $cBqcZ = parcelRequire("cBqcZ");

var $9qxAh = parcelRequire("9qxAh");

var $kIJx0 = parcelRequire("kIJx0");
function $2dcd1b6060126fce$export$e9b5b20eb46e0952() {
    if ((0, $kFaIT.canUseEventBridge)() && !(0, $kFaIT.bridgeSupports)("records" /* BridgeCapability.RECORDS */ ) || !(0, $cBqcZ.isBrowserSupported)()) return {
        start: (0, $aed8w.noop),
        stop: (0, $aed8w.noop),
        getReplayStats: ()=>undefined,
        onRumStart: (0, $aed8w.noop),
        isRecording: ()=>false,
        getSessionReplayLink: ()=>undefined
    };
    // eslint-disable-next-line prefer-const
    let { strategy: strategy, shouldStartImmediately: shouldStartImmediately } = (0, $kIJx0.createPreStartStrategy)();
    return {
        start: (options)=>strategy.start(options),
        stop: ()=>strategy.stop(),
        getSessionReplayLink: ()=>strategy.getSessionReplayLink(),
        onRumStart: onRumStart,
        isRecording: ()=>// The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            (0, $ftUlk.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  && strategy.isRecording(),
        getReplayStats: (viewId)=>(0, $ftUlk.getDeflateWorkerStatus)() === 3 /* DeflateWorkerStatus.Initialized */  ? (0, $j4d5H.getReplayStats)(viewId) : undefined
    };
    function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker, telemetry) {
        let cachedDeflateEncoder;
        function getOrCreateDeflateEncoder() {
            if (!cachedDeflateEncoder) {
                worker !== null && worker !== void 0 ? worker : worker = (0, $ftUlk.startDeflateWorker)(configuration, 'Datadog Session Replay', ()=>strategy.stop());
                if (worker) cachedDeflateEncoder = (0, $3nvYK.createDeflateEncoder)(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */ );
            }
            return cachedDeflateEncoder;
        }
        strategy = (0, $9qxAh.createPostStartStrategy)(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry);
        if (shouldStartImmediately(configuration)) strategy.start();
    }
}

});
parcelRegister("j4d5H", function(module, exports) {

$parcel$export(module.exports, "getSegmentsCount", () => $de188ba0cd76f643$export$4223f4e280561ccd);
$parcel$export(module.exports, "addSegment", () => $de188ba0cd76f643$export$1c43f9ac826b6462);
$parcel$export(module.exports, "addRecord", () => $de188ba0cd76f643$export$ab0ab92b3cb31c66);
$parcel$export(module.exports, "addWroteData", () => $de188ba0cd76f643$export$ae4fdff69a4959e9);
$parcel$export(module.exports, "getReplayStats", () => $de188ba0cd76f643$export$92ac42d7bd545b2a);
const $de188ba0cd76f643$export$f10444a7271b7f1e = 1000;
let $de188ba0cd76f643$var$statsPerView;
function $de188ba0cd76f643$export$4223f4e280561ccd(viewId) {
    return $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count;
}
function $de188ba0cd76f643$export$1c43f9ac826b6462(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count += 1;
}
function $de188ba0cd76f643$export$ab0ab92b3cb31c66(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).records_count += 1;
}
function $de188ba0cd76f643$export$ae4fdff69a4959e9(viewId, additionalBytesCount) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function $de188ba0cd76f643$export$92ac42d7bd545b2a(viewId) {
    return $de188ba0cd76f643$var$statsPerView === null || $de188ba0cd76f643$var$statsPerView === void 0 ? void 0 : $de188ba0cd76f643$var$statsPerView.get(viewId);
}
function $de188ba0cd76f643$export$f6629d8f23dffc10() {
    $de188ba0cd76f643$var$statsPerView = undefined;
}
function $de188ba0cd76f643$var$getOrCreateReplayStats(viewId) {
    if (!$de188ba0cd76f643$var$statsPerView) $de188ba0cd76f643$var$statsPerView = new Map();
    let replayStats;
    if ($de188ba0cd76f643$var$statsPerView.has(viewId)) replayStats = $de188ba0cd76f643$var$statsPerView.get(viewId);
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0
        };
        $de188ba0cd76f643$var$statsPerView.set(viewId, replayStats);
        if ($de188ba0cd76f643$var$statsPerView.size > $de188ba0cd76f643$export$f10444a7271b7f1e) $de188ba0cd76f643$var$deleteOldestStats();
    }
    return replayStats;
}
function $de188ba0cd76f643$var$deleteOldestStats() {
    if (!$de188ba0cd76f643$var$statsPerView) return;
    const toDelete = $de188ba0cd76f643$var$statsPerView.keys().next().value;
    if (toDelete) $de188ba0cd76f643$var$statsPerView.delete(toDelete);
}

});

parcelRegister("l2g7V", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", () => (parcelRequire("3nvYK")).createDeflateEncoder);
$parcel$export(module.exports, "startDeflateWorker", () => (parcelRequire("ftUlk")).startDeflateWorker);
$parcel$export(module.exports, "getDeflateWorkerStatus", () => (parcelRequire("ftUlk")).getDeflateWorkerStatus);

var $3nvYK = parcelRequire("3nvYK");

var $ftUlk = parcelRequire("ftUlk");

});
parcelRegister("3nvYK", function(module, exports) {

$parcel$export(module.exports, "createDeflateEncoder", () => $275c53661b5d2fb2$export$1b838d3ae89a44b8);

var $hXhfS = parcelRequire("hXhfS");
var $7S2uk = parcelRequire("7S2uk");
function $275c53661b5d2fb2$export$1b838d3ae89a44b8(configuration, worker, streamId) {
    let rawBytesCount = 0;
    let compressedData = [];
    let compressedDataTrailer;
    let isEmpty = true;
    let nextWriteActionId = 0;
    const pendingWriteActions = [];
    const { stop: removeMessageListener } = (0, $hXhfS.addEventListener)(configuration, worker, 'message', ({ data: workerResponse })=>{
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) return;
        const nextPendingAction = pendingWriteActions[0];
        if (nextPendingAction) {
            if (nextPendingAction.id === workerResponse.id) {
                pendingWriteActions.shift();
                rawBytesCount += workerResponse.additionalBytesCount;
                compressedData.push(workerResponse.result);
                compressedDataTrailer = workerResponse.trailer;
                if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
                else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
            } else if (nextPendingAction.id < workerResponse.id) // Worker responses received out of order
            removeMessageListener();
        }
    });
    function consumeResult() {
        const output = compressedData.length === 0 ? new Uint8Array(0) : (0, $7S2uk.concatBuffers)(compressedData.concat(compressedDataTrailer));
        const result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate'
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (!isEmpty) {
            worker.postMessage({
                action: 'reset',
                streamId: streamId
            });
            isEmpty = true;
        }
    }
    return {
        isAsync: true,
        get isEmpty () {
            return isEmpty;
        },
        write (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data
            });
            isEmpty = false;
            nextWriteActionId += 1;
        },
        finish (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) callback(consumeResult());
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach((pendingWriteAction)=>{
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = ()=>callback(consumeResult());
            }
        },
        finishSync () {
            sendResetIfNeeded();
            const pendingData = pendingWriteActions.map((pendingWriteAction)=>pendingWriteAction.data).join('');
            // Ignore all pending write actions responses from the worker
            pendingWriteActions.length = 0;
            return {
                ...consumeResult(),
                pendingData: pendingData
            };
        },
        estimateEncodedBytesCount (data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop () {
            removeMessageListener();
        }
    };
}

});

parcelRegister("ftUlk", function(module, exports) {

$parcel$export(module.exports, "startDeflateWorker", () => $b455450598273b03$export$8ad05986c983585a);
$parcel$export(module.exports, "getDeflateWorkerStatus", () => $b455450598273b03$export$c2a4b833556ae71);

var $hXhfS = parcelRequire("hXhfS");
var $fhNdh = parcelRequire("fhNdh");
var $5IDGB = parcelRequire("5IDGB");
var $4Umqd = parcelRequire("4Umqd");
var $ly0px = parcelRequire("ly0px");
var $d97UU = parcelRequire("d97UU");

var $9zxD5 = parcelRequire("9zxD5");
const $b455450598273b03$export$da9b966004898f5b = 30 * (0, $ly0px.ONE_SECOND);
function $b455450598273b03$export$f7f3c9481e41f43(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob([
        "(()=>{function t(t){if(1===t.length)return t[0];const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},C=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},D=!1,M=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},j=M,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),T=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},O={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},q=j,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=O[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?M(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);C(t,t.dyn_ltree,e-1),C(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=T(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t||!t.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){D||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),D=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t||!t.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=T(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t||!t.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(O[n]);if(t.header&&(e=this.strm,a=t.header,e&&e.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r=\"[object ArrayBuffer]\"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t||!t.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(O[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:e+\"\",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,\"[object ArrayBuffer]\"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener(\"message\",n=>{try{const r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"6.33.0\"};case\"write\":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,n,r,i,s=t.length,h=0;for(r=0;r<s;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),h+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(h),i=0,r=0;i<h;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,2),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();"
    ])));
}
let $b455450598273b03$var$state = {
    status: 0 /* DeflateWorkerStatus.Nil */ 
};
function $b455450598273b03$export$8ad05986c983585a(configuration, source, onInitializationFailure) {
    if ($b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) // doStartDeflateWorker updates the state to "loading" or "error"
    $b455450598273b03$export$ae2ae5e796988f9a(configuration, source);
    switch($b455450598273b03$var$state.status){
        case 1 /* DeflateWorkerStatus.Loading */ :
            $b455450598273b03$var$state.initializationFailureCallbacks.push(onInitializationFailure);
            return $b455450598273b03$var$state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */ :
            return $b455450598273b03$var$state.worker;
    }
}
function $b455450598273b03$export$1c93a34ce7f0a4fd() {
    if ($b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  || $b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.stop();
    $b455450598273b03$var$state = {
        status: 0 /* DeflateWorkerStatus.Nil */ 
    };
}
function $b455450598273b03$export$c2a4b833556ae71() {
    return $b455450598273b03$var$state.status;
}
function $b455450598273b03$export$ae2ae5e796988f9a(configuration, source) {
    try {
        const worker = (0, $4Umqd.mockable)($b455450598273b03$export$f7f3c9481e41f43)(configuration);
        const { stop: removeErrorListener } = (0, $hXhfS.addEventListener)(configuration, worker, 'error', (error)=>{
            $b455450598273b03$var$onError(configuration, source, error);
        });
        const { stop: removeMessageListener } = (0, $hXhfS.addEventListener)(configuration, worker, 'message', ({ data: data })=>{
            if (data.type === 'errored') $b455450598273b03$var$onError(configuration, source, data.error, data.streamId);
            else if (data.type === 'initialized') $b455450598273b03$var$onInitialized(data.version);
        });
        worker.postMessage({
            action: 'init'
        });
        (0, $d97UU.setTimeout)(()=>$b455450598273b03$var$onTimeout(source), $b455450598273b03$export$da9b966004898f5b);
        const stop = ()=>{
            removeErrorListener();
            removeMessageListener();
        };
        $b455450598273b03$var$state = {
            status: 1 /* DeflateWorkerStatus.Loading */ ,
            worker: worker,
            stop: stop,
            initializationFailureCallbacks: []
        };
    } catch (error) {
        $b455450598273b03$var$onError(configuration, source, error);
    }
}
function $b455450598273b03$var$onTimeout(source) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) {
        (0, $5IDGB.display).error(`${source} failed to start: a timeout occurred while initializing the Worker`);
        $b455450598273b03$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    }
}
function $b455450598273b03$var$onInitialized(version) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state = {
        status: 3 /* DeflateWorkerStatus.Initialized */ ,
        worker: $b455450598273b03$var$state.worker,
        stop: $b455450598273b03$var$state.stop,
        version: version
    };
}
function $b455450598273b03$var$onError(configuration, source, error, streamId) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */  || $b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) {
        (0, $9zxD5.reportScriptLoadingError)({
            configuredUrl: configuration.workerUrl,
            error: error,
            source: source,
            scriptType: 'worker'
        });
        if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.initializationFailureCallbacks.forEach((callback)=>callback());
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    } else (0, $fhNdh.addTelemetryError)(error, {
        worker_version: $b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  && $b455450598273b03$var$state.version,
        stream_id: streamId
    });
}

});
parcelRegister("9zxD5", function(module, exports) {

$parcel$export(module.exports, "reportScriptLoadingError", () => $6f817809c24003ca$export$a276d138883e3de4);

var $fhNdh = parcelRequire("fhNdh");
var $5IDGB = parcelRequire("5IDGB");
function $6f817809c24003ca$export$a276d138883e3de4({ configuredUrl: configuredUrl, error: error, source: source, scriptType: scriptType }) {
    (0, $5IDGB.display).error(`${source} failed to start: an error occurred while initializing the ${scriptType}:`, error);
    if (error instanceof Event || error instanceof Error && $6f817809c24003ca$var$isMessageCspRelated(error.message)) {
        let baseMessage;
        if (configuredUrl) baseMessage = `Please make sure the ${scriptType} URL ${configuredUrl} is correct and CSP is correctly configured.`;
        else baseMessage = 'Please make sure CSP is correctly configured.';
        (0, $5IDGB.display).error(`${baseMessage} See documentation at ${(0, $5IDGB.DOCS_ORIGIN)}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
    } else if (scriptType === 'worker') (0, $fhNdh.addTelemetryError)(error);
}
function $6f817809c24003ca$var$isMessageCspRelated(message) {
    return message.includes('Content Security Policy') || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
    message.includes("requires 'TrustedScriptURL'");
}

});



parcelRegister("cBqcZ", function(module, exports) {

$parcel$export(module.exports, "isBrowserSupported", () => $92cd453a3fca38f8$export$3fe402ec04821f17);
/**
 * Test for Browser features used while recording
 */ function $92cd453a3fca38f8$export$3fe402ec04821f17() {
    return(// Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && typeof URL.createObjectURL === 'function' && 'forEach' in NodeList.prototype);
}

});

parcelRegister("9qxAh", function(module, exports) {

$parcel$export(module.exports, "createPostStartStrategy", () => $6dd097e009e9d65f$export$eedb6b2f1f53c8e);

var $9h4jO = parcelRequire("9h4jO");
var $2wH3Z = parcelRequire("2wH3Z");
var $4wc1a = parcelRequire("4wc1a");

var $hj8ld = parcelRequire("hj8ld");

var $8yqvU = parcelRequire("8yqvU");

var $9m660 = parcelRequire("9m660");
function $6dd097e009e9d65f$export$eedb6b2f1f53c8e(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry) {
    let status = 0 /* RecorderStatus.Stopped */ ;
    let stopRecording;
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , ()=>{
        if (status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ) {
            stop();
            status = 1 /* RecorderStatus.IntentToStart */ ;
        }
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , ()=>{
        if (status === 1 /* RecorderStatus.IntentToStart */ ) start();
    });
    const observable = new (0, $4wc1a.Observable)();
    (0, $8yqvU.startRecorderInitTelemetry)(telemetry, observable);
    const doStart = async (forced)=>{
        observable.notify({
            type: 'start',
            forced: forced
        });
        const [startRecordingImpl] = await Promise.all([
            $6dd097e009e9d65f$var$notifyWhenSettled(observable, {
                type: 'recorder-settled'
            }, (0, $9m660.lazyLoadRecorder)()),
            $6dd097e009e9d65f$var$notifyWhenSettled(observable, {
                type: 'document-ready'
            }, (0, $9h4jO.asyncRunOnReadyState)(configuration, 'interactive'))
        ]);
        if (status !== 2 /* RecorderStatus.Starting */ ) {
            observable.notify({
                type: 'aborted'
            });
            return;
        }
        if (!startRecordingImpl) {
            status = 0 /* RecorderStatus.Stopped */ ;
            observable.notify({
                type: 'recorder-load-failed'
            });
            return;
        }
        const deflateEncoder = getOrCreateDeflateEncoder();
        if (!deflateEncoder) {
            status = 0 /* RecorderStatus.Stopped */ ;
            observable.notify({
                type: 'deflate-encoder-load-failed'
            });
            return;
        }
        ({ stop: stopRecording } = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry));
        status = 3 /* RecorderStatus.Started */ ;
        observable.notify({
            type: 'succeeded'
        });
    };
    function start(options) {
        const session = sessionManager.findTrackedSession();
        if ($6dd097e009e9d65f$var$canStartRecording(session, options)) {
            status = 1 /* RecorderStatus.IntentToStart */ ;
            return;
        }
        if ($6dd097e009e9d65f$var$isRecordingInProgress(status)) return;
        status = 2 /* RecorderStatus.Starting */ ;
        const forced = $6dd097e009e9d65f$var$shouldForceReplay(session, options) || false;
        // Intentionally not awaiting doStart() to keep it asynchronous
        doStart(forced).catch((0, $2wH3Z.monitorError));
        if (forced) sessionManager.setForcedReplay();
    }
    function stop() {
        if (status === 3 /* RecorderStatus.Started */ ) stopRecording === null || stopRecording === void 0 || stopRecording();
        status = 0 /* RecorderStatus.Stopped */ ;
    }
    return {
        start: start,
        stop: stop,
        getSessionReplayLink () {
            return (0, $hj8ld.getSessionReplayLink)(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */ );
        },
        isRecording: ()=>status === 3 /* RecorderStatus.Started */ 
    };
}
function $6dd097e009e9d65f$var$canStartRecording(session, options) {
    return !session || session.sessionReplay === 0 /* SessionReplayState.OFF */  && (!options || !options.force);
}
function $6dd097e009e9d65f$var$isRecordingInProgress(status) {
    return status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ;
}
function $6dd097e009e9d65f$var$shouldForceReplay(session, options) {
    return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */ ;
}
async function $6dd097e009e9d65f$var$notifyWhenSettled(observable, event, promise) {
    try {
        return await promise;
    } finally{
        observable.notify(event);
    }
}

});
parcelRegister("hj8ld", function(module, exports) {

$parcel$export(module.exports, "getSessionReplayLink", () => $c99aae6d4d014aa5$export$5070ba0fc541c84);
parcelRequire("4oXVz");
var $dKooA = parcelRequire("dKooA");

var $cBqcZ = parcelRequire("cBqcZ");
function $c99aae6d4d014aa5$export$5070ba0fc541c84(configuration, sessionManager, viewHistory, isRecordingStarted) {
    const session = sessionManager.findTrackedSession();
    const errorType = $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted);
    const viewContext = viewHistory.findView();
    return (0, $dKooA.getSessionReplayUrl)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session
    });
}
function $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted) {
    if (!(0, $cBqcZ.isBrowserSupported)()) return 'browser-not-supported';
    if (!session) // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return 'rum-not-tracked';
    if (session.sessionReplay === 0 /* SessionReplayState.OFF */ ) // possibilities
    // - replay sampled out
    return 'incorrect-session-plan';
    if (!isRecordingStarted) return 'replay-not-started';
}

});

parcelRegister("8yqvU", function(module, exports) {

$parcel$export(module.exports, "startRecorderInitTelemetry", () => $63a610c4be211341$export$85fe378f0447e9bb);

var $fhNdh = parcelRequire("fhNdh");
var $ly0px = parcelRequire("ly0px");
var $aed8w = parcelRequire("aed8w");
function $63a610c4be211341$export$85fe378f0447e9bb(telemetry, observable) {
    if (!telemetry.metricsEnabled) return {
        stop: (0, $aed8w.noop)
    };
    let startContext;
    let documentReadyDuration;
    let recorderSettledDuration;
    const { unsubscribe: unsubscribe } = observable.subscribe((event)=>{
        switch(event.type){
            case 'start':
                startContext = {
                    forced: event.forced,
                    timestamp: (0, $ly0px.timeStampNow)()
                };
                documentReadyDuration = undefined;
                recorderSettledDuration = undefined;
                break;
            case 'document-ready':
                if (startContext) documentReadyDuration = (0, $ly0px.elapsed)(startContext.timestamp, (0, $ly0px.timeStampNow)());
                break;
            case 'recorder-settled':
                if (startContext) recorderSettledDuration = (0, $ly0px.elapsed)(startContext.timestamp, (0, $ly0px.timeStampNow)());
                break;
            case 'aborted':
            case 'deflate-encoder-load-failed':
            case 'recorder-load-failed':
            case 'succeeded':
                // Only send metrics for the first attempt at starting the recorder.
                unsubscribe();
                if (startContext) // monitor-until: 2026-07-01
                (0, $fhNdh.addTelemetryMetrics)("Recorder init metrics" /* TelemetryMetrics.RECORDER_INIT_METRICS_TELEMETRY_NAME */ , {
                    metrics: $63a610c4be211341$var$createRecorderInitMetrics(startContext.forced, recorderSettledDuration, (0, $ly0px.elapsed)(startContext.timestamp, (0, $ly0px.timeStampNow)()), event.type, documentReadyDuration)
                });
                break;
        }
    });
    return {
        stop: unsubscribe
    };
}
function $63a610c4be211341$var$createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
    return {
        forced: forced,
        loadRecorderModuleDuration: loadRecorderModuleDuration,
        recorderInitDuration: recorderInitDuration,
        result: result,
        waitForDocReadyDuration: waitForDocReadyDuration
    };
}

});

parcelRegister("9m660", function(module, exports) {

$parcel$export(module.exports, "lazyLoadRecorder", () => $6cfae5a2710292a1$export$789fad9c3c8f2281);

var $4Umqd = parcelRequire("4Umqd");

var $9zxD5 = parcelRequire("9zxD5");
async function $6cfae5a2710292a1$export$789fad9c3c8f2281() {
    try {
        return await (0, $4Umqd.mockable)($6cfae5a2710292a1$export$209e5cb48ef53c0a)();
    } catch (error) {
        (0, $9zxD5.reportScriptLoadingError)({
            error: error,
            source: 'Recorder',
            scriptType: 'module'
        });
    }
}

async function $6cfae5a2710292a1$export$209e5cb48ef53c0a() {
    const module = await (parcelRequire("2IlPS"));
    return module.startRecording;
}

});
parcelRegister("2IlPS", function(module, exports) {
module.exports = import("jxn3r").then(()=>parcelRequire('jIcSw'));

});



parcelRegister("kIJx0", function(module, exports) {

$parcel$export(module.exports, "createPreStartStrategy", () => $f15b3c4f990eacd1$export$8f7002373dcc6602);

var $aed8w = parcelRequire("aed8w");
function $f15b3c4f990eacd1$export$8f7002373dcc6602() {
    let status = 0 /* PreStartRecorderStatus.None */ ;
    return {
        strategy: {
            start () {
                status = 1 /* PreStartRecorderStatus.HadManualStart */ ;
            },
            stop () {
                status = 2 /* PreStartRecorderStatus.HadManualStop */ ;
            },
            isRecording: ()=>false,
            getSessionReplayLink: (0, $aed8w.noop)
        },
        shouldStartImmediately (configuration) {
            return status === 1 /* PreStartRecorderStatus.HadManualStart */  || status === 0 /* PreStartRecorderStatus.None */  && !configuration.startSessionReplayRecordingManually;
        }
    };
}

});


parcelRegister("kQuIw", function(module, exports) {

$parcel$export(module.exports, "makeProfilerApi", () => $f2d07dbfaea48d19$export$4cbb20720c46956f);
parcelRequire("4oXVz");
var $2Gs1I = parcelRequire("2Gs1I");

var $2wH3Z = parcelRequire("2wH3Z");

var $iqrwM = parcelRequire("iqrwM");

var $4pLgc = parcelRequire("4pLgc");

var $fbCbR = parcelRequire("fbCbR");
function $f2d07dbfaea48d19$export$4cbb20720c46956f() {
    let profiler;
    function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, createEncoder) {
        const session = sessionManager.findTrackedSession(); // Check if the session is tracked.
        if (!session) // No session tracked, no profiling.
        // Note: No Profiling context is set at this stage.
        return;
        // Sampling (sticky sampling based on session id)
        if (!(0, $2Gs1I.isSampled)(session.id, configuration.profilingSampleRate)) // No sampling, no profiling.
        // Note: No Profiling context is set at this stage.
        return;
        // Listen to events and add the profiling context to them.
        const profilingContextManager = (0, $4pLgc.startProfilingContext)(hooks);
        // Browser support check
        if (!(0, $iqrwM.isProfilingSupported)()) {
            profilingContextManager.set({
                status: 'error',
                error_reason: 'not-supported-by-browser'
            });
            return;
        }
        (0, $fbCbR.lazyLoadProfiler)().then((createRumProfiler)=>{
            if (!createRumProfiler) {
                profilingContextManager.set({
                    status: 'error',
                    error_reason: 'failed-to-lazy-load'
                });
                return;
            }
            profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, createEncoder, viewHistory, undefined);
            profiler.start();
        }).catch((0, $2wH3Z.monitorError));
    }
    return {
        onRumStart: onRumStart,
        stop: ()=>{
            profiler === null || profiler === void 0 || profiler.stop();
        }
    };
}

});
parcelRegister("iqrwM", function(module, exports) {

$parcel$export(module.exports, "isProfilingSupported", () => $d6a002227e3eaa08$export$e6a61085ab61d2c1);

var $1sTNW = parcelRequire("1sTNW");
function $d6a002227e3eaa08$export$e6a61085ab61d2c1() {
    const globalThis = (0, $1sTNW.getGlobalObject)();
    // This API might be unavailable in some browsers
    const globalThisProfiler = globalThis.Profiler;
    return globalThisProfiler !== undefined;
}

});

parcelRegister("4pLgc", function(module, exports) {

$parcel$export(module.exports, "startProfilingContext", () => $336e281ff62f826d$export$5a7dfb6ed5bd727);

var $i3LOd = parcelRequire("i3LOd");
parcelRequire("4oXVz");
var $kDJMQ = parcelRequire("kDJMQ");
function $336e281ff62f826d$export$5a7dfb6ed5bd727(hooks) {
    let currentContext = {
        status: 'starting'
    };
    hooks.register(0 /* HookNames.Assemble */ , ({ eventType: eventType })=>{
        if (eventType !== (0, $kDJMQ.RumEventType).VIEW && eventType !== (0, $kDJMQ.RumEventType).LONG_TASK && eventType !== (0, $kDJMQ.RumEventType).ACTION && eventType !== (0, $kDJMQ.RumEventType).VITAL) return 0, $i3LOd.SKIPPED;
        return {
            type: eventType,
            _dd: {
                profiling: currentContext
            }
        };
    });
    return {
        get: ()=>currentContext,
        set: (newContext)=>{
            currentContext = newContext;
        }
    };
}

});

parcelRegister("fbCbR", function(module, exports) {

$parcel$export(module.exports, "lazyLoadProfiler", () => $b0e581e857d2b6bf$export$2c07ce88fb5e9ae2);

var $4Umqd = parcelRequire("4Umqd");

var $9zxD5 = parcelRequire("9zxD5");
async function $b0e581e857d2b6bf$export$2c07ce88fb5e9ae2() {
    try {
        return await (0, $4Umqd.mockable)($b0e581e857d2b6bf$export$348922f82d1132a5)();
    } catch (error) {
        (0, $9zxD5.reportScriptLoadingError)({
            error: error,
            source: 'Profiler',
            scriptType: 'module'
        });
    }
}

async function $b0e581e857d2b6bf$export$348922f82d1132a5() {
    const module = await (parcelRequire("dBorO"));
    return module.createRumProfiler;
}

});
parcelRegister("dBorO", function(module, exports) {
module.exports = import("2yNAm").then(()=>parcelRequire('26Stw'));

});





parcelRegister("28zQ1", function(module, exports) {

$parcel$export(module.exports, "useUserStore", () => $18e820d23c432327$export$cc885caaa8b7ab4e);

var $i0TKe = parcelRequire("i0TKe");

var $h8sKa = parcelRequire("h8sKa");

var $dmrHV = parcelRequire("dmrHV");

var $jFUWD = parcelRequire("jFUWD");
const $18e820d23c432327$export$cc885caaa8b7ab4e = (0, $i0TKe.defineStore)('user', {
    // 状态
    state: ()=>({
            userData: null
        }),
    // getters
    getters: {
        // 获取用户信息
        getUserData: (state)=>state.userData,
        // 判断是否有用户信息
        hasUser: (state)=>!!state.userData
    },
    // actions
    actions: {
        // 获取用户信息
        async fetchUserData () {
            const { t: t } = (0, $jFUWD.useI18n)();
            try {
                const authRes = await (0, $h8sKa.request)('auth/currentUserInfo', null, true, 'POST', true);
                if (authRes?.status === 200) {
                    const res = await authRes.json();
                    this.userData = res.data;
                    sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(res.data));
                    (0, $dmrHV.setUser)({
                        id: res.data.userId,
                        email: res.data.email
                    });
                    const customerNameEl = document.querySelector('.customer-name');
                    if (res.data?.surname && res.data?.name) customerNameEl.textContent = `${res.data.surname} ${res.data.name}`;
                    else customerNameEl.textContent = t('landing.unnamed');
                }
            } catch (error) {}
            return this.userData;
        },
        // 设置用户数据（用于从外部直接设置数据）
        setUserData (data) {
            this.userData = data;
        },
        // 清除用户数据（用于登出）
        clearUserData () {
            this.userData = null;
        }
    }
});

});


//# sourceMappingURL=Dashboard.f0b09dd4.js.map
